var l3 = Object.defineProperty, r3 = Object.defineProperties;
var h3 = Object.getOwnPropertyDescriptors;
var a1 = Object.getOwnPropertySymbols;
var U1 = Object.prototype.hasOwnProperty, O1 = Object.prototype.propertyIsEnumerable;
var W1 = (C, e, i) => e in C ? l3(C, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : C[e] = i, d = (C, e) => {
  for (var i in e || (e = {}))
    U1.call(e, i) && W1(C, i, e[i]);
  if (a1)
    for (var i of a1(e))
      O1.call(e, i) && W1(C, i, e[i]);
  return C;
}, Z = (C, e) => r3(C, h3(e));
var w1 = (C, e) => {
  var i = {};
  for (var n in C)
    U1.call(C, n) && e.indexOf(n) < 0 && (i[n] = C[n]);
  if (C != null && a1)
    for (var n of a1(C))
      e.indexOf(n) < 0 && O1.call(C, n) && (i[n] = C[n]);
  return i;
};
var p1 = (C, e, i) => new Promise((n, o) => {
  var r = (H) => {
    try {
      h(i.next(H));
    } catch (V) {
      o(V);
    }
  }, l = (H) => {
    try {
      h(i.throw(H));
    } catch (V) {
      o(V);
    }
  }, h = (H) => H.done ? n(H.value) : Promise.resolve(H.value).then(r, l);
  h((i = i.apply(C, e)).next());
});
import { jsx as t, jsxs as c, Fragment as Q1 } from "react/jsx-runtime";
import T from "classnames";
import { useState as z, useEffect as n1, useRef as J, useCallback as q1, forwardRef as n3 } from "react";
import C2 from "react-player";
import o3 from "resize-observer-polyfill";
import { nanoid as r1 } from "nanoid";
import { isMobile as H3, isIOS as t2, isMacOs as a3 } from "react-device-detect";
import { Controller as s1, useWatch as p3, useForm as V3 } from "react-hook-form";
import c3 from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import d3 from "react-select";
import * as _ from "yup";
import { yupResolver as s3 } from "@hookform/resolvers/yup";
const L3 = "_button_qgnvj_1", M3 = "_Small_qgnvj_38", Z3 = "_Medium_qgnvj_47", w3 = "_Large_qgnvj_56", f3 = "_Primary_qgnvj_65", u3 = "_Secondary_qgnvj_75", k3 = "_Link_qgnvj_83", g3 = "_globalButtonStyle_qgnvj_93", V1 = {
  button: L3,
  Small: M3,
  Medium: Z3,
  Large: w3,
  Primary: f3,
  Secondary: u3,
  Link: k3,
  globalButtonStyle: g3
}, x3 = "_text_1kq8d_1", v3 = {
  text: x3
}, e2 = ({ element: C, text: e, minWidth: i }) => {
  const n = C == null ? void 0 : C.settings;
  return /* @__PURE__ */ t(
    "div",
    {
      id: C == null ? void 0 : C.id,
      "data-test": "TextView",
      className: v3.text,
      style: { minWidth: i },
      dangerouslySetInnerHTML: {
        __html: e[n == null ? void 0 : n.textId] || ""
      }
    }
  );
};
var i2 = /* @__PURE__ */ ((C) => (C.Primary = "Primary", C.Secondary = "Secondary", C.Link = "Link", C))(i2 || {}), _3 = /* @__PURE__ */ ((C) => (C.Small = "Small", C.Medium = "Medium", C.Large = "Large", C))(_3 || {}), O = /* @__PURE__ */ ((C) => (C.Internal_Link = "Internal_Link", C.External_Link = "External_Link", C.Email = "Email", C.Phone = "Phone", C.Button = "Button", C.Submit = "Submit", C))(O || {}), U = /* @__PURE__ */ ((C) => (C.Internal_Link = "Internal_Link", C.External_Link = "External_Link", C.Scale_Up = "Scale_Up", C.Do_Nothing = "Do_Nothing", C))(U || {}), l2 = /* @__PURE__ */ ((C) => (C.None = "None", C.Fill = "Fill", C.Cover = "Cover", C.Contain = "Contain", C))(l2 || {}), r2 = /* @__PURE__ */ ((C) => (C.Fill = "Fill", C.Cover = "Cover", C.Contain = "Contain", C.Auto = "Auto", C))(r2 || {}), b3 = /* @__PURE__ */ ((C) => (C.Apple = "Apple", C.Google = "Google", C.Samsung = "Samsung", C.Huawei = "Huawei", C))(b3 || {}), $ = /* @__PURE__ */ ((C) => (C.Behance = "behance", C.Discord = "discord", C.Dribbble = "dribbble", C.Facebook = "facebook", C.Messenger = "messenger", C.Github = "github", C.Instagram = "instagram", C.Linkedin = "linkedin", C.Pinterest = "pinterest", C.Skype = "skype", C.Telegram = "telegram", C.Tiktok = "tiktok", C.Twitter = "twitter", C.Whatsapp = "whatsapp", C.Youtube = "youtube", C.Snapchat = "snapchat", C))($ || {}), m3 = /* @__PURE__ */ ((C) => (C.Brand = "Brand", C.Black = "Black", C.White = "White", C))(m3 || {}), g = /* @__PURE__ */ ((C) => (C.Text = "Text", C.Email = "Email", C.Phone = "Phone", C.TextArea = "TextArea", C.Link = "Link", C.Date = "Date", C.Checkbox = "Checkbox", C.Radio = "Radio", C.Select = "Select", C.Time = "Time", C.File = "File", C))(g || {}), b1 = /* @__PURE__ */ ((C) => (C.Message = "Message", C.Redirect = "Redirect", C))(b1 || {}), y3 = /* @__PURE__ */ ((C) => (C.Name = "name", C.UserName = "username", C.OrganizationTitle = "organization-title", C.Organization = "organization", C.StreetAddress = "street-address", C.AddressLine1 = "address-line1", C.AddressLine2 = "address-line2", C.AddressLine3 = "address-line3", C.Country = "country", C.CountryName = "country-name", C.PostalCode = "postal-code", C.Language = "language", C.Sex = "sex", C.Email = "email", C.Phone = "phone", C.Url = "url", C))(y3 || {}), m1 = /* @__PURE__ */ ((C) => (C.Limited = "Limited", C.Unlimited = "Unlimited", C))(m1 || {}), m = /* @__PURE__ */ ((C) => (C.Color = "Color", C.Gradient = "Gradient", C.Image = "Image", C))(m || {}), B3 = /* @__PURE__ */ ((C) => (C.START = "start", C.CENTER = "center", C.END = "end", C))(B3 || {}), y1 = /* @__PURE__ */ ((C) => (C["left top"] = "left top", C["left center"] = "left center", C["left bottom"] = "left bottom", C["right top"] = "right top", C["right center"] = "right center", C["right bottom"] = "right bottom", C["center top"] = "center top", C["center center"] = "center center", C["center bottom"] = "center bottom", C))(y1 || {}), B1 = /* @__PURE__ */ ((C) => (C.repeat = "repeat", C["no-repeat"] = "no-repeat", C))(B1 || {}), L1 = /* @__PURE__ */ ((C) => (C.fixed = "fixed", C.scroll = "scroll", C))(L1 || {}), _1 = /* @__PURE__ */ ((C) => (C.none = "none", C.outer = "outer", C.inner = "inner", C))(_1 || {}), M = /* @__PURE__ */ ((C) => (C.Filled = "Filled", C.Outlined = "Outlined", C.Colored = "Colored", C))(M || {}), F3 = /* @__PURE__ */ ((C) => (C.NOT_FOUND_PAGE = "NOT_FOUND_PAGE", C.UNDER_MAINTENANCE_PAGE = "UNDER_MAINTENANCE_PAGE", C))(F3 || {}), I3 = /* @__PURE__ */ ((C) => (C.brand1 = "--theme-color-brand1", C.brand2 = "--theme-color-brand2", C.brand3 = "--theme-color-brand3", C.brand4 = "--theme-color-brand4", C.secondary1 = "--theme-color-secondary1", C.secondary2 = "--theme-color-secondary2", C.secondary3 = "--theme-color-secondary3", C.secondary4 = "--theme-color-secondary4", C.base1 = "--theme-color-base1", C.base2 = "--theme-color-base2", C.base3 = "--theme-color-base3", C.base4 = "--theme-color-base4", C.base5 = "--theme-color-base5", C.accent1 = "--theme-color-accent1", C.accent2 = "--theme-color-accent2", C))(I3 || {});
const F1 = ({
  element: C,
  wuiltContext: e,
  children: i,
  stopAction: n,
  disabled: o,
  customClassName: r,
  text: l,
  minWidth: h,
  customStyle: H
}) => {
  var b, A, F, y, R, B, q, E, D, W, k, N, G;
  const V = !!r, p = C == null ? void 0 : C.settings, a = e == null ? void 0 : e.base, L = (b = e == null ? void 0 : e.props) == null ? void 0 : b.theme, s = a == null ? void 0 : a.Link, u = a == null ? void 0 : a.PageLink, w = n ? "button" : ((A = p == null ? void 0 : p.action) == null ? void 0 : A.type) === O.Internal_Link ? u : ((F = p == null ? void 0 : p.action) == null ? void 0 : F.type) === O.Button || ((y = p == null ? void 0 : p.action) == null ? void 0 : y.type) === O.Submit ? "button" : s, { page: f, href: v, type: I } = R3(p == null ? void 0 : p.action), x = ((R = p == null ? void 0 : p.design) == null ? void 0 : R.type) === i2.Link ? "tertiary" : (q = (B = p == null ? void 0 : p.design) == null ? void 0 : B.type) == null ? void 0 : q.toLowerCase();
  return w ? /* @__PURE__ */ t("div", { id: "general-button-text", children: /* @__PURE__ */ t(
    w,
    {
      id: C == null ? void 0 : C.id,
      "data-test": "ButtonView",
      disabled: o,
      className: (E = L == null ? void 0 : L.colors) != null && E.buttons ? T(
        [V1.globalButtonStyle],
        `button-view-${x}`,
        H ? `${H}` : ""
      ) : T(
        [V1.button],
        [V1[((D = p == null ? void 0 : p.design) == null ? void 0 : D.type) || "Primary"]],
        [V1[((W = p == null ? void 0 : p.design) == null ? void 0 : W.size) || "Large"]],
        {
          [r]: V
        }
      ),
      style: {
        borderRadius: (k = L == null ? void 0 : L.colors) != null && k.buttons || (N = p == null ? void 0 : p.design) == null ? void 0 : N.borderRadius
      },
      page: n ? void 0 : f,
      href: n ? void 0 : v,
      target: (G = p == null ? void 0 : p.action) != null && G.newTab ? "_blank" : void 0,
      type: I,
      children: i || /* @__PURE__ */ t(e2, { element: C, text: l, minWidth: h })
    }
  ) }) : null;
};
function R3(C) {
  return (C == null ? void 0 : C.type) === O.External_Link ? { href: C == null ? void 0 : C.value } : (C == null ? void 0 : C.type) === O.Phone ? { href: `tel:${C == null ? void 0 : C.value}` } : (C == null ? void 0 : C.type) === O.Email ? { href: `mailto:${C == null ? void 0 : C.value}?subject=${C.emailSubject || ""}` } : (C == null ? void 0 : C.type) === O.Button ? { type: "button" } : (C == null ? void 0 : C.type) === O.Submit ? { type: "submit" } : { page: { id: C == null ? void 0 : C.value }, href: "#" };
}
const A3 = (o) => {
  var r = o, {
    element: C,
    children: e,
    text: i
  } = r, n = w1(r, [
    "element",
    "children",
    "text"
  ]);
  var h;
  const l = C == null ? void 0 : C.settings;
  return /* @__PURE__ */ t(
    "div",
    {
      "data-test": "ButtonsView",
      style: { display: "inline-flex", gap: 12, flexWrap: "wrap" },
      children: e || ((h = l == null ? void 0 : l.buttons) == null ? void 0 : h.map((H) => {
        const V = {
          id: H == null ? void 0 : H.id,
          settings: H,
          type: "Button"
        };
        return /* @__PURE__ */ t(
          F1,
          Z(d({
            element: V
          }, n), {
            text: i
          }),
          H == null ? void 0 : H.id
        );
      }))
    }
  );
};
function $3(C) {
  const [e, i] = z({ height: 1, width: 1 });
  return n1(() => {
    if (C.current == null)
      return;
    const n = new o3(([o]) => {
      var r, l, h, H;
      i({
        width: (l = (r = o.borderBoxSize) == null ? void 0 : r[0]) == null ? void 0 : l.inlineSize,
        height: (H = (h = o.borderBoxSize) == null ? void 0 : h[0]) == null ? void 0 : H.blockSize
      });
    });
    return n.observe(C.current), () => n.disconnect();
  }, []), e;
}
const E3 = "_wrapper_1k8do_1", W3 = "_videoPlayer_1k8do_6", U3 = {
  wrapper: E3,
  videoPlayer: W3
}, I1 = ({
  wrapperRef: C,
  settings: e
}) => {
  var a, L, s, u, w, f, v, I;
  const n = (((a = e == null ? void 0 : e.background) == null ? void 0 : a.length) === 0 || ((L = e == null ? void 0 : e.background) == null ? void 0 : L.length) === 1 && ((w = (u = (s = e == null ? void 0 : e.background) == null ? void 0 : s[0]) == null ? void 0 : u.color) == null ? void 0 : w.toUpperCase()) === "#FFFFFF01") && !!((f = e == null ? void 0 : e.videoBackground) != null && f.active) ? 0 : -1, { width: o, height: r } = $3(C);
  if (!((v = e == null ? void 0 : e.videoBackground) != null && v.active))
    return null;
  const l = o / r;
  let h, H;
  if (l > 1) {
    const x = 1.7777777777777777;
    h = o, H = o / x, H < r && (H = r, h = H * x);
  } else {
    const x = 1.7777777777777777;
    h = r * x, H = r, h < o && (h = o, H = h * x);
  }
  const V = (H - r) / 2, p = (h - o) / 2;
  return /* @__PURE__ */ t(
    C2,
    {
      url: (I = e == null ? void 0 : e.videoBackground) == null ? void 0 : I.src,
      muted: !0,
      loop: !0,
      playing: !0,
      width: `${h}px`,
      height: `${H}px`,
      className: U3.videoPlayer,
      playsinline: !0,
      style: {
        right: -Math.abs(p),
        bottom: -Math.abs(V),
        top: -Math.abs(V),
        left: -Math.abs(p),
        zIndex: n
      },
      config: {
        // https://developers.google.com/youtube/player_parameters?playerVersion=HTML5
        youtube: {
          playerVars: {
            showinfo: 0,
            controls: 0,
            modestbranding: 1,
            cc_load_policy: 0,
            disablekb: 1,
            iv_load_policy: 3
          }
        }
      }
    }
  );
};
function O3(C) {
  return C.getBoundingClientRect().top <= (window.innerHeight || document.documentElement.clientHeight);
}
function q3(C) {
  return {
    "data-aos": C == null ? void 0 : C.name,
    "data-aos-delay": (C == null ? void 0 : C.delay) || 0,
    "data-aos-duration": (C == null ? void 0 : C.duration) || 500,
    "data-aos-easing": C == null ? void 0 : C.ease,
    "data-aos-mirror": C == null ? void 0 : C.mirror,
    "data-aos-once": !(C != null && C.repeat)
    // "data-aos-offset": "100",
  };
}
function R1(C, e, i = "") {
  const n = J(), o = !!(C != null && C.name), r = q1(() => {
    n.current = setTimeout(() => {
      e.current && O3(e.current) && (e.current.className = `${i} aos-init aos-animate`);
    }, 1e3);
  }, []), l = q1(() => {
    n.current && clearTimeout(n.current);
  }, []);
  n1(() => {
    if (e.current)
      return e.current.className = `${i} aos-init`, r(), l;
  }, [C == null ? void 0 : C.name, C == null ? void 0 : C.ease]);
  const h = o ? q3(C) : {};
  return { ref: e, animationProps: h };
}
function D3(C) {
  const e = C == null ? void 0 : C.replace("#", ""), i = (e == null ? void 0 : e.length) === 3 ? e + e : e, n = parseInt(i == null ? void 0 : i.substring(6, 8), 16) || 255;
  return Math.round(n / 255 * 100) / 100;
}
function T3(C) {
  const e = C == null ? void 0 : C.replace("#", ""), i = (e == null ? void 0 : e.length) === 3 ? e + e : e, n = parseInt(i == null ? void 0 : i.substring(0, 2), 16), o = parseInt(i == null ? void 0 : i.substring(2, 4), 16), r = parseInt(i == null ? void 0 : i.substring(4, 6), 16), l = D3(C);
  return `rgba(${n}, ${o}, ${r}, ${l})`;
}
function G3(C) {
  const e = {};
  return C != null && (e.gap = C), e;
}
function j3(C) {
  const e = {};
  return (C == null ? void 0 : C.width) != null && (e.width = C == null ? void 0 : C.width), (C == null ? void 0 : C.height) != null && (e.height = C == null ? void 0 : C.height), C != null && C.fullWidth && (e.minWidth = "100vw"), C != null && C.fullHeight && (e.minHeight = "100vh"), e;
}
function N3(C) {
  const e = {};
  return (C == null ? void 0 : C.top) != null && (e.paddingTop = C.top), (C == null ? void 0 : C.right) != null && (e.paddingRight = C.right), (C == null ? void 0 : C.bottom) != null && (e.paddingBottom = C.bottom), (C == null ? void 0 : C.left) != null && (e.paddingLeft = C.left), e;
}
function S3(C) {
  const e = {};
  return (C == null ? void 0 : C.bottom) != null && (e.borderBottomStyle = C.bottom), (C == null ? void 0 : C.top) != null && (e.borderTopStyle = C.top), (C == null ? void 0 : C.right) != null && (e.borderRightStyle = C.right), (C == null ? void 0 : C.left) != null && (e.borderLeftStyle = C.left), e;
}
function z3(C) {
  const e = {};
  return (C == null ? void 0 : C.bottom) != null && (e.borderBottomWidth = C.bottom), (C == null ? void 0 : C.top) != null && (e.borderTopWidth = C.top), (C == null ? void 0 : C.right) != null && (e.borderRightWidth = C.right), (C == null ? void 0 : C.left) != null && (e.borderLeftWidth = C.left), e;
}
function P3(C) {
  const e = {};
  return (C == null ? void 0 : C.bottom) != null && (e.borderBottomColor = C.bottom), (C == null ? void 0 : C.top) != null && (e.borderTopColor = C.top), (C == null ? void 0 : C.left) != null && (e.borderLeftColor = C.left), (C == null ? void 0 : C.right) != null && (e.borderRightColor = C.right), e;
}
function Y3(C) {
  let e = {};
  return e = d(d(d({}, P3(C == null ? void 0 : C.borderColor)), z3(C == null ? void 0 : C.borderWidth)), S3(C == null ? void 0 : C.borderStyle)), e;
}
function J3(C) {
  const e = {};
  return (C == null ? void 0 : C.horizontal) != null && (e.justifyContent = C.vertical), (C == null ? void 0 : C.vertical) != null && (e.textAlign = C.horizontal), e;
}
function K3(C) {
  var i, n, o, r, l, h, H, V, p, a;
  const e = {};
  return (C == null ? void 0 : C.type) === _1.inner && (e.boxShadow = `${((i = C == null ? void 0 : C.innerShadow) == null ? void 0 : i.horizontalOffset) || 0}px ${((n = C == null ? void 0 : C.innerShadow) == null ? void 0 : n.verticalOffset) || 0}px ${((o = C == null ? void 0 : C.innerShadow) == null ? void 0 : o.blur) || 0}px ${((r = C == null ? void 0 : C.innerShadow) == null ? void 0 : r.spread) || 0}px ${((l = C == null ? void 0 : C.innerShadow) == null ? void 0 : l.color) || "#000000"} inset`), (C == null ? void 0 : C.type) === _1.outer && (e.boxShadow = `${((h = C == null ? void 0 : C.outerShadow) == null ? void 0 : h.horizontalOffset) || 0}px ${((H = C == null ? void 0 : C.outerShadow) == null ? void 0 : H.verticalOffset) || 0}px ${((V = C == null ? void 0 : C.outerShadow) == null ? void 0 : V.blur) || 0}px ${((p = C == null ? void 0 : C.outerShadow) == null ? void 0 : p.spread) || 0}px ${((a = C == null ? void 0 : C.outerShadow) == null ? void 0 : a.color) || "#000000"}`), e;
}
function X3(C) {
  return C ? `url(${C == null ? void 0 : C.src})` : "";
}
function h2(C) {
  if (!C)
    return "";
  const e = T3(C);
  return `linear-gradient(0deg,${e},${e})`;
}
function Q3(C) {
  return C != null && C.startColor ? `linear-gradient(${C == null ? void 0 : C.angle}deg,${C == null ? void 0 : C.startColor} ${C == null ? void 0 : C.startPosition}%,${C == null ? void 0 : C.endColor} ${C == null ? void 0 : C.endPosition}%)` : "";
}
function C7(C) {
  let e = {};
  const i = C == null ? void 0 : C.map((h) => {
    if ((h == null ? void 0 : h.type) === m.Color)
      return h2(h == null ? void 0 : h.color);
    if ((h == null ? void 0 : h.type) === m.Gradient)
      return Q3(h == null ? void 0 : h.gradient);
    if ((h == null ? void 0 : h.type) === m.Image)
      return X3(h == null ? void 0 : h.image);
  }), n = C == null ? void 0 : C.map((h) => {
    var H;
    if ((h == null ? void 0 : h.type) === m.Color || (h == null ? void 0 : h.type) === m.Gradient)
      return "center center";
    if ((h == null ? void 0 : h.type) === m.Image)
      return ((H = h == null ? void 0 : h.image) == null ? void 0 : H.position) || "center center";
  }), o = C == null ? void 0 : C.map((h) => {
    var H;
    if ((h == null ? void 0 : h.type) === m.Color || (h == null ? void 0 : h.type) === m.Gradient)
      return "cover";
    if ((h == null ? void 0 : h.type) === m.Image)
      return ((H = h == null ? void 0 : h.image) == null ? void 0 : H.size) || "cover";
  }), r = C == null ? void 0 : C.map((h) => {
    var H;
    if ((h == null ? void 0 : h.type) === m.Color || (h == null ? void 0 : h.type) === m.Gradient)
      return "no-repeat";
    if ((h == null ? void 0 : h.type) === m.Image)
      return ((H = h == null ? void 0 : h.image) == null ? void 0 : H.repeat) || "no-repeat";
  }), l = C == null ? void 0 : C.map((h) => {
    var H;
    if ((h == null ? void 0 : h.type) === m.Color || (h == null ? void 0 : h.type) === m.Gradient)
      return "scroll";
    if ((h == null ? void 0 : h.type) === m.Image)
      return ((H = h == null ? void 0 : h.image) == null ? void 0 : H.scrollEffect) || "scroll";
  });
  return e = {
    backgroundImage: i == null ? void 0 : i.join(", "),
    backgroundPosition: n == null ? void 0 : n.join(", "),
    backgroundSize: o == null ? void 0 : o.join(", "),
    backgroundRepeat: r == null ? void 0 : r.join(", "),
    backgroundAttachment: l == null ? void 0 : l.join(", ")
  }, e;
}
function t7(C) {
  const e = {};
  return (C == null ? void 0 : C.borderRadiusAll) != null && (e.borderRadius = C.borderRadiusAll), (C == null ? void 0 : C.borderBottomLeftRadius) != null && (e.borderBottomLeftRadius = C.borderBottomLeftRadius), (C == null ? void 0 : C.borderBottomRightRadius) != null && (e.borderBottomRightRadius = C.borderBottomRightRadius), (C == null ? void 0 : C.borderTopLeftRadius) != null && (e.borderTopLeftRadius = C.borderTopLeftRadius), (C == null ? void 0 : C.borderTopRightRadius) != null && (e.borderTopRightRadius = C.borderTopRightRadius), e;
}
function e7(C) {
  const e = {};
  if ((C == null ? void 0 : C.objectFit) != null) {
    const i = C == null ? void 0 : C.objectFit.toLowerCase();
    e.objectFit = i, e.width = "100%";
  }
  if ((C == null ? void 0 : C.objectFit) === l2.None && (e.width = "auto"), (C == null ? void 0 : C.size) != null) {
    const i = C == null ? void 0 : C.size.toLowerCase();
    e.backgroundSize = i;
  }
  if ((C == null ? void 0 : C.position) != null) {
    const i = C == null ? void 0 : C.position.toLowerCase();
    e.backgroundSize = i;
  }
  return e;
}
function h1(C) {
  var i, n, o, r, l;
  return d(d(d(d(d(d(d(d(d({}, G3(C == null ? void 0 : C.gap)), j3(C == null ? void 0 : C.layout)), N3((i = C == null ? void 0 : C.layout) == null ? void 0 : i.padding)), J3((n = C == null ? void 0 : C.layout) == null ? void 0 : n.alignment)), C7(C == null ? void 0 : C.background)), e7(C == null ? void 0 : C.image)), Y3((o = C == null ? void 0 : C.layout) == null ? void 0 : o.borders)), K3((r = C == null ? void 0 : C.layout) == null ? void 0 : r.shadow)), t7((l = C == null ? void 0 : C.layout) == null ? void 0 : l.borderRadius));
}
function i7(C) {
  var n, o, r, l;
  if (Array.isArray(C == null ? void 0 : C.background))
    return C;
  const e = C == null ? void 0 : C.background, i = [
    {
      id: `Background:${r1()}`,
      type: (n = e == null ? void 0 : e.meta) != null && n.hasImage ? m.Image : m.Color,
      color: e == null ? void 0 : e.color,
      image: Z(d({}, e == null ? void 0 : e.image), {
        repeat: B1["no-repeat"],
        position: y1["center center"],
        scrollEffect: L1.scroll,
        size: r2.Cover
      }),
      gradient: void 0
    }
  ];
  return (o = e == null ? void 0 : e.meta) != null && o.hasImage && ((r = e == null ? void 0 : e.meta) != null && r.hasOverlay) && i.unshift({
    id: `Background:${r1()}`,
    type: m.Color,
    color: (l = e == null ? void 0 : e.image) == null ? void 0 : l.overlay,
    image: void 0,
    gradient: void 0
  }), C.background = i, C;
}
function l7(C) {
  return C ? i7(C) : {};
}
const A1 = (C, e) => {
  var n;
  if (!e)
    return C;
  const i = (n = C == null ? void 0 : C.background) == null ? void 0 : n.map((o) => (o == null ? void 0 : o.type) === "Image" ? Z(d({}, o), {
    image: Z(d({}, o == null ? void 0 : o.image), {
      scrollEffect: L1.scroll
    })
  }) : o);
  return Z(d({}, C), {
    background: i
  });
}, $1 = () => {
  const [C, e] = z();
  return n1(() => {
    e(H3 && t2);
  }, []), C;
}, r7 = "_sectionContainer_1f6wa_1", h7 = {
  sectionContainer: r7
}, n7 = ({ settings: C, children: e }) => {
  const i = J(null), { animationProps: n } = R1(C == null ? void 0 : C.animation, i), o = $1(), r = l7(C), l = A1(r, o);
  return /* @__PURE__ */ c(
    "section",
    Z(d({
      "data-test": "SectionView",
      ref: i
    }, n), {
      style: Z(d({}, h1(l)), {
        display: "grid",
        alignItems: "center",
        position: "relative",
        overflow: "hidden"
      }),
      children: [
        /* @__PURE__ */ t(I1, { wrapperRef: i, settings: C }),
        /* @__PURE__ */ t("div", { className: `container ${o ? h7.sectionContainer : ""}`, children: e })
      ]
    })
  );
};
function o7(C) {
  var n, o, r, l;
  if (Array.isArray(C == null ? void 0 : C.background))
    return C;
  const e = C == null ? void 0 : C.background, i = [
    {
      id: `Background:${r1()}`,
      type: (n = e == null ? void 0 : e.meta) != null && n.hasImage ? m.Image : m.Color,
      color: e == null ? void 0 : e.color,
      image: Z(d({}, e == null ? void 0 : e.image), {
        repeat: B1["no-repeat"],
        position: y1["center center"],
        scrollEffect: L1.scroll
      }),
      gradient: void 0
    }
  ];
  return (o = e == null ? void 0 : e.meta) != null && o.hasImage && ((r = e == null ? void 0 : e.meta) != null && r.hasOverlay) && i.unshift({
    id: `Background:${r1()}`,
    type: m.Color,
    color: (l = e == null ? void 0 : e.image) == null ? void 0 : l.overlay,
    image: void 0,
    gradient: void 0
  }), C.background = i, C;
}
function H7(C) {
  return C ? o7(C) : {};
}
const a7 = "_column_1mtba_1", p7 = {
  column: a7
}, V7 = ({ column: C, children: e }) => {
  var h;
  const i = J(null), { animationProps: n } = R1(
    (h = C == null ? void 0 : C.settings) == null ? void 0 : h.animation,
    i,
    p7.column
  ), o = $1(), r = H7(C == null ? void 0 : C.settings), l = A1(r, o);
  return /* @__PURE__ */ c(
    "div",
    Z(d({
      id: C == null ? void 0 : C.id,
      "data-test": "ColumnView",
      ref: i
    }, n), {
      style: h1(l),
      children: [
        /* @__PURE__ */ t(I1, { wrapperRef: i, settings: C == null ? void 0 : C.settings }),
        e
      ]
    })
  );
}, n2 = 16;
function o2(C) {
  var i;
  return n2 / ((i = C == null ? void 0 : C.columns) == null ? void 0 : i.length);
}
function c7(C) {
  var n;
  const e = o2(C);
  return Array((n = C == null ? void 0 : C.columns) == null ? void 0 : n.length).fill(
    e
  );
}
function d7(C) {
  var o, r, l;
  const e = o2(C), i = c7(C);
  return (l = ((r = (o = C == null ? void 0 : C.settings) == null ? void 0 : o.layout) == null ? void 0 : r.gridTemplates) || i) == null ? void 0 : l.map(
    (h) => `minmax(0, calc(100% * ${h || e} / ${n2}))`
  );
}
const s7 = "_desktop_iyjbk_1", L7 = "_tablet_iyjbk_10", M7 = "_mobile_iyjbk_19", Z7 = "_overlay_iyjbk_28", w7 = "_row_iyjbk_37", f7 = {
  desktop: s7,
  tablet: L7,
  mobile: M7,
  overlay: Z7,
  row: w7
}, u7 = ({ row: C, children: e, isLastRow: i }) => {
  var p, a, L;
  const n = d7(C), o = (a = (p = C == null ? void 0 : C.settings) == null ? void 0 : p.layout) == null ? void 0 : a.fullWidth, r = T(f7.row, "CustomSection_RowView"), l = $1(), h = A1(
    C == null ? void 0 : C.settings,
    l
  ), H = J(null), { animationProps: V } = R1(
    (L = C.settings) == null ? void 0 : L.animation,
    H,
    r
  );
  return /* @__PURE__ */ c(
    "div",
    Z(d({
      id: C == null ? void 0 : C.id,
      "data-test": "RowView",
      ref: H
    }, V), {
      style: Z(d({}, h1(h)), {
        "--gridColumnTemplates": n == null ? void 0 : n.join(" "),
        "--marginBottom": i ? "0" : "40px",
        width: o ? "100vw" : "",
        maxWidth: o ? "100vw" : "",
        marginInline: o ? "calc(-50vw + 50%)" : ""
      }),
      children: [
        /* @__PURE__ */ t(I1, { wrapperRef: H, settings: C == null ? void 0 : C.settings }),
        e
      ]
    })
  );
}, k7 = "_element_1c7zx_1", g7 = {
  element: k7
}, x7 = ({
  sectionId: C,
  rowId: e,
  columnId: i,
  sectionValueId: n,
  element: o,
  column: r,
  row: l,
  section: h,
  wuiltContext: H,
  Component: V,
  text: p
}) => /* @__PURE__ */ t("div", { "data-test": "ElementView", className: g7.element, children: /* @__PURE__ */ t(
  V,
  {
    element: o,
    column: r,
    row: l,
    section: h,
    wuiltContext: H,
    sectionId: C,
    rowId: e,
    columnId: i,
    sectionValueId: n,
    text: p
  }
) }), v7 = "_desktop_qcg8m_1", _7 = "_tablet_qcg8m_10", b7 = "_mobile_qcg8m_19", f1 = {
  desktop: v7,
  tablet: _7,
  mobile: b7
}, m7 = "_desktop_1ry7l_1", y7 = "_tablet_1ry7l_10", B7 = "_mobile_1ry7l_19", F7 = "_overlay_1ry7l_28", D1 = {
  desktop: m7,
  tablet: y7,
  mobile: B7,
  overlay: F7
}, I7 = ({
  element: C,
  className: e,
  aspectRatio: i,
  Component: n,
  linkProps: o,
  handleClick: r
}) => {
  var a, L, s, u, w, f, v, I, x, b, A, F, y, R, B;
  const l = C == null ? void 0 : C.settings, h = (L = (a = l == null ? void 0 : l.desktop) == null ? void 0 : a.crop) != null && L.backgroundPosition ? `${(u = (s = l == null ? void 0 : l.desktop) == null ? void 0 : s.crop) == null ? void 0 : u.backgroundPosition.x}% ${(f = (w = l == null ? void 0 : l.desktop) == null ? void 0 : w.crop) == null ? void 0 : f.backgroundPosition.y}%` : "center center", H = (I = (v = l == null ? void 0 : l.desktop) == null ? void 0 : v.crop) != null && I.backgroundSize ? `${(b = (x = l == null ? void 0 : l.desktop) == null ? void 0 : x.crop) == null ? void 0 : b.backgroundSize.x}% ${(F = (A = l == null ? void 0 : l.desktop) == null ? void 0 : A.crop) == null ? void 0 : F.backgroundSize.y}%` : "cover", V = h2((y = l == null ? void 0 : l.desktop) == null ? void 0 : y.overlay), p = V ? `${V},` : "";
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ t(
      n,
      Z(d({
        id: C.id,
        "data-test": "ImageView",
        className: e,
        onClick: r
      }, o), {
        style: {
          display: "block",
          aspectRatio: i || ((R = l == null ? void 0 : l.desktop) == null ? void 0 : R.aspect) || 1,
          backgroundImage: `${p} url('${(B = l.desktop) == null ? void 0 : B.src}')`,
          backgroundRepeat: "no-repeat no-repeat",
          backgroundPosition: h,
          backgroundSize: H
        }
      })
    )
  );
}, R7 = ({
  stopAction: C,
  element: e,
  wuiltContext: i,
  asBackground: n,
  aspectRatio: o,
  customClassName: r
}) => {
  var I, x, b, A;
  const [l, h] = z(""), H = e == null ? void 0 : e.settings, V = i == null ? void 0 : i.base, p = (V == null ? void 0 : V.Image) || "img", a = i == null ? void 0 : i.elements, L = a == null ? void 0 : a.ImageLightBox, s = G1(V, H, "desktop"), u = G1(V, H, "mobile"), w = () => {
    var F, y, R, B;
    C || ((y = (F = H == null ? void 0 : H.desktop) == null ? void 0 : F.action) == null ? void 0 : y.type) === (U == null ? void 0 : U.Scale_Up) && h(((R = H == null ? void 0 : H.desktop) == null ? void 0 : R.src) || ((B = H == null ? void 0 : H.mobile) == null ? void 0 : B.src) || "");
  }, f = () => {
    var F, y, R, B;
    C || ((y = (F = H == null ? void 0 : H.mobile) == null ? void 0 : F.action) == null ? void 0 : y.type) === (U == null ? void 0 : U.Scale_Up) && h(((R = H == null ? void 0 : H.mobile) == null ? void 0 : R.src) || ((B = H == null ? void 0 : H.desktop) == null ? void 0 : B.src) || "");
  };
  if (n)
    return /* @__PURE__ */ c(Q1, { children: [
      /* @__PURE__ */ t(
        L,
        {
          onClose: () => h(""),
          imageUrl: ((I = H == null ? void 0 : H.desktop) == null ? void 0 : I.src) || ((x = H == null ? void 0 : H.mobile) == null ? void 0 : x.src),
          isOpen: l
        }
      ),
      /* @__PURE__ */ t(
        I7,
        {
          element: e,
          aspectRatio: o,
          className: r,
          handleClick: w,
          Component: s || u,
          linkProps: u1(H, "desktop", C)
        }
      )
    ] });
  const v = {
    height: "auto",
    maxHeight: "400px"
  };
  return /* @__PURE__ */ c(
    "div",
    {
      id: e == null ? void 0 : e.id,
      "data-test": "ImageView",
      className: r,
      style: { position: "relative", overflow: "hidden" },
      children: [
        /* @__PURE__ */ c(
          u,
          Z(d(d({}, N1("mobile")), u1(H, "mobile", C)), {
            onClick: f,
            children: [
              /* @__PURE__ */ t(
                "div",
                {
                  className: D1.overlay,
                  style: { backgroundColor: (b = H == null ? void 0 : H.mobile) == null ? void 0 : b.overlay }
                }
              ),
              /* @__PURE__ */ t(
                p,
                Z(d({}, j1(H, "mobile")), {
                  style: d(d({}, v), h1({ image: S1(H, "mobile") }))
                })
              )
            ]
          })
        ),
        /* @__PURE__ */ c(
          s,
          Z(d(d({}, N1("desktop")), u1(H, "desktop", C)), {
            onClick: w,
            children: [
              /* @__PURE__ */ t(
                "div",
                {
                  className: D1.overlay,
                  style: { backgroundColor: (A = H == null ? void 0 : H.desktop) == null ? void 0 : A.overlay }
                }
              ),
              /* @__PURE__ */ t(
                p,
                Z(d({}, j1(H, "desktop")), {
                  style: d(d({}, v), h1({ image: S1(H, "desktop") }))
                })
              )
            ]
          })
        ),
        /* @__PURE__ */ t(
          L,
          {
            onClose: () => h(""),
            imageUrl: l,
            isOpen: !!l
          }
        )
      ]
    }
  );
};
function T1(C, e, i) {
  var r;
  if (i)
    return {};
  const n = (r = C == null ? void 0 : C[e]) == null ? void 0 : r.action, o = n != null && n.newTab ? "_blank" : void 0;
  return (n == null ? void 0 : n.type) === U.External_Link ? { href: n == null ? void 0 : n.value, target: o } : (n == null ? void 0 : n.type) === U.Internal_Link ? { page: { id: n == null ? void 0 : n.value }, href: "#", target: o } : {};
}
function G1(C, e, i) {
  var r, l, h, H;
  const n = C == null ? void 0 : C.Link, o = C == null ? void 0 : C.PageLink;
  return ((l = (r = e == null ? void 0 : e[i]) == null ? void 0 : r.action) == null ? void 0 : l.type) === U.Internal_Link ? o : ((H = (h = e == null ? void 0 : e[i]) == null ? void 0 : h.action) == null ? void 0 : H.type) === U.External_Link ? n : "span";
}
const A7 = "https://s3.eu-central-1.amazonaws.com/assets.wuiltsites.canary/272668/11232022120331637e0c131e329.png";
function j1(C, e) {
  var n, o, r, l, h, H;
  const i = e === "desktop" ? "mobile" : "desktop";
  return {
    src: ((n = C == null ? void 0 : C[e]) == null ? void 0 : n.src) || ((o = C == null ? void 0 : C[i]) == null ? void 0 : o.src) || A7,
    alt: ((r = C == null ? void 0 : C[e]) == null ? void 0 : r.alt) || ((l = C == null ? void 0 : C[i]) == null ? void 0 : l.alt),
    title: ((h = C == null ? void 0 : C[e]) == null ? void 0 : h.alt) || ((H = C == null ? void 0 : C[i]) == null ? void 0 : H.alt)
  };
}
function u1(C, e, i = !1) {
  const n = e === "desktop" ? "mobile" : "desktop", o = T1(C, e, i), r = T1(C, n, i);
  return {
    page: (o == null ? void 0 : o.page) || (r == null ? void 0 : r.page),
    target: (o == null ? void 0 : o.target) || (r == null ? void 0 : r.target),
    href: (o == null ? void 0 : o.href) || (r == null ? void 0 : r.href)
  };
}
function N1(C) {
  return {
    className: f1 == null ? void 0 : f1[C]
  };
}
function S1(C, e) {
  var n, o;
  const i = e === "desktop" ? "mobile" : "desktop";
  return Z(d({}, C), {
    objectFit: ((n = C == null ? void 0 : C[e]) == null ? void 0 : n.objectFit) || ((o = C == null ? void 0 : C[i]) == null ? void 0 : o.objectFit)
  });
}
const $7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "132",
    height: "44",
    viewBox: "0 0 132 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "131", height: "43", rx: "6.5", fill: "white" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M89.6793 21.1211V23.6413H88.0997V25.2939H89.6793V30.9094C89.6793 32.8269 90.5468 33.5939 92.729 33.5939C93.1125 33.5939 93.4778 33.5482 93.7973 33.4935V31.859C93.5234 31.8864 93.3499 31.9047 93.0486 31.9047C92.0716 31.9047 91.6425 31.4481 91.6425 30.4072V25.2939H93.7973V23.6413H91.6425V21.1211H89.6793Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M99.3566 33.7309C102.26 33.7309 104.041 31.786 104.041 28.5628C104.041 25.3579 102.251 23.4039 99.3566 23.4039C96.453 23.4039 94.6633 25.3579 94.6633 28.5628C94.6633 31.786 96.4438 33.7309 99.3566 33.7309ZM99.3566 31.9869C97.6491 31.9869 96.6904 30.7359 96.6904 28.5628C96.6904 26.4079 97.6491 25.1479 99.3566 25.1479C101.055 25.1479 102.023 26.4079 102.023 28.5628C102.023 30.7268 101.055 31.9869 99.3566 31.9869Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M105.564 33.5391H107.527V27.668C107.527 26.2709 108.577 25.3305 110.066 25.3305C110.413 25.3305 110.997 25.3944 111.161 25.4492V23.5134C110.951 23.4586 110.577 23.4312 110.285 23.4312C108.988 23.4312 107.883 24.1435 107.6 25.1205H107.454V23.5956H105.564V33.5391Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M116.036 25.0748C117.488 25.0748 118.437 26.0883 118.483 27.6497H113.461C113.57 26.0975 114.584 25.0748 116.036 25.0748ZM118.474 30.8546C118.108 31.6308 117.296 32.0599 116.109 32.0599C114.538 32.0599 113.525 30.9551 113.461 29.2111V29.1015H120.482V28.4167C120.482 25.2939 118.812 23.4039 116.045 23.4039C113.242 23.4039 111.461 25.4218 111.461 28.5993C111.461 31.7769 113.205 33.7309 116.054 33.7309C118.328 33.7309 119.916 32.6352 120.364 30.8546H118.474Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M76.8054 29.8671C76.9568 32.3088 78.9915 33.8703 82.02 33.8703C85.2566 33.8703 87.2819 32.2331 87.2819 29.6211C87.2819 27.5674 86.1273 26.4317 83.326 25.7787L81.8212 25.4096C80.042 24.9932 79.3228 24.4349 79.3228 23.4601C79.3228 22.2298 80.4395 21.4254 82.1146 21.4254C83.7045 21.4254 84.8024 22.2109 85.0011 23.4696H87.0642C86.9412 21.1698 84.9159 19.5515 82.143 19.5515C79.1619 19.5515 77.1745 21.1698 77.1745 23.602C77.1745 25.6084 78.3007 26.8008 80.7707 27.3781L82.531 27.804C84.3386 28.2299 85.1336 28.8545 85.1336 29.8955C85.1336 31.1069 83.8844 31.987 82.1809 31.987C80.3543 31.987 79.0862 31.1637 78.9064 29.8671H76.8054Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M56.4693 23.4312C55.118 23.4312 53.9492 24.1069 53.3466 25.2392H53.2005V23.5956H51.3104V36.8445H53.2735V32.0325H53.4287C53.9492 33.0826 55.0723 33.7035 56.4876 33.7035C58.9986 33.7035 60.5965 31.7221 60.5965 28.5628C60.5965 25.4035 58.9986 23.4312 56.4693 23.4312ZM55.9123 31.9412C54.2688 31.9412 53.237 30.6446 53.237 28.5719C53.237 26.4901 54.2688 25.1935 55.9215 25.1935C57.5833 25.1935 58.5785 26.4627 58.5785 28.5628C58.5785 30.672 57.5833 31.9412 55.9123 31.9412Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M67.4658 23.4312C66.1144 23.4312 64.9457 24.1069 64.343 25.2392H64.1969V23.5956H62.3069V36.8445H64.27V32.0325H64.4252C64.9457 33.0826 66.0688 33.7035 67.4841 33.7035C69.995 33.7035 71.5929 31.7221 71.5929 28.5628C71.5929 25.4035 69.995 23.4312 67.4658 23.4312ZM66.9088 31.9412C65.2653 31.9412 64.2335 30.6446 64.2335 28.5719C64.2335 26.4901 65.2653 25.1935 66.9179 25.1935C68.5798 25.1935 69.575 26.4627 69.575 28.5628C69.575 30.672 68.5798 31.9412 66.9088 31.9412Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M47.7882 33.5391H50.0406L45.1099 19.8827H42.8291L37.8984 33.5391H40.0751L41.3338 29.9144H46.5389L47.7882 33.5391ZM43.8607 22.3623H44.0216L45.9995 28.1352H41.8733L43.8607 22.3623Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M39.2148 9.58196V16.1699H41.5934C43.5566 16.1699 44.6934 14.96 44.6934 12.8554C44.6934 10.7827 43.5474 9.58196 41.5934 9.58196H39.2148ZM40.2375 10.5133H41.4793C42.8444 10.5133 43.6524 11.3807 43.6524 12.8691C43.6524 14.3802 42.8581 15.2385 41.4793 15.2385H40.2375V10.5133Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M48.175 16.2657C49.6268 16.2657 50.517 15.2933 50.517 13.6817C50.517 12.0792 49.6222 11.1022 48.175 11.1022C46.7232 11.1022 45.8283 12.0792 45.8283 13.6817C45.8283 15.2933 46.7186 16.2657 48.175 16.2657ZM48.175 15.3937C47.3212 15.3937 46.8419 14.7683 46.8419 13.6817C46.8419 12.6043 47.3212 11.9742 48.175 11.9742C49.0241 11.9742 49.5081 12.6043 49.5081 13.6817C49.5081 14.7637 49.0241 15.3937 48.175 15.3937Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M58.0984 11.1981H57.1168L56.2311 14.992H56.1535L55.1308 11.1981H54.1904L53.1677 14.992H53.0947L52.2044 11.1981H51.2091L52.5788 16.1699H53.5877L54.6104 12.5084H54.688L55.7152 16.1699H56.7333L58.0984 11.1981Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M59.2288 16.1699H60.2103V13.2617C60.2103 12.4856 60.6715 12.0016 61.3974 12.0016C62.1233 12.0016 62.4702 12.3988 62.4702 13.1978V16.1699H63.4518V12.9512C63.4518 11.7688 62.84 11.1022 61.7306 11.1022C60.9819 11.1022 60.4888 11.4355 60.2469 11.9879H60.1738V11.1981H59.2288V16.1699Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M64.9977 16.1699H65.9792V9.25781H64.9977V16.1699Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M69.6708 16.2657C71.1226 16.2657 72.0129 15.2933 72.0129 13.6817C72.0129 12.0792 71.1181 11.1022 69.6708 11.1022C68.219 11.1022 67.3242 12.0792 67.3242 13.6817C67.3242 15.2933 68.2145 16.2657 69.6708 16.2657ZM69.6708 15.3937C68.8171 15.3937 68.3377 14.7683 68.3377 13.6817C68.3377 12.6043 68.8171 11.9742 69.6708 11.9742C70.52 11.9742 71.0039 12.6043 71.0039 13.6817C71.0039 14.7637 70.52 15.3937 69.6708 15.3937Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M74.9375 15.4257C74.4034 15.4257 74.0153 15.1655 74.0153 14.7181C74.0153 14.2798 74.3257 14.0469 75.0106 14.0013L76.225 13.9237V14.3391C76.225 14.9555 75.6771 15.4257 74.9375 15.4257ZM74.6864 16.2521C75.3393 16.2521 75.8825 15.969 76.1793 15.4714H76.2569V16.1699H77.202V12.7732C77.202 11.7231 76.4989 11.1022 75.2525 11.1022C74.1249 11.1022 73.3213 11.6501 73.2209 12.5038H74.1705C74.2801 12.1523 74.659 11.9514 75.2069 11.9514C75.878 11.9514 76.225 12.2482 76.225 12.7732V13.2023L74.8782 13.28C73.6957 13.353 73.0292 13.8689 73.0292 14.7637C73.0292 15.6722 73.7277 16.2521 74.6864 16.2521Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M80.5329 16.2521C81.2177 16.2521 81.7975 15.9279 82.0943 15.3846H82.1719V16.1699H83.1124V9.25781H82.1308V11.9879H82.0578C81.7884 11.4401 81.2131 11.1159 80.5329 11.1159C79.2774 11.1159 78.4693 12.1112 78.4693 13.6817C78.4693 15.2568 79.2683 16.2521 80.5329 16.2521ZM80.8114 11.9971C81.6332 11.9971 82.1491 12.6499 82.1491 13.6863C82.1491 14.7272 81.6377 15.3709 80.8114 15.3709C79.9805 15.3709 79.4828 14.7363 79.4828 13.6817C79.4828 12.6362 79.985 11.9971 80.8114 11.9971Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M89.4775 16.2657C90.9293 16.2657 91.8196 15.2933 91.8196 13.6817C91.8196 12.0792 90.9247 11.1022 89.4775 11.1022C88.0257 11.1022 87.1309 12.0792 87.1309 13.6817C87.1309 15.2933 88.0211 16.2657 89.4775 16.2657ZM89.4775 15.3937C88.6238 15.3937 88.1444 14.7683 88.1444 13.6817C88.1444 12.6043 88.6238 11.9742 89.4775 11.9742C90.3267 11.9742 90.8106 12.6043 90.8106 13.6817C90.8106 14.7637 90.3267 15.3937 89.4775 15.3937Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M93.1189 16.1699H94.1004V13.2617C94.1004 12.4856 94.5616 12.0016 95.2875 12.0016C96.0134 12.0016 96.3603 12.3988 96.3603 13.1978V16.1699H97.3419V12.9512C97.3419 11.7688 96.7301 11.1022 95.6207 11.1022C94.872 11.1022 94.3789 11.4355 94.137 11.9879H94.0639V11.1981H93.1189V16.1699Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M101.863 9.96089V11.2209H101.073V12.0473H101.863V14.855C101.863 15.8138 102.296 16.1973 103.387 16.1973C103.579 16.1973 103.762 16.1744 103.922 16.147V15.3298C103.785 15.3435 103.698 15.3527 103.547 15.3527C103.059 15.3527 102.844 15.1244 102.844 14.6039V12.0473H103.922V11.2209H102.844V9.96089H101.863Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M105.239 16.1699H106.221V13.2663C106.221 12.513 106.668 12.0062 107.472 12.0062C108.166 12.0062 108.535 12.408 108.535 13.2023V16.1699H109.517V12.9604C109.517 11.7779 108.864 11.1068 107.805 11.1068C107.056 11.1068 106.531 11.4401 106.289 11.9971H106.212V9.25781H105.239V16.1699Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M113.058 11.9377C113.784 11.9377 114.259 12.4445 114.281 13.2252H111.77C111.825 12.449 112.332 11.9377 113.058 11.9377ZM114.277 14.8276C114.094 15.2157 113.688 15.4303 113.094 15.4303C112.309 15.4303 111.802 14.8779 111.77 14.0059V13.9511H115.281V13.6087C115.281 12.0473 114.446 11.1022 113.062 11.1022C111.661 11.1022 110.771 12.1112 110.771 13.7C110.771 15.2887 111.643 16.2657 113.067 16.2657C114.204 16.2657 114.998 15.7179 115.222 14.8276H114.277Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M27.2458 22.3309C27.2696 20.4818 28.2627 18.7322 29.838 17.7637C28.8442 16.3443 27.1796 15.4444 25.4477 15.3902C23.6006 15.1963 21.8098 16.4955 20.8685 16.4955C19.909 16.4955 18.4598 15.4095 16.8992 15.4416C14.865 15.5073 12.9687 16.6638 11.979 18.4422C9.85158 22.1255 11.4384 27.5386 13.4763 30.5159C14.4959 31.9738 15.6875 33.6023 17.2467 33.5445C18.7725 33.4813 19.3423 32.5716 21.184 32.5716C23.0087 32.5716 23.5433 33.5445 25.1341 33.5078C26.7714 33.4813 27.8029 32.0435 28.7867 30.5718C29.5193 29.533 30.083 28.3849 30.457 27.17C28.5329 26.3562 27.248 24.42 27.2458 22.3309Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M24.241 13.4322C25.1336 12.3606 25.5734 10.9832 25.4669 9.59253C24.1031 9.73577 22.8433 10.3876 21.9386 11.4181C21.0539 12.425 20.5935 13.7781 20.6805 15.1156C22.0448 15.1297 23.386 14.4955 24.241 13.4322Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "131", height: "43", rx: "6.5", stroke: "black" })
    ]
  }
), E7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "120",
    height: "40",
    viewBox: "0 0 120 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "119", height: "39", rx: "6.5", fill: "white" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M81.5267 19.2009V21.4919H80.0906V22.9943H81.5267V28.0993C81.5267 29.8425 82.3152 30.5397 84.2991 30.5397C84.6478 30.5397 84.9798 30.4982 85.2703 30.4484V28.9626C85.0213 28.9875 84.8636 29.0041 84.5896 29.0041C83.7015 29.0041 83.3113 28.589 83.3113 27.6428V22.9943H85.2703V21.4919H83.3113V19.2009H81.5267Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M90.3242 30.6642C92.9638 30.6642 94.5825 28.8962 94.5825 25.966C94.5825 23.0524 92.9555 21.2761 90.3242 21.2761C87.6845 21.2761 86.0576 23.0524 86.0576 25.966C86.0576 28.8962 87.6762 30.6642 90.3242 30.6642ZM90.3242 29.0788C88.7719 29.0788 87.9003 27.9416 87.9003 25.966C87.9003 24.007 88.7719 22.8615 90.3242 22.8615C91.8681 22.8615 92.748 24.007 92.748 25.966C92.748 27.9333 91.8681 29.0788 90.3242 29.0788Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M95.9674 30.4899H97.752V25.1525C97.752 23.8825 98.7066 23.0275 100.06 23.0275C100.375 23.0275 100.906 23.0856 101.056 23.1354V21.3757C100.865 21.3259 100.524 21.301 100.259 21.301C99.0802 21.301 98.0758 21.9484 97.8184 22.8366H97.6856V21.4504H95.9674V30.4899Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M105.487 22.7951C106.807 22.7951 107.67 23.7165 107.712 25.1359H103.146C103.246 23.7248 104.167 22.7951 105.487 22.7951ZM107.703 28.0495C107.371 28.7551 106.633 29.1452 105.553 29.1452C104.126 29.1452 103.204 28.1408 103.146 26.5554V26.4557H109.53V25.8332C109.53 22.9943 108.01 21.2761 105.495 21.2761C102.947 21.2761 101.328 23.1105 101.328 25.9992C101.328 28.8879 102.914 30.6642 105.504 30.6642C107.571 30.6642 109.015 29.6681 109.422 28.0495H107.703Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M69.8231 27.1518C69.9607 29.3715 71.8105 30.791 74.5636 30.791C77.506 30.791 79.3472 29.3026 79.3472 26.9281C79.3472 25.0611 78.2975 24.0287 75.7509 23.435L74.3829 23.0995C72.7655 22.7209 72.1116 22.2133 72.1116 21.3272C72.1116 20.2087 73.1268 19.4774 74.6497 19.4774C76.095 19.4774 77.093 20.1915 77.2737 21.3358H79.1493C79.0374 19.2451 77.1963 17.7739 74.6755 17.7739C71.9654 17.7739 70.1586 19.2451 70.1586 21.4562C70.1586 23.2802 71.1824 24.3642 73.4279 24.889L75.0282 25.2762C76.6715 25.6634 77.3942 26.2312 77.3942 27.1776C77.3942 28.2788 76.2585 29.0789 74.7099 29.0789C73.0494 29.0789 71.8965 28.3304 71.7331 27.1518H69.8231Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M51.3357 21.301C50.1072 21.301 49.0447 21.9152 48.4969 22.9445H48.3641V21.4504H46.6458V33.4948H48.4305V29.1203H48.5716C49.0447 30.0749 50.0657 30.6393 51.3523 30.6393C53.6351 30.6393 55.0877 28.8381 55.0877 25.966C55.0877 23.0939 53.6351 21.301 51.3357 21.301ZM50.8294 29.0373C49.3353 29.0373 48.3973 27.8586 48.3973 25.9743C48.3973 24.0817 49.3353 22.903 50.8377 22.903C52.3484 22.903 53.2532 24.0568 53.2532 25.966C53.2532 27.8835 52.3484 29.0373 50.8294 29.0373Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M61.3325 21.301C60.104 21.301 59.0415 21.9152 58.4937 22.9445H58.3609V21.4504H56.6426V33.4948H58.4273V29.1203H58.5684C59.0415 30.0749 60.0625 30.6393 61.3491 30.6393C63.6319 30.6393 65.0845 28.8381 65.0845 25.966C65.0845 23.0939 63.6319 21.301 61.3325 21.301ZM60.8262 29.0373C59.3321 29.0373 58.3941 27.8586 58.3941 25.9743C58.3941 24.0817 59.3321 22.903 60.8345 22.903C62.3452 22.903 63.25 24.0568 63.25 25.966C63.25 27.8835 62.3452 29.0373 60.8262 29.0373Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M43.4438 30.4899H45.4914L41.009 18.075H38.9356L34.4531 30.4899H36.4319L37.5762 27.1948H42.3081L43.4438 30.4899ZM39.8733 20.3292H40.0196L41.8177 25.5773H38.0666L39.8733 20.3292Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M35.6523 8.71094V14.7H37.8147C39.5994 14.7 40.6328 13.6001 40.6328 11.6868C40.6328 9.80249 39.5911 8.71094 37.8147 8.71094H35.6523ZM36.582 9.55762H37.7109C38.9519 9.55762 39.6865 10.3462 39.6865 11.6992C39.6865 13.073 38.9644 13.8533 37.7109 13.8533H36.582V9.55762Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M43.7979 14.7871C45.1177 14.7871 45.9271 13.9031 45.9271 12.438C45.9271 10.9812 45.1136 10.093 43.7979 10.093C42.4781 10.093 41.6646 10.9812 41.6646 12.438C41.6646 13.9031 42.4739 14.7871 43.7979 14.7871ZM43.7979 13.9944C43.0218 13.9944 42.586 13.4258 42.586 12.438C42.586 11.4585 43.0218 10.8857 43.7979 10.8857C44.5699 10.8857 45.0098 11.4585 45.0098 12.438C45.0098 13.4216 44.5699 13.9944 43.7979 13.9944Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M52.8192 10.1802H51.9269L51.1217 13.6292H51.0511L50.1214 10.1802H49.2665L48.3368 13.6292H48.2704L47.461 10.1802H46.5562L47.8014 14.7H48.7186L49.6483 11.3713H49.7188L50.6527 14.7H51.5782L52.8192 10.1802Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M53.8468 14.7H54.7392V12.0562C54.7392 11.3506 55.1583 10.9106 55.8183 10.9106C56.4782 10.9106 56.7936 11.2717 56.7936 11.998V14.7H57.6859V11.7739C57.6859 10.699 57.1298 10.093 56.1212 10.093C55.4406 10.093 54.9923 10.396 54.7724 10.8982H54.706V10.1802H53.8468V14.7Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t("path", { d: "M59.0913 14.7H59.9836V8.41626H59.0913V14.7Z", fill: "black" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M63.3396 14.7871C64.6594 14.7871 65.4688 13.9031 65.4688 12.438C65.4688 10.9812 64.6553 10.093 63.3396 10.093C62.0198 10.093 61.2063 10.9812 61.2063 12.438C61.2063 13.9031 62.0156 14.7871 63.3396 14.7871ZM63.3396 13.9944C62.5635 13.9944 62.1277 13.4258 62.1277 12.438C62.1277 11.4585 62.5635 10.8857 63.3396 10.8857C64.1116 10.8857 64.5515 11.4585 64.5515 12.438C64.5515 13.4216 64.1116 13.9944 63.3396 13.9944Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M68.1275 14.0234C67.6419 14.0234 67.2891 13.7869 67.2891 13.3801C67.2891 12.9817 67.5713 12.77 68.1939 12.7285L69.2979 12.658V13.0356C69.2979 13.5959 68.7999 14.0234 68.1275 14.0234ZM67.8992 14.7747C68.4927 14.7747 68.9866 14.5173 69.2564 14.0649H69.327V14.7H70.1861V11.6121C70.1861 10.6575 69.5469 10.093 68.4139 10.093C67.3887 10.093 66.6583 10.5911 66.5669 11.3672H67.4302C67.5298 11.0476 67.8743 10.865 68.3724 10.865C68.9825 10.865 69.2979 11.1348 69.2979 11.6121V12.0022L68.0735 12.0728C66.9986 12.1392 66.3926 12.6082 66.3926 13.4216C66.3926 14.2476 67.0276 14.7747 67.8992 14.7747Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M73.2142 14.7747C73.8368 14.7747 74.3639 14.48 74.6336 13.9861H74.7042V14.7H75.5592V8.41626H74.6668V10.8982H74.6004C74.3556 10.4001 73.8326 10.1055 73.2142 10.1055C72.0728 10.1055 71.3382 11.0103 71.3382 12.438C71.3382 13.8699 72.0645 14.7747 73.2142 14.7747ZM73.4674 10.9065C74.2145 10.9065 74.6834 11.5 74.6834 12.4421C74.6834 13.3884 74.2186 13.9736 73.4674 13.9736C72.712 13.9736 72.2596 13.3967 72.2596 12.438C72.2596 11.4875 72.7162 10.9065 73.4674 10.9065Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M81.3457 14.7871C82.6655 14.7871 83.4748 13.9031 83.4748 12.438C83.4748 10.9812 82.6613 10.093 81.3457 10.093C80.0258 10.093 79.2124 10.9812 79.2124 12.438C79.2124 13.9031 80.0217 14.7871 81.3457 14.7871ZM81.3457 13.9944C80.5695 13.9944 80.1337 13.4258 80.1337 12.438C80.1337 11.4585 80.5695 10.8857 81.3457 10.8857C82.1176 10.8857 82.5576 11.4585 82.5576 12.438C82.5576 13.4216 82.1176 13.9944 81.3457 13.9944Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M84.656 14.7H85.5483V12.0562C85.5483 11.3506 85.9675 10.9106 86.6274 10.9106C87.2874 10.9106 87.6028 11.2717 87.6028 11.998V14.7H88.4951V11.7739C88.4951 10.699 87.939 10.093 86.9304 10.093C86.2498 10.093 85.8015 10.396 85.5815 10.8982H85.5151V10.1802H84.656V14.7Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M92.6048 9.05542V10.2009H91.8868V10.9521H92.6048V13.5046C92.6048 14.3762 92.9991 14.7249 93.9911 14.7249C94.1654 14.7249 94.3314 14.7041 94.4767 14.6792V13.9363C94.3521 13.9487 94.2733 13.957 94.1363 13.957C93.6922 13.957 93.4972 13.7495 93.4972 13.2764V10.9521H94.4767V10.2009H93.4972V9.05542H92.6048Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M95.6745 14.7H96.5668V12.0603C96.5668 11.3755 96.9735 10.9148 97.704 10.9148C98.3349 10.9148 98.671 11.28 98.671 12.0022V14.7H99.5634V11.7822C99.5634 10.7073 98.9699 10.0972 98.007 10.0972C97.3263 10.0972 96.849 10.4001 96.6291 10.9065H96.5585V8.41626H95.6745V14.7Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M102.782 10.8525C103.442 10.8525 103.874 11.3132 103.895 12.0229H101.612C101.662 11.3174 102.123 10.8525 102.782 10.8525ZM103.891 13.4797C103.725 13.8325 103.355 14.0276 102.816 14.0276C102.102 14.0276 101.641 13.5254 101.612 12.7327V12.6829H104.804V12.3716C104.804 10.9521 104.044 10.093 102.787 10.093C101.512 10.093 100.703 11.0103 100.703 12.4546C100.703 13.8989 101.496 14.7871 102.791 14.7871C103.824 14.7871 104.546 14.2891 104.75 13.4797H103.891Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M24.77 20.3008C24.7916 18.6198 25.6944 17.0292 27.1265 16.1488C26.2231 14.8584 24.7098 14.0403 23.1354 13.9911C21.4561 13.8148 19.8282 14.9959 18.9725 14.9959C18.1002 14.9959 16.7827 14.0086 15.364 14.0378C13.5147 14.0975 11.7907 15.1489 10.891 16.7656C8.95705 20.1141 10.3996 25.0351 12.2522 27.7417C13.1791 29.0671 14.2624 30.5475 15.6799 30.495C17.0669 30.4375 17.585 29.6105 19.2593 29.6105C20.918 29.6105 21.4041 30.495 22.8503 30.4616C24.3387 30.4375 25.2764 29.1304 26.1708 27.7925C26.8368 26.8481 27.3492 25.8044 27.6892 24.7C25.9401 23.9602 24.772 22.2 24.77 20.3008Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M22.0383 12.2111C22.8498 11.2369 23.2496 9.98469 23.1528 8.72046C21.913 8.85068 20.7677 9.44324 19.9452 10.3801C19.141 11.2954 18.7224 12.5255 18.8015 13.7415C20.0418 13.7542 21.2611 13.1777 22.0383 12.2111Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "119", height: "39", rx: "6.5", stroke: "black" })
    ]
  }
), W7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "132",
    height: "44",
    viewBox: "0 0 132 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "131", height: "43", rx: "6.5", fill: "black" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M89.6793 21.1211V23.6413H88.0997V25.2939H89.6793V30.9094C89.6793 32.8269 90.5468 33.5939 92.729 33.5939C93.1125 33.5939 93.4778 33.5482 93.7973 33.4935V31.859C93.5234 31.8864 93.3499 31.9047 93.0486 31.9047C92.0716 31.9047 91.6425 31.4481 91.6425 30.4072V25.2939H93.7973V23.6413H91.6425V21.1211H89.6793Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M99.3566 33.7309C102.26 33.7309 104.041 31.786 104.041 28.5628C104.041 25.3579 102.251 23.4039 99.3566 23.4039C96.453 23.4039 94.6633 25.3579 94.6633 28.5628C94.6633 31.786 96.4438 33.7309 99.3566 33.7309ZM99.3566 31.9869C97.6491 31.9869 96.6904 30.7359 96.6904 28.5628C96.6904 26.4079 97.6491 25.1479 99.3566 25.1479C101.055 25.1479 102.023 26.4079 102.023 28.5628C102.023 30.7268 101.055 31.9869 99.3566 31.9869Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M105.564 33.5391H107.527V27.668C107.527 26.2709 108.577 25.3305 110.066 25.3305C110.413 25.3305 110.997 25.3944 111.161 25.4492V23.5134C110.951 23.4586 110.577 23.4312 110.285 23.4312C108.988 23.4312 107.883 24.1435 107.6 25.1205H107.454V23.5956H105.564V33.5391Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M116.036 25.0748C117.488 25.0748 118.437 26.0883 118.483 27.6497H113.461C113.57 26.0975 114.584 25.0748 116.036 25.0748ZM118.474 30.8546C118.108 31.6308 117.296 32.0599 116.109 32.0599C114.538 32.0599 113.525 30.9551 113.461 29.2111V29.1015H120.482V28.4167C120.482 25.2939 118.812 23.4039 116.045 23.4039C113.242 23.4039 111.461 25.4218 111.461 28.5993C111.461 31.7769 113.205 33.7309 116.054 33.7309C118.328 33.7309 119.916 32.6352 120.364 30.8546H118.474Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M76.8054 29.8671C76.9568 32.3088 78.9915 33.8703 82.02 33.8703C85.2566 33.8703 87.2819 32.2331 87.2819 29.6211C87.2819 27.5674 86.1273 26.4317 83.326 25.7787L81.8212 25.4096C80.042 24.9932 79.3228 24.4349 79.3228 23.4601C79.3228 22.2298 80.4395 21.4254 82.1146 21.4254C83.7045 21.4254 84.8024 22.2109 85.0011 23.4696H87.0642C86.9412 21.1698 84.9159 19.5515 82.143 19.5515C79.1619 19.5515 77.1745 21.1698 77.1745 23.602C77.1745 25.6084 78.3007 26.8008 80.7707 27.3781L82.531 27.804C84.3386 28.2299 85.1336 28.8545 85.1336 29.8955C85.1336 31.1069 83.8844 31.987 82.1809 31.987C80.3543 31.987 79.0862 31.1637 78.9064 29.8671H76.8054Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M56.4693 23.4312C55.118 23.4312 53.9492 24.1069 53.3466 25.2392H53.2005V23.5956H51.3104V36.8445H53.2735V32.0325H53.4287C53.9492 33.0826 55.0723 33.7035 56.4876 33.7035C58.9986 33.7035 60.5965 31.7221 60.5965 28.5628C60.5965 25.4035 58.9986 23.4312 56.4693 23.4312ZM55.9123 31.9412C54.2688 31.9412 53.237 30.6446 53.237 28.5719C53.237 26.4901 54.2688 25.1935 55.9215 25.1935C57.5833 25.1935 58.5785 26.4627 58.5785 28.5628C58.5785 30.672 57.5833 31.9412 55.9123 31.9412Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M67.4658 23.4312C66.1144 23.4312 64.9457 24.1069 64.343 25.2392H64.1969V23.5956H62.3069V36.8445H64.27V32.0325H64.4252C64.9457 33.0826 66.0688 33.7035 67.4841 33.7035C69.995 33.7035 71.5929 31.7221 71.5929 28.5628C71.5929 25.4035 69.995 23.4312 67.4658 23.4312ZM66.9088 31.9412C65.2653 31.9412 64.2335 30.6446 64.2335 28.5719C64.2335 26.4901 65.2653 25.1935 66.9179 25.1935C68.5798 25.1935 69.575 26.4627 69.575 28.5628C69.575 30.672 68.5798 31.9412 66.9088 31.9412Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M47.7882 33.5391H50.0406L45.1099 19.8827H42.8291L37.8984 33.5391H40.0751L41.3338 29.9144H46.5389L47.7882 33.5391ZM43.8607 22.3623H44.0216L45.9995 28.1352H41.8733L43.8607 22.3623Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M39.2148 9.58196V16.1699H41.5934C43.5566 16.1699 44.6934 14.96 44.6934 12.8554C44.6934 10.7827 43.5474 9.58196 41.5934 9.58196H39.2148ZM40.2375 10.5133H41.4793C42.8444 10.5133 43.6524 11.3807 43.6524 12.8691C43.6524 14.3802 42.8581 15.2385 41.4793 15.2385H40.2375V10.5133Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M48.175 16.2657C49.6268 16.2657 50.517 15.2933 50.517 13.6817C50.517 12.0792 49.6222 11.1022 48.175 11.1022C46.7232 11.1022 45.8283 12.0792 45.8283 13.6817C45.8283 15.2933 46.7186 16.2657 48.175 16.2657ZM48.175 15.3937C47.3212 15.3937 46.8419 14.7683 46.8419 13.6817C46.8419 12.6043 47.3212 11.9742 48.175 11.9742C49.0241 11.9742 49.5081 12.6043 49.5081 13.6817C49.5081 14.7637 49.0241 15.3937 48.175 15.3937Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M58.0984 11.1981H57.1168L56.2311 14.992H56.1535L55.1308 11.1981H54.1904L53.1677 14.992H53.0947L52.2044 11.1981H51.2091L52.5788 16.1699H53.5877L54.6104 12.5084H54.688L55.7152 16.1699H56.7333L58.0984 11.1981Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M59.2288 16.1699H60.2103V13.2617C60.2103 12.4856 60.6715 12.0016 61.3974 12.0016C62.1233 12.0016 62.4702 12.3988 62.4702 13.1978V16.1699H63.4518V12.9512C63.4518 11.7688 62.84 11.1022 61.7306 11.1022C60.9819 11.1022 60.4888 11.4355 60.2469 11.9879H60.1738V11.1981H59.2288V16.1699Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M64.9977 16.1699H65.9792V9.25781H64.9977V16.1699Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M69.6708 16.2657C71.1226 16.2657 72.0129 15.2933 72.0129 13.6817C72.0129 12.0792 71.1181 11.1022 69.6708 11.1022C68.219 11.1022 67.3242 12.0792 67.3242 13.6817C67.3242 15.2933 68.2145 16.2657 69.6708 16.2657ZM69.6708 15.3937C68.8171 15.3937 68.3377 14.7683 68.3377 13.6817C68.3377 12.6043 68.8171 11.9742 69.6708 11.9742C70.52 11.9742 71.0039 12.6043 71.0039 13.6817C71.0039 14.7637 70.52 15.3937 69.6708 15.3937Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M74.9375 15.4257C74.4034 15.4257 74.0153 15.1655 74.0153 14.7181C74.0153 14.2798 74.3257 14.0469 75.0106 14.0013L76.225 13.9237V14.3391C76.225 14.9555 75.6771 15.4257 74.9375 15.4257ZM74.6864 16.2521C75.3393 16.2521 75.8825 15.969 76.1793 15.4714H76.2569V16.1699H77.202V12.7732C77.202 11.7231 76.4989 11.1022 75.2525 11.1022C74.1249 11.1022 73.3213 11.6501 73.2209 12.5038H74.1705C74.2801 12.1523 74.659 11.9514 75.2069 11.9514C75.878 11.9514 76.225 12.2482 76.225 12.7732V13.2023L74.8782 13.28C73.6957 13.353 73.0292 13.8689 73.0292 14.7637C73.0292 15.6722 73.7277 16.2521 74.6864 16.2521Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M80.5329 16.2521C81.2177 16.2521 81.7975 15.9279 82.0943 15.3846H82.1719V16.1699H83.1124V9.25781H82.1308V11.9879H82.0578C81.7884 11.4401 81.2131 11.1159 80.5329 11.1159C79.2774 11.1159 78.4693 12.1112 78.4693 13.6817C78.4693 15.2568 79.2683 16.2521 80.5329 16.2521ZM80.8114 11.9971C81.6332 11.9971 82.1491 12.6499 82.1491 13.6863C82.1491 14.7272 81.6377 15.3709 80.8114 15.3709C79.9805 15.3709 79.4828 14.7363 79.4828 13.6817C79.4828 12.6362 79.985 11.9971 80.8114 11.9971Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M89.4775 16.2657C90.9293 16.2657 91.8196 15.2933 91.8196 13.6817C91.8196 12.0792 90.9247 11.1022 89.4775 11.1022C88.0257 11.1022 87.1309 12.0792 87.1309 13.6817C87.1309 15.2933 88.0211 16.2657 89.4775 16.2657ZM89.4775 15.3937C88.6238 15.3937 88.1444 14.7683 88.1444 13.6817C88.1444 12.6043 88.6238 11.9742 89.4775 11.9742C90.3267 11.9742 90.8106 12.6043 90.8106 13.6817C90.8106 14.7637 90.3267 15.3937 89.4775 15.3937Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M93.1189 16.1699H94.1004V13.2617C94.1004 12.4856 94.5616 12.0016 95.2875 12.0016C96.0134 12.0016 96.3603 12.3988 96.3603 13.1978V16.1699H97.3419V12.9512C97.3419 11.7688 96.7301 11.1022 95.6207 11.1022C94.872 11.1022 94.3789 11.4355 94.137 11.9879H94.0639V11.1981H93.1189V16.1699Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M101.863 9.96089V11.2209H101.073V12.0473H101.863V14.855C101.863 15.8138 102.296 16.1973 103.387 16.1973C103.579 16.1973 103.762 16.1744 103.922 16.147V15.3298C103.785 15.3435 103.698 15.3527 103.547 15.3527C103.059 15.3527 102.844 15.1244 102.844 14.6039V12.0473H103.922V11.2209H102.844V9.96089H101.863Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M105.239 16.1699H106.221V13.2663C106.221 12.513 106.668 12.0062 107.472 12.0062C108.166 12.0062 108.535 12.408 108.535 13.2023V16.1699H109.517V12.9604C109.517 11.7779 108.864 11.1068 107.805 11.1068C107.056 11.1068 106.531 11.4401 106.289 11.9971H106.212V9.25781H105.239V16.1699Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M113.058 11.9377C113.784 11.9377 114.259 12.4445 114.281 13.2252H111.77C111.825 12.449 112.332 11.9377 113.058 11.9377ZM114.277 14.8276C114.094 15.2157 113.688 15.4303 113.094 15.4303C112.309 15.4303 111.802 14.8779 111.77 14.0059V13.9511H115.281V13.6087C115.281 12.0473 114.446 11.1022 113.062 11.1022C111.661 11.1022 110.771 12.1112 110.771 13.7C110.771 15.2887 111.643 16.2657 113.067 16.2657C114.204 16.2657 114.998 15.7179 115.222 14.8276H114.277Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M27.2458 22.3309C27.2696 20.4818 28.2627 18.7322 29.838 17.7637C28.8442 16.3443 27.1796 15.4444 25.4477 15.3902C23.6006 15.1963 21.8098 16.4955 20.8685 16.4955C19.909 16.4955 18.4598 15.4095 16.8992 15.4416C14.865 15.5073 12.9687 16.6638 11.979 18.4422C9.85158 22.1255 11.4384 27.5386 13.4763 30.5159C14.4959 31.9738 15.6875 33.6023 17.2467 33.5445C18.7725 33.4813 19.3423 32.5716 21.184 32.5716C23.0087 32.5716 23.5433 33.5445 25.1341 33.5078C26.7714 33.4813 27.8029 32.0435 28.7867 30.5718C29.5193 29.533 30.083 28.3849 30.457 27.17C28.5329 26.3562 27.248 24.42 27.2458 22.3309Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M24.241 13.4322C25.1336 12.3606 25.5734 10.9832 25.4669 9.59253C24.1031 9.73577 22.8433 10.3876 21.9386 11.4181C21.0539 12.425 20.5935 13.7781 20.6805 15.1156C22.0448 15.1297 23.386 14.4955 24.241 13.4322Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "131", height: "43", rx: "6.5", stroke: "#A6A6A6" })
    ]
  }
), U7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "120",
    height: "40",
    viewBox: "0 0 120 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "119", height: "39", rx: "6.5", fill: "black" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M81.5267 19.2009V21.4919H80.0906V22.9943H81.5267V28.0993C81.5267 29.8425 82.3152 30.5397 84.2991 30.5397C84.6478 30.5397 84.9798 30.4982 85.2703 30.4484V28.9626C85.0213 28.9875 84.8636 29.0041 84.5896 29.0041C83.7015 29.0041 83.3113 28.589 83.3113 27.6428V22.9943H85.2703V21.4919H83.3113V19.2009H81.5267Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M90.3242 30.6642C92.9638 30.6642 94.5825 28.8962 94.5825 25.966C94.5825 23.0524 92.9555 21.2761 90.3242 21.2761C87.6845 21.2761 86.0576 23.0524 86.0576 25.966C86.0576 28.8962 87.6762 30.6642 90.3242 30.6642ZM90.3242 29.0788C88.7719 29.0788 87.9003 27.9416 87.9003 25.966C87.9003 24.007 88.7719 22.8615 90.3242 22.8615C91.8681 22.8615 92.748 24.007 92.748 25.966C92.748 27.9333 91.8681 29.0788 90.3242 29.0788Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M95.9674 30.4899H97.752V25.1525C97.752 23.8825 98.7066 23.0275 100.06 23.0275C100.375 23.0275 100.906 23.0856 101.056 23.1354V21.3757C100.865 21.3259 100.524 21.301 100.259 21.301C99.0802 21.301 98.0758 21.9484 97.8184 22.8366H97.6856V21.4504H95.9674V30.4899Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M105.487 22.7951C106.807 22.7951 107.67 23.7165 107.712 25.1359H103.146C103.246 23.7248 104.167 22.7951 105.487 22.7951ZM107.703 28.0495C107.371 28.7551 106.633 29.1452 105.553 29.1452C104.126 29.1452 103.204 28.1408 103.146 26.5554V26.4557H109.53V25.8332C109.53 22.9943 108.01 21.2761 105.495 21.2761C102.947 21.2761 101.328 23.1105 101.328 25.9992C101.328 28.8879 102.914 30.6642 105.504 30.6642C107.571 30.6642 109.015 29.6681 109.422 28.0495H107.703Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M69.8231 27.1518C69.9607 29.3715 71.8105 30.791 74.5636 30.791C77.506 30.791 79.3472 29.3026 79.3472 26.9281C79.3472 25.0611 78.2975 24.0287 75.7509 23.435L74.3829 23.0995C72.7655 22.7209 72.1116 22.2133 72.1116 21.3272C72.1116 20.2087 73.1268 19.4774 74.6497 19.4774C76.095 19.4774 77.093 20.1915 77.2737 21.3358H79.1493C79.0374 19.2451 77.1963 17.7739 74.6755 17.7739C71.9654 17.7739 70.1586 19.2451 70.1586 21.4562C70.1586 23.2802 71.1824 24.3642 73.4279 24.889L75.0282 25.2762C76.6715 25.6634 77.3942 26.2312 77.3942 27.1776C77.3942 28.2788 76.2585 29.0789 74.7099 29.0789C73.0494 29.0789 71.8965 28.3304 71.7331 27.1518H69.8231Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M51.3357 21.301C50.1072 21.301 49.0447 21.9152 48.4969 22.9445H48.3641V21.4504H46.6458V33.4948H48.4305V29.1203H48.5716C49.0447 30.0749 50.0657 30.6393 51.3523 30.6393C53.6351 30.6393 55.0877 28.8381 55.0877 25.966C55.0877 23.0939 53.6351 21.301 51.3357 21.301ZM50.8294 29.0373C49.3353 29.0373 48.3973 27.8586 48.3973 25.9743C48.3973 24.0817 49.3353 22.903 50.8377 22.903C52.3484 22.903 53.2532 24.0568 53.2532 25.966C53.2532 27.8835 52.3484 29.0373 50.8294 29.0373Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M61.3325 21.301C60.104 21.301 59.0415 21.9152 58.4937 22.9445H58.3609V21.4504H56.6426V33.4948H58.4273V29.1203H58.5684C59.0415 30.0749 60.0625 30.6393 61.3491 30.6393C63.6319 30.6393 65.0845 28.8381 65.0845 25.966C65.0845 23.0939 63.6319 21.301 61.3325 21.301ZM60.8262 29.0373C59.3321 29.0373 58.3941 27.8586 58.3941 25.9743C58.3941 24.0817 59.3321 22.903 60.8345 22.903C62.3452 22.903 63.25 24.0568 63.25 25.966C63.25 27.8835 62.3452 29.0373 60.8262 29.0373Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M43.4438 30.4899H45.4914L41.009 18.075H38.9356L34.4531 30.4899H36.4319L37.5762 27.1948H42.3081L43.4438 30.4899ZM39.8733 20.3292H40.0196L41.8177 25.5773H38.0666L39.8733 20.3292Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M35.6523 8.71094V14.7H37.8147C39.5994 14.7 40.6328 13.6001 40.6328 11.6868C40.6328 9.80249 39.5911 8.71094 37.8147 8.71094H35.6523ZM36.582 9.55762H37.7109C38.9519 9.55762 39.6865 10.3462 39.6865 11.6992C39.6865 13.073 38.9644 13.8533 37.7109 13.8533H36.582V9.55762Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M43.7979 14.7871C45.1177 14.7871 45.9271 13.9031 45.9271 12.438C45.9271 10.9812 45.1136 10.093 43.7979 10.093C42.4781 10.093 41.6646 10.9812 41.6646 12.438C41.6646 13.9031 42.4739 14.7871 43.7979 14.7871ZM43.7979 13.9944C43.0218 13.9944 42.586 13.4258 42.586 12.438C42.586 11.4585 43.0218 10.8857 43.7979 10.8857C44.5699 10.8857 45.0098 11.4585 45.0098 12.438C45.0098 13.4216 44.5699 13.9944 43.7979 13.9944Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M52.8192 10.1802H51.9269L51.1217 13.6292H51.0511L50.1214 10.1802H49.2665L48.3368 13.6292H48.2704L47.461 10.1802H46.5562L47.8014 14.7H48.7186L49.6483 11.3713H49.7188L50.6527 14.7H51.5782L52.8192 10.1802Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M53.8468 14.7H54.7392V12.0562C54.7392 11.3506 55.1583 10.9106 55.8183 10.9106C56.4782 10.9106 56.7936 11.2717 56.7936 11.998V14.7H57.6859V11.7739C57.6859 10.699 57.1298 10.093 56.1212 10.093C55.4406 10.093 54.9923 10.396 54.7724 10.8982H54.706V10.1802H53.8468V14.7Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t("path", { d: "M59.0913 14.7H59.9836V8.41626H59.0913V14.7Z", fill: "white" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M63.3396 14.7871C64.6594 14.7871 65.4688 13.9031 65.4688 12.438C65.4688 10.9812 64.6553 10.093 63.3396 10.093C62.0198 10.093 61.2063 10.9812 61.2063 12.438C61.2063 13.9031 62.0156 14.7871 63.3396 14.7871ZM63.3396 13.9944C62.5635 13.9944 62.1277 13.4258 62.1277 12.438C62.1277 11.4585 62.5635 10.8857 63.3396 10.8857C64.1116 10.8857 64.5515 11.4585 64.5515 12.438C64.5515 13.4216 64.1116 13.9944 63.3396 13.9944Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M68.1275 14.0234C67.6419 14.0234 67.2891 13.7869 67.2891 13.3801C67.2891 12.9817 67.5713 12.77 68.1939 12.7285L69.2979 12.658V13.0356C69.2979 13.5959 68.7999 14.0234 68.1275 14.0234ZM67.8992 14.7747C68.4927 14.7747 68.9866 14.5173 69.2564 14.0649H69.327V14.7H70.1861V11.6121C70.1861 10.6575 69.5469 10.093 68.4139 10.093C67.3887 10.093 66.6583 10.5911 66.5669 11.3672H67.4302C67.5298 11.0476 67.8743 10.865 68.3724 10.865C68.9825 10.865 69.2979 11.1348 69.2979 11.6121V12.0022L68.0735 12.0728C66.9986 12.1392 66.3926 12.6082 66.3926 13.4216C66.3926 14.2476 67.0276 14.7747 67.8992 14.7747Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M73.2142 14.7747C73.8368 14.7747 74.3639 14.48 74.6336 13.9861H74.7042V14.7H75.5592V8.41626H74.6668V10.8982H74.6004C74.3556 10.4001 73.8326 10.1055 73.2142 10.1055C72.0728 10.1055 71.3382 11.0103 71.3382 12.438C71.3382 13.8699 72.0645 14.7747 73.2142 14.7747ZM73.4674 10.9065C74.2145 10.9065 74.6834 11.5 74.6834 12.4421C74.6834 13.3884 74.2186 13.9736 73.4674 13.9736C72.712 13.9736 72.2596 13.3967 72.2596 12.438C72.2596 11.4875 72.7162 10.9065 73.4674 10.9065Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M81.3457 14.7871C82.6655 14.7871 83.4748 13.9031 83.4748 12.438C83.4748 10.9812 82.6613 10.093 81.3457 10.093C80.0258 10.093 79.2124 10.9812 79.2124 12.438C79.2124 13.9031 80.0217 14.7871 81.3457 14.7871ZM81.3457 13.9944C80.5695 13.9944 80.1337 13.4258 80.1337 12.438C80.1337 11.4585 80.5695 10.8857 81.3457 10.8857C82.1176 10.8857 82.5576 11.4585 82.5576 12.438C82.5576 13.4216 82.1176 13.9944 81.3457 13.9944Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M84.656 14.7H85.5483V12.0562C85.5483 11.3506 85.9675 10.9106 86.6274 10.9106C87.2874 10.9106 87.6028 11.2717 87.6028 11.998V14.7H88.4951V11.7739C88.4951 10.699 87.939 10.093 86.9304 10.093C86.2498 10.093 85.8015 10.396 85.5815 10.8982H85.5151V10.1802H84.656V14.7Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M92.6048 9.05542V10.2009H91.8868V10.9521H92.6048V13.5046C92.6048 14.3762 92.9991 14.7249 93.9911 14.7249C94.1654 14.7249 94.3314 14.7041 94.4767 14.6792V13.9363C94.3521 13.9487 94.2733 13.957 94.1363 13.957C93.6922 13.957 93.4972 13.7495 93.4972 13.2764V10.9521H94.4767V10.2009H93.4972V9.05542H92.6048Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M95.6745 14.7H96.5668V12.0603C96.5668 11.3755 96.9735 10.9148 97.704 10.9148C98.3349 10.9148 98.671 11.28 98.671 12.0022V14.7H99.5634V11.7822C99.5634 10.7073 98.9699 10.0972 98.007 10.0972C97.3263 10.0972 96.849 10.4001 96.6291 10.9065H96.5585V8.41626H95.6745V14.7Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M102.782 10.8525C103.442 10.8525 103.874 11.3132 103.895 12.0229H101.612C101.662 11.3174 102.123 10.8525 102.782 10.8525ZM103.891 13.4797C103.725 13.8325 103.355 14.0276 102.816 14.0276C102.102 14.0276 101.641 13.5254 101.612 12.7327V12.6829H104.804V12.3716C104.804 10.9521 104.044 10.093 102.787 10.093C101.512 10.093 100.703 11.0103 100.703 12.4546C100.703 13.8989 101.496 14.7871 102.791 14.7871C103.824 14.7871 104.546 14.2891 104.75 13.4797H103.891Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M24.77 20.3008C24.7916 18.6198 25.6944 17.0292 27.1265 16.1488C26.2231 14.8584 24.7098 14.0403 23.1354 13.9911C21.4561 13.8148 19.8282 14.9959 18.9725 14.9959C18.1002 14.9959 16.7827 14.0086 15.364 14.0378C13.5147 14.0975 11.7907 15.1489 10.891 16.7656C8.95705 20.1141 10.3996 25.0351 12.2522 27.7417C13.1791 29.0671 14.2624 30.5475 15.6799 30.495C17.0669 30.4375 17.585 29.6105 19.2593 29.6105C20.918 29.6105 21.4041 30.495 22.8503 30.4616C24.3387 30.4375 25.2764 29.1304 26.1708 27.7925C26.8368 26.8481 27.3492 25.8044 27.6892 24.7C25.9401 23.9602 24.772 22.2 24.77 20.3008Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M22.0383 12.2111C22.8498 11.2369 23.2496 9.98469 23.1528 8.72046C21.913 8.85068 20.7677 9.44324 19.9452 10.3801C19.141 11.2954 18.7224 12.5255 18.8015 13.7415C20.0418 13.7542 21.2611 13.1777 22.0383 12.2111Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "119", height: "39", rx: "6.5", stroke: "#A6A6A6" })
    ]
  }
), O7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "132",
    height: "44",
    viewBox: "0 0 132 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M89.6793 21.1211V23.6413H88.0997V25.2939H89.6793V30.9094C89.6793 32.8269 90.5468 33.5939 92.729 33.5939C93.1125 33.5939 93.4778 33.5482 93.7973 33.4935V31.859C93.5234 31.8864 93.3499 31.9047 93.0486 31.9047C92.0716 31.9047 91.6425 31.4481 91.6425 30.4072V25.2939H93.7973V23.6413H91.6425V21.1211H89.6793Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M99.3566 33.7309C102.26 33.7309 104.041 31.786 104.041 28.5628C104.041 25.3579 102.251 23.4039 99.3566 23.4039C96.453 23.4039 94.6633 25.3579 94.6633 28.5628C94.6633 31.786 96.4438 33.7309 99.3566 33.7309ZM99.3566 31.9869C97.6491 31.9869 96.6904 30.7359 96.6904 28.5628C96.6904 26.4079 97.6491 25.1479 99.3566 25.1479C101.055 25.1479 102.023 26.4079 102.023 28.5628C102.023 30.7268 101.055 31.9869 99.3566 31.9869Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M105.564 33.5391H107.527V27.668C107.527 26.2709 108.577 25.3305 110.066 25.3305C110.413 25.3305 110.997 25.3944 111.161 25.4492V23.5134C110.951 23.4586 110.577 23.4312 110.285 23.4312C108.988 23.4312 107.883 24.1435 107.6 25.1205H107.454V23.5956H105.564V33.5391Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M116.036 25.0748C117.488 25.0748 118.437 26.0883 118.483 27.6497H113.461C113.57 26.0975 114.584 25.0748 116.036 25.0748ZM118.474 30.8546C118.108 31.6308 117.296 32.0599 116.109 32.0599C114.538 32.0599 113.525 30.9551 113.461 29.2111V29.1015H120.482V28.4167C120.482 25.2939 118.812 23.4039 116.045 23.4039C113.242 23.4039 111.461 25.4218 111.461 28.5993C111.461 31.7769 113.205 33.7309 116.054 33.7309C118.328 33.7309 119.916 32.6352 120.364 30.8546H118.474Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M76.8054 29.8671C76.9568 32.3088 78.9915 33.8703 82.02 33.8703C85.2566 33.8703 87.2819 32.2331 87.2819 29.6211C87.2819 27.5674 86.1273 26.4317 83.326 25.7787L81.8212 25.4096C80.042 24.9932 79.3228 24.4349 79.3228 23.4601C79.3228 22.2298 80.4395 21.4254 82.1146 21.4254C83.7045 21.4254 84.8024 22.2109 85.0011 23.4696H87.0642C86.9412 21.1698 84.9159 19.5515 82.143 19.5515C79.1619 19.5515 77.1745 21.1698 77.1745 23.602C77.1745 25.6084 78.3007 26.8008 80.7707 27.3781L82.531 27.804C84.3386 28.2299 85.1336 28.8545 85.1336 29.8955C85.1336 31.1069 83.8844 31.987 82.1809 31.987C80.3543 31.987 79.0862 31.1637 78.9064 29.8671H76.8054Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M56.4693 23.4312C55.118 23.4312 53.9492 24.1069 53.3466 25.2392H53.2005V23.5956H51.3104V36.8445H53.2735V32.0325H53.4287C53.9492 33.0826 55.0723 33.7035 56.4876 33.7035C58.9986 33.7035 60.5965 31.7221 60.5965 28.5628C60.5965 25.4035 58.9986 23.4312 56.4693 23.4312ZM55.9123 31.9412C54.2688 31.9412 53.237 30.6446 53.237 28.5719C53.237 26.4901 54.2688 25.1935 55.9215 25.1935C57.5833 25.1935 58.5785 26.4627 58.5785 28.5628C58.5785 30.672 57.5833 31.9412 55.9123 31.9412Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M67.4658 23.4312C66.1144 23.4312 64.9457 24.1069 64.343 25.2392H64.1969V23.5956H62.3069V36.8445H64.27V32.0325H64.4252C64.9457 33.0826 66.0688 33.7035 67.4841 33.7035C69.995 33.7035 71.5929 31.7221 71.5929 28.5628C71.5929 25.4035 69.995 23.4312 67.4658 23.4312ZM66.9088 31.9412C65.2653 31.9412 64.2335 30.6446 64.2335 28.5719C64.2335 26.4901 65.2653 25.1935 66.9179 25.1935C68.5798 25.1935 69.575 26.4627 69.575 28.5628C69.575 30.672 68.5798 31.9412 66.9088 31.9412Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M47.7882 33.5391H50.0406L45.1099 19.8827H42.8291L37.8984 33.5391H40.0751L41.3338 29.9144H46.5389L47.7882 33.5391ZM43.8607 22.3623H44.0216L45.9995 28.1352H41.8733L43.8607 22.3623Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M39.2148 9.58196V16.1699H41.5934C43.5566 16.1699 44.6934 14.96 44.6934 12.8554C44.6934 10.7827 43.5474 9.58196 41.5934 9.58196H39.2148ZM40.2375 10.5133H41.4793C42.8444 10.5133 43.6524 11.3807 43.6524 12.8691C43.6524 14.3802 42.8581 15.2385 41.4793 15.2385H40.2375V10.5133Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M48.175 16.2657C49.6268 16.2657 50.517 15.2933 50.517 13.6817C50.517 12.0792 49.6222 11.1022 48.175 11.1022C46.7232 11.1022 45.8283 12.0792 45.8283 13.6817C45.8283 15.2933 46.7186 16.2657 48.175 16.2657ZM48.175 15.3937C47.3212 15.3937 46.8419 14.7683 46.8419 13.6817C46.8419 12.6043 47.3212 11.9742 48.175 11.9742C49.0241 11.9742 49.5081 12.6043 49.5081 13.6817C49.5081 14.7637 49.0241 15.3937 48.175 15.3937Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M58.0984 11.1981H57.1168L56.2311 14.992H56.1535L55.1308 11.1981H54.1904L53.1677 14.992H53.0947L52.2044 11.1981H51.2091L52.5788 16.1699H53.5877L54.6104 12.5084H54.688L55.7152 16.1699H56.7333L58.0984 11.1981Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M59.2288 16.1699H60.2103V13.2617C60.2103 12.4856 60.6715 12.0016 61.3974 12.0016C62.1233 12.0016 62.4702 12.3988 62.4702 13.1978V16.1699H63.4518V12.9512C63.4518 11.7688 62.84 11.1022 61.7306 11.1022C60.9819 11.1022 60.4888 11.4355 60.2469 11.9879H60.1738V11.1981H59.2288V16.1699Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M64.9977 16.1699H65.9792V9.25781H64.9977V16.1699Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M69.6708 16.2657C71.1226 16.2657 72.0129 15.2933 72.0129 13.6817C72.0129 12.0792 71.1181 11.1022 69.6708 11.1022C68.219 11.1022 67.3242 12.0792 67.3242 13.6817C67.3242 15.2933 68.2145 16.2657 69.6708 16.2657ZM69.6708 15.3937C68.8171 15.3937 68.3377 14.7683 68.3377 13.6817C68.3377 12.6043 68.8171 11.9742 69.6708 11.9742C70.52 11.9742 71.0039 12.6043 71.0039 13.6817C71.0039 14.7637 70.52 15.3937 69.6708 15.3937Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M74.9375 15.4257C74.4034 15.4257 74.0153 15.1655 74.0153 14.7181C74.0153 14.2798 74.3257 14.0469 75.0106 14.0013L76.225 13.9237V14.3391C76.225 14.9555 75.6771 15.4257 74.9375 15.4257ZM74.6864 16.2521C75.3393 16.2521 75.8825 15.969 76.1793 15.4714H76.2569V16.1699H77.202V12.7732C77.202 11.7231 76.4989 11.1022 75.2525 11.1022C74.1249 11.1022 73.3213 11.6501 73.2209 12.5038H74.1705C74.2801 12.1523 74.659 11.9514 75.2069 11.9514C75.878 11.9514 76.225 12.2482 76.225 12.7732V13.2023L74.8782 13.28C73.6957 13.353 73.0292 13.8689 73.0292 14.7637C73.0292 15.6722 73.7277 16.2521 74.6864 16.2521Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M80.5329 16.2521C81.2177 16.2521 81.7975 15.9279 82.0943 15.3846H82.1719V16.1699H83.1124V9.25781H82.1308V11.9879H82.0578C81.7884 11.4401 81.2131 11.1159 80.5329 11.1159C79.2774 11.1159 78.4693 12.1112 78.4693 13.6817C78.4693 15.2568 79.2683 16.2521 80.5329 16.2521ZM80.8114 11.9971C81.6332 11.9971 82.1491 12.6499 82.1491 13.6863C82.1491 14.7272 81.6377 15.3709 80.8114 15.3709C79.9805 15.3709 79.4828 14.7363 79.4828 13.6817C79.4828 12.6362 79.985 11.9971 80.8114 11.9971Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M89.4775 16.2657C90.9293 16.2657 91.8196 15.2933 91.8196 13.6817C91.8196 12.0792 90.9247 11.1022 89.4775 11.1022C88.0257 11.1022 87.1309 12.0792 87.1309 13.6817C87.1309 15.2933 88.0211 16.2657 89.4775 16.2657ZM89.4775 15.3937C88.6238 15.3937 88.1444 14.7683 88.1444 13.6817C88.1444 12.6043 88.6238 11.9742 89.4775 11.9742C90.3267 11.9742 90.8106 12.6043 90.8106 13.6817C90.8106 14.7637 90.3267 15.3937 89.4775 15.3937Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M93.1189 16.1699H94.1004V13.2617C94.1004 12.4856 94.5616 12.0016 95.2875 12.0016C96.0134 12.0016 96.3603 12.3988 96.3603 13.1978V16.1699H97.3419V12.9512C97.3419 11.7688 96.7301 11.1022 95.6207 11.1022C94.872 11.1022 94.3789 11.4355 94.137 11.9879H94.0639V11.1981H93.1189V16.1699Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M101.863 9.96089V11.2209H101.073V12.0473H101.863V14.855C101.863 15.8138 102.296 16.1973 103.387 16.1973C103.579 16.1973 103.762 16.1744 103.922 16.147V15.3298C103.785 15.3435 103.698 15.3527 103.547 15.3527C103.059 15.3527 102.844 15.1244 102.844 14.6039V12.0473H103.922V11.2209H102.844V9.96089H101.863Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M105.239 16.1699H106.221V13.2663C106.221 12.513 106.668 12.0062 107.472 12.0062C108.166 12.0062 108.535 12.408 108.535 13.2023V16.1699H109.517V12.9604C109.517 11.7779 108.864 11.1068 107.805 11.1068C107.056 11.1068 106.531 11.4401 106.289 11.9971H106.212V9.25781H105.239V16.1699Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M113.058 11.9377C113.784 11.9377 114.259 12.4445 114.281 13.2252H111.77C111.825 12.449 112.332 11.9377 113.058 11.9377ZM114.277 14.8276C114.094 15.2157 113.688 15.4303 113.094 15.4303C112.309 15.4303 111.802 14.8779 111.77 14.0059V13.9511H115.281V13.6087C115.281 12.0473 114.446 11.1022 113.062 11.1022C111.661 11.1022 110.771 12.1112 110.771 13.7C110.771 15.2887 111.643 16.2657 113.067 16.2657C114.204 16.2657 114.998 15.7179 115.222 14.8276H114.277Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M27.2458 22.3309C27.2696 20.4818 28.2627 18.7322 29.838 17.7637C28.8442 16.3443 27.1796 15.4444 25.4477 15.3902C23.6006 15.1963 21.8098 16.4955 20.8685 16.4955C19.909 16.4955 18.4598 15.4095 16.8992 15.4416C14.865 15.5073 12.9687 16.6638 11.979 18.4422C9.85158 22.1255 11.4384 27.5386 13.4763 30.5159C14.4959 31.9738 15.6875 33.6023 17.2467 33.5445C18.7725 33.4813 19.3423 32.5716 21.184 32.5716C23.0087 32.5716 23.5433 33.5445 25.1341 33.5078C26.7714 33.4813 27.8029 32.0435 28.7867 30.5718C29.5193 29.533 30.083 28.3849 30.457 27.17C28.5329 26.3562 27.248 24.42 27.2458 22.3309Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M24.241 13.4322C25.1336 12.3606 25.5734 10.9832 25.4669 9.59253C24.1031 9.73577 22.8433 10.3876 21.9386 11.4181C21.0539 12.425 20.5935 13.7781 20.6805 15.1156C22.0448 15.1297 23.386 14.4955 24.241 13.4322Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "131", height: "43", rx: "6.5", stroke: "white" })
    ]
  }
), q7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "120",
    height: "40",
    viewBox: "0 0 120 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M81.5267 19.2009V21.4919H80.0906V22.9943H81.5267V28.0993C81.5267 29.8425 82.3152 30.5397 84.2991 30.5397C84.6478 30.5397 84.9798 30.4982 85.2703 30.4484V28.9626C85.0213 28.9875 84.8636 29.0041 84.5896 29.0041C83.7015 29.0041 83.3113 28.589 83.3113 27.6428V22.9943H85.2703V21.4919H83.3113V19.2009H81.5267Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M90.3242 30.6642C92.9638 30.6642 94.5825 28.8962 94.5825 25.966C94.5825 23.0524 92.9555 21.2761 90.3242 21.2761C87.6845 21.2761 86.0576 23.0524 86.0576 25.966C86.0576 28.8962 87.6762 30.6642 90.3242 30.6642ZM90.3242 29.0788C88.7719 29.0788 87.9003 27.9416 87.9003 25.966C87.9003 24.007 88.7719 22.8615 90.3242 22.8615C91.8681 22.8615 92.748 24.007 92.748 25.966C92.748 27.9333 91.8681 29.0788 90.3242 29.0788Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M95.9674 30.4899H97.752V25.1525C97.752 23.8825 98.7066 23.0275 100.06 23.0275C100.375 23.0275 100.906 23.0856 101.056 23.1354V21.3757C100.865 21.3259 100.524 21.301 100.259 21.301C99.0802 21.301 98.0758 21.9484 97.8184 22.8366H97.6856V21.4504H95.9674V30.4899Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M105.487 22.7951C106.807 22.7951 107.67 23.7165 107.712 25.1359H103.146C103.246 23.7248 104.167 22.7951 105.487 22.7951ZM107.703 28.0495C107.371 28.7551 106.633 29.1452 105.553 29.1452C104.126 29.1452 103.204 28.1408 103.146 26.5554V26.4557H109.53V25.8332C109.53 22.9943 108.01 21.2761 105.495 21.2761C102.947 21.2761 101.328 23.1105 101.328 25.9992C101.328 28.8879 102.914 30.6642 105.504 30.6642C107.571 30.6642 109.015 29.6681 109.422 28.0495H107.703Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M69.8231 27.1518C69.9607 29.3715 71.8105 30.791 74.5636 30.791C77.506 30.791 79.3472 29.3026 79.3472 26.9281C79.3472 25.0611 78.2975 24.0287 75.7509 23.435L74.3829 23.0995C72.7655 22.7209 72.1116 22.2133 72.1116 21.3272C72.1116 20.2087 73.1268 19.4774 74.6497 19.4774C76.095 19.4774 77.093 20.1915 77.2737 21.3358H79.1493C79.0374 19.2451 77.1963 17.7739 74.6755 17.7739C71.9654 17.7739 70.1586 19.2451 70.1586 21.4562C70.1586 23.2802 71.1824 24.3642 73.4279 24.889L75.0282 25.2762C76.6715 25.6634 77.3942 26.2312 77.3942 27.1776C77.3942 28.2788 76.2585 29.0789 74.7099 29.0789C73.0494 29.0789 71.8965 28.3304 71.7331 27.1518H69.8231Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M51.3357 21.301C50.1072 21.301 49.0447 21.9152 48.4969 22.9445H48.3641V21.4504H46.6458V33.4948H48.4305V29.1203H48.5716C49.0447 30.0749 50.0657 30.6393 51.3523 30.6393C53.6351 30.6393 55.0877 28.8381 55.0877 25.966C55.0877 23.0939 53.6351 21.301 51.3357 21.301ZM50.8294 29.0373C49.3353 29.0373 48.3973 27.8586 48.3973 25.9743C48.3973 24.0817 49.3353 22.903 50.8377 22.903C52.3484 22.903 53.2532 24.0568 53.2532 25.966C53.2532 27.8835 52.3484 29.0373 50.8294 29.0373Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M61.3325 21.301C60.104 21.301 59.0415 21.9152 58.4937 22.9445H58.3609V21.4504H56.6426V33.4948H58.4273V29.1203H58.5684C59.0415 30.0749 60.0625 30.6393 61.3491 30.6393C63.6319 30.6393 65.0845 28.8381 65.0845 25.966C65.0845 23.0939 63.6319 21.301 61.3325 21.301ZM60.8262 29.0373C59.3321 29.0373 58.3941 27.8586 58.3941 25.9743C58.3941 24.0817 59.3321 22.903 60.8345 22.903C62.3452 22.903 63.25 24.0568 63.25 25.966C63.25 27.8835 62.3452 29.0373 60.8262 29.0373Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M43.4438 30.4899H45.4914L41.009 18.075H38.9356L34.4531 30.4899H36.4319L37.5762 27.1948H42.3081L43.4438 30.4899ZM39.8733 20.3292H40.0196L41.8177 25.5773H38.0666L39.8733 20.3292Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M35.6523 8.71094V14.7H37.8147C39.5994 14.7 40.6328 13.6001 40.6328 11.6868C40.6328 9.80249 39.5911 8.71094 37.8147 8.71094H35.6523ZM36.582 9.55762H37.7109C38.9519 9.55762 39.6865 10.3462 39.6865 11.6992C39.6865 13.073 38.9644 13.8533 37.7109 13.8533H36.582V9.55762Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M43.7979 14.7871C45.1177 14.7871 45.9271 13.9031 45.9271 12.438C45.9271 10.9812 45.1136 10.093 43.7979 10.093C42.4781 10.093 41.6646 10.9812 41.6646 12.438C41.6646 13.9031 42.4739 14.7871 43.7979 14.7871ZM43.7979 13.9944C43.0218 13.9944 42.586 13.4258 42.586 12.438C42.586 11.4585 43.0218 10.8857 43.7979 10.8857C44.5699 10.8857 45.0098 11.4585 45.0098 12.438C45.0098 13.4216 44.5699 13.9944 43.7979 13.9944Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M52.8192 10.1802H51.9269L51.1217 13.6292H51.0511L50.1214 10.1802H49.2665L48.3368 13.6292H48.2704L47.461 10.1802H46.5562L47.8014 14.7H48.7186L49.6483 11.3713H49.7188L50.6527 14.7H51.5782L52.8192 10.1802Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M53.8468 14.7H54.7392V12.0562C54.7392 11.3506 55.1583 10.9106 55.8183 10.9106C56.4782 10.9106 56.7936 11.2717 56.7936 11.998V14.7H57.6859V11.7739C57.6859 10.699 57.1298 10.093 56.1212 10.093C55.4406 10.093 54.9923 10.396 54.7724 10.8982H54.706V10.1802H53.8468V14.7Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t("path", { d: "M59.0913 14.7H59.9836V8.41626H59.0913V14.7Z", fill: "white" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M63.3396 14.7871C64.6594 14.7871 65.4688 13.9031 65.4688 12.438C65.4688 10.9812 64.6553 10.093 63.3396 10.093C62.0198 10.093 61.2063 10.9812 61.2063 12.438C61.2063 13.9031 62.0156 14.7871 63.3396 14.7871ZM63.3396 13.9944C62.5635 13.9944 62.1277 13.4258 62.1277 12.438C62.1277 11.4585 62.5635 10.8857 63.3396 10.8857C64.1116 10.8857 64.5515 11.4585 64.5515 12.438C64.5515 13.4216 64.1116 13.9944 63.3396 13.9944Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M68.1275 14.0234C67.6419 14.0234 67.2891 13.7869 67.2891 13.3801C67.2891 12.9817 67.5713 12.77 68.1939 12.7285L69.2979 12.658V13.0356C69.2979 13.5959 68.7999 14.0234 68.1275 14.0234ZM67.8992 14.7747C68.4927 14.7747 68.9866 14.5173 69.2564 14.0649H69.327V14.7H70.1861V11.6121C70.1861 10.6575 69.5469 10.093 68.4139 10.093C67.3887 10.093 66.6583 10.5911 66.5669 11.3672H67.4302C67.5298 11.0476 67.8743 10.865 68.3724 10.865C68.9825 10.865 69.2979 11.1348 69.2979 11.6121V12.0022L68.0735 12.0728C66.9986 12.1392 66.3926 12.6082 66.3926 13.4216C66.3926 14.2476 67.0276 14.7747 67.8992 14.7747Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M73.2142 14.7747C73.8368 14.7747 74.3639 14.48 74.6336 13.9861H74.7042V14.7H75.5592V8.41626H74.6668V10.8982H74.6004C74.3556 10.4001 73.8326 10.1055 73.2142 10.1055C72.0728 10.1055 71.3382 11.0103 71.3382 12.438C71.3382 13.8699 72.0645 14.7747 73.2142 14.7747ZM73.4674 10.9065C74.2145 10.9065 74.6834 11.5 74.6834 12.4421C74.6834 13.3884 74.2186 13.9736 73.4674 13.9736C72.712 13.9736 72.2596 13.3967 72.2596 12.438C72.2596 11.4875 72.7162 10.9065 73.4674 10.9065Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M81.3457 14.7871C82.6655 14.7871 83.4748 13.9031 83.4748 12.438C83.4748 10.9812 82.6613 10.093 81.3457 10.093C80.0258 10.093 79.2124 10.9812 79.2124 12.438C79.2124 13.9031 80.0217 14.7871 81.3457 14.7871ZM81.3457 13.9944C80.5695 13.9944 80.1337 13.4258 80.1337 12.438C80.1337 11.4585 80.5695 10.8857 81.3457 10.8857C82.1176 10.8857 82.5576 11.4585 82.5576 12.438C82.5576 13.4216 82.1176 13.9944 81.3457 13.9944Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M84.656 14.7H85.5483V12.0562C85.5483 11.3506 85.9675 10.9106 86.6274 10.9106C87.2874 10.9106 87.6028 11.2717 87.6028 11.998V14.7H88.4951V11.7739C88.4951 10.699 87.939 10.093 86.9304 10.093C86.2498 10.093 85.8015 10.396 85.5815 10.8982H85.5151V10.1802H84.656V14.7Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M92.6048 9.05542V10.2009H91.8868V10.9521H92.6048V13.5046C92.6048 14.3762 92.9991 14.7249 93.9911 14.7249C94.1654 14.7249 94.3314 14.7041 94.4767 14.6792V13.9363C94.3521 13.9487 94.2733 13.957 94.1363 13.957C93.6922 13.957 93.4972 13.7495 93.4972 13.2764V10.9521H94.4767V10.2009H93.4972V9.05542H92.6048Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M95.6745 14.7H96.5668V12.0603C96.5668 11.3755 96.9735 10.9148 97.704 10.9148C98.3349 10.9148 98.671 11.28 98.671 12.0022V14.7H99.5634V11.7822C99.5634 10.7073 98.9699 10.0972 98.007 10.0972C97.3263 10.0972 96.849 10.4001 96.6291 10.9065H96.5585V8.41626H95.6745V14.7Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M102.782 10.8525C103.442 10.8525 103.874 11.3132 103.895 12.0229H101.612C101.662 11.3174 102.123 10.8525 102.782 10.8525ZM103.891 13.4797C103.725 13.8325 103.355 14.0276 102.816 14.0276C102.102 14.0276 101.641 13.5254 101.612 12.7327V12.6829H104.804V12.3716C104.804 10.9521 104.044 10.093 102.787 10.093C101.512 10.093 100.703 11.0103 100.703 12.4546C100.703 13.8989 101.496 14.7871 102.791 14.7871C103.824 14.7871 104.546 14.2891 104.75 13.4797H103.891Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M24.77 20.3008C24.7916 18.6198 25.6944 17.0292 27.1265 16.1488C26.2231 14.8584 24.7098 14.0403 23.1354 13.9911C21.4561 13.8148 19.8282 14.9959 18.9725 14.9959C18.1002 14.9959 16.7827 14.0086 15.364 14.0378C13.5147 14.0975 11.7907 15.1489 10.891 16.7656C8.95705 20.1141 10.3996 25.0351 12.2522 27.7417C13.1791 29.0671 14.2624 30.5475 15.6799 30.495C17.0669 30.4375 17.585 29.6105 19.2593 29.6105C20.918 29.6105 21.4041 30.495 22.8503 30.4616C24.3387 30.4375 25.2764 29.1304 26.1708 27.7925C26.8368 26.8481 27.3492 25.8044 27.6892 24.7C25.9401 23.9602 24.772 22.2 24.77 20.3008Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M22.0383 12.2111C22.8498 11.2369 23.2496 9.98469 23.1528 8.72046C21.913 8.85068 20.7677 9.44324 19.9452 10.3801C19.141 11.2954 18.7224 12.5255 18.8015 13.7415C20.0418 13.7542 21.2611 13.1777 22.0383 12.2111Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "119", height: "39", rx: "6.5", stroke: "white" })
    ]
  }
), D7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "149",
    height: "44",
    viewBox: "0 0 149 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "147.5", height: "43", rx: "4.5", fill: "white" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M74.9479 23.9264C72.3607 23.9264 70.252 25.8943 70.252 28.6047C70.252 31.2986 72.3607 33.283 74.9479 33.283C77.5362 33.283 79.6449 31.2986 79.6449 28.6047C79.6438 25.8943 77.5351 23.9264 74.9479 23.9264ZM74.9479 31.4416C73.53 31.4416 72.3079 30.2723 72.3079 28.6058C72.3079 26.9217 73.5311 25.77 74.9479 25.77C76.3658 25.77 77.5879 26.9217 77.5879 28.6058C77.5879 30.2712 76.3658 31.4416 74.9479 31.4416ZM64.7025 23.9264C62.1153 23.9264 60.0066 25.8943 60.0066 28.6047C60.0066 31.2986 62.1153 33.283 64.7025 33.283C67.2908 33.283 69.3995 31.2986 69.3995 28.6047C69.3995 25.8943 67.2908 23.9264 64.7025 23.9264ZM64.7025 31.4416C63.2846 31.4416 62.0625 30.2723 62.0625 28.6058C62.0625 26.9217 63.2857 25.77 64.7025 25.77C66.1204 25.77 67.3425 26.9217 67.3425 28.6058C67.3436 30.2712 66.1204 31.4416 64.7025 31.4416ZM52.5167 25.363V27.3474H57.2665C57.1246 28.4639 56.7528 29.279 56.1852 29.8455C55.4944 30.5363 54.4131 31.2986 52.5167 31.2986C49.5929 31.2986 47.3071 28.9413 47.3071 26.0175C47.3071 23.0937 49.5929 20.7364 52.5167 20.7364C54.0941 20.7364 55.2458 21.3568 56.0961 22.1543L57.4964 20.754C56.3084 19.6199 54.7321 18.752 52.5167 18.752C48.5116 18.752 45.1445 22.0124 45.1445 26.0175C45.1445 30.0226 48.5116 33.283 52.5167 33.283C54.6782 33.283 56.3095 32.5735 57.5844 31.2447C58.8956 29.9335 59.3037 28.0899 59.3037 26.6016C59.3037 26.1418 59.2685 25.7161 59.197 25.3619H52.5167V25.363ZM102.356 26.9041C101.966 25.8591 100.778 23.9264 98.3504 23.9264C95.9403 23.9264 93.9372 25.8228 93.9372 28.6047C93.9372 31.2271 95.9227 33.283 98.5803 33.283C100.724 33.283 101.965 31.9718 102.48 31.2095L100.885 30.1458C100.354 30.9257 99.6264 31.4394 98.5803 31.4394C97.5353 31.4394 96.7906 30.9609 96.3121 30.0215L102.568 27.4343L102.356 26.9041ZM95.9755 28.4639C95.9227 26.6555 97.3758 25.7348 98.4219 25.7348C99.237 25.7348 99.9278 26.1429 100.159 26.727L95.9755 28.4639ZM90.8902 33.0003H92.945V19.2492H90.8902V33.0003ZM87.522 24.9725H87.4516C86.9907 24.4225 86.1041 23.9264 84.9887 23.9264C82.649 23.9264 80.5051 25.9823 80.5051 28.6234C80.5051 31.2458 82.649 33.2841 84.9887 33.2841C86.1052 33.2841 86.9907 32.788 87.4516 32.2215H87.522V32.8947C87.522 34.6844 86.565 35.6414 85.0239 35.6414C83.7655 35.6414 82.9856 34.7383 82.6666 33.976L80.8769 34.7207C81.3906 35.9604 82.7546 37.485 85.0239 37.485C87.434 37.485 89.4723 36.0671 89.4723 32.6109V24.2113H87.5231V24.9725H87.522ZM85.1658 31.4416C83.7479 31.4416 82.561 30.2536 82.561 28.6234C82.561 26.9745 83.7479 25.77 85.1658 25.77C86.565 25.77 87.6639 26.9745 87.6639 28.6234C87.6639 30.2536 86.565 31.4416 85.1658 31.4416ZM111.985 19.2492H107.067V33.0003H109.118V27.7907H111.984C114.259 27.7907 116.496 26.144 116.496 23.5205C116.496 20.897 114.26 19.2492 111.985 19.2492ZM112.038 25.8767H109.118V21.1632H112.038C113.572 21.1632 114.443 22.4337 114.443 23.5205C114.443 24.5853 113.572 25.8767 112.038 25.8767ZM124.723 23.9022C123.237 23.9022 121.698 24.5567 121.061 26.0076L122.883 26.7677C123.272 26.0076 123.998 25.759 124.758 25.759C125.82 25.759 126.899 26.3959 126.916 27.5278V27.6697C126.545 27.4574 125.748 27.1395 124.776 27.1395C122.812 27.1395 120.812 28.2186 120.812 30.2349C120.812 32.0752 122.423 33.2599 124.227 33.2599C125.606 33.2599 126.367 32.6406 126.845 31.9146H126.915V32.9761H128.897V27.7038C128.899 25.264 127.075 23.9022 124.723 23.9022ZM124.474 31.4383C123.803 31.4383 122.865 31.1017 122.865 30.2701C122.865 29.2086 124.033 28.8016 125.042 28.8016C125.943 28.8016 126.369 28.9963 126.916 29.2614C126.757 30.5363 125.66 31.4383 124.474 31.4383ZM136.116 24.2025L133.763 30.1645H133.692L131.25 24.2025H129.039L132.701 32.535L130.613 37.1704H132.754L138.398 24.2025H136.116ZM117.629 33.0003H119.681V19.2492H117.629V33.0003Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M52.1609 11.2673C52.1609 12.1891 51.8881 12.9228 51.3414 13.4706C50.721 14.1218 49.9114 14.4474 48.917 14.4474C47.9644 14.4474 47.1537 14.1174 46.4882 13.4574C45.8216 12.7963 45.4883 11.9779 45.4883 11.0011C45.4883 10.0232 45.8216 9.20476 46.4882 8.54476C47.1537 7.88366 47.9644 7.55366 48.917 7.55366C49.39 7.55366 49.8421 7.64606 50.2711 7.82976C50.7012 8.01456 51.0455 8.25986 51.3029 8.56676L50.7232 9.14756C50.2865 8.62506 49.6848 8.36436 48.9159 8.36436C48.2207 8.36436 47.6201 8.60856 47.113 9.09696C46.6059 9.58536 46.3529 10.2201 46.3529 11C46.3529 11.7799 46.6059 12.4146 47.113 12.903C47.6201 13.3914 48.2207 13.6356 48.9159 13.6356C49.6529 13.6356 50.2678 13.3903 50.7595 12.8986C51.0785 12.5785 51.2633 12.133 51.3128 11.5621H48.9159V10.769H52.1136C52.1466 10.9417 52.1609 11.1078 52.1609 11.2673Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M57.232 8.51072H54.2268V10.6029H56.9372V11.396H54.2268V13.4882H57.232V14.3H53.3787V7.70002H57.232V8.51072Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M60.808 14.3H59.9599V8.51072H58.1163V7.70002H62.6516V8.51072H60.808V14.3Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t("path", { d: "M65.9328 14.3V7.70002H66.7809V14.3H65.9328Z", fill: "black" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M70.542 14.3H69.6939V8.51072H67.8503V7.70002H72.3856V8.51072H70.542V14.3Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M80.9708 13.4475C80.3218 14.1141 79.5155 14.4474 78.5508 14.4474C77.5861 14.4474 76.7798 14.1141 76.1319 13.4475C75.4829 12.7809 75.1595 11.9647 75.1595 11C75.1595 10.0353 75.4829 9.21911 76.1319 8.55251C76.7798 7.88591 77.5861 7.55151 78.5508 7.55151C79.51 7.55151 80.3153 7.88701 80.9664 8.55691C81.6176 9.22681 81.9432 10.0408 81.9432 11C81.9432 11.9647 81.6187 12.7809 80.9708 13.4475ZM76.7578 12.8942C77.2462 13.3892 77.8435 13.6356 78.5508 13.6356C79.2581 13.6356 79.8565 13.3881 80.3438 12.8942C80.8322 12.3992 81.0775 11.7678 81.0775 11C81.0775 10.2322 80.8322 9.60081 80.3438 9.10581C79.8565 8.61081 79.2581 8.36441 78.5508 8.36441C77.8435 8.36441 77.2462 8.61191 76.7578 9.10581C76.2705 9.60081 76.0252 10.2322 76.0252 11C76.0252 11.7678 76.2705 12.3992 76.7578 12.8942Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M83.1335 14.3V7.70002H84.1653L87.3729 12.8337H87.4092L87.3729 11.5621V7.70002H88.221V14.3H87.3355L83.9794 8.91663H83.9431L83.9794 10.1882V14.3H83.1335Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M52.1609 11.2673C52.1609 12.1891 51.8881 12.9228 51.3414 13.4706C50.721 14.1218 49.9114 14.4474 48.917 14.4474C47.9644 14.4474 47.1537 14.1174 46.4882 13.4574C45.8216 12.7963 45.4883 11.9779 45.4883 11.0011C45.4883 10.0232 45.8216 9.20476 46.4882 8.54476C47.1537 7.88366 47.9644 7.55366 48.917 7.55366C49.39 7.55366 49.8421 7.64606 50.2711 7.82976C50.7012 8.01456 51.0455 8.25986 51.3029 8.56676L50.7232 9.14756C50.2865 8.62506 49.6848 8.36436 48.9159 8.36436C48.2207 8.36436 47.6201 8.60856 47.113 9.09696C46.6059 9.58536 46.3529 10.2201 46.3529 11C46.3529 11.7799 46.6059 12.4146 47.113 12.903C47.6201 13.3914 48.2207 13.6356 48.9159 13.6356C49.6529 13.6356 50.2678 13.3903 50.7595 12.8986C51.0785 12.5785 51.2633 12.133 51.3128 11.5621H48.9159V10.769H52.1136C52.1466 10.9417 52.1609 11.1078 52.1609 11.2673Z",
          stroke: "black",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M57.232 8.51072H54.2268V10.6029H56.9372V11.396H54.2268V13.4882H57.232V14.3H53.3787V7.70002H57.232V8.51072Z",
          stroke: "black",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M60.808 14.3H59.9599V8.51072H58.1163V7.70002H62.6516V8.51072H60.808V14.3Z",
          stroke: "black",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M65.9328 14.3V7.70002H66.7809V14.3H65.9328Z",
          stroke: "black",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M70.542 14.3H69.6939V8.51072H67.8503V7.70002H72.3856V8.51072H70.542V14.3Z",
          stroke: "black",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M80.9708 13.4475C80.3218 14.1141 79.5155 14.4474 78.5508 14.4474C77.5861 14.4474 76.7798 14.1141 76.1319 13.4475C75.4829 12.7809 75.1595 11.9647 75.1595 11C75.1595 10.0353 75.4829 9.21911 76.1319 8.55251C76.7798 7.88591 77.5861 7.55151 78.5508 7.55151C79.51 7.55151 80.3153 7.88701 80.9664 8.55691C81.6176 9.22681 81.9432 10.0408 81.9432 11C81.9432 11.9647 81.6187 12.7809 80.9708 13.4475ZM76.7578 12.8942C77.2462 13.3892 77.8435 13.6356 78.5508 13.6356C79.2581 13.6356 79.8565 13.3881 80.3438 12.8942C80.8322 12.3992 81.0775 11.7678 81.0775 11C81.0775 10.2322 80.8322 9.60081 80.3438 9.10581C79.8565 8.61081 79.2581 8.36441 78.5508 8.36441C77.8435 8.36441 77.2462 8.61191 76.7578 9.10581C76.2705 9.60081 76.0252 10.2322 76.0252 11C76.0252 11.7678 76.2705 12.3992 76.7578 12.8942Z",
          stroke: "black",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M83.1335 14.3V7.70002H84.1653L87.3729 12.8337H87.4092L87.3729 11.5621V7.70002H88.221V14.3H87.3355L83.9794 8.91663H83.9431L83.9794 10.1882V14.3H83.1335Z",
          stroke: "black",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.1927 8.7146C11.0487 9.01741 10.9688 9.39455 10.9688 9.83725V34.1649C10.9688 34.6085 11.0488 34.9857 11.1929 35.2883L24.4787 22.0006L11.1927 8.7146ZM11.8865 36.009C12.3831 36.245 13.0426 36.1876 13.7638 35.7786L29.3818 26.9037L25.1858 22.7078L11.8865 36.009ZM30.2843 26.392L35.2149 23.5906C36.7516 22.7161 36.7516 21.2872 35.2149 20.4138L30.2821 17.6108L25.8929 22.0006L30.2843 26.392ZM29.3803 17.0984L13.7638 8.22466C13.0425 7.81477 12.383 7.75779 11.8864 7.99411L25.1858 21.2935L29.3803 17.0984Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "147.5", height: "43", rx: "4.5", stroke: "black" })
    ]
  }
), T7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "135",
    height: "40",
    viewBox: "0 0 135 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "134", height: "39", rx: "4.5", fill: "white" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M68.137 21.7511C65.785 21.7511 63.868 23.5401 63.868 26.0041C63.868 28.4531 65.785 30.2571 68.137 30.2571C70.49 30.2571 72.407 28.4531 72.407 26.0041C72.406 23.5401 70.489 21.7511 68.137 21.7511ZM68.137 28.5831C66.848 28.5831 65.737 27.5201 65.737 26.0051C65.737 24.4741 66.849 23.4271 68.137 23.4271C69.426 23.4271 70.537 24.4741 70.537 26.0051C70.537 27.5191 69.426 28.5831 68.137 28.5831ZM58.823 21.7511C56.471 21.7511 54.554 23.5401 54.554 26.0041C54.554 28.4531 56.471 30.2571 58.823 30.2571C61.176 30.2571 63.093 28.4531 63.093 26.0041C63.093 23.5401 61.176 21.7511 58.823 21.7511ZM58.823 28.5831C57.534 28.5831 56.423 27.5201 56.423 26.0051C56.423 24.4741 57.535 23.4271 58.823 23.4271C60.112 23.4271 61.223 24.4741 61.223 26.0051C61.224 27.5191 60.112 28.5831 58.823 28.5831ZM47.745 23.0571V24.8611H52.063C51.934 25.8761 51.596 26.6171 51.08 27.1321C50.452 27.7601 49.469 28.4531 47.745 28.4531C45.087 28.4531 43.009 26.3101 43.009 23.6521C43.009 20.9941 45.087 18.8511 47.745 18.8511C49.179 18.8511 50.226 19.4151 50.999 20.1401L52.272 18.8671C51.192 17.8361 49.759 17.0471 47.745 17.0471C44.104 17.0471 41.043 20.0111 41.043 23.6521C41.043 27.2931 44.104 30.2571 47.745 30.2571C49.71 30.2571 51.193 29.6121 52.352 28.4041C53.544 27.2121 53.915 25.5361 53.915 24.1831C53.915 23.7651 53.883 23.3781 53.818 23.0561H47.745V23.0571ZM93.053 24.4581C92.699 23.5081 91.619 21.7511 89.412 21.7511C87.221 21.7511 85.4 23.4751 85.4 26.0041C85.4 28.3881 87.205 30.2571 89.621 30.2571C91.57 30.2571 92.698 29.0651 93.166 28.3721L91.716 27.4051C91.233 28.1141 90.572 28.5811 89.621 28.5811C88.671 28.5811 87.994 28.1461 87.559 27.2921L93.246 24.9401L93.053 24.4581ZM87.253 25.8761C87.205 24.2321 88.526 23.3951 89.477 23.3951C90.218 23.3951 90.846 23.7661 91.056 24.2971L87.253 25.8761ZM82.63 30.0001H84.498V17.4991H82.63V30.0001ZM79.568 22.7021H79.504C79.085 22.2021 78.279 21.7511 77.265 21.7511C75.138 21.7511 73.189 23.6201 73.189 26.0211C73.189 28.4051 75.138 30.2581 77.265 30.2581C78.28 30.2581 79.085 29.8071 79.504 29.2921H79.568V29.9041C79.568 31.5311 78.698 32.4011 77.297 32.4011C76.153 32.4011 75.444 31.5801 75.154 30.8871L73.527 31.5641C73.994 32.6911 75.234 34.0771 77.297 34.0771C79.488 34.0771 81.341 32.7881 81.341 29.6461V22.0101H79.569V22.7021H79.568ZM77.426 28.5831C76.137 28.5831 75.058 27.5031 75.058 26.0211C75.058 24.5221 76.137 23.4271 77.426 23.4271C78.698 23.4271 79.697 24.5221 79.697 26.0211C79.697 27.5031 78.698 28.5831 77.426 28.5831ZM101.807 17.4991H97.336V30.0001H99.201V25.2641H101.806C103.874 25.2641 105.908 23.7671 105.908 21.3821C105.908 18.9971 103.875 17.4991 101.807 17.4991ZM101.855 23.5241H99.201V19.2391H101.855C103.25 19.2391 104.042 20.3941 104.042 21.3821C104.042 22.3501 103.25 23.5241 101.855 23.5241ZM113.387 21.7291C112.036 21.7291 110.637 22.3241 110.058 23.6431L111.714 24.3341C112.068 23.6431 112.728 23.4171 113.419 23.4171C114.384 23.4171 115.365 23.9961 115.381 25.0251V25.1541C115.043 24.9611 114.319 24.6721 113.435 24.6721C111.65 24.6721 109.832 25.6531 109.832 27.4861C109.832 29.1591 111.296 30.2361 112.936 30.2361C114.19 30.2361 114.882 29.6731 115.316 29.0131H115.38V29.9781H117.182V25.1851C117.183 22.9671 115.525 21.7291 113.387 21.7291ZM113.161 28.5801C112.551 28.5801 111.698 28.2741 111.698 27.5181C111.698 26.5531 112.76 26.1831 113.677 26.1831C114.496 26.1831 114.883 26.3601 115.381 26.6011C115.236 27.7601 114.239 28.5801 113.161 28.5801ZM123.744 22.0021L121.605 27.4221H121.541L119.321 22.0021H117.311L120.64 29.5771L118.742 33.7911H120.688L125.819 22.0021H123.744ZM106.938 30.0001H108.803V17.4991H106.938V30.0001Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M47.4176 10.2429C47.4176 11.0809 47.1696 11.7479 46.6726 12.2459C46.1086 12.8379 45.3726 13.1339 44.4686 13.1339C43.6026 13.1339 42.8656 12.8339 42.2606 12.2339C41.6546 11.6329 41.3516 10.8889 41.3516 10.0009C41.3516 9.11194 41.6546 8.36794 42.2606 7.76794C42.8656 7.16694 43.6026 6.86694 44.4686 6.86694C44.8986 6.86694 45.3096 6.95094 45.6996 7.11794C46.0906 7.28594 46.4036 7.50894 46.6376 7.78794L46.1106 8.31594C45.7136 7.84094 45.1666 7.60394 44.4676 7.60394C43.8356 7.60394 43.2896 7.82594 42.8286 8.26994C42.3676 8.71394 42.1376 9.29094 42.1376 9.99994C42.1376 10.7089 42.3676 11.2859 42.8286 11.7299C43.2896 12.1739 43.8356 12.3959 44.4676 12.3959C45.1376 12.3959 45.6966 12.1729 46.1436 11.7259C46.4336 11.4349 46.6016 11.0299 46.6466 10.5109H44.4676V9.78994H47.3746C47.4046 9.94694 47.4176 10.0979 47.4176 10.2429Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M52.0277 7.737H49.2957V9.639H51.7597V10.36H49.2957V12.262H52.0277V13H48.5247V7H52.0277V7.737Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M55.2785 13H54.5075V7.737H52.8315V7H56.9545V7.737H55.2785V13Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t("path", { d: "M59.9375 13V7H60.7085V13H59.9375Z", fill: "black" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M64.1277 13H63.3567V7.737H61.6807V7H65.8037V7.737H64.1277V13Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M73.6084 12.225C73.0184 12.831 72.2854 13.134 71.4084 13.134C70.5314 13.134 69.7984 12.831 69.2094 12.225C68.6194 11.619 68.3254 10.877 68.3254 9.99999C68.3254 9.12299 68.6194 8.38099 69.2094 7.77499C69.7984 7.16899 70.5314 6.86499 71.4084 6.86499C72.2804 6.86499 73.0124 7.16999 73.6044 7.77899C74.1964 8.38799 74.4924 9.12799 74.4924 9.99999C74.4924 10.877 74.1974 11.619 73.6084 12.225ZM69.7784 11.722C70.2224 12.172 70.7654 12.396 71.4084 12.396C72.0514 12.396 72.5954 12.171 73.0384 11.722C73.4824 11.272 73.7054 10.698 73.7054 9.99999C73.7054 9.30199 73.4824 8.72799 73.0384 8.27799C72.5954 7.82799 72.0514 7.60399 71.4084 7.60399C70.7654 7.60399 70.2224 7.82899 69.7784 8.27799C69.3354 8.72799 69.1124 9.30199 69.1124 9.99999C69.1124 10.698 69.3354 11.272 69.7784 11.722Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M75.5745 13V7H76.5125L79.4285 11.667H79.4615L79.4285 10.511V7H80.1995V13H79.3945L76.3435 8.106H76.3105L76.3435 9.262V13H75.5745Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M47.4176 10.2429C47.4176 11.0809 47.1696 11.7479 46.6726 12.2459C46.1086 12.8379 45.3726 13.1339 44.4686 13.1339C43.6026 13.1339 42.8656 12.8339 42.2606 12.2339C41.6546 11.6329 41.3516 10.8889 41.3516 10.0009C41.3516 9.11194 41.6546 8.36794 42.2606 7.76794C42.8656 7.16694 43.6026 6.86694 44.4686 6.86694C44.8986 6.86694 45.3096 6.95094 45.6996 7.11794C46.0906 7.28594 46.4036 7.50894 46.6376 7.78794L46.1106 8.31594C45.7136 7.84094 45.1666 7.60394 44.4676 7.60394C43.8356 7.60394 43.2896 7.82594 42.8286 8.26994C42.3676 8.71394 42.1376 9.29094 42.1376 9.99994C42.1376 10.7089 42.3676 11.2859 42.8286 11.7299C43.2896 12.1739 43.8356 12.3959 44.4676 12.3959C45.1376 12.3959 45.6966 12.1729 46.1436 11.7259C46.4336 11.4349 46.6016 11.0299 46.6466 10.5109H44.4676V9.78994H47.3746C47.4046 9.94694 47.4176 10.0979 47.4176 10.2429Z",
          stroke: "black",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M52.0277 7.737H49.2957V9.639H51.7597V10.36H49.2957V12.262H52.0277V13H48.5247V7H52.0277V7.737Z",
          stroke: "black",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M55.2785 13H54.5075V7.737H52.8315V7H56.9545V7.737H55.2785V13Z",
          stroke: "black",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M59.9375 13V7H60.7085V13H59.9375Z",
          stroke: "black",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M64.1277 13H63.3567V7.737H61.6807V7H65.8037V7.737H64.1277V13Z",
          stroke: "black",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M73.6084 12.225C73.0184 12.831 72.2854 13.134 71.4084 13.134C70.5314 13.134 69.7984 12.831 69.2094 12.225C68.6194 11.619 68.3254 10.877 68.3254 9.99999C68.3254 9.12299 68.6194 8.38099 69.2094 7.77499C69.7984 7.16899 70.5314 6.86499 71.4084 6.86499C72.2804 6.86499 73.0124 7.16999 73.6044 7.77899C74.1964 8.38799 74.4924 9.12799 74.4924 9.99999C74.4924 10.877 74.1974 11.619 73.6084 12.225ZM69.7784 11.722C70.2224 12.172 70.7654 12.396 71.4084 12.396C72.0514 12.396 72.5954 12.171 73.0384 11.722C73.4824 11.272 73.7054 10.698 73.7054 9.99999C73.7054 9.30199 73.4824 8.72799 73.0384 8.27799C72.5954 7.82799 72.0514 7.60399 71.4084 7.60399C70.7654 7.60399 70.2224 7.82899 69.7784 8.27799C69.3354 8.72799 69.1124 9.30199 69.1124 9.99999C69.1124 10.698 69.3354 11.272 69.7784 11.722Z",
          stroke: "black",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M75.5745 13V7H76.5125L79.4285 11.667H79.4615L79.4285 10.511V7H80.1995V13H79.3945L76.3435 8.106H76.3105L76.3435 9.262V13H75.5745Z",
          stroke: "black",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.156 7.96642C10.0379 8.23392 9.97266 8.56168 9.97266 8.94294V31.0589C9.97266 31.441 10.038 31.7688 10.1562 32.0362L22.1902 20.0006L10.156 7.96642ZM10.8512 32.7554C11.2973 32.9463 11.8792 32.8858 12.5137 32.5259L26.6708 24.4812L22.8973 20.7077L10.8512 32.7554ZM27.5732 23.9694L32.0147 21.4459C33.4116 20.6509 33.4116 19.3519 32.0147 18.5579L27.5712 16.0331L23.6043 20.0005L27.5732 23.9694ZM26.6694 15.5206L12.5137 7.47694C11.8791 7.11637 11.2972 7.0562 10.8512 7.24734L22.8972 19.2934L26.6694 15.5206Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "134", height: "39", rx: "4.5", stroke: "black" })
    ]
  }
), G7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "149",
    height: "44",
    viewBox: "0 0 149 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "147.5", height: "43", rx: "4.5", fill: "black" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M74.9479 23.9264C72.3607 23.9264 70.252 25.8943 70.252 28.6047C70.252 31.2986 72.3607 33.283 74.9479 33.283C77.5362 33.283 79.6449 31.2986 79.6449 28.6047C79.6438 25.8943 77.5351 23.9264 74.9479 23.9264ZM74.9479 31.4416C73.53 31.4416 72.3079 30.2723 72.3079 28.6058C72.3079 26.9217 73.5311 25.77 74.9479 25.77C76.3658 25.77 77.5879 26.9217 77.5879 28.6058C77.5879 30.2712 76.3658 31.4416 74.9479 31.4416ZM64.7025 23.9264C62.1153 23.9264 60.0066 25.8943 60.0066 28.6047C60.0066 31.2986 62.1153 33.283 64.7025 33.283C67.2908 33.283 69.3995 31.2986 69.3995 28.6047C69.3995 25.8943 67.2908 23.9264 64.7025 23.9264ZM64.7025 31.4416C63.2846 31.4416 62.0625 30.2723 62.0625 28.6058C62.0625 26.9217 63.2857 25.77 64.7025 25.77C66.1204 25.77 67.3425 26.9217 67.3425 28.6058C67.3436 30.2712 66.1204 31.4416 64.7025 31.4416ZM52.5167 25.363V27.3474H57.2665C57.1246 28.4639 56.7528 29.279 56.1852 29.8455C55.4944 30.5363 54.4131 31.2986 52.5167 31.2986C49.5929 31.2986 47.3071 28.9413 47.3071 26.0175C47.3071 23.0937 49.5929 20.7364 52.5167 20.7364C54.0941 20.7364 55.2458 21.3568 56.0961 22.1543L57.4964 20.754C56.3084 19.6199 54.7321 18.752 52.5167 18.752C48.5116 18.752 45.1445 22.0124 45.1445 26.0175C45.1445 30.0226 48.5116 33.283 52.5167 33.283C54.6782 33.283 56.3095 32.5735 57.5844 31.2447C58.8956 29.9335 59.3037 28.0899 59.3037 26.6016C59.3037 26.1418 59.2685 25.7161 59.197 25.3619H52.5167V25.363ZM102.356 26.9041C101.966 25.8591 100.778 23.9264 98.3504 23.9264C95.9403 23.9264 93.9372 25.8228 93.9372 28.6047C93.9372 31.2271 95.9227 33.283 98.5803 33.283C100.724 33.283 101.965 31.9718 102.48 31.2095L100.885 30.1458C100.354 30.9257 99.6264 31.4394 98.5803 31.4394C97.5353 31.4394 96.7906 30.9609 96.3121 30.0215L102.568 27.4343L102.356 26.9041ZM95.9755 28.4639C95.9227 26.6555 97.3758 25.7348 98.4219 25.7348C99.237 25.7348 99.9278 26.1429 100.159 26.727L95.9755 28.4639ZM90.8902 33.0003H92.945V19.2492H90.8902V33.0003ZM87.522 24.9725H87.4516C86.9907 24.4225 86.1041 23.9264 84.9887 23.9264C82.649 23.9264 80.5051 25.9823 80.5051 28.6234C80.5051 31.2458 82.649 33.2841 84.9887 33.2841C86.1052 33.2841 86.9907 32.788 87.4516 32.2215H87.522V32.8947C87.522 34.6844 86.565 35.6414 85.0239 35.6414C83.7655 35.6414 82.9856 34.7383 82.6666 33.976L80.8769 34.7207C81.3906 35.9604 82.7546 37.485 85.0239 37.485C87.434 37.485 89.4723 36.0671 89.4723 32.6109V24.2113H87.5231V24.9725H87.522ZM85.1658 31.4416C83.7479 31.4416 82.561 30.2536 82.561 28.6234C82.561 26.9745 83.7479 25.77 85.1658 25.77C86.565 25.77 87.6639 26.9745 87.6639 28.6234C87.6639 30.2536 86.565 31.4416 85.1658 31.4416ZM111.985 19.2492H107.067V33.0003H109.118V27.7907H111.984C114.259 27.7907 116.496 26.144 116.496 23.5205C116.496 20.897 114.26 19.2492 111.985 19.2492ZM112.038 25.8767H109.118V21.1632H112.038C113.572 21.1632 114.443 22.4337 114.443 23.5205C114.443 24.5853 113.572 25.8767 112.038 25.8767ZM124.723 23.9022C123.237 23.9022 121.698 24.5567 121.061 26.0076L122.883 26.7677C123.272 26.0076 123.998 25.759 124.758 25.759C125.82 25.759 126.899 26.3959 126.916 27.5278V27.6697C126.545 27.4574 125.748 27.1395 124.776 27.1395C122.812 27.1395 120.812 28.2186 120.812 30.2349C120.812 32.0752 122.423 33.2599 124.227 33.2599C125.606 33.2599 126.367 32.6406 126.845 31.9146H126.915V32.9761H128.897V27.7038C128.899 25.264 127.075 23.9022 124.723 23.9022ZM124.474 31.4383C123.803 31.4383 122.865 31.1017 122.865 30.2701C122.865 29.2086 124.033 28.8016 125.042 28.8016C125.943 28.8016 126.369 28.9963 126.916 29.2614C126.757 30.5363 125.66 31.4383 124.474 31.4383ZM136.116 24.2025L133.763 30.1645H133.692L131.25 24.2025H129.039L132.701 32.535L130.613 37.1704H132.754L138.398 24.2025H136.116ZM117.629 33.0003H119.681V19.2492H117.629V33.0003Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M52.1609 11.2673C52.1609 12.1891 51.8881 12.9228 51.3414 13.4706C50.721 14.1218 49.9114 14.4474 48.917 14.4474C47.9644 14.4474 47.1537 14.1174 46.4882 13.4574C45.8216 12.7963 45.4883 11.9779 45.4883 11.0011C45.4883 10.0232 45.8216 9.20476 46.4882 8.54476C47.1537 7.88366 47.9644 7.55366 48.917 7.55366C49.39 7.55366 49.8421 7.64606 50.2711 7.82976C50.7012 8.01456 51.0455 8.25986 51.3029 8.56676L50.7232 9.14756C50.2865 8.62506 49.6848 8.36436 48.9159 8.36436C48.2207 8.36436 47.6201 8.60856 47.113 9.09696C46.6059 9.58536 46.3529 10.2201 46.3529 11C46.3529 11.7799 46.6059 12.4146 47.113 12.903C47.6201 13.3914 48.2207 13.6356 48.9159 13.6356C49.6529 13.6356 50.2678 13.3903 50.7595 12.8986C51.0785 12.5785 51.2633 12.133 51.3128 11.5621H48.9159V10.769H52.1136C52.1466 10.9417 52.1609 11.1078 52.1609 11.2673Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M57.232 8.51072H54.2268V10.6029H56.9372V11.396H54.2268V13.4882H57.232V14.3H53.3787V7.70002H57.232V8.51072Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M60.808 14.3H59.9599V8.51072H58.1163V7.70002H62.6516V8.51072H60.808V14.3Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t("path", { d: "M65.9328 14.3V7.70002H66.7809V14.3H65.9328Z", fill: "white" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M70.542 14.3H69.6939V8.51072H67.8503V7.70002H72.3856V8.51072H70.542V14.3Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M80.9708 13.4475C80.3218 14.1141 79.5155 14.4474 78.5508 14.4474C77.5861 14.4474 76.7798 14.1141 76.1319 13.4475C75.4829 12.7809 75.1595 11.9647 75.1595 11C75.1595 10.0353 75.4829 9.21911 76.1319 8.55251C76.7798 7.88591 77.5861 7.55151 78.5508 7.55151C79.51 7.55151 80.3153 7.88701 80.9664 8.55691C81.6176 9.22681 81.9432 10.0408 81.9432 11C81.9432 11.9647 81.6187 12.7809 80.9708 13.4475ZM76.7578 12.8942C77.2462 13.3892 77.8435 13.6356 78.5508 13.6356C79.2581 13.6356 79.8565 13.3881 80.3438 12.8942C80.8322 12.3992 81.0775 11.7678 81.0775 11C81.0775 10.2322 80.8322 9.60081 80.3438 9.10581C79.8565 8.61081 79.2581 8.36441 78.5508 8.36441C77.8435 8.36441 77.2462 8.61191 76.7578 9.10581C76.2705 9.60081 76.0252 10.2322 76.0252 11C76.0252 11.7678 76.2705 12.3992 76.7578 12.8942Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M83.1335 14.3V7.70002H84.1653L87.3729 12.8337H87.4092L87.3729 11.5621V7.70002H88.221V14.3H87.3355L83.9794 8.91663H83.9431L83.9794 10.1882V14.3H83.1335Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M52.1609 11.2673C52.1609 12.1891 51.8881 12.9228 51.3414 13.4706C50.721 14.1218 49.9114 14.4474 48.917 14.4474C47.9644 14.4474 47.1537 14.1174 46.4882 13.4574C45.8216 12.7963 45.4883 11.9779 45.4883 11.0011C45.4883 10.0232 45.8216 9.20476 46.4882 8.54476C47.1537 7.88366 47.9644 7.55366 48.917 7.55366C49.39 7.55366 49.8421 7.64606 50.2711 7.82976C50.7012 8.01456 51.0455 8.25986 51.3029 8.56676L50.7232 9.14756C50.2865 8.62506 49.6848 8.36436 48.9159 8.36436C48.2207 8.36436 47.6201 8.60856 47.113 9.09696C46.6059 9.58536 46.3529 10.2201 46.3529 11C46.3529 11.7799 46.6059 12.4146 47.113 12.903C47.6201 13.3914 48.2207 13.6356 48.9159 13.6356C49.6529 13.6356 50.2678 13.3903 50.7595 12.8986C51.0785 12.5785 51.2633 12.133 51.3128 11.5621H48.9159V10.769H52.1136C52.1466 10.9417 52.1609 11.1078 52.1609 11.2673Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M57.232 8.51072H54.2268V10.6029H56.9372V11.396H54.2268V13.4882H57.232V14.3H53.3787V7.70002H57.232V8.51072Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M60.808 14.3H59.9599V8.51072H58.1163V7.70002H62.6516V8.51072H60.808V14.3Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M65.9328 14.3V7.70002H66.7809V14.3H65.9328Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M70.542 14.3H69.6939V8.51072H67.8503V7.70002H72.3856V8.51072H70.542V14.3Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M80.9708 13.4475C80.3218 14.1141 79.5155 14.4474 78.5508 14.4474C77.5861 14.4474 76.7798 14.1141 76.1319 13.4475C75.4829 12.7809 75.1595 11.9647 75.1595 11C75.1595 10.0353 75.4829 9.21911 76.1319 8.55251C76.7798 7.88591 77.5861 7.55151 78.5508 7.55151C79.51 7.55151 80.3153 7.88701 80.9664 8.55691C81.6176 9.22681 81.9432 10.0408 81.9432 11C81.9432 11.9647 81.6187 12.7809 80.9708 13.4475ZM76.7578 12.8942C77.2462 13.3892 77.8435 13.6356 78.5508 13.6356C79.2581 13.6356 79.8565 13.3881 80.3438 12.8942C80.8322 12.3992 81.0775 11.7678 81.0775 11C81.0775 10.2322 80.8322 9.60081 80.3438 9.10581C79.8565 8.61081 79.2581 8.36441 78.5508 8.36441C77.8435 8.36441 77.2462 8.61191 76.7578 9.10581C76.2705 9.60081 76.0252 10.2322 76.0252 11C76.0252 11.7678 76.2705 12.3992 76.7578 12.8942Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M83.1335 14.3V7.70002H84.1653L87.3729 12.8337H87.4092L87.3729 11.5621V7.70002H88.221V14.3H87.3355L83.9794 8.91663H83.9431L83.9794 10.1882V14.3H83.1335Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ c("g", { filter: "url(#filter0_ii_2136_37677)", children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M11.4781 8.29173C11.158 8.63053 10.9687 9.15633 10.9687 9.83723V34.1648C10.9687 34.8468 11.158 35.3715 11.4781 35.7103L11.5595 35.7895L25.1874 22.1616V22.001V21.8404L11.5595 8.21143L11.4781 8.29173Z",
            fill: "url(#paint0_linear_2136_37677)"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M29.7294 26.7057L25.1875 22.1616V22.001V21.8404L29.7305 17.2974L29.8328 17.3557L35.2151 20.4137C36.7518 21.2871 36.7518 22.716 35.2151 23.5905L29.8328 26.6485L29.7294 26.7057Z",
            fill: "url(#paint1_linear_2136_37677)"
          }
        ),
        /* @__PURE__ */ t("g", { filter: "url(#filter1_i_2136_37677)", children: /* @__PURE__ */ t(
          "path",
          {
            d: "M29.8312 26.6474L25.1848 22.001L11.4766 35.7103C11.9826 36.2471 12.8197 36.3131 13.7624 35.7785L29.8312 26.6474Z",
            fill: "url(#paint2_linear_2136_37677)"
          }
        ) }),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M29.8312 17.3547L13.7624 8.22466C12.8197 7.68896 11.9826 7.75606 11.4766 8.29286L25.1859 22.0022L29.8312 17.3547Z",
            fill: "url(#paint3_linear_2136_37677)"
          }
        )
      ] }),
      /* @__PURE__ */ t(
        "rect",
        {
          x: "0.5",
          y: "0.5",
          width: "147.5",
          height: "43",
          rx: "4.5",
          stroke: "#A6A6A6"
        }
      ),
      /* @__PURE__ */ c("defs", { children: [
        /* @__PURE__ */ c(
          "filter",
          {
            id: "filter0_ii_2136_37677",
            x: "10.9688",
            y: "7.85498",
            width: "25.3984",
            height: "28.2927",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ t("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ t(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              ),
              /* @__PURE__ */ t(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ t("feOffset", { dy: "-0.15" }),
              /* @__PURE__ */ t("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
              /* @__PURE__ */ t(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                }
              ),
              /* @__PURE__ */ t(
                "feBlend",
                {
                  mode: "normal",
                  in2: "shape",
                  result: "effect1_innerShadow_2136_37677"
                }
              ),
              /* @__PURE__ */ t(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ t("feOffset", { dy: "0.15" }),
              /* @__PURE__ */ t("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
              /* @__PURE__ */ t(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
                }
              ),
              /* @__PURE__ */ t(
                "feBlend",
                {
                  mode: "normal",
                  in2: "effect1_innerShadow_2136_37677",
                  result: "effect2_innerShadow_2136_37677"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ c(
          "filter",
          {
            id: "filter1_i_2136_37677",
            x: "11.4766",
            y: "22.001",
            width: "18.3555",
            height: "14.1467",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ t("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ t(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              ),
              /* @__PURE__ */ t(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ t("feOffset", { dy: "-0.15" }),
              /* @__PURE__ */ t("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
              /* @__PURE__ */ t(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                }
              ),
              /* @__PURE__ */ t(
                "feBlend",
                {
                  mode: "normal",
                  in2: "shape",
                  result: "effect1_innerShadow_2136_37677"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ c(
          "linearGradient",
          {
            id: "paint0_linear_2136_37677",
            x1: "23.9793",
            y1: "9.57983",
            x2: "5.51913",
            y2: "28.04",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ t("stop", { stopColor: "#00A0FF" }),
              /* @__PURE__ */ t("stop", { offset: "0.0066", stopColor: "#00A1FF" }),
              /* @__PURE__ */ t("stop", { offset: "0.2601", stopColor: "#00BEFF" }),
              /* @__PURE__ */ t("stop", { offset: "0.5122", stopColor: "#00D2FF" }),
              /* @__PURE__ */ t("stop", { offset: "0.7604", stopColor: "#00DFFF" }),
              /* @__PURE__ */ t("stop", { offset: "1", stopColor: "#00E3FF" })
            ]
          }
        ),
        /* @__PURE__ */ c(
          "linearGradient",
          {
            id: "paint1_linear_2136_37677",
            x1: "37.2154",
            y1: "22.001",
            x2: "10.6",
            y2: "22.001",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ t("stop", { stopColor: "#FFE000" }),
              /* @__PURE__ */ t("stop", { offset: "0.4087", stopColor: "#FFBD00" }),
              /* @__PURE__ */ t("stop", { offset: "0.7754", stopColor: "#FFA500" }),
              /* @__PURE__ */ t("stop", { offset: "1", stopColor: "#FF9C00" })
            ]
          }
        ),
        /* @__PURE__ */ c(
          "linearGradient",
          {
            id: "paint2_linear_2136_37677",
            x1: "27.3079",
            y1: "24.5243",
            x2: "2.27353",
            y2: "49.5586",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ t("stop", { stopColor: "#FF3A44" }),
              /* @__PURE__ */ t("stop", { offset: "1", stopColor: "#C31162" })
            ]
          }
        ),
        /* @__PURE__ */ c(
          "linearGradient",
          {
            id: "paint3_linear_2136_37677",
            x1: "8.0241",
            y1: "0.194443",
            x2: "19.2026",
            y2: "11.373",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ t("stop", { stopColor: "#32A071" }),
              /* @__PURE__ */ t("stop", { offset: "0.0685", stopColor: "#2DA771" }),
              /* @__PURE__ */ t("stop", { offset: "0.4762", stopColor: "#15CF74" }),
              /* @__PURE__ */ t("stop", { offset: "0.8009", stopColor: "#06E775" }),
              /* @__PURE__ */ t("stop", { offset: "1", stopColor: "#00F076" })
            ]
          }
        )
      ] })
    ]
  }
), j7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "135",
    height: "40",
    viewBox: "0 0 135 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "134", height: "39", rx: "4.5", fill: "black" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M68.137 21.7511C65.785 21.7511 63.868 23.5401 63.868 26.0041C63.868 28.4531 65.785 30.2571 68.137 30.2571C70.49 30.2571 72.407 28.4531 72.407 26.0041C72.406 23.5401 70.489 21.7511 68.137 21.7511ZM68.137 28.5831C66.848 28.5831 65.737 27.5201 65.737 26.0051C65.737 24.4741 66.849 23.4271 68.137 23.4271C69.426 23.4271 70.537 24.4741 70.537 26.0051C70.537 27.5191 69.426 28.5831 68.137 28.5831ZM58.823 21.7511C56.471 21.7511 54.554 23.5401 54.554 26.0041C54.554 28.4531 56.471 30.2571 58.823 30.2571C61.176 30.2571 63.093 28.4531 63.093 26.0041C63.093 23.5401 61.176 21.7511 58.823 21.7511ZM58.823 28.5831C57.534 28.5831 56.423 27.5201 56.423 26.0051C56.423 24.4741 57.535 23.4271 58.823 23.4271C60.112 23.4271 61.223 24.4741 61.223 26.0051C61.224 27.5191 60.112 28.5831 58.823 28.5831ZM47.745 23.0571V24.8611H52.063C51.934 25.8761 51.596 26.6171 51.08 27.1321C50.452 27.7601 49.469 28.4531 47.745 28.4531C45.087 28.4531 43.009 26.3101 43.009 23.6521C43.009 20.9941 45.087 18.8511 47.745 18.8511C49.179 18.8511 50.226 19.4151 50.999 20.1401L52.272 18.8671C51.192 17.8361 49.759 17.0471 47.745 17.0471C44.104 17.0471 41.043 20.0111 41.043 23.6521C41.043 27.2931 44.104 30.2571 47.745 30.2571C49.71 30.2571 51.193 29.6121 52.352 28.4041C53.544 27.2121 53.915 25.5361 53.915 24.1831C53.915 23.7651 53.883 23.3781 53.818 23.0561H47.745V23.0571ZM93.053 24.4581C92.699 23.5081 91.619 21.7511 89.412 21.7511C87.221 21.7511 85.4 23.4751 85.4 26.0041C85.4 28.3881 87.205 30.2571 89.621 30.2571C91.57 30.2571 92.698 29.0651 93.166 28.3721L91.716 27.4051C91.233 28.1141 90.572 28.5811 89.621 28.5811C88.671 28.5811 87.994 28.1461 87.559 27.2921L93.246 24.9401L93.053 24.4581ZM87.253 25.8761C87.205 24.2321 88.526 23.3951 89.477 23.3951C90.218 23.3951 90.846 23.7661 91.056 24.2971L87.253 25.8761ZM82.63 30.0001H84.498V17.4991H82.63V30.0001ZM79.568 22.7021H79.504C79.085 22.2021 78.279 21.7511 77.265 21.7511C75.138 21.7511 73.189 23.6201 73.189 26.0211C73.189 28.4051 75.138 30.2581 77.265 30.2581C78.28 30.2581 79.085 29.8071 79.504 29.2921H79.568V29.9041C79.568 31.5311 78.698 32.4011 77.297 32.4011C76.153 32.4011 75.444 31.5801 75.154 30.8871L73.527 31.5641C73.994 32.6911 75.234 34.0771 77.297 34.0771C79.488 34.0771 81.341 32.7881 81.341 29.6461V22.0101H79.569V22.7021H79.568ZM77.426 28.5831C76.137 28.5831 75.058 27.5031 75.058 26.0211C75.058 24.5221 76.137 23.4271 77.426 23.4271C78.698 23.4271 79.697 24.5221 79.697 26.0211C79.697 27.5031 78.698 28.5831 77.426 28.5831ZM101.807 17.4991H97.336V30.0001H99.201V25.2641H101.806C103.874 25.2641 105.908 23.7671 105.908 21.3821C105.908 18.9971 103.875 17.4991 101.807 17.4991ZM101.855 23.5241H99.201V19.2391H101.855C103.25 19.2391 104.042 20.3941 104.042 21.3821C104.042 22.3501 103.25 23.5241 101.855 23.5241ZM113.387 21.7291C112.036 21.7291 110.637 22.3241 110.058 23.6431L111.714 24.3341C112.068 23.6431 112.728 23.4171 113.419 23.4171C114.384 23.4171 115.365 23.9961 115.381 25.0251V25.1541C115.043 24.9611 114.319 24.6721 113.435 24.6721C111.65 24.6721 109.832 25.6531 109.832 27.4861C109.832 29.1591 111.296 30.2361 112.936 30.2361C114.19 30.2361 114.882 29.6731 115.316 29.0131H115.38V29.9781H117.182V25.1851C117.183 22.9671 115.525 21.7291 113.387 21.7291ZM113.161 28.5801C112.551 28.5801 111.698 28.2741 111.698 27.5181C111.698 26.5531 112.76 26.1831 113.677 26.1831C114.496 26.1831 114.883 26.3601 115.381 26.6011C115.236 27.7601 114.239 28.5801 113.161 28.5801ZM123.744 22.0021L121.605 27.4221H121.541L119.321 22.0021H117.311L120.64 29.5771L118.742 33.7911H120.688L125.819 22.0021H123.744ZM106.938 30.0001H108.803V17.4991H106.938V30.0001Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M47.4176 10.2429C47.4176 11.0809 47.1696 11.7479 46.6726 12.2459C46.1086 12.8379 45.3726 13.1339 44.4686 13.1339C43.6026 13.1339 42.8656 12.8339 42.2606 12.2339C41.6546 11.6329 41.3516 10.8889 41.3516 10.0009C41.3516 9.11194 41.6546 8.36794 42.2606 7.76794C42.8656 7.16694 43.6026 6.86694 44.4686 6.86694C44.8986 6.86694 45.3096 6.95094 45.6996 7.11794C46.0906 7.28594 46.4036 7.50894 46.6376 7.78794L46.1106 8.31594C45.7136 7.84094 45.1666 7.60394 44.4676 7.60394C43.8356 7.60394 43.2896 7.82594 42.8286 8.26994C42.3676 8.71394 42.1376 9.29094 42.1376 9.99994C42.1376 10.7089 42.3676 11.2859 42.8286 11.7299C43.2896 12.1739 43.8356 12.3959 44.4676 12.3959C45.1376 12.3959 45.6966 12.1729 46.1436 11.7259C46.4336 11.4349 46.6016 11.0299 46.6466 10.5109H44.4676V9.78994H47.3746C47.4046 9.94694 47.4176 10.0979 47.4176 10.2429Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M52.0277 7.737H49.2957V9.639H51.7597V10.36H49.2957V12.262H52.0277V13H48.5247V7H52.0277V7.737Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M55.2785 13H54.5075V7.737H52.8315V7H56.9545V7.737H55.2785V13Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t("path", { d: "M59.9375 13V7H60.7085V13H59.9375Z", fill: "white" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M64.1277 13H63.3567V7.737H61.6807V7H65.8037V7.737H64.1277V13Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M73.6084 12.225C73.0184 12.831 72.2854 13.134 71.4084 13.134C70.5314 13.134 69.7984 12.831 69.2094 12.225C68.6194 11.619 68.3254 10.877 68.3254 9.99999C68.3254 9.12299 68.6194 8.38099 69.2094 7.77499C69.7984 7.16899 70.5314 6.86499 71.4084 6.86499C72.2804 6.86499 73.0124 7.16999 73.6044 7.77899C74.1964 8.38799 74.4924 9.12799 74.4924 9.99999C74.4924 10.877 74.1974 11.619 73.6084 12.225ZM69.7784 11.722C70.2224 12.172 70.7654 12.396 71.4084 12.396C72.0514 12.396 72.5954 12.171 73.0384 11.722C73.4824 11.272 73.7054 10.698 73.7054 9.99999C73.7054 9.30199 73.4824 8.72799 73.0384 8.27799C72.5954 7.82799 72.0514 7.60399 71.4084 7.60399C70.7654 7.60399 70.2224 7.82899 69.7784 8.27799C69.3354 8.72799 69.1124 9.30199 69.1124 9.99999C69.1124 10.698 69.3354 11.272 69.7784 11.722Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M75.5745 13V7H76.5125L79.4285 11.667H79.4615L79.4285 10.511V7H80.1995V13H79.3945L76.3435 8.106H76.3105L76.3435 9.262V13H75.5745Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M47.4176 10.2429C47.4176 11.0809 47.1696 11.7479 46.6726 12.2459C46.1086 12.8379 45.3726 13.1339 44.4686 13.1339C43.6026 13.1339 42.8656 12.8339 42.2606 12.2339C41.6546 11.6329 41.3516 10.8889 41.3516 10.0009C41.3516 9.11194 41.6546 8.36794 42.2606 7.76794C42.8656 7.16694 43.6026 6.86694 44.4686 6.86694C44.8986 6.86694 45.3096 6.95094 45.6996 7.11794C46.0906 7.28594 46.4036 7.50894 46.6376 7.78794L46.1106 8.31594C45.7136 7.84094 45.1666 7.60394 44.4676 7.60394C43.8356 7.60394 43.2896 7.82594 42.8286 8.26994C42.3676 8.71394 42.1376 9.29094 42.1376 9.99994C42.1376 10.7089 42.3676 11.2859 42.8286 11.7299C43.2896 12.1739 43.8356 12.3959 44.4676 12.3959C45.1376 12.3959 45.6966 12.1729 46.1436 11.7259C46.4336 11.4349 46.6016 11.0299 46.6466 10.5109H44.4676V9.78994H47.3746C47.4046 9.94694 47.4176 10.0979 47.4176 10.2429Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M52.0277 7.737H49.2957V9.639H51.7597V10.36H49.2957V12.262H52.0277V13H48.5247V7H52.0277V7.737Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M55.2785 13H54.5075V7.737H52.8315V7H56.9545V7.737H55.2785V13Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M59.9375 13V7H60.7085V13H59.9375Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M64.1277 13H63.3567V7.737H61.6807V7H65.8037V7.737H64.1277V13Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M73.6084 12.225C73.0184 12.831 72.2854 13.134 71.4084 13.134C70.5314 13.134 69.7984 12.831 69.2094 12.225C68.6194 11.619 68.3254 10.877 68.3254 9.99999C68.3254 9.12299 68.6194 8.38099 69.2094 7.77499C69.7984 7.16899 70.5314 6.86499 71.4084 6.86499C72.2804 6.86499 73.0124 7.16999 73.6044 7.77899C74.1964 8.38799 74.4924 9.12799 74.4924 9.99999C74.4924 10.877 74.1974 11.619 73.6084 12.225ZM69.7784 11.722C70.2224 12.172 70.7654 12.396 71.4084 12.396C72.0514 12.396 72.5954 12.171 73.0384 11.722C73.4824 11.272 73.7054 10.698 73.7054 9.99999C73.7054 9.30199 73.4824 8.72799 73.0384 8.27799C72.5954 7.82799 72.0514 7.60399 71.4084 7.60399C70.7654 7.60399 70.2224 7.82899 69.7784 8.27799C69.3354 8.72799 69.1124 9.30199 69.1124 9.99999C69.1124 10.698 69.3354 11.272 69.7784 11.722Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M75.5745 13V7H76.5125L79.4285 11.667H79.4615L79.4285 10.511V7H80.1995V13H79.3945L76.3435 8.106H76.3105L76.3435 9.262V13H75.5745Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ c("g", { filter: "url(#filter0_ii_2136_36895)", children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M10.4357 7.53784C10.1447 7.84584 9.97266 8.32384 9.97266 8.94284V31.0588C9.97266 31.6788 10.1447 32.1558 10.4357 32.4638L10.5097 32.5358L22.8987 20.1468V20.0008V19.8548L10.5097 7.46484L10.4357 7.53784Z",
            fill: "url(#paint0_linear_2136_36895)"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M27.0274 24.2779L22.8984 20.1469V20.0009V19.8549L27.0284 15.7249L27.1214 15.7779L32.0144 18.5579C33.4114 19.3519 33.4114 20.6509 32.0144 21.4459L27.1214 24.2259L27.0274 24.2779Z",
            fill: "url(#paint1_linear_2136_36895)"
          }
        ),
        /* @__PURE__ */ t("g", { filter: "url(#filter1_i_2136_36895)", children: /* @__PURE__ */ t(
          "path",
          {
            d: "M27.1235 24.225L22.8995 20.001L10.4375 32.464C10.8975 32.952 11.6585 33.012 12.5155 32.526L27.1235 24.225Z",
            fill: "url(#paint2_linear_2136_36895)"
          }
        ) }),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M27.1235 15.7769L12.5155 7.47694C11.6585 6.98994 10.8975 7.05094 10.4375 7.53894L22.9005 20.0019L27.1235 15.7769Z",
            fill: "url(#paint3_linear_2136_36895)"
          }
        )
      ] }),
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "134", height: "39", rx: "4.5", stroke: "#A6A6A6" }),
      /* @__PURE__ */ c("defs", { children: [
        /* @__PURE__ */ c(
          "filter",
          {
            id: "filter0_ii_2136_36895",
            x: "9.97266",
            y: "7.14087",
            width: "23.0898",
            height: "25.7207",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ t("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ t(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              ),
              /* @__PURE__ */ t(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ t("feOffset", { dy: "-0.15" }),
              /* @__PURE__ */ t("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
              /* @__PURE__ */ t(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                }
              ),
              /* @__PURE__ */ t(
                "feBlend",
                {
                  mode: "normal",
                  in2: "shape",
                  result: "effect1_innerShadow_2136_36895"
                }
              ),
              /* @__PURE__ */ t(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ t("feOffset", { dy: "0.15" }),
              /* @__PURE__ */ t("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
              /* @__PURE__ */ t(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
                }
              ),
              /* @__PURE__ */ t(
                "feBlend",
                {
                  mode: "normal",
                  in2: "effect1_innerShadow_2136_36895",
                  result: "effect2_innerShadow_2136_36895"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ c(
          "filter",
          {
            id: "filter1_i_2136_36895",
            x: "10.4375",
            y: "20.001",
            width: "16.6875",
            height: "12.8606",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ t("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ t(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "BackgroundImageFix",
                  result: "shape"
                }
              ),
              /* @__PURE__ */ t(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ t("feOffset", { dy: "-0.15" }),
              /* @__PURE__ */ t("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
              /* @__PURE__ */ t(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                }
              ),
              /* @__PURE__ */ t(
                "feBlend",
                {
                  mode: "normal",
                  in2: "shape",
                  result: "effect1_innerShadow_2136_36895"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ c(
          "linearGradient",
          {
            id: "paint0_linear_2136_36895",
            x1: "21.8005",
            y1: "8.70884",
            x2: "5.01846",
            y2: "25.4908",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ t("stop", { stopColor: "#00A0FF" }),
              /* @__PURE__ */ t("stop", { offset: "0.0066", stopColor: "#00A1FF" }),
              /* @__PURE__ */ t("stop", { offset: "0.2601", stopColor: "#00BEFF" }),
              /* @__PURE__ */ t("stop", { offset: "0.5122", stopColor: "#00D2FF" }),
              /* @__PURE__ */ t("stop", { offset: "0.7604", stopColor: "#00DFFF" }),
              /* @__PURE__ */ t("stop", { offset: "1", stopColor: "#00E3FF" })
            ]
          }
        ),
        /* @__PURE__ */ c(
          "linearGradient",
          {
            id: "paint1_linear_2136_36895",
            x1: "33.8329",
            y1: "20.0009",
            x2: "9.63704",
            y2: "20.0009",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ t("stop", { stopColor: "#FFE000" }),
              /* @__PURE__ */ t("stop", { offset: "0.4087", stopColor: "#FFBD00" }),
              /* @__PURE__ */ t("stop", { offset: "0.7754", stopColor: "#FFA500" }),
              /* @__PURE__ */ t("stop", { offset: "1", stopColor: "#FF9C00" })
            ]
          }
        ),
        /* @__PURE__ */ c(
          "linearGradient",
          {
            id: "paint2_linear_2136_36895",
            x1: "24.8296",
            y1: "22.2949",
            x2: "2.0711",
            y2: "45.0534",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ t("stop", { stopColor: "#FF3A44" }),
              /* @__PURE__ */ t("stop", { offset: "1", stopColor: "#C31162" })
            ]
          }
        ),
        /* @__PURE__ */ c(
          "linearGradient",
          {
            id: "paint3_linear_2136_36895",
            x1: "7.2989",
            y1: "0.176745",
            x2: "17.4612",
            y2: "10.339",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ t("stop", { stopColor: "#32A071" }),
              /* @__PURE__ */ t("stop", { offset: "0.0685", stopColor: "#2DA771" }),
              /* @__PURE__ */ t("stop", { offset: "0.4762", stopColor: "#15CF74" }),
              /* @__PURE__ */ t("stop", { offset: "0.8009", stopColor: "#06E775" }),
              /* @__PURE__ */ t("stop", { offset: "1", stopColor: "#00F076" })
            ]
          }
        )
      ] })
    ]
  }
), N7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "149",
    height: "44",
    viewBox: "0 0 149 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M74.9479 23.9264C72.3607 23.9264 70.252 25.8943 70.252 28.6047C70.252 31.2986 72.3607 33.283 74.9479 33.283C77.5362 33.283 79.6449 31.2986 79.6449 28.6047C79.6438 25.8943 77.5351 23.9264 74.9479 23.9264ZM74.9479 31.4416C73.53 31.4416 72.3079 30.2723 72.3079 28.6058C72.3079 26.9217 73.5311 25.77 74.9479 25.77C76.3658 25.77 77.5879 26.9217 77.5879 28.6058C77.5879 30.2712 76.3658 31.4416 74.9479 31.4416ZM64.7025 23.9264C62.1153 23.9264 60.0066 25.8943 60.0066 28.6047C60.0066 31.2986 62.1153 33.283 64.7025 33.283C67.2908 33.283 69.3995 31.2986 69.3995 28.6047C69.3995 25.8943 67.2908 23.9264 64.7025 23.9264ZM64.7025 31.4416C63.2846 31.4416 62.0625 30.2723 62.0625 28.6058C62.0625 26.9217 63.2857 25.77 64.7025 25.77C66.1204 25.77 67.3425 26.9217 67.3425 28.6058C67.3436 30.2712 66.1204 31.4416 64.7025 31.4416ZM52.5167 25.363V27.3474H57.2665C57.1246 28.4639 56.7528 29.279 56.1852 29.8455C55.4944 30.5363 54.4131 31.2986 52.5167 31.2986C49.5929 31.2986 47.3071 28.9413 47.3071 26.0175C47.3071 23.0937 49.5929 20.7364 52.5167 20.7364C54.0941 20.7364 55.2458 21.3568 56.0961 22.1543L57.4964 20.754C56.3084 19.6199 54.7321 18.752 52.5167 18.752C48.5116 18.752 45.1445 22.0124 45.1445 26.0175C45.1445 30.0226 48.5116 33.283 52.5167 33.283C54.6782 33.283 56.3095 32.5735 57.5844 31.2447C58.8956 29.9335 59.3037 28.0899 59.3037 26.6016C59.3037 26.1418 59.2685 25.7161 59.197 25.3619H52.5167V25.363ZM102.356 26.9041C101.966 25.8591 100.778 23.9264 98.3504 23.9264C95.9403 23.9264 93.9372 25.8228 93.9372 28.6047C93.9372 31.2271 95.9227 33.283 98.5803 33.283C100.724 33.283 101.965 31.9718 102.48 31.2095L100.885 30.1458C100.354 30.9257 99.6264 31.4394 98.5803 31.4394C97.5353 31.4394 96.7906 30.9609 96.3121 30.0215L102.568 27.4343L102.356 26.9041ZM95.9755 28.4639C95.9227 26.6555 97.3758 25.7348 98.4219 25.7348C99.237 25.7348 99.9278 26.1429 100.159 26.727L95.9755 28.4639ZM90.8902 33.0003H92.945V19.2492H90.8902V33.0003ZM87.522 24.9725H87.4516C86.9907 24.4225 86.1041 23.9264 84.9887 23.9264C82.649 23.9264 80.5051 25.9823 80.5051 28.6234C80.5051 31.2458 82.649 33.2841 84.9887 33.2841C86.1052 33.2841 86.9907 32.788 87.4516 32.2215H87.522V32.8947C87.522 34.6844 86.565 35.6414 85.0239 35.6414C83.7655 35.6414 82.9856 34.7383 82.6666 33.976L80.8769 34.7207C81.3906 35.9604 82.7546 37.485 85.0239 37.485C87.434 37.485 89.4723 36.0671 89.4723 32.6109V24.2113H87.5231V24.9725H87.522ZM85.1658 31.4416C83.7479 31.4416 82.561 30.2536 82.561 28.6234C82.561 26.9745 83.7479 25.77 85.1658 25.77C86.565 25.77 87.6639 26.9745 87.6639 28.6234C87.6639 30.2536 86.565 31.4416 85.1658 31.4416ZM111.985 19.2492H107.067V33.0003H109.118V27.7907H111.984C114.259 27.7907 116.496 26.144 116.496 23.5205C116.496 20.897 114.26 19.2492 111.985 19.2492ZM112.038 25.8767H109.118V21.1632H112.038C113.572 21.1632 114.443 22.4337 114.443 23.5205C114.443 24.5853 113.572 25.8767 112.038 25.8767ZM124.723 23.9022C123.237 23.9022 121.698 24.5567 121.061 26.0076L122.883 26.7677C123.272 26.0076 123.998 25.759 124.758 25.759C125.82 25.759 126.899 26.3959 126.916 27.5278V27.6697C126.545 27.4574 125.748 27.1395 124.776 27.1395C122.812 27.1395 120.812 28.2186 120.812 30.2349C120.812 32.0752 122.423 33.2599 124.227 33.2599C125.606 33.2599 126.367 32.6406 126.845 31.9146H126.915V32.9761H128.897V27.7038C128.899 25.264 127.075 23.9022 124.723 23.9022ZM124.474 31.4383C123.803 31.4383 122.865 31.1017 122.865 30.2701C122.865 29.2086 124.033 28.8016 125.042 28.8016C125.943 28.8016 126.369 28.9963 126.916 29.2614C126.757 30.5363 125.66 31.4383 124.474 31.4383ZM136.116 24.2025L133.763 30.1645H133.692L131.25 24.2025H129.039L132.701 32.535L130.613 37.1704H132.754L138.398 24.2025H136.116ZM117.629 33.0003H119.681V19.2492H117.629V33.0003Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M52.1609 11.2673C52.1609 12.1891 51.8881 12.9228 51.3414 13.4706C50.721 14.1218 49.9114 14.4474 48.917 14.4474C47.9644 14.4474 47.1537 14.1174 46.4882 13.4574C45.8216 12.7963 45.4883 11.9779 45.4883 11.0011C45.4883 10.0232 45.8216 9.20476 46.4882 8.54476C47.1537 7.88366 47.9644 7.55366 48.917 7.55366C49.39 7.55366 49.8421 7.64606 50.2711 7.82976C50.7012 8.01456 51.0455 8.25986 51.3029 8.56676L50.7232 9.14756C50.2865 8.62506 49.6848 8.36436 48.9159 8.36436C48.2207 8.36436 47.6201 8.60856 47.113 9.09696C46.6059 9.58536 46.3529 10.2201 46.3529 11C46.3529 11.7799 46.6059 12.4146 47.113 12.903C47.6201 13.3914 48.2207 13.6356 48.9159 13.6356C49.6529 13.6356 50.2678 13.3903 50.7595 12.8986C51.0785 12.5785 51.2633 12.133 51.3128 11.5621H48.9159V10.769H52.1136C52.1466 10.9417 52.1609 11.1078 52.1609 11.2673Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M57.232 8.51072H54.2268V10.6029H56.9372V11.396H54.2268V13.4882H57.232V14.3H53.3787V7.70002H57.232V8.51072Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M60.808 14.3H59.9599V8.51072H58.1163V7.70002H62.6516V8.51072H60.808V14.3Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t("path", { d: "M65.9328 14.3V7.70002H66.7809V14.3H65.9328Z", fill: "white" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M70.542 14.3H69.6939V8.51072H67.8503V7.70002H72.3856V8.51072H70.542V14.3Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M80.9708 13.4475C80.3218 14.1141 79.5155 14.4474 78.5508 14.4474C77.5861 14.4474 76.7798 14.1141 76.1319 13.4475C75.4829 12.7809 75.1595 11.9647 75.1595 11C75.1595 10.0353 75.4829 9.21911 76.1319 8.55251C76.7798 7.88591 77.5861 7.55151 78.5508 7.55151C79.51 7.55151 80.3153 7.88701 80.9664 8.55691C81.6176 9.22681 81.9432 10.0408 81.9432 11C81.9432 11.9647 81.6187 12.7809 80.9708 13.4475ZM76.7578 12.8942C77.2462 13.3892 77.8435 13.6356 78.5508 13.6356C79.2581 13.6356 79.8565 13.3881 80.3438 12.8942C80.8322 12.3992 81.0775 11.7678 81.0775 11C81.0775 10.2322 80.8322 9.60081 80.3438 9.10581C79.8565 8.61081 79.2581 8.36441 78.5508 8.36441C77.8435 8.36441 77.2462 8.61191 76.7578 9.10581C76.2705 9.60081 76.0252 10.2322 76.0252 11C76.0252 11.7678 76.2705 12.3992 76.7578 12.8942Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M83.1335 14.3V7.70002H84.1653L87.3729 12.8337H87.4092L87.3729 11.5621V7.70002H88.221V14.3H87.3355L83.9794 8.91663H83.9431L83.9794 10.1882V14.3H83.1335Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M52.1609 11.2673C52.1609 12.1891 51.8881 12.9228 51.3414 13.4706C50.721 14.1218 49.9114 14.4474 48.917 14.4474C47.9644 14.4474 47.1537 14.1174 46.4882 13.4574C45.8216 12.7963 45.4883 11.9779 45.4883 11.0011C45.4883 10.0232 45.8216 9.20476 46.4882 8.54476C47.1537 7.88366 47.9644 7.55366 48.917 7.55366C49.39 7.55366 49.8421 7.64606 50.2711 7.82976C50.7012 8.01456 51.0455 8.25986 51.3029 8.56676L50.7232 9.14756C50.2865 8.62506 49.6848 8.36436 48.9159 8.36436C48.2207 8.36436 47.6201 8.60856 47.113 9.09696C46.6059 9.58536 46.3529 10.2201 46.3529 11C46.3529 11.7799 46.6059 12.4146 47.113 12.903C47.6201 13.3914 48.2207 13.6356 48.9159 13.6356C49.6529 13.6356 50.2678 13.3903 50.7595 12.8986C51.0785 12.5785 51.2633 12.133 51.3128 11.5621H48.9159V10.769H52.1136C52.1466 10.9417 52.1609 11.1078 52.1609 11.2673Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M57.232 8.51072H54.2268V10.6029H56.9372V11.396H54.2268V13.4882H57.232V14.3H53.3787V7.70002H57.232V8.51072Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M60.808 14.3H59.9599V8.51072H58.1163V7.70002H62.6516V8.51072H60.808V14.3Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M65.9328 14.3V7.70002H66.7809V14.3H65.9328Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M70.542 14.3H69.6939V8.51072H67.8503V7.70002H72.3856V8.51072H70.542V14.3Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M80.9708 13.4475C80.3218 14.1141 79.5155 14.4474 78.5508 14.4474C77.5861 14.4474 76.7798 14.1141 76.1319 13.4475C75.4829 12.7809 75.1595 11.9647 75.1595 11C75.1595 10.0353 75.4829 9.21911 76.1319 8.55251C76.7798 7.88591 77.5861 7.55151 78.5508 7.55151C79.51 7.55151 80.3153 7.88701 80.9664 8.55691C81.6176 9.22681 81.9432 10.0408 81.9432 11C81.9432 11.9647 81.6187 12.7809 80.9708 13.4475ZM76.7578 12.8942C77.2462 13.3892 77.8435 13.6356 78.5508 13.6356C79.2581 13.6356 79.8565 13.3881 80.3438 12.8942C80.8322 12.3992 81.0775 11.7678 81.0775 11C81.0775 10.2322 80.8322 9.60081 80.3438 9.10581C79.8565 8.61081 79.2581 8.36441 78.5508 8.36441C77.8435 8.36441 77.2462 8.61191 76.7578 9.10581C76.2705 9.60081 76.0252 10.2322 76.0252 11C76.0252 11.7678 76.2705 12.3992 76.7578 12.8942Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M83.1335 14.3V7.70002H84.1653L87.3729 12.8337H87.4092L87.3729 11.5621V7.70002H88.221V14.3H87.3355L83.9794 8.91663H83.9431L83.9794 10.1882V14.3H83.1335Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.1927 8.7146C11.0487 9.01741 10.9688 9.39455 10.9688 9.83725V34.1649C10.9688 34.6085 11.0488 34.9857 11.1929 35.2883L24.4787 22.0006L11.1927 8.7146ZM11.8865 36.009C12.3831 36.245 13.0426 36.1876 13.7638 35.7786L29.3818 26.9037L25.1858 22.7078L11.8865 36.009ZM30.2843 26.392L35.2149 23.5906C36.7516 22.7161 36.7516 21.2872 35.2149 20.4138L30.2821 17.6108L25.8929 22.0006L30.2843 26.392ZM29.3803 17.0984L13.7638 8.22466C13.0425 7.81477 12.383 7.75779 11.8864 7.99411L25.1858 21.2935L29.3803 17.0984Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "147.5", height: "43", rx: "4.5", stroke: "white" })
    ]
  }
), S7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "135",
    height: "40",
    viewBox: "0 0 135 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M68.137 21.7511C65.785 21.7511 63.868 23.5401 63.868 26.0041C63.868 28.4531 65.785 30.2571 68.137 30.2571C70.49 30.2571 72.407 28.4531 72.407 26.0041C72.406 23.5401 70.489 21.7511 68.137 21.7511ZM68.137 28.5831C66.848 28.5831 65.737 27.5201 65.737 26.0051C65.737 24.4741 66.849 23.4271 68.137 23.4271C69.426 23.4271 70.537 24.4741 70.537 26.0051C70.537 27.5191 69.426 28.5831 68.137 28.5831ZM58.823 21.7511C56.471 21.7511 54.554 23.5401 54.554 26.0041C54.554 28.4531 56.471 30.2571 58.823 30.2571C61.176 30.2571 63.093 28.4531 63.093 26.0041C63.093 23.5401 61.176 21.7511 58.823 21.7511ZM58.823 28.5831C57.534 28.5831 56.423 27.5201 56.423 26.0051C56.423 24.4741 57.535 23.4271 58.823 23.4271C60.112 23.4271 61.223 24.4741 61.223 26.0051C61.224 27.5191 60.112 28.5831 58.823 28.5831ZM47.745 23.0571V24.8611H52.063C51.934 25.8761 51.596 26.6171 51.08 27.1321C50.452 27.7601 49.469 28.4531 47.745 28.4531C45.087 28.4531 43.009 26.3101 43.009 23.6521C43.009 20.9941 45.087 18.8511 47.745 18.8511C49.179 18.8511 50.226 19.4151 50.999 20.1401L52.272 18.8671C51.192 17.8361 49.759 17.0471 47.745 17.0471C44.104 17.0471 41.043 20.0111 41.043 23.6521C41.043 27.2931 44.104 30.2571 47.745 30.2571C49.71 30.2571 51.193 29.6121 52.352 28.4041C53.544 27.2121 53.915 25.5361 53.915 24.1831C53.915 23.7651 53.883 23.3781 53.818 23.0561H47.745V23.0571ZM93.053 24.4581C92.699 23.5081 91.619 21.7511 89.412 21.7511C87.221 21.7511 85.4 23.4751 85.4 26.0041C85.4 28.3881 87.205 30.2571 89.621 30.2571C91.57 30.2571 92.698 29.0651 93.166 28.3721L91.716 27.4051C91.233 28.1141 90.572 28.5811 89.621 28.5811C88.671 28.5811 87.994 28.1461 87.559 27.2921L93.246 24.9401L93.053 24.4581ZM87.253 25.8761C87.205 24.2321 88.526 23.3951 89.477 23.3951C90.218 23.3951 90.846 23.7661 91.056 24.2971L87.253 25.8761ZM82.63 30.0001H84.498V17.4991H82.63V30.0001ZM79.568 22.7021H79.504C79.085 22.2021 78.279 21.7511 77.265 21.7511C75.138 21.7511 73.189 23.6201 73.189 26.0211C73.189 28.4051 75.138 30.2581 77.265 30.2581C78.28 30.2581 79.085 29.8071 79.504 29.2921H79.568V29.9041C79.568 31.5311 78.698 32.4011 77.297 32.4011C76.153 32.4011 75.444 31.5801 75.154 30.8871L73.527 31.5641C73.994 32.6911 75.234 34.0771 77.297 34.0771C79.488 34.0771 81.341 32.7881 81.341 29.6461V22.0101H79.569V22.7021H79.568ZM77.426 28.5831C76.137 28.5831 75.058 27.5031 75.058 26.0211C75.058 24.5221 76.137 23.4271 77.426 23.4271C78.698 23.4271 79.697 24.5221 79.697 26.0211C79.697 27.5031 78.698 28.5831 77.426 28.5831ZM101.807 17.4991H97.336V30.0001H99.201V25.2641H101.806C103.874 25.2641 105.908 23.7671 105.908 21.3821C105.908 18.9971 103.875 17.4991 101.807 17.4991ZM101.855 23.5241H99.201V19.2391H101.855C103.25 19.2391 104.042 20.3941 104.042 21.3821C104.042 22.3501 103.25 23.5241 101.855 23.5241ZM113.387 21.7291C112.036 21.7291 110.637 22.3241 110.058 23.6431L111.714 24.3341C112.068 23.6431 112.728 23.4171 113.419 23.4171C114.384 23.4171 115.365 23.9961 115.381 25.0251V25.1541C115.043 24.9611 114.319 24.6721 113.435 24.6721C111.65 24.6721 109.832 25.6531 109.832 27.4861C109.832 29.1591 111.296 30.2361 112.936 30.2361C114.19 30.2361 114.882 29.6731 115.316 29.0131H115.38V29.9781H117.182V25.1851C117.183 22.9671 115.525 21.7291 113.387 21.7291ZM113.161 28.5801C112.551 28.5801 111.698 28.2741 111.698 27.5181C111.698 26.5531 112.76 26.1831 113.677 26.1831C114.496 26.1831 114.883 26.3601 115.381 26.6011C115.236 27.7601 114.239 28.5801 113.161 28.5801ZM123.744 22.0021L121.605 27.4221H121.541L119.321 22.0021H117.311L120.64 29.5771L118.742 33.7911H120.688L125.819 22.0021H123.744ZM106.938 30.0001H108.803V17.4991H106.938V30.0001Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M47.4176 10.2429C47.4176 11.0809 47.1696 11.7479 46.6726 12.2459C46.1086 12.8379 45.3726 13.1339 44.4686 13.1339C43.6026 13.1339 42.8656 12.8339 42.2606 12.2339C41.6546 11.6329 41.3516 10.8889 41.3516 10.0009C41.3516 9.11194 41.6546 8.36794 42.2606 7.76794C42.8656 7.16694 43.6026 6.86694 44.4686 6.86694C44.8986 6.86694 45.3096 6.95094 45.6996 7.11794C46.0906 7.28594 46.4036 7.50894 46.6376 7.78794L46.1106 8.31594C45.7136 7.84094 45.1666 7.60394 44.4676 7.60394C43.8356 7.60394 43.2896 7.82594 42.8286 8.26994C42.3676 8.71394 42.1376 9.29094 42.1376 9.99994C42.1376 10.7089 42.3676 11.2859 42.8286 11.7299C43.2896 12.1739 43.8356 12.3959 44.4676 12.3959C45.1376 12.3959 45.6966 12.1729 46.1436 11.7259C46.4336 11.4349 46.6016 11.0299 46.6466 10.5109H44.4676V9.78994H47.3746C47.4046 9.94694 47.4176 10.0979 47.4176 10.2429Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M52.0277 7.737H49.2957V9.639H51.7597V10.36H49.2957V12.262H52.0277V13H48.5247V7H52.0277V7.737Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M55.2785 13H54.5075V7.737H52.8315V7H56.9545V7.737H55.2785V13Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t("path", { d: "M59.9375 13V7H60.7085V13H59.9375Z", fill: "white" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M64.1277 13H63.3567V7.737H61.6807V7H65.8037V7.737H64.1277V13Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M73.6084 12.225C73.0184 12.831 72.2854 13.134 71.4084 13.134C70.5314 13.134 69.7984 12.831 69.2094 12.225C68.6194 11.619 68.3254 10.877 68.3254 9.99999C68.3254 9.12299 68.6194 8.38099 69.2094 7.77499C69.7984 7.16899 70.5314 6.86499 71.4084 6.86499C72.2804 6.86499 73.0124 7.16999 73.6044 7.77899C74.1964 8.38799 74.4924 9.12799 74.4924 9.99999C74.4924 10.877 74.1974 11.619 73.6084 12.225ZM69.7784 11.722C70.2224 12.172 70.7654 12.396 71.4084 12.396C72.0514 12.396 72.5954 12.171 73.0384 11.722C73.4824 11.272 73.7054 10.698 73.7054 9.99999C73.7054 9.30199 73.4824 8.72799 73.0384 8.27799C72.5954 7.82799 72.0514 7.60399 71.4084 7.60399C70.7654 7.60399 70.2224 7.82899 69.7784 8.27799C69.3354 8.72799 69.1124 9.30199 69.1124 9.99999C69.1124 10.698 69.3354 11.272 69.7784 11.722Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M75.5745 13V7H76.5125L79.4285 11.667H79.4615L79.4285 10.511V7H80.1995V13H79.3945L76.3435 8.106H76.3105L76.3435 9.262V13H75.5745Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M47.4176 10.2429C47.4176 11.0809 47.1696 11.7479 46.6726 12.2459C46.1086 12.8379 45.3726 13.1339 44.4686 13.1339C43.6026 13.1339 42.8656 12.8339 42.2606 12.2339C41.6546 11.6329 41.3516 10.8889 41.3516 10.0009C41.3516 9.11194 41.6546 8.36794 42.2606 7.76794C42.8656 7.16694 43.6026 6.86694 44.4686 6.86694C44.8986 6.86694 45.3096 6.95094 45.6996 7.11794C46.0906 7.28594 46.4036 7.50894 46.6376 7.78794L46.1106 8.31594C45.7136 7.84094 45.1666 7.60394 44.4676 7.60394C43.8356 7.60394 43.2896 7.82594 42.8286 8.26994C42.3676 8.71394 42.1376 9.29094 42.1376 9.99994C42.1376 10.7089 42.3676 11.2859 42.8286 11.7299C43.2896 12.1739 43.8356 12.3959 44.4676 12.3959C45.1376 12.3959 45.6966 12.1729 46.1436 11.7259C46.4336 11.4349 46.6016 11.0299 46.6466 10.5109H44.4676V9.78994H47.3746C47.4046 9.94694 47.4176 10.0979 47.4176 10.2429Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M52.0277 7.737H49.2957V9.639H51.7597V10.36H49.2957V12.262H52.0277V13H48.5247V7H52.0277V7.737Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M55.2785 13H54.5075V7.737H52.8315V7H56.9545V7.737H55.2785V13Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M59.9375 13V7H60.7085V13H59.9375Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M64.1277 13H63.3567V7.737H61.6807V7H65.8037V7.737H64.1277V13Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M73.6084 12.225C73.0184 12.831 72.2854 13.134 71.4084 13.134C70.5314 13.134 69.7984 12.831 69.2094 12.225C68.6194 11.619 68.3254 10.877 68.3254 9.99999C68.3254 9.12299 68.6194 8.38099 69.2094 7.77499C69.7984 7.16899 70.5314 6.86499 71.4084 6.86499C72.2804 6.86499 73.0124 7.16999 73.6044 7.77899C74.1964 8.38799 74.4924 9.12799 74.4924 9.99999C74.4924 10.877 74.1974 11.619 73.6084 12.225ZM69.7784 11.722C70.2224 12.172 70.7654 12.396 71.4084 12.396C72.0514 12.396 72.5954 12.171 73.0384 11.722C73.4824 11.272 73.7054 10.698 73.7054 9.99999C73.7054 9.30199 73.4824 8.72799 73.0384 8.27799C72.5954 7.82799 72.0514 7.60399 71.4084 7.60399C70.7654 7.60399 70.2224 7.82899 69.7784 8.27799C69.3354 8.72799 69.1124 9.30199 69.1124 9.99999C69.1124 10.698 69.3354 11.272 69.7784 11.722Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M75.5745 13V7H76.5125L79.4285 11.667H79.4615L79.4285 10.511V7H80.1995V13H79.3945L76.3435 8.106H76.3105L76.3435 9.262V13H75.5745Z",
          stroke: "white",
          strokeWidth: "0.2",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.156 7.96642C10.0379 8.23392 9.97266 8.56168 9.97266 8.94294V31.0589C9.97266 31.441 10.038 31.7688 10.1562 32.0362L22.1902 20.0006L10.156 7.96642ZM10.8512 32.7554C11.2973 32.9463 11.8792 32.8858 12.5137 32.5259L26.6708 24.4812L22.8973 20.7077L10.8512 32.7554ZM27.5732 23.9694L32.0147 21.4459C33.4116 20.6509 33.4116 19.3519 32.0147 18.5579L27.5712 16.0331L23.6043 20.0005L27.5732 23.9694ZM26.6694 15.5206L12.5137 7.47694C11.8791 7.11637 11.2972 7.0562 10.8512 7.24734L22.8972 19.2934L26.6694 15.5206Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "134", height: "39", rx: "4.5", stroke: "white" })
    ]
  }
), z7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "147",
    height: "44",
    viewBox: "0 0 147 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "145.3", height: "43", rx: "6.25", fill: "white" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M49.9353 27.9528H53.7806L52.404 24.2675C52.2145 23.7584 52.0282 23.1962 51.8446 22.5803C51.6788 23.1251 51.4981 23.6814 51.3028 24.2498L49.9353 27.9528ZM54.4376 29.7022H49.287L48.0262 33.1477H45.7617L50.8056 20.2804H52.9458L58.1052 33.1477H55.7254L54.4376 29.7022Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M64.7853 30.8078C65.2323 30.2071 65.4558 29.3292 65.4558 28.1748C65.4558 27.1035 65.2707 26.3262 64.9009 25.8436C64.5307 25.3612 64.0379 25.12 63.4222 25.12C62.9959 25.12 62.6023 25.2209 62.2412 25.422C61.8801 25.6233 61.5366 25.8925 61.211 26.23V31.3629C61.4301 31.4693 61.6847 31.5538 61.9749 31.6157C62.265 31.6782 62.5521 31.7093 62.8361 31.7093C63.6888 31.7093 64.3383 31.4086 64.7853 30.8078ZM59.0178 25.9104C59.0178 25.2 58.994 24.4184 58.9468 23.5661H61.0069C61.0837 23.9627 61.1371 24.3684 61.1667 24.7826C62.0192 23.8533 62.996 23.3883 64.0971 23.3883C64.7366 23.3883 65.3285 23.5497 65.8733 23.8722C66.4177 24.195 66.8574 24.7041 67.1918 25.3996C67.5265 26.0954 67.6937 26.9791 67.6937 28.0505C67.6937 29.1694 67.5027 30.1256 67.1208 30.9188C66.7389 31.7122 66.2047 32.3129 65.518 32.7216C64.8313 33.1299 64.0379 33.3343 63.1382 33.3343C62.4867 33.3343 61.8443 33.2246 61.211 33.0058V36.9661L59.0178 37.1526V25.9104Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M74.7923 30.8078C75.2394 30.2071 75.4629 29.3292 75.4629 28.1748C75.4629 27.1035 75.2778 26.3262 74.9079 25.8436C74.5377 25.3612 74.0449 25.12 73.4292 25.12C73.003 25.12 72.6094 25.2209 72.2483 25.422C71.8869 25.6233 71.5437 25.8925 71.2181 26.23V31.3629C71.4372 31.4693 71.6915 31.5538 71.9819 31.6157C72.2717 31.6782 72.5589 31.7093 72.8431 31.7093C73.6956 31.7093 74.3453 31.4086 74.7923 30.8078ZM69.0245 25.9104C69.0245 25.2 69.0008 24.4184 68.9535 23.5661H71.0139C71.0908 23.9627 71.1442 24.3684 71.1738 24.7826C72.0262 23.8533 73.003 23.3883 74.1042 23.3883C74.7436 23.3883 75.3353 23.5497 75.8803 23.8722C76.4247 24.195 76.8644 24.7041 77.1991 25.3996C77.5332 26.0954 77.7007 26.9791 77.7007 28.0505C77.7007 29.1694 77.5095 30.1256 77.1279 30.9188C76.7459 31.7122 76.2115 32.3129 75.5251 32.7216C74.8381 33.1299 74.0449 33.3343 73.145 33.3343C72.4938 33.3343 71.8514 33.2246 71.2181 33.0058V36.9661L69.0245 37.1526V25.9104Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M81.73 32.5394C80.7825 32.0158 80.0544 31.2651 79.5455 30.2883C79.036 29.3115 78.7817 28.157 78.7817 26.825C78.7817 25.3807 79.0747 24.1535 79.6608 23.144C80.2469 22.1349 81.0447 21.3771 82.0538 20.8708C83.0635 20.3647 84.1954 20.1116 85.4509 20.1116C86.1907 20.1116 86.8968 20.193 87.5688 20.3558C88.2405 20.5187 88.8665 20.742 89.447 21.0263L88.8873 22.7134C87.721 22.157 86.6081 21.8787 85.5486 21.8787C84.6545 21.8787 83.8716 22.0697 83.1999 22.4516C82.5278 22.8335 82.0051 23.3944 81.6323 24.1344C81.2592 24.8745 81.0729 25.7683 81.0729 26.8161C81.0729 27.734 81.2163 28.5478 81.5032 29.2582C81.7907 29.9686 82.2436 30.5312 82.8622 30.9454C83.4809 31.3599 84.2608 31.5669 85.2021 31.5669C85.6284 31.5669 86.0546 31.5315 86.4808 31.4605C86.907 31.3896 87.3068 31.286 87.6796 31.1496V28.5478H84.705V26.8428H89.811V32.2598C89.0768 32.603 88.3056 32.8668 87.4978 33.0501C86.6894 33.2334 85.8859 33.3252 85.0866 33.3252C83.7959 33.3252 82.6768 33.0636 81.73 32.5394Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M96.2913 31.3716C96.7469 31.1528 97.12 30.8802 97.4101 30.5547V28.7787C96.812 28.7137 96.3236 28.6811 95.9449 28.6811C95.0391 28.6811 94.4128 28.8274 94.067 29.1207C93.7203 29.4133 93.5472 29.8088 93.5472 30.306C93.5472 30.78 93.673 31.1305 93.9247 31.3584C94.1764 31.5863 94.5181 31.7002 94.9502 31.7002C95.3882 31.7002 95.8352 31.5908 96.2913 31.3716ZM97.6055 33.1477C97.5283 32.7746 97.4779 32.3516 97.4544 31.8779C97.1171 32.2807 96.6777 32.6224 96.1356 32.9037C95.5944 33.1848 94.9828 33.3252 94.302 33.3252C93.7514 33.3252 93.2498 33.2173 92.7966 33.0011C92.3442 32.7852 91.9843 32.4595 91.718 32.0242C91.4516 31.5893 91.3182 31.0581 91.3182 30.4303C91.3182 29.501 91.6526 28.7594 92.3216 28.2057C92.9907 27.6523 94.1066 27.3756 95.6695 27.3756C96.2556 27.3756 96.8358 27.4172 97.4101 27.4999V27.3135C97.4101 26.467 97.2294 25.8705 96.8683 25.5239C96.5072 25.1779 95.9892 25.0047 95.3145 25.0047C94.8467 25.0047 94.3465 25.0728 93.8136 25.2088C93.2809 25.3452 92.813 25.5079 92.4105 25.6973L92.0641 24.0989C92.4548 23.9211 92.9699 23.7584 93.6094 23.6104C94.2489 23.4626 94.9235 23.3883 95.634 23.3883C96.4629 23.3883 97.1672 23.5141 97.7475 23.7656C98.3277 24.0174 98.7806 24.4497 99.1062 25.0622C99.4318 25.6752 99.5946 26.4996 99.5946 27.5354V31.3449C99.5946 31.7418 99.618 32.3429 99.6656 33.1477H97.6055Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M101.277 30.8477V19.5255L103.462 19.3479V30.457C103.462 30.8656 103.531 31.154 103.67 31.3229C103.809 31.4913 104.03 31.5761 104.332 31.5761C104.468 31.5761 104.661 31.5436 104.909 31.4784L105.167 33.0501C104.959 33.1331 104.706 33.1997 104.408 33.2498C104.109 33.3 103.826 33.3252 103.56 33.3252C102.038 33.3252 101.277 32.4995 101.277 30.8477Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M106.739 30.8477V19.5255L108.923 19.3479V30.457C108.923 30.8656 108.993 31.154 109.132 31.3229C109.271 31.4913 109.492 31.5761 109.793 31.5761C109.93 31.5761 110.122 31.5436 110.371 31.4784L110.628 33.0501C110.421 33.1331 110.168 33.1997 109.869 33.2498C109.57 33.3 109.287 33.3252 109.021 33.3252C107.499 33.3252 106.739 32.4995 106.739 30.8477Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M117.474 27.2425C117.43 26.4787 117.239 25.9061 116.896 25.5239C116.552 25.1424 116.092 24.9512 115.52 24.9512C114.963 24.9512 114.499 25.1439 114.13 25.5285C113.76 25.9135 113.516 26.4847 113.405 27.2425H117.474ZM119.612 28.6366H113.343C113.443 30.6436 114.399 31.647 116.212 31.647C116.661 31.647 117.122 31.5923 117.594 31.4828C118.063 31.3731 118.515 31.2268 118.946 31.0431L119.427 32.5438C118.354 33.065 117.151 33.3252 115.813 33.3252C114.792 33.3252 113.936 33.1331 113.238 32.7482C112.537 32.3634 112.012 31.8099 111.66 31.0874C111.308 30.3655 111.132 29.4952 111.132 28.4768C111.132 27.4172 111.319 26.5053 111.692 25.7417C112.064 24.9779 112.584 24.3949 113.25 23.9923C113.915 23.5898 114.684 23.3883 115.555 23.3883C116.462 23.3883 117.215 23.6001 117.823 24.0235C118.43 24.4465 118.879 25.0106 119.172 25.7149C119.465 26.4198 119.612 27.198 119.612 28.0505V28.6366Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M121.272 25.9725C121.272 25.4458 121.246 24.6437 121.199 23.5661H123.252C123.287 23.8325 123.32 24.1507 123.355 24.5208C123.387 24.8906 123.408 25.1911 123.419 25.422C123.675 25.0017 123.924 24.6479 124.17 24.3609C124.417 24.0735 124.704 23.8399 125.033 23.6591C125.361 23.4786 125.734 23.3883 126.156 23.3883C126.494 23.3883 126.781 23.424 127.024 23.495L126.749 25.3954C126.538 25.3303 126.3 25.2976 126.039 25.2976C125.526 25.2976 125.074 25.4294 124.69 25.6929C124.305 25.9561 123.895 26.3898 123.455 26.9937V33.1477H121.272V25.9725Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M128.256 37.0682C127.937 37.0122 127.673 36.9485 127.467 36.8775L127.866 35.2791C128.013 35.3202 128.201 35.3603 128.427 35.3988C128.65 35.4376 128.864 35.4566 129.066 35.4566C130.037 35.4566 130.764 34.8318 131.248 33.5828L131.392 33.2276L127.858 23.5661H130.21L131.988 28.9651C132.275 29.8889 132.463 30.5963 132.545 31.0874C132.712 30.3949 132.906 29.7022 133.132 29.0096L134.936 23.5661H137.144L133.622 33.2722C133.29 34.1897 132.929 34.9295 132.545 35.4921C132.161 36.0544 131.706 36.4718 131.184 36.7443C130.659 37.0163 130.028 37.1526 129.286 37.1526C128.919 37.1526 128.576 37.1248 128.256 37.0682Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M45.7539 8.03127H49.6634L49.5534 8.97551H46.8997V10.8042H49.4021V11.6888H46.8997V13.7146H49.6954L49.5992 14.6679H45.7539V8.03127Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M52.3583 11.2808L50.2959 8.03127H51.5974L52.9954 10.4193L54.4668 8.03127H55.7316L53.6874 11.2395L55.9012 14.6679H54.5812L53.0001 12.0555L51.3912 14.6679H50.1263L52.3583 11.2808Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M59.6183 10.9942C59.8626 10.7731 59.985 10.4604 59.985 10.057C59.985 9.64754 59.8603 9.35303 59.6115 9.17263C59.3625 8.99223 58.9964 8.90218 58.5139 8.90218H57.8906V11.2579C58.1777 11.3037 58.3977 11.3266 58.5506 11.3266C59.0178 11.3266 59.374 11.216 59.6183 10.9942ZM56.7445 8.03127H58.5321C59.3722 8.03127 60.0155 8.20258 60.4616 8.54461C60.9078 8.88693 61.1307 9.38178 61.1307 10.0295C61.1307 10.4695 61.0307 10.854 60.8306 11.1823C60.6303 11.5108 60.3516 11.7631 59.994 11.9385C59.6368 12.1145 59.2255 12.2022 58.7612 12.2022C58.5077 12.2022 58.2173 12.1717 57.8906 12.1104V14.6679H56.7445V8.03127Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M62.263 8.03127H63.4088V13.687H66.1541L66.0578 14.6679H62.263V8.03127Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M70.8659 13.5289C71.1868 13.3136 71.4264 13.0173 71.5854 12.6398C71.7444 12.2626 71.8239 11.8308 71.8239 11.3451C71.8239 10.8684 71.7535 10.4439 71.613 10.0708C71.4722 9.69798 71.2478 9.40113 70.9392 9.17937C70.6306 8.95791 70.2334 8.84702 69.7474 8.84702C69.283 8.84702 68.8888 8.95937 68.565 9.18406C68.2411 9.40846 67.9982 9.70972 67.8363 10.0869C67.6744 10.4645 67.5934 10.8807 67.5934 11.336C67.5934 11.8156 67.6697 12.245 67.8225 12.6237C67.9751 13.0027 68.2088 13.3022 68.5239 13.5222C68.8383 13.7422 69.2279 13.8522 69.6925 13.8522C70.1539 13.8522 70.5449 13.7442 70.8659 13.5289ZM67.8959 14.3426C67.4101 14.0645 67.0387 13.6741 66.7821 13.1713C66.5254 12.6689 66.3972 12.0845 66.3972 11.4184C66.3972 10.7188 66.5336 10.1069 66.8073 9.58271C67.0807 9.05881 67.4749 8.65401 67.9897 8.36801C68.5045 8.0826 69.1117 7.93945 69.8116 7.93945C70.4807 7.93945 71.0568 8.07791 71.5396 8.35423C72.0222 8.63113 72.3906 9.0198 72.644 9.52081C72.8978 10.0221 73.0245 10.6026 73.0245 11.2626C73.0245 11.9745 72.8863 12.5935 72.6097 13.1188C72.3331 13.6442 71.9392 14.0493 71.4273 14.3332C70.9154 14.6175 70.3144 14.7596 69.6239 14.7596C68.9577 14.7596 68.3816 14.6207 67.8959 14.3426Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M76.1001 11.1708C76.3779 11.1708 76.624 11.1168 76.8379 11.008C77.0517 10.8998 77.2183 10.747 77.3374 10.5498C77.4568 10.3527 77.5163 10.1242 77.5163 9.86461C77.5163 9.53167 77.4108 9.28791 77.2001 9.13362C76.9892 8.97933 76.6821 8.90218 76.2788 8.90218H75.4492V11.1708H76.1001ZM74.3035 8.03127H76.3797C77.1373 8.03127 77.7111 8.18263 78.1007 8.48506C78.4902 8.78749 78.685 9.22015 78.685 9.78218C78.685 10.1336 78.6146 10.4431 78.4741 10.7103C78.3336 10.9778 78.1593 11.1955 77.9517 11.3632C77.7437 11.5313 77.5301 11.6566 77.3101 11.7393L79.3497 14.6679H78.0206L76.2925 12.037H75.4492V14.6679H74.3035V8.03127Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M80.2572 8.03127H84.1668L84.0568 8.97551H81.403V10.8042H83.9054V11.6888H81.403V13.7146H84.1987L84.1025 14.6679H80.2572V8.03127Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M88.4201 8.03127H89.5659V14.6679H88.4201V8.03127Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M92.5954 8.9893H90.5374L90.6383 8.03127H95.8039L95.6983 8.9893H93.7412V14.6679H92.5954V8.9893Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M103.747 13.5289C104.067 13.3136 104.307 13.0173 104.466 12.6398C104.625 12.2626 104.705 11.8308 104.705 11.3451C104.705 10.8684 104.634 10.4439 104.494 10.0708C104.353 9.69798 104.128 9.40113 103.82 9.17937C103.511 8.95791 103.114 8.84702 102.628 8.84702C102.164 8.84702 101.77 8.95937 101.446 9.18406C101.122 9.40846 100.879 9.70972 100.717 10.0869C100.555 10.4645 100.474 10.8807 100.474 11.336C100.474 11.8156 100.55 12.245 100.703 12.6237C100.856 13.0027 101.09 13.3022 101.405 13.5222C101.719 13.7422 102.109 13.8522 102.573 13.8522C103.035 13.8522 103.426 13.7442 103.747 13.5289ZM100.777 14.3426C100.291 14.0645 99.9197 13.6741 99.663 13.1713C99.4063 12.6689 99.2778 12.0845 99.2778 11.4184C99.2778 10.7188 99.4145 10.1069 99.6882 9.58271C99.9613 9.05881 100.356 8.65401 100.871 8.36801C101.385 8.0826 101.993 7.93945 102.693 7.93945C103.362 7.93945 103.937 8.07791 104.421 8.35423C104.903 8.63113 105.271 9.0198 105.525 9.52081C105.778 10.0221 105.905 10.6026 105.905 11.2626C105.905 11.9745 105.767 12.5935 105.491 13.1188C105.214 13.6442 104.82 14.0493 104.308 14.3332C103.796 14.6175 103.195 14.7596 102.505 14.7596C101.838 14.7596 101.263 14.6207 100.777 14.3426Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M107.184 8.03127H108.5L111.782 13.1737C111.752 12.685 111.741 12.2342 111.741 11.8217V8.03127H112.803V14.6679H111.529L108.197 9.44279C108.231 10.0359 108.247 10.5613 108.247 11.0195V14.6679H107.184V8.03127Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M21.7668 24.2281H22.8844L22.3239 22.9245L21.7668 24.2281Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M29.6358 8.06665H17.4496C11.709 8.06665 9.60938 10.1663 9.60938 15.9069V28.0933C9.60938 33.8337 11.709 35.9333 17.4496 35.9333H29.632C35.3725 35.9333 37.476 33.8337 37.476 28.0933V15.9069C37.476 10.1663 35.3764 8.06665 29.6358 8.06665ZM21.4917 24.8852L21.1602 25.6437H20.4055L22.0106 22.0024H22.6627L24.2614 25.6437H23.4864L23.159 24.8852H21.4917ZM33.6366 25.6412H34.3661V22.0024H33.6366V25.6412ZM30.7335 24.0776H32.0778V23.4145H30.7335V22.6686H32.685V22.0047H30.0042V25.6434H32.7554V24.9797H30.7335V24.0776ZM27.835 24.5076L27.0078 22.0023H26.4047L25.5775 24.5076L24.7726 22.004H23.9859L25.2557 25.6454H25.8676L26.696 23.2535L27.5241 25.6454H28.1416L29.4082 22.004H28.6417L27.835 24.5076ZM19.292 24.0877C19.292 24.6801 18.9978 24.9966 18.4636 24.9966C17.9265 24.9966 17.6308 24.6711 17.6308 24.0625V22.0044H16.8916V24.0877C16.8916 25.1126 17.461 25.7002 18.4536 25.7002C19.456 25.7002 20.0309 25.1014 20.0309 24.0576V22.0023H19.292V24.0877ZM15.1278 22.0024H15.8667V25.6457H15.1278V24.1662H13.4585V25.6457H12.7193V22.0024H13.4585V23.4721H15.1278V22.0024ZM18.9042 12.7251C18.9042 15.2827 20.9851 17.3636 23.5427 17.3636C26.1003 17.3636 28.1812 15.2827 28.1812 12.7251H27.5259C27.5259 14.9214 25.7392 16.7083 23.5427 16.7083C21.3462 16.7083 19.5595 14.9214 19.5595 12.7251H18.9042Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "rect",
        {
          x: "0.5",
          y: "0.5",
          width: "145.3",
          height: "43",
          rx: "6.25",
          stroke: "black"
        }
      )
    ]
  }
), P7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "133",
    height: "40",
    viewBox: "0 0 133 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "132", height: "39", rx: "6.25", fill: "white" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M45.3957 25.4117H48.8914L47.64 22.0615C47.4677 21.5987 47.2984 21.0875 47.1314 20.5277C46.9808 21.023 46.8165 21.5287 46.6389 22.0454L45.3957 25.4117ZM49.4888 27.0021H44.8064L43.6602 30.1344H41.6016L46.1869 18.4368H48.1325L52.8229 30.1344H50.6594L49.4888 27.0021Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M58.8957 28.0072C59.3021 27.4611 59.5053 26.6631 59.5053 25.6136C59.5053 24.6396 59.337 23.9331 59.0008 23.4943C58.6642 23.0558 58.2162 22.8365 57.6565 22.8365C57.269 22.8365 56.9112 22.9282 56.5829 23.111C56.2546 23.294 55.9424 23.5388 55.6464 23.8456V28.5118C55.8456 28.6086 56.077 28.6854 56.3408 28.7416C56.6045 28.7985 56.8656 28.8267 57.1237 28.8267C57.8989 28.8267 58.4893 28.5534 58.8957 28.0072ZM53.6525 23.555C53.6525 22.9092 53.6309 22.1987 53.588 21.4238H55.4608C55.5306 21.7844 55.5792 22.1532 55.6061 22.5297C56.381 21.685 57.2691 21.2622 58.2701 21.2622C58.8515 21.2622 59.3896 21.4089 59.8848 21.7021C60.3797 21.9956 60.7795 22.4584 61.0835 23.0907C61.3877 23.7232 61.5397 24.5266 61.5397 25.5006C61.5397 26.5178 61.3661 27.387 61.0189 28.1081C60.6717 28.8294 60.1861 29.3755 59.5618 29.747C58.9376 30.1182 58.2162 30.304 57.3984 30.304C56.8061 30.304 56.2221 30.2043 55.6464 30.0054V33.6057L53.6525 33.7752V23.555Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M67.993 28.0072C68.3994 27.4611 68.6026 26.6631 68.6026 25.6136C68.6026 24.6396 68.4344 23.9331 68.0981 23.4943C67.7616 23.0558 67.3136 22.8365 66.7538 22.8365C66.3664 22.8365 66.0085 22.9282 65.6802 23.111C65.3517 23.294 65.0397 23.5388 64.7437 23.8456V28.5118C64.9429 28.6086 65.1741 28.6854 65.4381 28.7416C65.7016 28.7985 65.9626 28.8267 66.221 28.8267C66.996 28.8267 67.5866 28.5534 67.993 28.0072ZM62.7496 23.555C62.7496 22.9092 62.728 22.1987 62.685 21.4238H64.5581C64.628 21.7844 64.6765 22.1532 64.7034 22.5297C65.4784 21.685 66.3664 21.2622 67.3674 21.2622C67.9488 21.2622 68.4866 21.4089 68.9821 21.7021C69.477 21.9956 69.8768 22.4584 70.181 23.0907C70.4848 23.7232 70.637 24.5266 70.637 25.5006C70.637 26.5178 70.4632 27.387 70.1162 28.1081C69.769 28.8294 69.2832 29.3755 68.6592 29.747C68.0346 30.1182 67.3136 30.304 66.4954 30.304C65.9034 30.304 65.3194 30.2043 64.7437 30.0054V33.6057L62.7496 33.7752V23.555Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M74.3 29.5814C73.4386 29.1053 72.7768 28.4229 72.3141 27.5349C71.8509 26.6469 71.6197 25.5974 71.6197 24.3865C71.6197 23.0735 71.8861 21.9579 72.4189 21.0401C72.9517 20.1228 73.677 19.4338 74.5944 18.9736C75.5122 18.5135 76.5413 18.2834 77.6826 18.2834C78.3552 18.2834 78.9971 18.3574 79.608 18.5053C80.2187 18.6535 80.7877 18.8565 81.3154 19.1149L80.8066 20.6487C79.7464 20.1428 78.7346 19.8898 77.7715 19.8898C76.9586 19.8898 76.2469 20.0635 75.6362 20.4107C75.0253 20.7579 74.5501 21.2677 74.2112 21.9405C73.872 22.6133 73.7026 23.4259 73.7026 24.3784C73.7026 25.2128 73.833 25.9527 74.0938 26.5985C74.3552 27.2443 74.7669 27.7558 75.3293 28.1323C75.8917 28.5091 76.6008 28.6973 77.4565 28.6973C77.844 28.6973 78.2315 28.6651 78.6189 28.6006C79.0064 28.5361 79.3698 28.4419 79.7088 28.318V25.9527H77.0045V24.4027H81.6464V29.3272C80.9789 29.6392 80.2779 29.879 79.5435 30.0457C78.8085 30.2123 78.0781 30.2958 77.3514 30.2958C76.1781 30.2958 75.1608 30.058 74.3 29.5814Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M87.5376 28.5197C87.9517 28.3209 88.2909 28.0731 88.5547 27.7771V26.1625C88.0109 26.1035 87.5669 26.0738 87.2227 26.0738C86.3992 26.0738 85.8298 26.2068 85.5154 26.4735C85.2002 26.7395 85.0429 27.099 85.0429 27.551C85.0429 27.9819 85.1573 28.3006 85.3861 28.5077C85.6149 28.7149 85.9256 28.8185 86.3184 28.8185C86.7165 28.8185 87.1229 28.719 87.5376 28.5197ZM88.7323 30.1344C88.6621 29.7952 88.6162 29.4107 88.5949 28.98C88.2882 29.3462 87.8888 29.6568 87.396 29.9125C86.904 30.1681 86.348 30.2958 85.7291 30.2958C85.2285 30.2958 84.7725 30.1976 84.3605 30.0011C83.9493 29.8048 83.6221 29.5088 83.38 29.1131C83.1378 28.7176 83.0165 28.2347 83.0165 27.664C83.0165 26.8192 83.3205 26.145 83.9288 25.6417C84.537 25.1386 85.5515 24.887 86.9723 24.887C87.5051 24.887 88.0325 24.9248 88.5547 25V24.8306C88.5547 24.061 88.3904 23.5188 88.0621 23.2037C87.7338 22.8891 87.2629 22.7316 86.6496 22.7316C86.2242 22.7316 85.7696 22.7936 85.285 22.9172C84.8008 23.0412 84.3754 23.1891 84.0096 23.3613L83.6947 21.9082C84.0499 21.7466 84.5181 21.5987 85.0994 21.4641C85.6808 21.3297 86.2941 21.2622 86.94 21.2622C87.6936 21.2622 88.3339 21.3766 88.8613 21.6052C89.3888 21.8341 89.8005 22.2271 90.0965 22.7839C90.3925 23.3412 90.5405 24.0907 90.5405 25.0323V28.4955C90.5405 28.8563 90.5618 29.4028 90.605 30.1344H88.7323Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M92.0704 28.0435V17.7506L94.0562 17.5891V27.6883C94.0562 28.0597 94.1194 28.3219 94.2458 28.4755C94.3722 28.6286 94.5728 28.7057 94.8474 28.7057C94.9712 28.7057 95.1461 28.6761 95.3719 28.6168L95.6061 30.0457C95.4176 30.1211 95.1877 30.1816 94.9162 30.2272C94.6442 30.2728 94.3872 30.2958 94.145 30.2958C92.7616 30.2958 92.0704 29.5451 92.0704 28.0435Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M97.0352 28.0435V17.7506L99.021 17.5891V27.6883C99.021 28.0597 99.0842 28.3219 99.2106 28.4755C99.3373 28.6286 99.5378 28.7057 99.8122 28.7057C99.936 28.7057 100.111 28.6761 100.337 28.6168L100.571 30.0457C100.383 30.1211 100.152 30.1816 99.881 30.2272C99.609 30.2728 99.352 30.2958 99.1098 30.2958C97.7266 30.2958 97.0352 29.5451 97.0352 28.0435Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M106.794 24.766C106.754 24.0717 106.581 23.5511 106.269 23.2037C105.957 22.8568 105.538 22.6831 105.018 22.6831C104.511 22.6831 104.09 22.8582 103.754 23.2079C103.418 23.5579 103.197 24.0771 103.095 24.766H106.794ZM108.738 26.0334H103.039C103.13 27.858 103.999 28.7701 105.647 28.7701C106.055 28.7701 106.474 28.7204 106.903 28.6209C107.33 28.5211 107.741 28.3881 108.133 28.2211L108.57 29.5853C107.594 30.0592 106.501 30.2958 105.285 30.2958C104.357 30.2958 103.578 30.1211 102.943 29.7712C102.306 29.4214 101.829 28.9182 101.509 28.2614C101.189 27.6051 101.029 26.8139 101.029 25.8881C101.029 24.9248 101.199 24.0959 101.538 23.4016C101.877 22.7073 102.349 22.1773 102.954 21.8113C103.559 21.4453 104.258 21.2622 105.05 21.2622C105.874 21.2622 106.559 21.4547 107.111 21.8396C107.663 22.2242 108.071 22.737 108.338 23.3773C108.605 24.0181 108.738 24.7256 108.738 25.5006V26.0334Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M110.247 23.6115C110.247 23.1327 110.223 22.4035 110.181 21.4238H112.047C112.079 21.666 112.109 21.9553 112.141 22.2917C112.17 22.628 112.189 22.9011 112.199 23.111C112.431 22.7289 112.658 22.4073 112.882 22.1464C113.106 21.8851 113.367 21.6728 113.666 21.5084C113.965 21.3443 114.303 21.2622 114.687 21.2622C114.994 21.2622 115.255 21.2946 115.477 21.3592L115.226 23.0868C115.034 23.0277 114.818 22.998 114.581 22.998C114.114 22.998 113.703 23.1178 113.354 23.3573C113.005 23.5966 112.631 23.9909 112.231 24.5398V30.1344H110.247V23.6115Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M116.597 33.6985C116.306 33.6475 116.066 33.5896 115.879 33.5251L116.242 32.072C116.375 32.1094 116.546 32.1459 116.751 32.1809C116.954 32.2161 117.149 32.2334 117.333 32.2334C118.215 32.2334 118.877 31.6653 119.317 30.5299L119.447 30.207L116.234 21.4238H118.373L119.989 26.332C120.25 27.1718 120.421 27.8149 120.495 28.2614C120.647 27.6318 120.823 27.0021 121.029 26.3724L122.669 21.4238H124.677L121.474 30.2475C121.173 31.0816 120.845 31.7542 120.495 32.2657C120.146 32.7768 119.733 33.1563 119.258 33.404C118.781 33.6513 118.207 33.7752 117.533 33.7752C117.199 33.7752 116.887 33.7499 116.597 33.6985Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M41.5938 7.301H45.1479L45.0479 8.1594H42.6354V9.8218H44.9103V10.6261H42.6354V12.4677H45.177L45.0895 13.3343H41.5938V7.301Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M47.5977 10.2551L45.7228 7.301H46.906L48.1769 9.47193L49.5145 7.301H50.6644L48.806 10.2175L50.8185 13.3343H49.6185L48.1812 10.9594L46.7185 13.3343H45.5687L47.5977 10.2551Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M54.1977 9.9946C54.4199 9.79354 54.5311 9.50927 54.5311 9.1426C54.5311 8.77034 54.4177 8.5026 54.1916 8.3386C53.9652 8.1746 53.6324 8.09274 53.1937 8.09274H52.6271V10.2343C52.8881 10.2759 53.0881 10.2967 53.2271 10.2967C53.6519 10.2967 53.9756 10.1962 54.1977 9.9946ZM51.5852 7.301H53.2103C53.974 7.301 54.5588 7.45674 54.9644 7.76767C55.37 8.07887 55.5727 8.52874 55.5727 9.11754C55.5727 9.51754 55.4817 9.86714 55.2999 10.1655C55.1177 10.4642 54.8644 10.6935 54.5393 10.853C54.2145 11.013 53.8407 11.0927 53.4185 11.0927C53.1881 11.0927 52.9241 11.065 52.6271 11.0093V13.3343H51.5852V7.301Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M56.602 7.301H57.6436V12.4426H60.1393L60.0519 13.3343H56.602V7.301Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M64.4228 12.2989C64.7145 12.1031 64.9324 11.8338 65.0769 11.4906C65.2215 11.1477 65.2937 10.7551 65.2937 10.3135C65.2937 9.8802 65.2297 9.49433 65.102 9.15513C64.974 8.81619 64.77 8.54633 64.4895 8.34473C64.2089 8.1434 63.8479 8.04259 63.406 8.04259C62.9839 8.04259 62.6255 8.14473 62.3311 8.34899C62.0367 8.55299 61.8159 8.82686 61.6687 9.16979C61.5215 9.51299 61.4479 9.89139 61.4479 10.3053C61.4479 10.7413 61.5172 11.1317 61.6561 11.4759C61.7948 11.8205 62.0073 12.0927 62.2937 12.2927C62.5796 12.4927 62.9337 12.5927 63.3561 12.5927C63.7756 12.5927 64.1311 12.4946 64.4228 12.2989ZM61.7228 13.0386C61.2812 12.7858 60.9436 12.4309 60.7103 11.9738C60.4769 11.517 60.3604 10.9858 60.3604 10.3802C60.3604 9.7442 60.4844 9.18793 60.7332 8.7114C60.9817 8.23513 61.3401 7.86713 61.8081 7.60713C62.2761 7.34766 62.8281 7.21753 63.4644 7.21753C64.0727 7.21753 64.5964 7.3434 65.0353 7.5946C65.474 7.84633 65.8089 8.19966 66.0393 8.65513C66.27 9.11086 66.3852 9.63859 66.3852 10.2386C66.3852 10.8858 66.2596 11.4485 66.0081 11.9261C65.7567 12.4037 65.3985 12.7719 64.9332 13.0301C64.4679 13.2885 63.9215 13.4176 63.2937 13.4176C62.6881 13.4176 62.1644 13.2914 61.7228 13.0386Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M69.1812 10.1551C69.4338 10.1551 69.6575 10.1061 69.8519 10.0071C70.0463 9.90874 70.1978 9.7698 70.306 9.5906C70.4146 9.4114 70.4687 9.20367 70.4687 8.96767C70.4687 8.665 70.3727 8.4434 70.1812 8.30314C69.9895 8.16287 69.7103 8.09274 69.3436 8.09274H68.5895V10.1551H69.1812ZM67.5479 7.301H69.4353C70.1241 7.301 70.6458 7.4386 70.9999 7.71354C71.354 7.98847 71.5311 8.3818 71.5311 8.89274C71.5311 9.2122 71.4671 9.49354 71.3394 9.73647C71.2116 9.97967 71.0532 10.1775 70.8644 10.3301C70.6754 10.4829 70.4812 10.5967 70.2812 10.6719L72.1353 13.3343H70.9271L69.3562 10.9426H68.5895V13.3343H67.5479V7.301Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M72.9604 7.301H76.5145L76.4145 8.1594H74.002V9.8218H76.2769V10.6261H74.002V12.4677H76.5436L76.4561 13.3343H72.9604V7.301Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t("path", { d: "M80.3812 7.301H81.4228V13.3343H80.3812V7.301Z", fill: "black" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M84.1769 8.17193H82.306L82.3978 7.301H87.0937L86.9978 8.17193H85.2185V13.3343H84.1769V8.17193Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M94.3146 12.2989C94.606 12.1031 94.8241 11.8338 94.9687 11.4906C95.1129 11.1477 95.1852 10.7551 95.1852 10.3135C95.1852 9.8802 95.1212 9.49433 94.9938 9.15513C94.8658 8.81619 94.6615 8.54633 94.3812 8.34473C94.1004 8.1434 93.7394 8.04259 93.2978 8.04259C92.8754 8.04259 92.5172 8.14473 92.2228 8.34899C91.9282 8.55299 91.7074 8.82686 91.5604 9.16979C91.413 9.51299 91.3394 9.89139 91.3394 10.3053C91.3394 10.7413 91.4087 11.1317 91.5479 11.4759C91.6866 11.8205 91.8991 12.0927 92.1852 12.2927C92.4713 12.4927 92.8255 12.5927 93.2479 12.5927C93.6671 12.5927 94.0228 12.4946 94.3146 12.2989ZM91.6146 13.0386C91.1727 12.7858 90.8353 12.4309 90.602 11.9738C90.3687 11.517 90.2519 10.9858 90.2519 10.3802C90.2519 9.7442 90.3762 9.18793 90.625 8.7114C90.8732 8.23513 91.2316 7.86713 91.6999 7.60713C92.1679 7.34766 92.7199 7.21753 93.3562 7.21753C93.9644 7.21753 94.4879 7.3434 94.9271 7.5946C95.3658 7.84633 95.7004 8.19966 95.9311 8.65513C96.1615 9.11086 96.277 9.63859 96.277 10.2386C96.277 10.8858 96.1511 11.4485 95.8999 11.9261C95.6484 12.4037 95.29 12.7719 94.825 13.0301C94.3596 13.2885 93.8129 13.4176 93.1852 13.4176C92.5796 13.4176 92.0562 13.2914 91.6146 13.0386Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M97.4394 7.301H98.6353L101.619 11.9759C101.592 11.5317 101.582 11.1218 101.582 10.7469V7.301H102.547V13.3343H101.39L98.3604 8.5842C98.3908 9.1234 98.406 9.601 98.406 10.0175V13.3343H97.4394V7.301Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M19.7866 22.0254H20.8026L20.293 20.8403L19.7866 22.0254Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M26.9402 7.33325H15.8618C10.6432 7.33325 8.73438 9.24205 8.73438 14.4607V25.5393C8.73438 30.7578 10.6432 32.6666 15.8618 32.6666H26.9368C32.1554 32.6666 34.0677 30.7578 34.0677 25.5393V14.4607C34.0677 9.24205 32.1589 7.33325 26.9402 7.33325ZM19.5365 22.6228L19.2351 23.3124H18.549L20.0082 20.0021H20.601L22.0544 23.3124H21.3498L21.0522 22.6228H19.5365ZM30.5773 23.3101H31.2405V20.0021H30.5773V23.3101ZM27.9381 21.8887H29.1602V21.2859H27.9381V20.6077H29.7122V20.0042H27.2751V23.3121H29.7762V22.7088H27.9381V21.8887ZM25.3032 22.2796L24.5512 20.002H24.0029L23.2509 22.2796L22.5191 20.0036H21.804L22.9584 23.314H23.5146L24.2677 21.1395L25.0205 23.314H25.5818L26.7333 20.0036H26.0365L25.3032 22.2796ZM17.5367 21.8978C17.5367 22.4364 17.2693 22.7241 16.7837 22.7241C16.2954 22.7241 16.0266 22.4282 16.0266 21.8749V20.004H15.3546V21.8978C15.3546 22.8296 15.8722 23.3638 16.7746 23.3638C17.6858 23.3638 18.2085 22.8194 18.2085 21.8705V20.002H17.5367V21.8978ZM13.7512 20.0021H14.4229V23.3142H13.7512V21.9692H12.2335V23.3142H11.5616V20.0021H12.2335V21.3382H13.7512V20.0021ZM17.1842 11.5682C17.1842 13.8933 19.076 15.785 21.401 15.785C23.7261 15.785 25.6178 13.8933 25.6178 11.5682H25.0221C25.0221 13.5648 23.3978 15.1893 21.401 15.1893C19.4042 15.1893 17.78 13.5648 17.78 11.5682H17.1842Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "132", height: "39", rx: "6.25", stroke: "black" })
    ]
  }
), Y7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "147",
    height: "44",
    viewBox: "0 0 147 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "145.3", height: "43", rx: "6.25", fill: "black" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M49.9353 27.9528H53.7806L52.404 24.2675C52.2145 23.7584 52.0282 23.1962 51.8446 22.5803C51.6788 23.1251 51.4981 23.6814 51.3028 24.2498L49.9353 27.9528ZM54.4376 29.7022H49.287L48.0262 33.1477H45.7617L50.8056 20.2804H52.9458L58.1052 33.1477H55.7254L54.4376 29.7022Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M64.7853 30.8078C65.2323 30.2071 65.4558 29.3292 65.4558 28.1748C65.4558 27.1035 65.2707 26.3262 64.9009 25.8436C64.5307 25.3612 64.0379 25.12 63.4222 25.12C62.9959 25.12 62.6023 25.2209 62.2412 25.422C61.8801 25.6233 61.5366 25.8925 61.211 26.23V31.3629C61.4301 31.4693 61.6847 31.5538 61.9749 31.6157C62.265 31.6782 62.5521 31.7093 62.8361 31.7093C63.6888 31.7093 64.3383 31.4086 64.7853 30.8078ZM59.0178 25.9104C59.0178 25.2 58.994 24.4184 58.9468 23.5661H61.0069C61.0837 23.9627 61.1371 24.3684 61.1667 24.7826C62.0192 23.8533 62.996 23.3883 64.0971 23.3883C64.7366 23.3883 65.3285 23.5497 65.8733 23.8722C66.4177 24.195 66.8574 24.7041 67.1918 25.3996C67.5265 26.0954 67.6937 26.9791 67.6937 28.0505C67.6937 29.1694 67.5027 30.1256 67.1208 30.9188C66.7389 31.7122 66.2047 32.3129 65.518 32.7216C64.8313 33.1299 64.0379 33.3343 63.1382 33.3343C62.4867 33.3343 61.8443 33.2246 61.211 33.0058V36.9661L59.0178 37.1526V25.9104Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M74.7923 30.8078C75.2394 30.2071 75.4629 29.3292 75.4629 28.1748C75.4629 27.1035 75.2778 26.3262 74.9079 25.8436C74.5377 25.3612 74.0449 25.12 73.4292 25.12C73.003 25.12 72.6094 25.2209 72.2483 25.422C71.8869 25.6233 71.5437 25.8925 71.2181 26.23V31.3629C71.4372 31.4693 71.6915 31.5538 71.9819 31.6157C72.2717 31.6782 72.5589 31.7093 72.8431 31.7093C73.6956 31.7093 74.3453 31.4086 74.7923 30.8078ZM69.0245 25.9104C69.0245 25.2 69.0008 24.4184 68.9535 23.5661H71.0139C71.0908 23.9627 71.1442 24.3684 71.1738 24.7826C72.0262 23.8533 73.003 23.3883 74.1042 23.3883C74.7436 23.3883 75.3353 23.5497 75.8803 23.8722C76.4247 24.195 76.8644 24.7041 77.1991 25.3996C77.5332 26.0954 77.7007 26.9791 77.7007 28.0505C77.7007 29.1694 77.5095 30.1256 77.1279 30.9188C76.7459 31.7122 76.2115 32.3129 75.5251 32.7216C74.8381 33.1299 74.0449 33.3343 73.145 33.3343C72.4938 33.3343 71.8514 33.2246 71.2181 33.0058V36.9661L69.0245 37.1526V25.9104Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M81.73 32.5394C80.7825 32.0158 80.0544 31.2651 79.5455 30.2883C79.036 29.3115 78.7817 28.157 78.7817 26.825C78.7817 25.3807 79.0747 24.1535 79.6608 23.144C80.2469 22.1349 81.0447 21.3771 82.0538 20.8708C83.0635 20.3647 84.1954 20.1116 85.4509 20.1116C86.1907 20.1116 86.8968 20.193 87.5688 20.3558C88.2405 20.5187 88.8665 20.742 89.447 21.0263L88.8873 22.7134C87.721 22.157 86.6081 21.8787 85.5486 21.8787C84.6545 21.8787 83.8716 22.0697 83.1999 22.4516C82.5278 22.8335 82.0051 23.3944 81.6323 24.1344C81.2592 24.8745 81.0729 25.7683 81.0729 26.8161C81.0729 27.734 81.2163 28.5478 81.5032 29.2582C81.7907 29.9686 82.2436 30.5312 82.8622 30.9454C83.4809 31.3599 84.2608 31.5669 85.2021 31.5669C85.6284 31.5669 86.0546 31.5315 86.4808 31.4605C86.907 31.3896 87.3068 31.286 87.6796 31.1496V28.5478H84.705V26.8428H89.811V32.2598C89.0768 32.603 88.3056 32.8668 87.4978 33.0501C86.6894 33.2334 85.8859 33.3252 85.0866 33.3252C83.7959 33.3252 82.6768 33.0636 81.73 32.5394Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M96.2913 31.3716C96.7469 31.1528 97.12 30.8802 97.4101 30.5547V28.7787C96.812 28.7137 96.3236 28.6811 95.9449 28.6811C95.0391 28.6811 94.4128 28.8274 94.067 29.1207C93.7203 29.4133 93.5472 29.8088 93.5472 30.306C93.5472 30.78 93.673 31.1305 93.9247 31.3584C94.1764 31.5863 94.5181 31.7002 94.9502 31.7002C95.3882 31.7002 95.8352 31.5908 96.2913 31.3716ZM97.6055 33.1477C97.5283 32.7746 97.4779 32.3516 97.4544 31.8779C97.1171 32.2807 96.6777 32.6224 96.1356 32.9037C95.5944 33.1848 94.9828 33.3252 94.302 33.3252C93.7514 33.3252 93.2498 33.2173 92.7966 33.0011C92.3442 32.7852 91.9843 32.4595 91.718 32.0242C91.4516 31.5893 91.3182 31.0581 91.3182 30.4303C91.3182 29.501 91.6526 28.7594 92.3216 28.2057C92.9907 27.6523 94.1066 27.3756 95.6695 27.3756C96.2556 27.3756 96.8358 27.4172 97.4101 27.4999V27.3135C97.4101 26.467 97.2294 25.8705 96.8683 25.5239C96.5072 25.1779 95.9892 25.0047 95.3145 25.0047C94.8467 25.0047 94.3465 25.0728 93.8136 25.2088C93.2809 25.3452 92.813 25.5079 92.4105 25.6973L92.0641 24.0989C92.4548 23.9211 92.9699 23.7584 93.6094 23.6104C94.2489 23.4626 94.9235 23.3883 95.634 23.3883C96.4629 23.3883 97.1672 23.5141 97.7475 23.7656C98.3277 24.0174 98.7806 24.4497 99.1062 25.0622C99.4318 25.6752 99.5946 26.4996 99.5946 27.5354V31.3449C99.5946 31.7418 99.618 32.3429 99.6656 33.1477H97.6055Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M101.277 30.8477V19.5255L103.462 19.3479V30.457C103.462 30.8656 103.531 31.154 103.67 31.3229C103.809 31.4913 104.03 31.5761 104.332 31.5761C104.468 31.5761 104.661 31.5436 104.909 31.4784L105.167 33.0501C104.959 33.1331 104.706 33.1997 104.408 33.2498C104.109 33.3 103.826 33.3252 103.56 33.3252C102.038 33.3252 101.277 32.4995 101.277 30.8477Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M106.739 30.8477V19.5255L108.923 19.3479V30.457C108.923 30.8656 108.993 31.154 109.132 31.3229C109.271 31.4913 109.492 31.5761 109.793 31.5761C109.93 31.5761 110.122 31.5436 110.371 31.4784L110.628 33.0501C110.421 33.1331 110.168 33.1997 109.869 33.2498C109.57 33.3 109.287 33.3252 109.021 33.3252C107.499 33.3252 106.739 32.4995 106.739 30.8477Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M117.474 27.2425C117.43 26.4787 117.239 25.9061 116.896 25.5239C116.552 25.1424 116.092 24.9512 115.52 24.9512C114.963 24.9512 114.499 25.1439 114.13 25.5285C113.76 25.9135 113.516 26.4847 113.405 27.2425H117.474ZM119.612 28.6366H113.343C113.443 30.6436 114.399 31.647 116.212 31.647C116.661 31.647 117.122 31.5923 117.594 31.4828C118.063 31.3731 118.515 31.2268 118.946 31.0431L119.427 32.5438C118.354 33.065 117.151 33.3252 115.813 33.3252C114.792 33.3252 113.936 33.1331 113.238 32.7482C112.537 32.3634 112.012 31.8099 111.66 31.0874C111.308 30.3655 111.132 29.4952 111.132 28.4768C111.132 27.4172 111.319 26.5053 111.692 25.7417C112.064 24.9779 112.584 24.3949 113.25 23.9923C113.915 23.5898 114.684 23.3883 115.555 23.3883C116.462 23.3883 117.215 23.6001 117.823 24.0235C118.43 24.4465 118.879 25.0106 119.172 25.7149C119.465 26.4198 119.612 27.198 119.612 28.0505V28.6366Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M121.272 25.9725C121.272 25.4458 121.246 24.6437 121.199 23.5661H123.252C123.287 23.8325 123.32 24.1507 123.355 24.5208C123.387 24.8906 123.408 25.1911 123.419 25.422C123.675 25.0017 123.924 24.6479 124.17 24.3609C124.417 24.0735 124.704 23.8399 125.033 23.6591C125.361 23.4786 125.734 23.3883 126.156 23.3883C126.494 23.3883 126.781 23.424 127.024 23.495L126.749 25.3954C126.538 25.3303 126.3 25.2976 126.039 25.2976C125.526 25.2976 125.074 25.4294 124.69 25.6929C124.305 25.9561 123.895 26.3898 123.455 26.9937V33.1477H121.272V25.9725Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M128.256 37.0682C127.937 37.0122 127.673 36.9485 127.467 36.8775L127.866 35.2791C128.013 35.3202 128.201 35.3603 128.427 35.3988C128.65 35.4376 128.864 35.4566 129.066 35.4566C130.037 35.4566 130.764 34.8318 131.248 33.5828L131.392 33.2276L127.858 23.5661H130.21L131.988 28.9651C132.275 29.8889 132.463 30.5963 132.545 31.0874C132.712 30.3949 132.906 29.7022 133.132 29.0096L134.936 23.5661H137.144L133.622 33.2722C133.29 34.1897 132.929 34.9295 132.545 35.4921C132.161 36.0544 131.706 36.4718 131.184 36.7443C130.659 37.0163 130.028 37.1526 129.286 37.1526C128.919 37.1526 128.576 37.1248 128.256 37.0682Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M45.7539 8.03127H49.6634L49.5534 8.97551H46.8997V10.8042H49.4021V11.6888H46.8997V13.7146H49.6954L49.5992 14.6679H45.7539V8.03127Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M52.3583 11.2808L50.2959 8.03127H51.5974L52.9954 10.4193L54.4668 8.03127H55.7316L53.6874 11.2395L55.9012 14.6679H54.5812L53.0001 12.0555L51.3912 14.6679H50.1263L52.3583 11.2808Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M59.6183 10.9942C59.8626 10.7731 59.985 10.4604 59.985 10.057C59.985 9.64754 59.8603 9.35303 59.6115 9.17263C59.3625 8.99223 58.9964 8.90218 58.5139 8.90218H57.8906V11.2579C58.1777 11.3037 58.3977 11.3266 58.5506 11.3266C59.0178 11.3266 59.374 11.216 59.6183 10.9942ZM56.7445 8.03127H58.5321C59.3722 8.03127 60.0155 8.20258 60.4616 8.54461C60.9078 8.88693 61.1307 9.38178 61.1307 10.0295C61.1307 10.4695 61.0307 10.854 60.8306 11.1823C60.6303 11.5108 60.3516 11.7631 59.994 11.9385C59.6368 12.1145 59.2255 12.2022 58.7612 12.2022C58.5077 12.2022 58.2173 12.1717 57.8906 12.1104V14.6679H56.7445V8.03127Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M62.263 8.03127H63.4088V13.687H66.1541L66.0578 14.6679H62.263V8.03127Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M70.8659 13.5289C71.1868 13.3136 71.4264 13.0173 71.5854 12.6398C71.7444 12.2626 71.8239 11.8308 71.8239 11.3451C71.8239 10.8684 71.7535 10.4439 71.613 10.0708C71.4722 9.69798 71.2478 9.40113 70.9392 9.17937C70.6306 8.95791 70.2334 8.84702 69.7474 8.84702C69.283 8.84702 68.8888 8.95937 68.565 9.18406C68.2411 9.40846 67.9982 9.70972 67.8363 10.0869C67.6744 10.4645 67.5934 10.8807 67.5934 11.336C67.5934 11.8156 67.6697 12.245 67.8225 12.6237C67.9751 13.0027 68.2088 13.3022 68.5239 13.5222C68.8383 13.7422 69.2279 13.8522 69.6925 13.8522C70.1539 13.8522 70.5449 13.7442 70.8659 13.5289ZM67.8959 14.3426C67.4101 14.0645 67.0387 13.6741 66.7821 13.1713C66.5254 12.6689 66.3972 12.0845 66.3972 11.4184C66.3972 10.7188 66.5336 10.1069 66.8073 9.58271C67.0807 9.05881 67.4749 8.65401 67.9897 8.36801C68.5045 8.0826 69.1117 7.93945 69.8116 7.93945C70.4807 7.93945 71.0568 8.07791 71.5396 8.35423C72.0222 8.63113 72.3906 9.0198 72.644 9.52081C72.8978 10.0221 73.0245 10.6026 73.0245 11.2626C73.0245 11.9745 72.8863 12.5935 72.6097 13.1188C72.3331 13.6442 71.9392 14.0493 71.4273 14.3332C70.9154 14.6175 70.3144 14.7596 69.6239 14.7596C68.9577 14.7596 68.3816 14.6207 67.8959 14.3426Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M76.1001 11.1708C76.3779 11.1708 76.624 11.1168 76.8379 11.008C77.0517 10.8998 77.2183 10.747 77.3374 10.5498C77.4568 10.3527 77.5163 10.1242 77.5163 9.86461C77.5163 9.53167 77.4108 9.28791 77.2001 9.13362C76.9892 8.97933 76.6821 8.90218 76.2788 8.90218H75.4492V11.1708H76.1001ZM74.3035 8.03127H76.3797C77.1373 8.03127 77.7111 8.18263 78.1007 8.48506C78.4902 8.78749 78.685 9.22015 78.685 9.78218C78.685 10.1336 78.6146 10.4431 78.4741 10.7103C78.3336 10.9778 78.1593 11.1955 77.9517 11.3632C77.7437 11.5313 77.5301 11.6566 77.3101 11.7393L79.3497 14.6679H78.0206L76.2925 12.037H75.4492V14.6679H74.3035V8.03127Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M80.2572 8.03127H84.1668L84.0568 8.97551H81.403V10.8042H83.9054V11.6888H81.403V13.7146H84.1987L84.1025 14.6679H80.2572V8.03127Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M88.4201 8.03127H89.5659V14.6679H88.4201V8.03127Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M92.5954 8.9893H90.5374L90.6383 8.03127H95.8039L95.6983 8.9893H93.7412V14.6679H92.5954V8.9893Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M103.747 13.5289C104.067 13.3136 104.307 13.0173 104.466 12.6398C104.625 12.2626 104.705 11.8308 104.705 11.3451C104.705 10.8684 104.634 10.4439 104.494 10.0708C104.353 9.69798 104.128 9.40113 103.82 9.17937C103.511 8.95791 103.114 8.84702 102.628 8.84702C102.164 8.84702 101.77 8.95937 101.446 9.18406C101.122 9.40846 100.879 9.70972 100.717 10.0869C100.555 10.4645 100.474 10.8807 100.474 11.336C100.474 11.8156 100.55 12.245 100.703 12.6237C100.856 13.0027 101.09 13.3022 101.405 13.5222C101.719 13.7422 102.109 13.8522 102.573 13.8522C103.035 13.8522 103.426 13.7442 103.747 13.5289ZM100.777 14.3426C100.291 14.0645 99.9197 13.6741 99.663 13.1713C99.4063 12.6689 99.2778 12.0845 99.2778 11.4184C99.2778 10.7188 99.4145 10.1069 99.6882 9.58271C99.9613 9.05881 100.356 8.65401 100.871 8.36801C101.385 8.0826 101.993 7.93945 102.693 7.93945C103.362 7.93945 103.937 8.07791 104.421 8.35423C104.903 8.63113 105.271 9.0198 105.525 9.52081C105.778 10.0221 105.905 10.6026 105.905 11.2626C105.905 11.9745 105.767 12.5935 105.491 13.1188C105.214 13.6442 104.82 14.0493 104.308 14.3332C103.796 14.6175 103.195 14.7596 102.505 14.7596C101.838 14.7596 101.263 14.6207 100.777 14.3426Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M107.184 8.03127H108.5L111.782 13.1737C111.752 12.685 111.741 12.2342 111.741 11.8217V8.03127H112.803V14.6679H111.529L108.197 9.44279C108.231 10.0359 108.247 10.5613 108.247 11.0195V14.6679H107.184V8.03127Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M29.6358 8.06668H17.4496C11.709 8.06668 9.60938 10.1664 9.60938 15.9069V28.0933C9.60938 33.8337 11.709 35.9333 17.4496 35.9333H29.632C35.3725 35.9333 37.476 33.8337 37.476 28.0933V15.9069C37.476 10.1664 35.3764 8.06668 29.6358 8.06668Z",
          fill: "#C91C2E"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M21.7663 24.228H22.8839L22.3234 22.9244L21.7663 24.228ZM21.4912 24.8851L21.1597 25.6437H20.405L22.0101 22.0023H22.6622L24.2608 25.6437H23.4858L23.1585 24.8851H21.4912ZM33.636 25.6412H34.3656V22.0023H33.636V25.6412ZM30.7329 24.0776H32.0773V23.4145H30.7329V22.6685H32.6845V22.0046H30.0037V25.6433H32.7549V24.9797H30.7329V24.0776ZM27.8345 24.5076L27.0073 22.0022H26.4042L25.577 24.5076L24.7721 22.004H23.9854L25.2552 25.6454H25.8671L26.6955 23.2535L27.5236 25.6454H28.141L29.4077 22.004H28.6412L27.8345 24.5076ZM19.2915 24.0877C19.2915 24.68 18.9973 24.9965 18.4631 24.9965C17.926 24.9965 17.6303 24.6711 17.6303 24.0624V22.0044H16.8911V24.0877C16.8911 25.1126 17.4605 25.7002 18.4531 25.7002C19.4554 25.7002 20.0304 25.1014 20.0304 24.0575V22.0022H19.2915V24.0877ZM15.1273 22.0023H15.8662V25.6456H15.1273V24.1661H13.4579V25.6456H12.7188V22.0023H13.4579V23.4721H15.1273V22.0023Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M23.5408 17.3635C20.9832 17.3635 18.9023 15.2826 18.9023 12.725H19.5576C19.5576 14.9213 21.3443 16.7082 23.5408 16.7082C25.7373 16.7082 27.524 14.9213 27.524 12.725H28.1793C28.1793 15.2826 26.0984 17.3635 23.5408 17.3635Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "rect",
        {
          x: "0.5",
          y: "0.5",
          width: "145.3",
          height: "43",
          rx: "6.25",
          stroke: "#A6A6A6"
        }
      )
    ]
  }
), J7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "133",
    height: "40",
    viewBox: "0 0 133 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "132", height: "39", rx: "6.25", fill: "black" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M45.3957 25.4117H48.8914L47.64 22.0615C47.4677 21.5987 47.2984 21.0875 47.1314 20.5277C46.9808 21.023 46.8165 21.5287 46.6389 22.0454L45.3957 25.4117ZM49.4888 27.0021H44.8064L43.6602 30.1344H41.6016L46.1869 18.4368H48.1325L52.8229 30.1344H50.6594L49.4888 27.0021Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M58.8957 28.0072C59.3021 27.4611 59.5053 26.6631 59.5053 25.6136C59.5053 24.6396 59.337 23.9331 59.0008 23.4943C58.6642 23.0558 58.2162 22.8365 57.6565 22.8365C57.269 22.8365 56.9112 22.9282 56.5829 23.111C56.2546 23.294 55.9424 23.5388 55.6464 23.8456V28.5118C55.8456 28.6086 56.077 28.6854 56.3408 28.7416C56.6045 28.7985 56.8656 28.8267 57.1237 28.8267C57.8989 28.8267 58.4893 28.5534 58.8957 28.0072ZM53.6525 23.555C53.6525 22.9092 53.6309 22.1987 53.588 21.4238H55.4608C55.5306 21.7844 55.5792 22.1532 55.6061 22.5297C56.381 21.685 57.2691 21.2622 58.2701 21.2622C58.8515 21.2622 59.3896 21.4089 59.8848 21.7021C60.3797 21.9956 60.7795 22.4584 61.0835 23.0907C61.3877 23.7232 61.5397 24.5266 61.5397 25.5006C61.5397 26.5178 61.3661 27.387 61.0189 28.1081C60.6717 28.8294 60.1861 29.3755 59.5618 29.747C58.9376 30.1182 58.2162 30.304 57.3984 30.304C56.8061 30.304 56.2221 30.2043 55.6464 30.0054V33.6057L53.6525 33.7752V23.555Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M67.993 28.0072C68.3994 27.4611 68.6026 26.6631 68.6026 25.6136C68.6026 24.6396 68.4344 23.9331 68.0981 23.4943C67.7616 23.0558 67.3136 22.8365 66.7538 22.8365C66.3664 22.8365 66.0085 22.9282 65.6802 23.111C65.3517 23.294 65.0397 23.5388 64.7437 23.8456V28.5118C64.9429 28.6086 65.1741 28.6854 65.4381 28.7416C65.7016 28.7985 65.9626 28.8267 66.221 28.8267C66.996 28.8267 67.5866 28.5534 67.993 28.0072ZM62.7496 23.555C62.7496 22.9092 62.728 22.1987 62.685 21.4238H64.5581C64.628 21.7844 64.6765 22.1532 64.7034 22.5297C65.4784 21.685 66.3664 21.2622 67.3674 21.2622C67.9488 21.2622 68.4866 21.4089 68.9821 21.7021C69.477 21.9956 69.8768 22.4584 70.181 23.0907C70.4848 23.7232 70.637 24.5266 70.637 25.5006C70.637 26.5178 70.4632 27.387 70.1162 28.1081C69.769 28.8294 69.2832 29.3755 68.6592 29.747C68.0346 30.1182 67.3136 30.304 66.4954 30.304C65.9034 30.304 65.3194 30.2043 64.7437 30.0054V33.6057L62.7496 33.7752V23.555Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M74.3 29.5814C73.4386 29.1053 72.7768 28.4229 72.3141 27.5349C71.8509 26.6469 71.6197 25.5974 71.6197 24.3865C71.6197 23.0735 71.8861 21.9579 72.4189 21.0401C72.9517 20.1228 73.677 19.4338 74.5944 18.9736C75.5122 18.5135 76.5413 18.2834 77.6826 18.2834C78.3552 18.2834 78.9971 18.3574 79.608 18.5053C80.2187 18.6535 80.7877 18.8565 81.3154 19.1149L80.8066 20.6487C79.7464 20.1428 78.7346 19.8898 77.7715 19.8898C76.9586 19.8898 76.2469 20.0635 75.6362 20.4107C75.0253 20.7579 74.5501 21.2677 74.2112 21.9405C73.872 22.6133 73.7026 23.4259 73.7026 24.3784C73.7026 25.2128 73.833 25.9527 74.0938 26.5985C74.3552 27.2443 74.7669 27.7558 75.3293 28.1323C75.8917 28.5091 76.6008 28.6973 77.4565 28.6973C77.844 28.6973 78.2315 28.6651 78.6189 28.6006C79.0064 28.5361 79.3698 28.4419 79.7088 28.318V25.9527H77.0045V24.4027H81.6464V29.3272C80.9789 29.6392 80.2779 29.879 79.5435 30.0457C78.8085 30.2123 78.0781 30.2958 77.3514 30.2958C76.1781 30.2958 75.1608 30.058 74.3 29.5814Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M87.5376 28.5197C87.9517 28.3209 88.2909 28.0731 88.5547 27.7771V26.1625C88.0109 26.1035 87.5669 26.0738 87.2227 26.0738C86.3992 26.0738 85.8298 26.2068 85.5154 26.4735C85.2002 26.7395 85.0429 27.099 85.0429 27.551C85.0429 27.9819 85.1573 28.3006 85.3861 28.5077C85.6149 28.7149 85.9256 28.8185 86.3184 28.8185C86.7165 28.8185 87.1229 28.719 87.5376 28.5197ZM88.7323 30.1344C88.6621 29.7952 88.6162 29.4107 88.5949 28.98C88.2882 29.3462 87.8888 29.6568 87.396 29.9125C86.904 30.1681 86.348 30.2958 85.7291 30.2958C85.2285 30.2958 84.7725 30.1976 84.3605 30.0011C83.9493 29.8048 83.6221 29.5088 83.38 29.1131C83.1378 28.7176 83.0165 28.2347 83.0165 27.664C83.0165 26.8192 83.3205 26.145 83.9288 25.6417C84.537 25.1386 85.5515 24.887 86.9723 24.887C87.5051 24.887 88.0325 24.9248 88.5547 25V24.8306C88.5547 24.061 88.3904 23.5188 88.0621 23.2037C87.7338 22.8891 87.2629 22.7316 86.6496 22.7316C86.2242 22.7316 85.7696 22.7936 85.285 22.9172C84.8008 23.0412 84.3754 23.1891 84.0096 23.3613L83.6947 21.9082C84.0499 21.7466 84.5181 21.5987 85.0994 21.4641C85.6808 21.3297 86.2941 21.2622 86.94 21.2622C87.6936 21.2622 88.3339 21.3766 88.8613 21.6052C89.3888 21.8341 89.8005 22.2271 90.0965 22.7839C90.3925 23.3412 90.5405 24.0907 90.5405 25.0323V28.4955C90.5405 28.8563 90.5618 29.4028 90.605 30.1344H88.7323Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M92.0704 28.0435V17.7506L94.0562 17.5891V27.6883C94.0562 28.0597 94.1194 28.3219 94.2458 28.4755C94.3722 28.6286 94.5728 28.7057 94.8474 28.7057C94.9712 28.7057 95.1461 28.6761 95.3719 28.6168L95.6061 30.0457C95.4176 30.1211 95.1877 30.1816 94.9162 30.2272C94.6442 30.2728 94.3872 30.2958 94.145 30.2958C92.7616 30.2958 92.0704 29.5451 92.0704 28.0435Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M97.0352 28.0435V17.7506L99.021 17.5891V27.6883C99.021 28.0597 99.0842 28.3219 99.2106 28.4755C99.3373 28.6286 99.5378 28.7057 99.8122 28.7057C99.936 28.7057 100.111 28.6761 100.337 28.6168L100.571 30.0457C100.383 30.1211 100.152 30.1816 99.881 30.2272C99.609 30.2728 99.352 30.2958 99.1098 30.2958C97.7266 30.2958 97.0352 29.5451 97.0352 28.0435Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M106.794 24.766C106.754 24.0717 106.581 23.5511 106.269 23.2037C105.957 22.8568 105.538 22.6831 105.018 22.6831C104.511 22.6831 104.09 22.8582 103.754 23.2079C103.418 23.5579 103.197 24.0771 103.095 24.766H106.794ZM108.738 26.0334H103.039C103.13 27.858 103.999 28.7701 105.647 28.7701C106.055 28.7701 106.474 28.7204 106.903 28.6209C107.33 28.5211 107.741 28.3881 108.133 28.2211L108.57 29.5853C107.594 30.0592 106.501 30.2958 105.285 30.2958C104.357 30.2958 103.578 30.1211 102.943 29.7712C102.306 29.4214 101.829 28.9182 101.509 28.2614C101.189 27.6051 101.029 26.8139 101.029 25.8881C101.029 24.9248 101.199 24.0959 101.538 23.4016C101.877 22.7073 102.349 22.1773 102.954 21.8113C103.559 21.4453 104.258 21.2622 105.05 21.2622C105.874 21.2622 106.559 21.4547 107.111 21.8396C107.663 22.2242 108.071 22.737 108.338 23.3773C108.605 24.0181 108.738 24.7256 108.738 25.5006V26.0334Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M110.247 23.6115C110.247 23.1327 110.223 22.4035 110.181 21.4238H112.047C112.079 21.666 112.109 21.9553 112.141 22.2917C112.17 22.628 112.189 22.9011 112.199 23.111C112.431 22.7289 112.658 22.4073 112.882 22.1464C113.106 21.8851 113.367 21.6728 113.666 21.5084C113.965 21.3443 114.303 21.2622 114.687 21.2622C114.994 21.2622 115.255 21.2946 115.477 21.3592L115.226 23.0868C115.034 23.0277 114.818 22.998 114.581 22.998C114.114 22.998 113.703 23.1178 113.354 23.3573C113.005 23.5966 112.631 23.9909 112.231 24.5398V30.1344H110.247V23.6115Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M116.597 33.6985C116.306 33.6475 116.066 33.5896 115.879 33.5251L116.242 32.072C116.375 32.1094 116.546 32.1459 116.751 32.1809C116.954 32.2161 117.149 32.2334 117.333 32.2334C118.215 32.2334 118.877 31.6653 119.317 30.5299L119.447 30.207L116.234 21.4238H118.373L119.989 26.332C120.25 27.1718 120.421 27.8149 120.495 28.2614C120.647 27.6318 120.823 27.0021 121.029 26.3724L122.669 21.4238H124.677L121.474 30.2475C121.173 31.0816 120.845 31.7542 120.495 32.2657C120.146 32.7768 119.733 33.1563 119.258 33.404C118.781 33.6513 118.207 33.7752 117.533 33.7752C117.199 33.7752 116.887 33.7499 116.597 33.6985Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M41.5938 7.301H45.1479L45.0479 8.1594H42.6354V9.8218H44.9103V10.6261H42.6354V12.4677H45.177L45.0895 13.3343H41.5938V7.301Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M47.5977 10.2551L45.7228 7.301H46.906L48.1769 9.47193L49.5145 7.301H50.6644L48.806 10.2175L50.8185 13.3343H49.6185L48.1812 10.9594L46.7185 13.3343H45.5687L47.5977 10.2551Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M54.1977 9.9946C54.4199 9.79354 54.5311 9.50927 54.5311 9.1426C54.5311 8.77034 54.4177 8.5026 54.1916 8.3386C53.9652 8.1746 53.6324 8.09274 53.1937 8.09274H52.6271V10.2343C52.8881 10.2759 53.0881 10.2967 53.2271 10.2967C53.6519 10.2967 53.9756 10.1962 54.1977 9.9946ZM51.5852 7.301H53.2103C53.974 7.301 54.5588 7.45674 54.9644 7.76767C55.37 8.07887 55.5727 8.52874 55.5727 9.11754C55.5727 9.51754 55.4817 9.86714 55.2999 10.1655C55.1177 10.4642 54.8644 10.6935 54.5393 10.853C54.2145 11.013 53.8407 11.0927 53.4185 11.0927C53.1881 11.0927 52.9241 11.065 52.6271 11.0093V13.3343H51.5852V7.301Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M56.602 7.301H57.6436V12.4426H60.1393L60.0519 13.3343H56.602V7.301Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M64.4228 12.2989C64.7145 12.1031 64.9324 11.8338 65.0769 11.4906C65.2215 11.1477 65.2937 10.7551 65.2937 10.3135C65.2937 9.8802 65.2297 9.49433 65.102 9.15513C64.974 8.81619 64.77 8.54633 64.4895 8.34473C64.2089 8.1434 63.8479 8.04259 63.406 8.04259C62.9839 8.04259 62.6255 8.14473 62.3311 8.34899C62.0367 8.55299 61.8159 8.82686 61.6687 9.16979C61.5215 9.51299 61.4479 9.89139 61.4479 10.3053C61.4479 10.7413 61.5172 11.1317 61.6561 11.4759C61.7948 11.8205 62.0073 12.0927 62.2937 12.2927C62.5796 12.4927 62.9337 12.5927 63.3561 12.5927C63.7756 12.5927 64.1311 12.4946 64.4228 12.2989ZM61.7228 13.0386C61.2812 12.7858 60.9436 12.4309 60.7103 11.9738C60.4769 11.517 60.3604 10.9858 60.3604 10.3802C60.3604 9.7442 60.4844 9.18793 60.7332 8.7114C60.9817 8.23513 61.3401 7.86713 61.8081 7.60713C62.2761 7.34766 62.8281 7.21753 63.4644 7.21753C64.0727 7.21753 64.5964 7.3434 65.0353 7.5946C65.474 7.84633 65.8089 8.19966 66.0393 8.65513C66.27 9.11086 66.3852 9.63859 66.3852 10.2386C66.3852 10.8858 66.2596 11.4485 66.0081 11.9261C65.7567 12.4037 65.3985 12.7719 64.9332 13.0301C64.4679 13.2885 63.9215 13.4176 63.2937 13.4176C62.6881 13.4176 62.1644 13.2914 61.7228 13.0386Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M69.1812 10.1551C69.4338 10.1551 69.6575 10.1061 69.8519 10.0071C70.0463 9.90874 70.1978 9.7698 70.306 9.5906C70.4146 9.4114 70.4687 9.20367 70.4687 8.96767C70.4687 8.665 70.3727 8.4434 70.1812 8.30314C69.9895 8.16287 69.7103 8.09274 69.3436 8.09274H68.5895V10.1551H69.1812ZM67.5479 7.301H69.4353C70.1241 7.301 70.6458 7.4386 70.9999 7.71354C71.354 7.98847 71.5311 8.3818 71.5311 8.89274C71.5311 9.2122 71.4671 9.49354 71.3394 9.73647C71.2116 9.97967 71.0532 10.1775 70.8644 10.3301C70.6754 10.4829 70.4812 10.5967 70.2812 10.6719L72.1353 13.3343H70.9271L69.3562 10.9426H68.5895V13.3343H67.5479V7.301Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M72.9604 7.301H76.5145L76.4145 8.1594H74.002V9.8218H76.2769V10.6261H74.002V12.4677H76.5436L76.4561 13.3343H72.9604V7.301Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t("path", { d: "M80.3812 7.301H81.4228V13.3343H80.3812V7.301Z", fill: "white" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M84.1769 8.17193H82.306L82.3978 7.301H87.0937L86.9978 8.17193H85.2185V13.3343H84.1769V8.17193Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M94.3146 12.2989C94.606 12.1031 94.8241 11.8338 94.9687 11.4906C95.1129 11.1477 95.1852 10.7551 95.1852 10.3135C95.1852 9.8802 95.1212 9.49433 94.9938 9.15513C94.8658 8.81619 94.6615 8.54633 94.3812 8.34473C94.1004 8.1434 93.7394 8.04259 93.2978 8.04259C92.8754 8.04259 92.5172 8.14473 92.2228 8.34899C91.9282 8.55299 91.7074 8.82686 91.5604 9.16979C91.413 9.51299 91.3394 9.89139 91.3394 10.3053C91.3394 10.7413 91.4087 11.1317 91.5479 11.4759C91.6866 11.8205 91.8991 12.0927 92.1852 12.2927C92.4713 12.4927 92.8255 12.5927 93.2479 12.5927C93.6671 12.5927 94.0228 12.4946 94.3146 12.2989ZM91.6146 13.0386C91.1727 12.7858 90.8353 12.4309 90.602 11.9738C90.3687 11.517 90.2519 10.9858 90.2519 10.3802C90.2519 9.7442 90.3762 9.18793 90.625 8.7114C90.8732 8.23513 91.2316 7.86713 91.6999 7.60713C92.1679 7.34766 92.7199 7.21753 93.3562 7.21753C93.9644 7.21753 94.4879 7.3434 94.9271 7.5946C95.3658 7.84633 95.7004 8.19966 95.9311 8.65513C96.1615 9.11086 96.277 9.63859 96.277 10.2386C96.277 10.8858 96.1511 11.4485 95.8999 11.9261C95.6484 12.4037 95.29 12.7719 94.825 13.0301C94.3596 13.2885 93.8129 13.4176 93.1852 13.4176C92.5796 13.4176 92.0562 13.2914 91.6146 13.0386Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M97.4394 7.301H98.6353L101.619 11.9759C101.592 11.5317 101.582 11.1218 101.582 10.7469V7.301H102.547V13.3343H101.39L98.3604 8.5842C98.3908 9.1234 98.406 9.601 98.406 10.0175V13.3343H97.4394V7.301Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M26.9402 7.33317H15.8618C10.6432 7.33317 8.73438 9.24197 8.73438 14.4607V25.5392C8.73438 30.7578 10.6432 32.6665 15.8618 32.6665H26.9368C32.1554 32.6665 34.0677 30.7578 34.0677 25.5392V14.4607C34.0677 9.24197 32.1589 7.33317 26.9402 7.33317Z",
          fill: "#C91C2E"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M19.7876 22.0254H20.8036L20.294 20.8403L19.7876 22.0254ZM19.5374 22.6228L19.2361 23.3124H18.55L20.0092 20.0021H20.602L22.0553 23.3124H21.3508L21.0532 22.6228H19.5374ZM30.5782 23.3101H31.2414V20.0021H30.5782V23.3101ZM27.939 21.8886H29.1612V21.2858H27.939V20.6077H29.7132V20.0042H27.2761V23.3121H29.7772V22.7088H27.939V21.8886ZM25.3041 22.2796L24.5521 20.002H24.0038L23.2518 22.2796L22.5201 20.0036H21.8049L22.9593 23.314H23.5156L24.2686 21.1395L25.0214 23.314H25.5828L26.7342 20.0036H26.0374L25.3041 22.2796ZM17.5377 21.8978C17.5377 22.4364 17.2702 22.7241 16.7846 22.7241C16.2964 22.7241 16.0276 22.4282 16.0276 21.8749V20.004H15.3556V21.8978C15.3556 22.8296 15.8732 23.3638 16.7756 23.3638C17.6868 23.3638 18.2094 22.8194 18.2094 21.8704V20.002H17.5377V21.8978ZM13.7521 20.0021H14.4238V23.3142H13.7521V21.9692H12.2345V23.3142H11.5625V20.0021H12.2345V21.3382H13.7521V20.0021Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M21.4004 15.7849C19.0753 15.7849 17.1836 13.8932 17.1836 11.5681H17.7793C17.7793 13.5647 19.4036 15.1892 21.4004 15.1892C23.3972 15.1892 25.0215 13.5647 25.0215 11.5681H25.6172C25.6172 13.8932 23.7255 15.7849 21.4004 15.7849Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "rect",
        {
          x: "0.5",
          y: "0.5",
          width: "132",
          height: "39",
          rx: "6.25",
          stroke: "#A6A6A6"
        }
      )
    ]
  }
), K7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "147",
    height: "44",
    viewBox: "0 0 147 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M49.9353 27.9528H53.7806L52.404 24.2675C52.2145 23.7584 52.0282 23.1962 51.8446 22.5803C51.6788 23.1251 51.4981 23.6814 51.3028 24.2498L49.9353 27.9528ZM54.4376 29.7022H49.287L48.0262 33.1477H45.7617L50.8056 20.2804H52.9458L58.1052 33.1477H55.7254L54.4376 29.7022Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M64.7853 30.8078C65.2323 30.2071 65.4558 29.3292 65.4558 28.1748C65.4558 27.1035 65.2707 26.3262 64.9009 25.8436C64.5307 25.3612 64.0379 25.12 63.4222 25.12C62.9959 25.12 62.6023 25.2209 62.2412 25.422C61.8801 25.6233 61.5366 25.8925 61.211 26.23V31.3629C61.4301 31.4693 61.6847 31.5538 61.9749 31.6157C62.265 31.6782 62.5521 31.7093 62.8361 31.7093C63.6888 31.7093 64.3383 31.4086 64.7853 30.8078ZM59.0178 25.9104C59.0178 25.2 58.994 24.4184 58.9468 23.5661H61.0069C61.0837 23.9627 61.1371 24.3684 61.1667 24.7826C62.0192 23.8533 62.996 23.3883 64.0971 23.3883C64.7366 23.3883 65.3285 23.5497 65.8733 23.8722C66.4177 24.195 66.8574 24.7041 67.1918 25.3996C67.5265 26.0954 67.6937 26.9791 67.6937 28.0505C67.6937 29.1694 67.5027 30.1256 67.1208 30.9188C66.7389 31.7122 66.2047 32.3129 65.518 32.7216C64.8313 33.1299 64.0379 33.3343 63.1382 33.3343C62.4867 33.3343 61.8443 33.2246 61.211 33.0058V36.9661L59.0178 37.1526V25.9104Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M74.7923 30.8078C75.2394 30.2071 75.4629 29.3292 75.4629 28.1748C75.4629 27.1035 75.2778 26.3262 74.9079 25.8436C74.5377 25.3612 74.0449 25.12 73.4292 25.12C73.003 25.12 72.6094 25.2209 72.2483 25.422C71.8869 25.6233 71.5437 25.8925 71.2181 26.23V31.3629C71.4372 31.4693 71.6915 31.5538 71.9819 31.6157C72.2717 31.6782 72.5589 31.7093 72.8431 31.7093C73.6956 31.7093 74.3453 31.4086 74.7923 30.8078ZM69.0245 25.9104C69.0245 25.2 69.0008 24.4184 68.9535 23.5661H71.0139C71.0908 23.9627 71.1442 24.3684 71.1738 24.7826C72.0262 23.8533 73.003 23.3883 74.1042 23.3883C74.7436 23.3883 75.3353 23.5497 75.8803 23.8722C76.4247 24.195 76.8644 24.7041 77.1991 25.3996C77.5332 26.0954 77.7007 26.9791 77.7007 28.0505C77.7007 29.1694 77.5095 30.1256 77.1279 30.9188C76.7459 31.7122 76.2115 32.3129 75.5251 32.7216C74.8381 33.1299 74.0449 33.3343 73.145 33.3343C72.4938 33.3343 71.8514 33.2246 71.2181 33.0058V36.9661L69.0245 37.1526V25.9104Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M81.73 32.5394C80.7825 32.0158 80.0544 31.2651 79.5455 30.2883C79.036 29.3115 78.7817 28.157 78.7817 26.825C78.7817 25.3807 79.0747 24.1535 79.6608 23.144C80.2469 22.1349 81.0447 21.3771 82.0538 20.8708C83.0635 20.3647 84.1954 20.1116 85.4509 20.1116C86.1907 20.1116 86.8968 20.193 87.5688 20.3558C88.2405 20.5187 88.8665 20.742 89.447 21.0263L88.8873 22.7134C87.721 22.157 86.6081 21.8787 85.5486 21.8787C84.6545 21.8787 83.8716 22.0697 83.1999 22.4516C82.5278 22.8335 82.0051 23.3944 81.6323 24.1344C81.2592 24.8745 81.0729 25.7683 81.0729 26.8161C81.0729 27.734 81.2163 28.5478 81.5032 29.2582C81.7907 29.9686 82.2436 30.5312 82.8622 30.9454C83.4809 31.3599 84.2608 31.5669 85.2021 31.5669C85.6284 31.5669 86.0546 31.5315 86.4808 31.4605C86.907 31.3896 87.3068 31.286 87.6796 31.1496V28.5478H84.705V26.8428H89.811V32.2598C89.0768 32.603 88.3056 32.8668 87.4978 33.0501C86.6894 33.2334 85.8859 33.3252 85.0866 33.3252C83.7959 33.3252 82.6768 33.0636 81.73 32.5394Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M96.2913 31.3716C96.7469 31.1528 97.12 30.8802 97.4101 30.5547V28.7787C96.812 28.7137 96.3236 28.6811 95.9449 28.6811C95.0391 28.6811 94.4128 28.8274 94.067 29.1207C93.7203 29.4133 93.5472 29.8088 93.5472 30.306C93.5472 30.78 93.673 31.1305 93.9247 31.3584C94.1764 31.5863 94.5181 31.7002 94.9502 31.7002C95.3882 31.7002 95.8352 31.5908 96.2913 31.3716ZM97.6055 33.1477C97.5283 32.7746 97.4779 32.3516 97.4544 31.8779C97.1171 32.2807 96.6777 32.6224 96.1356 32.9037C95.5944 33.1848 94.9828 33.3252 94.302 33.3252C93.7514 33.3252 93.2498 33.2173 92.7966 33.0011C92.3442 32.7852 91.9843 32.4595 91.718 32.0242C91.4516 31.5893 91.3182 31.0581 91.3182 30.4303C91.3182 29.501 91.6526 28.7594 92.3216 28.2057C92.9907 27.6523 94.1066 27.3756 95.6695 27.3756C96.2556 27.3756 96.8358 27.4172 97.4101 27.4999V27.3135C97.4101 26.467 97.2294 25.8705 96.8683 25.5239C96.5072 25.1779 95.9892 25.0047 95.3145 25.0047C94.8467 25.0047 94.3465 25.0728 93.8136 25.2088C93.2809 25.3452 92.813 25.5079 92.4105 25.6973L92.0641 24.0989C92.4548 23.9211 92.9699 23.7584 93.6094 23.6104C94.2489 23.4626 94.9235 23.3883 95.634 23.3883C96.4629 23.3883 97.1672 23.5141 97.7475 23.7656C98.3277 24.0174 98.7806 24.4497 99.1062 25.0622C99.4318 25.6752 99.5946 26.4996 99.5946 27.5354V31.3449C99.5946 31.7418 99.618 32.3429 99.6656 33.1477H97.6055Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M101.277 30.8477V19.5255L103.462 19.3479V30.457C103.462 30.8656 103.531 31.154 103.67 31.3229C103.809 31.4913 104.03 31.5761 104.332 31.5761C104.468 31.5761 104.661 31.5436 104.909 31.4784L105.167 33.0501C104.959 33.1331 104.706 33.1997 104.408 33.2498C104.109 33.3 103.826 33.3252 103.56 33.3252C102.038 33.3252 101.277 32.4995 101.277 30.8477Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M106.739 30.8477V19.5255L108.923 19.3479V30.457C108.923 30.8656 108.993 31.154 109.132 31.3229C109.271 31.4913 109.492 31.5761 109.793 31.5761C109.93 31.5761 110.122 31.5436 110.371 31.4784L110.628 33.0501C110.421 33.1331 110.168 33.1997 109.869 33.2498C109.57 33.3 109.287 33.3252 109.021 33.3252C107.499 33.3252 106.739 32.4995 106.739 30.8477Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M117.474 27.2425C117.43 26.4787 117.239 25.9061 116.896 25.5239C116.552 25.1424 116.092 24.9512 115.52 24.9512C114.963 24.9512 114.499 25.1439 114.13 25.5285C113.76 25.9135 113.516 26.4847 113.405 27.2425H117.474ZM119.612 28.6366H113.343C113.443 30.6436 114.399 31.647 116.212 31.647C116.661 31.647 117.122 31.5923 117.594 31.4828C118.063 31.3731 118.515 31.2268 118.946 31.0431L119.427 32.5438C118.354 33.065 117.151 33.3252 115.813 33.3252C114.792 33.3252 113.936 33.1331 113.238 32.7482C112.537 32.3634 112.012 31.8099 111.66 31.0874C111.308 30.3655 111.132 29.4952 111.132 28.4768C111.132 27.4172 111.319 26.5053 111.692 25.7417C112.064 24.9779 112.584 24.3949 113.25 23.9923C113.915 23.5898 114.684 23.3883 115.555 23.3883C116.462 23.3883 117.215 23.6001 117.823 24.0235C118.43 24.4465 118.879 25.0106 119.172 25.7149C119.465 26.4198 119.612 27.198 119.612 28.0505V28.6366Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M121.272 25.9725C121.272 25.4458 121.246 24.6437 121.199 23.5661H123.252C123.287 23.8325 123.32 24.1507 123.355 24.5208C123.387 24.8906 123.408 25.1911 123.419 25.422C123.675 25.0017 123.924 24.6479 124.17 24.3609C124.417 24.0735 124.704 23.8399 125.033 23.6591C125.361 23.4786 125.734 23.3883 126.156 23.3883C126.494 23.3883 126.781 23.424 127.024 23.495L126.749 25.3954C126.538 25.3303 126.3 25.2976 126.039 25.2976C125.526 25.2976 125.074 25.4294 124.69 25.6929C124.305 25.9561 123.895 26.3898 123.455 26.9937V33.1477H121.272V25.9725Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M128.256 37.0682C127.937 37.0122 127.673 36.9485 127.467 36.8775L127.866 35.2791C128.013 35.3202 128.201 35.3603 128.427 35.3988C128.65 35.4376 128.864 35.4566 129.066 35.4566C130.037 35.4566 130.764 34.8318 131.248 33.5828L131.392 33.2276L127.858 23.5661H130.21L131.988 28.9651C132.275 29.8889 132.463 30.5963 132.545 31.0874C132.712 30.3949 132.906 29.7022 133.132 29.0096L134.936 23.5661H137.144L133.622 33.2722C133.29 34.1897 132.929 34.9295 132.545 35.4921C132.161 36.0544 131.706 36.4718 131.184 36.7443C130.659 37.0163 130.028 37.1526 129.286 37.1526C128.919 37.1526 128.576 37.1248 128.256 37.0682Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M45.7539 8.03127H49.6634L49.5534 8.97551H46.8997V10.8042H49.4021V11.6888H46.8997V13.7146H49.6954L49.5992 14.6679H45.7539V8.03127Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M52.3583 11.2808L50.2959 8.03127H51.5974L52.9954 10.4193L54.4668 8.03127H55.7316L53.6874 11.2395L55.9012 14.6679H54.5812L53.0001 12.0555L51.3912 14.6679H50.1263L52.3583 11.2808Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M59.6183 10.9942C59.8626 10.7731 59.985 10.4604 59.985 10.057C59.985 9.64754 59.8603 9.35303 59.6115 9.17263C59.3625 8.99223 58.9964 8.90218 58.5139 8.90218H57.8906V11.2579C58.1777 11.3037 58.3977 11.3266 58.5506 11.3266C59.0178 11.3266 59.374 11.216 59.6183 10.9942ZM56.7445 8.03127H58.5321C59.3722 8.03127 60.0155 8.20258 60.4616 8.54461C60.9078 8.88693 61.1307 9.38178 61.1307 10.0295C61.1307 10.4695 61.0307 10.854 60.8306 11.1823C60.6303 11.5108 60.3516 11.7631 59.994 11.9385C59.6368 12.1145 59.2255 12.2022 58.7612 12.2022C58.5077 12.2022 58.2173 12.1717 57.8906 12.1104V14.6679H56.7445V8.03127Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M62.263 8.03127H63.4088V13.687H66.1541L66.0578 14.6679H62.263V8.03127Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M70.8659 13.5289C71.1868 13.3136 71.4264 13.0173 71.5854 12.6398C71.7444 12.2626 71.8239 11.8308 71.8239 11.3451C71.8239 10.8684 71.7535 10.4439 71.613 10.0708C71.4722 9.69798 71.2478 9.40113 70.9392 9.17937C70.6306 8.95791 70.2334 8.84702 69.7474 8.84702C69.283 8.84702 68.8888 8.95937 68.565 9.18406C68.2411 9.40846 67.9982 9.70972 67.8363 10.0869C67.6744 10.4645 67.5934 10.8807 67.5934 11.336C67.5934 11.8156 67.6697 12.245 67.8225 12.6237C67.9751 13.0027 68.2088 13.3022 68.5239 13.5222C68.8383 13.7422 69.2279 13.8522 69.6925 13.8522C70.1539 13.8522 70.5449 13.7442 70.8659 13.5289ZM67.8959 14.3426C67.4101 14.0645 67.0387 13.6741 66.7821 13.1713C66.5254 12.6689 66.3972 12.0845 66.3972 11.4184C66.3972 10.7188 66.5336 10.1069 66.8073 9.58271C67.0807 9.05881 67.4749 8.65401 67.9897 8.36801C68.5045 8.0826 69.1117 7.93945 69.8116 7.93945C70.4807 7.93945 71.0568 8.07791 71.5396 8.35423C72.0222 8.63113 72.3906 9.0198 72.644 9.52081C72.8978 10.0221 73.0245 10.6026 73.0245 11.2626C73.0245 11.9745 72.8863 12.5935 72.6097 13.1188C72.3331 13.6442 71.9392 14.0493 71.4273 14.3332C70.9154 14.6175 70.3144 14.7596 69.6239 14.7596C68.9577 14.7596 68.3816 14.6207 67.8959 14.3426Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M76.1001 11.1708C76.3779 11.1708 76.624 11.1168 76.8379 11.008C77.0517 10.8998 77.2183 10.747 77.3374 10.5498C77.4568 10.3527 77.5163 10.1242 77.5163 9.86461C77.5163 9.53167 77.4108 9.28791 77.2001 9.13362C76.9892 8.97933 76.6821 8.90218 76.2788 8.90218H75.4492V11.1708H76.1001ZM74.3035 8.03127H76.3797C77.1373 8.03127 77.7111 8.18263 78.1007 8.48506C78.4902 8.78749 78.685 9.22015 78.685 9.78218C78.685 10.1336 78.6146 10.4431 78.4741 10.7103C78.3336 10.9778 78.1593 11.1955 77.9517 11.3632C77.7437 11.5313 77.5301 11.6566 77.3101 11.7393L79.3497 14.6679H78.0206L76.2925 12.037H75.4492V14.6679H74.3035V8.03127Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M80.2572 8.03127H84.1668L84.0568 8.97551H81.403V10.8042H83.9054V11.6888H81.403V13.7146H84.1987L84.1025 14.6679H80.2572V8.03127Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M88.4201 8.03127H89.5659V14.6679H88.4201V8.03127Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M92.5954 8.9893H90.5374L90.6383 8.03127H95.8039L95.6983 8.9893H93.7412V14.6679H92.5954V8.9893Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M103.747 13.5289C104.067 13.3136 104.307 13.0173 104.466 12.6398C104.625 12.2626 104.705 11.8308 104.705 11.3451C104.705 10.8684 104.634 10.4439 104.494 10.0708C104.353 9.69798 104.128 9.40113 103.82 9.17937C103.511 8.95791 103.114 8.84702 102.628 8.84702C102.164 8.84702 101.77 8.95937 101.446 9.18406C101.122 9.40846 100.879 9.70972 100.717 10.0869C100.555 10.4645 100.474 10.8807 100.474 11.336C100.474 11.8156 100.55 12.245 100.703 12.6237C100.856 13.0027 101.09 13.3022 101.405 13.5222C101.719 13.7422 102.109 13.8522 102.573 13.8522C103.035 13.8522 103.426 13.7442 103.747 13.5289ZM100.777 14.3426C100.291 14.0645 99.9197 13.6741 99.663 13.1713C99.4063 12.6689 99.2778 12.0845 99.2778 11.4184C99.2778 10.7188 99.4145 10.1069 99.6882 9.58271C99.9613 9.05881 100.356 8.65401 100.871 8.36801C101.385 8.0826 101.993 7.93945 102.693 7.93945C103.362 7.93945 103.937 8.07791 104.421 8.35423C104.903 8.63113 105.271 9.0198 105.525 9.52081C105.778 10.0221 105.905 10.6026 105.905 11.2626C105.905 11.9745 105.767 12.5935 105.491 13.1188C105.214 13.6442 104.82 14.0493 104.308 14.3332C103.796 14.6175 103.195 14.7596 102.505 14.7596C101.838 14.7596 101.263 14.6207 100.777 14.3426Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M107.184 8.03127H108.5L111.782 13.1737C111.752 12.685 111.741 12.2342 111.741 11.8217V8.03127H112.803V14.6679H111.529L108.197 9.44279C108.231 10.0359 108.247 10.5613 108.247 11.0195V14.6679H107.184V8.03127Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M21.7668 24.2281H22.8844L22.3239 22.9245L21.7668 24.2281Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M29.6358 8.06665H17.4496C11.709 8.06665 9.60938 10.1663 9.60938 15.9069V28.0933C9.60938 33.8337 11.709 35.9333 17.4496 35.9333H29.632C35.3725 35.9333 37.476 33.8337 37.476 28.0933V15.9069C37.476 10.1663 35.3764 8.06665 29.6358 8.06665ZM21.4917 24.8852L21.1602 25.6437H20.4055L22.0106 22.0024H22.6627L24.2614 25.6437H23.4864L23.159 24.8852H21.4917ZM33.6366 25.6412H34.3661V22.0024H33.6366V25.6412ZM30.7335 24.0776H32.0778V23.4145H30.7335V22.6686H32.685V22.0047H30.0042V25.6434H32.7554V24.9797H30.7335V24.0776ZM27.835 24.5076L27.0078 22.0023H26.4047L25.5775 24.5076L24.7726 22.004H23.9859L25.2557 25.6454H25.8676L26.696 23.2535L27.5241 25.6454H28.1416L29.4082 22.004H28.6417L27.835 24.5076ZM19.292 24.0877C19.292 24.6801 18.9978 24.9966 18.4636 24.9966C17.9265 24.9966 17.6308 24.6711 17.6308 24.0625V22.0044H16.8916V24.0877C16.8916 25.1126 17.461 25.7002 18.4536 25.7002C19.456 25.7002 20.0309 25.1014 20.0309 24.0576V22.0023H19.292V24.0877ZM15.1278 22.0024H15.8667V25.6457H15.1278V24.1662H13.4585V25.6457H12.7193V22.0024H13.4585V23.4721H15.1278V22.0024ZM18.9042 12.7251C18.9042 15.2827 20.9851 17.3636 23.5427 17.3636C26.1003 17.3636 28.1812 15.2827 28.1812 12.7251H27.5259C27.5259 14.9214 25.7392 16.7083 23.5427 16.7083C21.3462 16.7083 19.5595 14.9214 19.5595 12.7251H18.9042Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "rect",
        {
          x: "0.5",
          y: "0.5",
          width: "145.3",
          height: "43",
          rx: "6.25",
          stroke: "white"
        }
      )
    ]
  }
), X7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "133",
    height: "40",
    viewBox: "0 0 133 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M45.3957 25.4117H48.8914L47.64 22.0615C47.4677 21.5987 47.2984 21.0875 47.1314 20.5277C46.9808 21.023 46.8165 21.5287 46.6389 22.0454L45.3957 25.4117ZM49.4888 27.0021H44.8064L43.6602 30.1344H41.6016L46.1869 18.4368H48.1325L52.8229 30.1344H50.6594L49.4888 27.0021Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M58.8957 28.0072C59.3021 27.4611 59.5053 26.6631 59.5053 25.6136C59.5053 24.6396 59.337 23.9331 59.0008 23.4943C58.6642 23.0558 58.2162 22.8365 57.6565 22.8365C57.269 22.8365 56.9112 22.9282 56.5829 23.111C56.2546 23.294 55.9424 23.5388 55.6464 23.8456V28.5118C55.8456 28.6086 56.077 28.6854 56.3408 28.7416C56.6045 28.7985 56.8656 28.8267 57.1237 28.8267C57.8989 28.8267 58.4893 28.5534 58.8957 28.0072ZM53.6525 23.555C53.6525 22.9092 53.6309 22.1987 53.588 21.4238H55.4608C55.5306 21.7844 55.5792 22.1532 55.6061 22.5297C56.381 21.685 57.2691 21.2622 58.2701 21.2622C58.8515 21.2622 59.3896 21.4089 59.8848 21.7021C60.3797 21.9956 60.7795 22.4584 61.0835 23.0907C61.3877 23.7232 61.5397 24.5266 61.5397 25.5006C61.5397 26.5178 61.3661 27.387 61.0189 28.1081C60.6717 28.8294 60.1861 29.3755 59.5618 29.747C58.9376 30.1182 58.2162 30.304 57.3984 30.304C56.8061 30.304 56.2221 30.2043 55.6464 30.0054V33.6057L53.6525 33.7752V23.555Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M67.993 28.0072C68.3994 27.4611 68.6026 26.6631 68.6026 25.6136C68.6026 24.6396 68.4344 23.9331 68.0981 23.4943C67.7616 23.0558 67.3136 22.8365 66.7538 22.8365C66.3664 22.8365 66.0085 22.9282 65.6802 23.111C65.3517 23.294 65.0397 23.5388 64.7437 23.8456V28.5118C64.9429 28.6086 65.1741 28.6854 65.4381 28.7416C65.7016 28.7985 65.9626 28.8267 66.221 28.8267C66.996 28.8267 67.5866 28.5534 67.993 28.0072ZM62.7496 23.555C62.7496 22.9092 62.728 22.1987 62.685 21.4238H64.5581C64.628 21.7844 64.6765 22.1532 64.7034 22.5297C65.4784 21.685 66.3664 21.2622 67.3674 21.2622C67.9488 21.2622 68.4866 21.4089 68.9821 21.7021C69.477 21.9956 69.8768 22.4584 70.181 23.0907C70.4848 23.7232 70.637 24.5266 70.637 25.5006C70.637 26.5178 70.4632 27.387 70.1162 28.1081C69.769 28.8294 69.2832 29.3755 68.6592 29.747C68.0346 30.1182 67.3136 30.304 66.4954 30.304C65.9034 30.304 65.3194 30.2043 64.7437 30.0054V33.6057L62.7496 33.7752V23.555Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M74.3 29.5814C73.4386 29.1053 72.7768 28.4229 72.3141 27.5349C71.8509 26.6469 71.6197 25.5974 71.6197 24.3865C71.6197 23.0735 71.8861 21.9579 72.4189 21.0401C72.9517 20.1228 73.677 19.4338 74.5944 18.9736C75.5122 18.5135 76.5413 18.2834 77.6826 18.2834C78.3552 18.2834 78.9971 18.3574 79.608 18.5053C80.2187 18.6535 80.7877 18.8565 81.3154 19.1149L80.8066 20.6487C79.7464 20.1428 78.7346 19.8898 77.7715 19.8898C76.9586 19.8898 76.2469 20.0635 75.6362 20.4107C75.0253 20.7579 74.5501 21.2677 74.2112 21.9405C73.872 22.6133 73.7026 23.4259 73.7026 24.3784C73.7026 25.2128 73.833 25.9527 74.0938 26.5985C74.3552 27.2443 74.7669 27.7558 75.3293 28.1323C75.8917 28.5091 76.6008 28.6973 77.4565 28.6973C77.844 28.6973 78.2315 28.6651 78.6189 28.6006C79.0064 28.5361 79.3698 28.4419 79.7088 28.318V25.9527H77.0045V24.4027H81.6464V29.3272C80.9789 29.6392 80.2779 29.879 79.5435 30.0457C78.8085 30.2123 78.0781 30.2958 77.3514 30.2958C76.1781 30.2958 75.1608 30.058 74.3 29.5814Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M87.5376 28.5197C87.9517 28.3209 88.2909 28.0731 88.5547 27.7771V26.1625C88.0109 26.1035 87.5669 26.0738 87.2227 26.0738C86.3992 26.0738 85.8298 26.2068 85.5154 26.4735C85.2002 26.7395 85.0429 27.099 85.0429 27.551C85.0429 27.9819 85.1573 28.3006 85.3861 28.5077C85.6149 28.7149 85.9256 28.8185 86.3184 28.8185C86.7165 28.8185 87.1229 28.719 87.5376 28.5197ZM88.7323 30.1344C88.6621 29.7952 88.6162 29.4107 88.5949 28.98C88.2882 29.3462 87.8888 29.6568 87.396 29.9125C86.904 30.1681 86.348 30.2958 85.7291 30.2958C85.2285 30.2958 84.7725 30.1976 84.3605 30.0011C83.9493 29.8048 83.6221 29.5088 83.38 29.1131C83.1378 28.7176 83.0165 28.2347 83.0165 27.664C83.0165 26.8192 83.3205 26.145 83.9288 25.6417C84.537 25.1386 85.5515 24.887 86.9723 24.887C87.5051 24.887 88.0325 24.9248 88.5547 25V24.8306C88.5547 24.061 88.3904 23.5188 88.0621 23.2037C87.7338 22.8891 87.2629 22.7316 86.6496 22.7316C86.2242 22.7316 85.7696 22.7936 85.285 22.9172C84.8008 23.0412 84.3754 23.1891 84.0096 23.3613L83.6947 21.9082C84.0499 21.7466 84.5181 21.5987 85.0994 21.4641C85.6808 21.3297 86.2941 21.2622 86.94 21.2622C87.6936 21.2622 88.3339 21.3766 88.8613 21.6052C89.3888 21.8341 89.8005 22.2271 90.0965 22.7839C90.3925 23.3412 90.5405 24.0907 90.5405 25.0323V28.4955C90.5405 28.8563 90.5618 29.4028 90.605 30.1344H88.7323Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M92.0704 28.0435V17.7506L94.0562 17.5891V27.6883C94.0562 28.0597 94.1194 28.3219 94.2458 28.4755C94.3722 28.6286 94.5728 28.7057 94.8474 28.7057C94.9712 28.7057 95.1461 28.6761 95.3719 28.6168L95.6061 30.0457C95.4176 30.1211 95.1877 30.1816 94.9162 30.2272C94.6442 30.2728 94.3872 30.2958 94.145 30.2958C92.7616 30.2958 92.0704 29.5451 92.0704 28.0435Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M97.0352 28.0435V17.7506L99.021 17.5891V27.6883C99.021 28.0597 99.0842 28.3219 99.2106 28.4755C99.3373 28.6286 99.5378 28.7057 99.8122 28.7057C99.936 28.7057 100.111 28.6761 100.337 28.6168L100.571 30.0457C100.383 30.1211 100.152 30.1816 99.881 30.2272C99.609 30.2728 99.352 30.2958 99.1098 30.2958C97.7266 30.2958 97.0352 29.5451 97.0352 28.0435Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M106.794 24.766C106.754 24.0717 106.581 23.5511 106.269 23.2037C105.957 22.8568 105.538 22.6831 105.018 22.6831C104.511 22.6831 104.09 22.8582 103.754 23.2079C103.418 23.5579 103.197 24.0771 103.095 24.766H106.794ZM108.738 26.0334H103.039C103.13 27.858 103.999 28.7701 105.647 28.7701C106.055 28.7701 106.474 28.7204 106.903 28.6209C107.33 28.5211 107.741 28.3881 108.133 28.2211L108.57 29.5853C107.594 30.0592 106.501 30.2958 105.285 30.2958C104.357 30.2958 103.578 30.1211 102.943 29.7712C102.306 29.4214 101.829 28.9182 101.509 28.2614C101.189 27.6051 101.029 26.8139 101.029 25.8881C101.029 24.9248 101.199 24.0959 101.538 23.4016C101.877 22.7073 102.349 22.1773 102.954 21.8113C103.559 21.4453 104.258 21.2622 105.05 21.2622C105.874 21.2622 106.559 21.4547 107.111 21.8396C107.663 22.2242 108.071 22.737 108.338 23.3773C108.605 24.0181 108.738 24.7256 108.738 25.5006V26.0334Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M110.247 23.6115C110.247 23.1327 110.223 22.4035 110.181 21.4238H112.047C112.079 21.666 112.109 21.9553 112.141 22.2917C112.17 22.628 112.189 22.9011 112.199 23.111C112.431 22.7289 112.658 22.4073 112.882 22.1464C113.106 21.8851 113.367 21.6728 113.666 21.5084C113.965 21.3443 114.303 21.2622 114.687 21.2622C114.994 21.2622 115.255 21.2946 115.477 21.3592L115.226 23.0868C115.034 23.0277 114.818 22.998 114.581 22.998C114.114 22.998 113.703 23.1178 113.354 23.3573C113.005 23.5966 112.631 23.9909 112.231 24.5398V30.1344H110.247V23.6115Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M116.597 33.6985C116.306 33.6475 116.066 33.5896 115.879 33.5251L116.242 32.072C116.375 32.1094 116.546 32.1459 116.751 32.1809C116.954 32.2161 117.149 32.2334 117.333 32.2334C118.215 32.2334 118.877 31.6653 119.317 30.5299L119.447 30.207L116.234 21.4238H118.373L119.989 26.332C120.25 27.1718 120.421 27.8149 120.495 28.2614C120.647 27.6318 120.823 27.0021 121.029 26.3724L122.669 21.4238H124.677L121.474 30.2475C121.173 31.0816 120.845 31.7542 120.495 32.2657C120.146 32.7768 119.733 33.1563 119.258 33.404C118.781 33.6513 118.207 33.7752 117.533 33.7752C117.199 33.7752 116.887 33.7499 116.597 33.6985Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M41.5938 7.301H45.1479L45.0479 8.1594H42.6354V9.8218H44.9103V10.6261H42.6354V12.4677H45.177L45.0895 13.3343H41.5938V7.301Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M47.5977 10.2551L45.7228 7.301H46.906L48.1769 9.47193L49.5145 7.301H50.6644L48.806 10.2175L50.8185 13.3343H49.6185L48.1812 10.9594L46.7185 13.3343H45.5687L47.5977 10.2551Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M54.1977 9.9946C54.4199 9.79354 54.5311 9.50927 54.5311 9.1426C54.5311 8.77034 54.4177 8.5026 54.1916 8.3386C53.9652 8.1746 53.6324 8.09274 53.1937 8.09274H52.6271V10.2343C52.8881 10.2759 53.0881 10.2967 53.2271 10.2967C53.6519 10.2967 53.9756 10.1962 54.1977 9.9946ZM51.5852 7.301H53.2103C53.974 7.301 54.5588 7.45674 54.9644 7.76767C55.37 8.07887 55.5727 8.52874 55.5727 9.11754C55.5727 9.51754 55.4817 9.86714 55.2999 10.1655C55.1177 10.4642 54.8644 10.6935 54.5393 10.853C54.2145 11.013 53.8407 11.0927 53.4185 11.0927C53.1881 11.0927 52.9241 11.065 52.6271 11.0093V13.3343H51.5852V7.301Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M56.602 7.301H57.6436V12.4426H60.1393L60.0519 13.3343H56.602V7.301Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M64.4228 12.2989C64.7145 12.1031 64.9324 11.8338 65.0769 11.4906C65.2215 11.1477 65.2937 10.7551 65.2937 10.3135C65.2937 9.8802 65.2297 9.49433 65.102 9.15513C64.974 8.81619 64.77 8.54633 64.4895 8.34473C64.2089 8.1434 63.8479 8.04259 63.406 8.04259C62.9839 8.04259 62.6255 8.14473 62.3311 8.34899C62.0367 8.55299 61.8159 8.82686 61.6687 9.16979C61.5215 9.51299 61.4479 9.89139 61.4479 10.3053C61.4479 10.7413 61.5172 11.1317 61.6561 11.4759C61.7948 11.8205 62.0073 12.0927 62.2937 12.2927C62.5796 12.4927 62.9337 12.5927 63.3561 12.5927C63.7756 12.5927 64.1311 12.4946 64.4228 12.2989ZM61.7228 13.0386C61.2812 12.7858 60.9436 12.4309 60.7103 11.9738C60.4769 11.517 60.3604 10.9858 60.3604 10.3802C60.3604 9.7442 60.4844 9.18793 60.7332 8.7114C60.9817 8.23513 61.3401 7.86713 61.8081 7.60713C62.2761 7.34766 62.8281 7.21753 63.4644 7.21753C64.0727 7.21753 64.5964 7.3434 65.0353 7.5946C65.474 7.84633 65.8089 8.19966 66.0393 8.65513C66.27 9.11086 66.3852 9.63859 66.3852 10.2386C66.3852 10.8858 66.2596 11.4485 66.0081 11.9261C65.7567 12.4037 65.3985 12.7719 64.9332 13.0301C64.4679 13.2885 63.9215 13.4176 63.2937 13.4176C62.6881 13.4176 62.1644 13.2914 61.7228 13.0386Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M69.1812 10.1551C69.4338 10.1551 69.6575 10.1061 69.8519 10.0071C70.0463 9.90874 70.1978 9.7698 70.306 9.5906C70.4146 9.4114 70.4687 9.20367 70.4687 8.96767C70.4687 8.665 70.3727 8.4434 70.1812 8.30314C69.9895 8.16287 69.7103 8.09274 69.3436 8.09274H68.5895V10.1551H69.1812ZM67.5479 7.301H69.4353C70.1241 7.301 70.6458 7.4386 70.9999 7.71354C71.354 7.98847 71.5311 8.3818 71.5311 8.89274C71.5311 9.2122 71.4671 9.49354 71.3394 9.73647C71.2116 9.97967 71.0532 10.1775 70.8644 10.3301C70.6754 10.4829 70.4812 10.5967 70.2812 10.6719L72.1353 13.3343H70.9271L69.3562 10.9426H68.5895V13.3343H67.5479V7.301Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M72.9604 7.301H76.5145L76.4145 8.1594H74.002V9.8218H76.2769V10.6261H74.002V12.4677H76.5436L76.4561 13.3343H72.9604V7.301Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t("path", { d: "M80.3812 7.301H81.4228V13.3343H80.3812V7.301Z", fill: "white" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M84.1769 8.17193H82.306L82.3978 7.301H87.0937L86.9978 8.17193H85.2185V13.3343H84.1769V8.17193Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M94.3146 12.2989C94.606 12.1031 94.8241 11.8338 94.9687 11.4906C95.1129 11.1477 95.1852 10.7551 95.1852 10.3135C95.1852 9.8802 95.1212 9.49433 94.9938 9.15513C94.8658 8.81619 94.6615 8.54633 94.3812 8.34473C94.1004 8.1434 93.7394 8.04259 93.2978 8.04259C92.8754 8.04259 92.5172 8.14473 92.2228 8.34899C91.9282 8.55299 91.7074 8.82686 91.5604 9.16979C91.413 9.51299 91.3394 9.89139 91.3394 10.3053C91.3394 10.7413 91.4087 11.1317 91.5479 11.4759C91.6866 11.8205 91.8991 12.0927 92.1852 12.2927C92.4713 12.4927 92.8255 12.5927 93.2479 12.5927C93.6671 12.5927 94.0228 12.4946 94.3146 12.2989ZM91.6146 13.0386C91.1727 12.7858 90.8353 12.4309 90.602 11.9738C90.3687 11.517 90.2519 10.9858 90.2519 10.3802C90.2519 9.7442 90.3762 9.18793 90.625 8.7114C90.8732 8.23513 91.2316 7.86713 91.6999 7.60713C92.1679 7.34766 92.7199 7.21753 93.3562 7.21753C93.9644 7.21753 94.4879 7.3434 94.9271 7.5946C95.3658 7.84633 95.7004 8.19966 95.9311 8.65513C96.1615 9.11086 96.277 9.63859 96.277 10.2386C96.277 10.8858 96.1511 11.4485 95.8999 11.9261C95.6484 12.4037 95.29 12.7719 94.825 13.0301C94.3596 13.2885 93.8129 13.4176 93.1852 13.4176C92.5796 13.4176 92.0562 13.2914 91.6146 13.0386Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M97.4394 7.301H98.6353L101.619 11.9759C101.592 11.5317 101.582 11.1218 101.582 10.7469V7.301H102.547V13.3343H101.39L98.3604 8.5842C98.3908 9.1234 98.406 9.601 98.406 10.0175V13.3343H97.4394V7.301Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M19.7866 22.0254H20.8026L20.293 20.8403L19.7866 22.0254Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M26.9402 7.33325H15.8618C10.6432 7.33325 8.73438 9.24205 8.73438 14.4607V25.5393C8.73438 30.7578 10.6432 32.6666 15.8618 32.6666H26.9368C32.1554 32.6666 34.0677 30.7578 34.0677 25.5393V14.4607C34.0677 9.24205 32.1589 7.33325 26.9402 7.33325ZM19.5365 22.6228L19.2351 23.3124H18.549L20.0082 20.0021H20.601L22.0544 23.3124H21.3498L21.0522 22.6228H19.5365ZM30.5773 23.3101H31.2405V20.0021H30.5773V23.3101ZM27.9381 21.8887H29.1602V21.2859H27.9381V20.6077H29.7122V20.0042H27.2751V23.3121H29.7762V22.7088H27.9381V21.8887ZM25.3032 22.2796L24.5512 20.002H24.0029L23.2509 22.2796L22.5191 20.0036H21.804L22.9584 23.314H23.5146L24.2677 21.1395L25.0205 23.314H25.5818L26.7333 20.0036H26.0365L25.3032 22.2796ZM17.5367 21.8978C17.5367 22.4364 17.2693 22.7241 16.7837 22.7241C16.2954 22.7241 16.0266 22.4282 16.0266 21.8749V20.004H15.3546V21.8978C15.3546 22.8296 15.8722 23.3638 16.7746 23.3638C17.6858 23.3638 18.2085 22.8194 18.2085 21.8705V20.002H17.5367V21.8978ZM13.7512 20.0021H14.4229V23.3142H13.7512V21.9692H12.2335V23.3142H11.5616V20.0021H12.2335V21.3382H13.7512V20.0021ZM17.1842 11.5682C17.1842 13.8933 19.076 15.785 21.401 15.785C23.7261 15.785 25.6178 13.8933 25.6178 11.5682H25.0221C25.0221 13.5648 23.3978 15.1893 21.401 15.1893C19.4042 15.1893 17.78 13.5648 17.78 11.5682H17.1842Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "132", height: "39", rx: "6.25", stroke: "white" })
    ]
  }
), Q7 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "162",
    height: "44",
    viewBox: "0 0 162 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "160.7", height: "43", rx: "6.75", fill: "white" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M71.2267 22.4386H73.4487V34.5274H71.2267V22.4386Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M46.75 28.5669C46.75 25.1692 49.3146 22.441 52.8429 22.441C55.3098 22.441 57.2538 23.6988 58.2665 25.4957L56.3062 26.672C55.5712 25.3161 54.4279 24.5972 52.8594 24.5972C50.6378 24.5972 48.9551 26.3941 48.9551 28.5669C48.9551 30.772 50.6216 32.5365 52.9409 32.5365C54.7216 32.5365 55.9633 31.5235 56.3877 29.9554H52.5818V27.8318H58.7728V28.7141C58.7728 31.9318 56.5023 34.6931 52.9409 34.6931C49.2165 34.6931 46.75 31.8665 46.75 28.5669Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M59.7877 29.7597C59.7877 26.5905 62.1074 24.7775 64.5251 24.7775C65.783 24.7775 66.9101 25.2999 67.5963 26.1168V24.9735H69.8014V34.5297H67.5963V33.2877C66.8936 34.17 65.7503 34.7258 64.4924 34.7258C62.1889 34.7258 59.7877 32.8794 59.7877 29.7597ZM67.7105 29.727C67.7105 28.1097 66.4853 26.7865 64.8519 26.7865C63.2184 26.7865 61.9605 28.0774 61.9605 29.727C61.9605 31.3928 63.2184 32.6999 64.8519 32.6999C66.4853 32.6999 67.7105 31.3767 67.7105 29.727Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M74.5731 29.7597C74.5731 26.5905 76.8928 24.7775 79.3105 24.7775C80.5684 24.7775 81.6955 25.2999 82.3817 26.1168V24.9735H84.5868V34.5297H82.3817V33.2877C81.6793 34.17 80.536 34.7258 79.2778 34.7258C76.9747 34.7258 74.5731 32.8794 74.5731 29.7597ZM82.4962 29.727C82.4962 28.1097 81.2711 26.7865 79.6379 26.7865C78.0041 26.7865 76.7463 28.0774 76.7463 29.727C76.7463 31.3928 78.0041 32.6999 79.6379 32.6999C81.2707 32.6999 82.4962 31.3767 82.4962 29.727Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M88.8852 29.6617L85.4223 24.9735H88.1179L90.29 28.0117L92.4466 24.9735H95.06L91.6294 29.6944L95.2887 34.5297H92.5935L90.2576 31.3443L87.9868 34.5297H85.2912L88.8852 29.6617Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M99.4231 34.0558L95.5027 24.9732H97.8547L100.518 31.4093L103.033 24.9732H105.353L99.6518 38.94H97.414L99.4231 34.0558Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M109.88 32.553L111.905 30.9522C112.51 31.9813 113.441 32.5692 114.519 32.5692C115.695 32.5692 116.332 31.8021 116.332 30.9684C116.332 29.9558 115.124 29.6455 113.849 29.2534C112.249 28.7468 110.468 28.1263 110.468 25.8554C110.468 23.9444 112.134 22.4413 114.421 22.4413C116.349 22.4413 117.46 23.1767 118.423 24.1731L116.594 25.5614C116.087 24.8101 115.385 24.418 114.438 24.418C113.36 24.418 112.771 25.0062 112.771 25.7736C112.771 26.7212 113.915 27.0318 115.206 27.4566C116.823 27.979 118.652 28.6979 118.652 30.9849C118.652 32.8633 117.149 34.6935 114.536 34.6935C112.379 34.6931 110.958 33.7779 109.88 32.553Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M118.833 24.9732H120.466V23.5193L122.688 22V24.9732H124.632V26.9499H122.688V30.5271C122.688 32.1936 122.917 32.455 124.632 32.455V34.5294H124.322C121.366 34.5294 120.467 33.5821 120.467 30.5439V26.9499H118.833L118.833 24.9732Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M125.221 29.7597C125.221 26.9826 127.41 24.7771 130.171 24.7771C132.915 24.7771 135.12 26.9826 135.12 29.7597C135.12 32.5203 132.915 34.7258 130.171 34.7258C127.41 34.7258 125.221 32.5203 125.221 29.7597ZM132.948 29.7597C132.948 28.1589 131.722 26.8519 130.171 26.8519C128.586 26.8519 127.393 28.1589 127.393 29.7597C127.393 31.3443 128.586 32.651 130.171 32.651C131.722 32.651 132.948 31.3443 132.948 29.7597Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M138.438 24.9732V26.3944C138.879 25.4468 139.679 24.9732 140.888 24.9732C141.574 24.9732 142.146 25.1366 142.571 25.3815L141.737 27.4724C141.41 27.2602 141.035 27.0968 140.414 27.0968C139.14 27.0968 138.454 27.783 138.454 29.4326V34.5294H136.249V24.9732H138.438Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M142.817 29.7759C142.817 26.9826 144.989 24.7771 147.783 24.7771C150.625 24.7771 152.7 26.8681 152.7 29.6944V30.5271H144.924C145.218 31.8672 146.296 32.7817 147.865 32.7817C149.09 32.7817 150.054 32.1121 150.511 31.0991L152.324 32.1444C151.491 33.6805 149.988 34.7255 147.865 34.7255C144.859 34.7255 142.817 32.5365 142.817 29.7759ZM145.039 28.6814H150.462C150.135 27.4074 149.155 26.7212 147.783 26.7212C146.459 26.7212 145.431 27.5216 145.039 28.6814Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M51.3686 15.3715H48.2921L47.7254 16.9401H46.7539L49.3041 9.92693H50.3667L52.9069 16.9401H51.9353L51.3686 15.3715ZM51.1055 14.6226L49.8304 11.0604L48.5553 14.6226H51.1055Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M55.4756 16.09L57.196 11.3943H58.1776L56.0018 16.9401H54.9291L52.7533 11.3943H53.7451L55.4756 16.09Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M58.841 14.147C58.841 13.5802 58.9557 13.0844 59.1851 12.6593C59.4144 12.2275 59.7282 11.8936 60.1262 11.6574C60.531 11.4213 60.9797 11.3032 61.4722 11.3032C61.9579 11.3032 62.3796 11.4078 62.7372 11.617C63.0948 11.8261 63.3612 12.0892 63.5367 12.4063V11.3943H64.4677V16.9401H63.5367V15.9078C63.3545 16.2317 63.0813 16.5016 62.7169 16.7174C62.3594 16.9266 61.9411 17.0312 61.4621 17.0312C60.9696 17.0312 60.5243 16.9097 60.1262 16.6668C59.7282 16.424 59.4144 16.0833 59.1851 15.6447C58.9557 15.2062 58.841 14.7069 58.841 14.147ZM63.5367 14.1571C63.5367 13.7388 63.4523 13.3745 63.2837 13.0641C63.115 12.7538 62.8856 12.5176 62.5955 12.3557C62.3121 12.1871 61.9984 12.1027 61.6543 12.1027C61.3103 12.1027 60.9965 12.1837 60.7132 12.3456C60.4298 12.5075 60.2038 12.7437 60.0351 13.054C59.8665 13.3644 59.7821 13.7287 59.7821 14.147C59.7821 14.572 59.8665 14.9431 60.0351 15.2602C60.2038 15.5705 60.4298 15.81 60.7132 15.9787C60.9965 16.1406 61.3103 16.2216 61.6543 16.2216C61.9984 16.2216 62.3121 16.1406 62.5955 15.9787C62.8856 15.81 63.115 15.5705 63.2837 15.2602C63.4523 14.9431 63.5367 14.5754 63.5367 14.1571Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M66.2972 10.4936C66.1218 10.4936 65.9734 10.4329 65.8519 10.3115C65.7305 10.19 65.6698 10.0416 65.6698 9.86621C65.6698 9.6908 65.7305 9.54237 65.8519 9.42093C65.9734 9.29949 66.1218 9.23877 66.2972 9.23877C66.4659 9.23877 66.6076 9.29949 66.7222 9.42093C66.8437 9.54237 66.9044 9.6908 66.9044 9.86621C66.9044 10.0416 66.8437 10.19 66.7222 10.3115C66.6076 10.4329 66.4659 10.4936 66.2972 10.4936ZM66.7425 11.3943V16.9401H65.8216V11.3943H66.7425Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M69.0306 9.45129V16.9401H68.1096V9.45129H69.0306Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M70.256 14.147C70.256 13.5802 70.3707 13.0844 70.6001 12.6593C70.8295 12.2275 71.1432 11.8936 71.5413 11.6574C71.9461 11.4213 72.3947 11.3032 72.8872 11.3032C73.373 11.3032 73.7946 11.4078 74.1522 11.617C74.5098 11.8261 74.7763 12.0892 74.9517 12.4063V11.3943H75.8827V16.9401H74.9517V15.9078C74.7695 16.2317 74.4963 16.5016 74.132 16.7174C73.7744 16.9266 73.3561 17.0312 72.8771 17.0312C72.3846 17.0312 71.9393 16.9097 71.5413 16.6668C71.1432 16.424 70.8295 16.0833 70.6001 15.6447C70.3707 15.2062 70.256 14.7069 70.256 14.147ZM74.9517 14.1571C74.9517 13.7388 74.8674 13.3745 74.6987 13.0641C74.53 12.7538 74.3006 12.5176 74.0105 12.3557C73.7272 12.1871 73.4135 12.1027 73.0694 12.1027C72.7253 12.1027 72.4116 12.1837 72.1282 12.3456C71.8449 12.5075 71.6188 12.7437 71.4502 13.054C71.2815 13.3644 71.1972 13.7287 71.1972 14.147C71.1972 14.572 71.2815 14.9431 71.4502 15.2602C71.6188 15.5705 71.8449 15.81 72.1282 15.9787C72.4116 16.1406 72.7253 16.2216 73.0694 16.2216C73.4135 16.2216 73.7272 16.1406 74.0105 15.9787C74.3006 15.81 74.53 15.5705 74.6987 15.2602C74.8674 14.9431 74.9517 14.5754 74.9517 14.1571Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M78.4611 12.4266C78.65 12.096 78.9266 11.8261 79.291 11.617C79.6553 11.4078 80.0702 11.3032 80.5357 11.3032C81.035 11.3032 81.4836 11.4213 81.8817 11.6574C82.2797 11.8936 82.5935 12.2275 82.8228 12.6593C83.0522 13.0844 83.1669 13.5802 83.1669 14.147C83.1669 14.7069 83.0522 15.2062 82.8228 15.6447C82.5935 16.0833 82.2764 16.424 81.8716 16.6668C81.4735 16.9097 81.0282 17.0312 80.5357 17.0312C80.0567 17.0312 79.635 16.9266 79.2707 16.7174C78.9132 16.5083 78.6433 16.2418 78.4611 15.918V16.9401H77.5402V9.45129H78.4611V12.4266ZM82.2258 14.147C82.2258 13.7287 82.1414 13.3644 81.9728 13.054C81.8041 12.7437 81.5747 12.5075 81.2846 12.3456C81.0012 12.1837 80.6875 12.1027 80.3434 12.1027C80.0061 12.1027 79.6924 12.1871 79.4023 12.3557C79.1189 12.5176 78.8895 12.7572 78.7141 13.0742C78.5455 13.3846 78.4611 13.7455 78.4611 14.1571C78.4611 14.5754 78.5455 14.9431 78.7141 15.2602C78.8895 15.5705 79.1189 15.81 79.4023 15.9787C79.6924 16.1406 80.0061 16.2216 80.3434 16.2216C80.6875 16.2216 81.0012 16.1406 81.2846 15.9787C81.5747 15.81 81.8041 15.5705 81.9728 15.2602C82.1414 14.9431 82.2258 14.572 82.2258 14.147Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t("path", { d: "M85.3 9.45129V16.9401H84.3791V9.45129H85.3Z", fill: "black" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M92.0308 13.9547C92.0308 14.1301 92.0207 14.3156 92.0004 14.5113H87.5679C87.6016 15.0578 87.7871 15.4862 88.1245 15.7965C88.4685 16.1001 88.8835 16.2519 89.3692 16.2519C89.7673 16.2519 90.0979 16.1609 90.361 15.9787C90.6308 15.7898 90.8197 15.5402 90.9277 15.2298H91.9195C91.771 15.7628 91.4742 16.198 91.0289 16.5353C90.5836 16.8659 90.0304 17.0312 89.3692 17.0312C88.843 17.0312 88.3707 16.9131 87.9524 16.677C87.5409 16.4408 87.217 16.1069 86.9809 15.6751C86.7448 15.2366 86.6267 14.7306 86.6267 14.1571C86.6267 13.5836 86.7414 13.081 86.9708 12.6492C87.2002 12.2174 87.5206 11.8868 87.9322 11.6574C88.3505 11.4213 88.8295 11.3032 89.3692 11.3032C89.8955 11.3032 90.361 11.4179 90.7658 11.6473C91.1706 11.8767 91.4809 12.1938 91.6968 12.5986C91.9195 12.9967 92.0308 13.4487 92.0308 13.9547ZM91.0795 13.7624C91.0795 13.4116 91.0019 13.1114 90.8467 12.8617C90.6916 12.6054 90.479 12.4131 90.2092 12.2849C89.9461 12.15 89.6526 12.0825 89.3287 12.0825C88.8632 12.0825 88.4652 12.2309 88.1346 12.5278C87.8107 12.8246 87.6252 13.2362 87.578 13.7624H91.0795Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M98.5654 17.0312C98.046 17.0312 97.5737 16.9131 97.1487 16.677C96.7304 16.4408 96.3998 16.1069 96.1569 15.6751C95.9208 15.2366 95.8027 14.7306 95.8027 14.1571C95.8027 13.5904 95.9241 13.0911 96.167 12.6593C96.4166 12.2208 96.754 11.8868 97.179 11.6574C97.604 11.4213 98.0797 11.3032 98.6059 11.3032C99.1322 11.3032 99.6078 11.4213 100.033 11.6574C100.458 11.8868 100.792 12.2174 101.035 12.6492C101.284 13.081 101.409 13.5836 101.409 14.1571C101.409 14.7306 101.281 15.2366 101.025 15.6751C100.775 16.1069 100.434 16.4408 100.002 16.677C99.5707 16.9131 99.0917 17.0312 98.5654 17.0312ZM98.5654 16.2216C98.896 16.2216 99.2064 16.144 99.4965 15.9888C99.7866 15.8336 100.019 15.6009 100.195 15.2905C100.377 14.9802 100.468 14.6024 100.468 14.1571C100.468 13.7118 100.38 13.334 100.205 13.0236C100.029 12.7133 99.8001 12.4839 99.5167 12.3355C99.2334 12.1803 98.9264 12.1027 98.5958 12.1027C98.2585 12.1027 97.9481 12.1803 97.6648 12.3355C97.3882 12.4839 97.1655 12.7133 96.9968 13.0236C96.8282 13.334 96.7439 13.7118 96.7439 14.1571C96.7439 14.6091 96.8248 14.9903 96.9867 15.3007C97.1554 15.611 97.378 15.8438 97.6546 15.9989C97.9313 16.1474 98.2349 16.2216 98.5654 16.2216Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M105.524 11.2931C106.199 11.2931 106.746 11.4989 107.164 11.9104C107.582 12.3152 107.791 12.9022 107.791 13.6713V16.9401H106.881V13.8029C106.881 13.2497 106.742 12.828 106.466 12.5379C106.189 12.241 105.811 12.0926 105.332 12.0926C104.846 12.0926 104.458 12.2444 104.168 12.548C103.885 12.8516 103.743 13.2935 103.743 13.8737V16.9401H102.822V11.3943H103.743V12.1837C103.925 11.9003 104.172 11.6811 104.482 11.5259C104.799 11.3707 105.147 11.2931 105.524 11.2931Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.2024 16.1321C9.89844 17.398 9.89844 18.932 9.89844 22C9.89844 25.0679 9.89844 26.6019 10.2024 27.8678C11.168 31.89 14.3084 35.0304 18.3305 35.996C19.5965 36.2999 21.1305 36.2999 24.1984 36.2999C27.2664 36.2999 28.8004 36.2999 30.0663 35.996C34.0885 35.0304 37.2289 31.89 38.1945 27.8678C38.4984 26.6019 38.4984 25.0679 38.4984 22C38.4984 18.932 38.4984 17.398 38.1945 16.1321C37.2289 12.1099 34.0885 8.96951 30.0663 8.00388C28.8004 7.69995 27.2664 7.69995 24.1984 7.69995C21.1305 7.69995 19.5965 7.69995 18.3305 8.00388C14.3084 8.96951 11.168 12.1099 10.2024 16.1321ZM28.3102 17.9675L28.369 18.2264H31.7454L30.8352 26.711C30.6529 28.4366 29.1975 29.7463 27.462 29.7463H20.9343C19.1988 29.7463 17.7434 28.4366 17.5611 26.7109L16.651 18.2264H20.0274L20.0863 17.9675C20.0863 15.7006 21.9308 13.8564 24.1981 13.8564C26.4654 13.8564 28.3102 15.7006 28.3102 17.9675ZM21.8812 17.9675L21.8149 18.2264H26.5815L26.5153 17.9675C26.5153 16.6901 25.4759 15.6509 24.1981 15.6509C22.9206 15.6509 21.8812 16.6901 21.8812 17.9675Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "rect",
        {
          x: "0.5",
          y: "0.5",
          width: "160.7",
          height: "43",
          rx: "6.75",
          stroke: "black"
        }
      )
    ]
  }
), C4 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "147",
    height: "40",
    viewBox: "0 0 147 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "146", height: "39", rx: "6.75", fill: "white" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M64.7516 20.3987H66.7715V31.3885H64.7516V20.3987Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M42.5 25.9699C42.5 22.8811 44.8314 20.4009 48.039 20.4009C50.2816 20.4009 52.0489 21.5444 52.9695 23.1779L51.1875 24.2473C50.5193 23.0146 49.4799 22.3611 48.054 22.3611C46.0343 22.3611 44.5047 23.9946 44.5047 25.9699C44.5047 27.9745 46.0196 29.5786 48.1281 29.5786C49.7469 29.5786 50.8757 28.6578 51.2616 27.2322H47.8017V25.3017H53.4298V26.1037C53.4298 29.0289 51.3657 31.5392 48.1281 31.5392C44.7423 31.5392 42.5 28.9695 42.5 25.9699Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M54.3525 27.0543C54.3525 24.1732 56.4613 22.525 58.6592 22.525C59.8027 22.525 60.8274 22.9999 61.4512 23.7426V22.7032H63.4558V31.3907H61.4512V30.2616C60.8124 31.0636 59.773 31.5689 58.6295 31.5689C56.5354 31.5689 54.3525 29.8904 54.3525 27.0543ZM61.555 27.0246C61.555 25.5543 60.4412 24.3514 58.9562 24.3514C57.4713 24.3514 56.3278 25.5249 56.3278 27.0246C56.3278 28.539 57.4713 29.7272 58.9562 29.7272C60.4412 29.7272 61.555 28.5243 61.555 27.0246Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M67.7938 27.0543C67.7938 24.1732 69.9026 22.525 72.1005 22.525C73.244 22.525 74.2686 22.9999 74.8925 23.7426V22.7032H76.8971V31.3907H74.8925V30.2616C74.2539 31.0636 73.2146 31.5689 72.0707 31.5689C69.977 31.5689 67.7938 29.8904 67.7938 27.0543ZM74.9966 27.0246C74.9966 25.5543 73.8828 24.3514 72.3981 24.3514C70.9128 24.3514 69.7693 25.5249 69.7693 27.0246C69.7693 28.539 70.9128 29.7272 72.3981 29.7272C73.8825 29.7272 74.9966 28.5243 74.9966 27.0246Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M80.8048 26.9652L77.6566 22.7032H80.1072L82.0818 25.4652L84.0424 22.7032H86.4182L83.2994 26.9949L86.6261 31.3907H84.1759L82.0524 28.4949L79.988 31.3907H77.5375L80.8048 26.9652Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M90.3846 30.9598L86.8206 22.7029H88.9588L91.3796 28.554L93.6663 22.7029H95.7757L90.5926 35.4H88.5582L90.3846 30.9598Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M99.8907 29.5936L101.732 28.1384C102.282 29.074 103.128 29.6083 104.108 29.6083C105.178 29.6083 105.757 28.911 105.757 28.1531C105.757 27.2325 104.658 26.9505 103.499 26.594C102.044 26.1334 100.426 25.5693 100.426 23.5049C100.426 21.7676 101.94 20.4012 104.019 20.4012C105.772 20.4012 106.781 21.0697 107.658 21.9756L105.994 23.2376C105.534 22.5547 104.895 22.1982 104.034 22.1982C103.054 22.1982 102.519 22.7329 102.519 23.4305C102.519 24.292 103.559 24.5743 104.732 24.9605C106.203 25.4355 107.866 26.089 107.866 28.1681C107.866 29.8757 106.499 31.5395 104.123 31.5395C102.163 31.5392 100.871 30.7071 99.8907 29.5936Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M108.03 22.7029H109.515V21.3812L111.535 20V22.7029H113.302V24.4999H111.535V27.7519C111.535 29.2669 111.743 29.5045 113.302 29.5045V31.3904H113.02C110.332 31.3904 109.515 30.5292 109.515 27.7672V24.4999H108.03L108.03 22.7029Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M113.838 27.0543C113.838 24.5296 115.827 22.5247 118.337 22.5247C120.832 22.5247 122.837 24.5296 122.837 27.0543C122.837 29.5639 120.832 31.5689 118.337 31.5689C115.827 31.5689 113.838 29.5639 113.838 27.0543ZM120.862 27.0543C120.862 25.599 119.747 24.4108 118.337 24.4108C116.896 24.4108 115.812 25.599 115.812 27.0543C115.812 28.4949 116.896 29.6828 118.337 29.6828C119.747 29.6828 120.862 28.4949 120.862 27.0543Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M125.853 22.7029V23.9949C126.254 23.1335 126.981 22.7029 128.08 22.7029C128.704 22.7029 129.223 22.8514 129.61 23.0741L128.852 24.9749C128.555 24.782 128.214 24.6334 127.649 24.6334C126.491 24.6334 125.867 25.2573 125.867 26.7569V31.3904H123.862V22.7029H125.853Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M129.834 27.069C129.834 24.5296 131.808 22.5247 134.348 22.5247C136.932 22.5247 138.818 24.4255 138.818 26.9949V27.7519H131.749C132.017 28.9701 132.997 29.8016 134.423 29.8016C135.536 29.8016 136.413 29.1928 136.828 28.2719L138.477 29.2222C137.719 30.6186 136.353 31.5686 134.423 31.5686C131.69 31.5686 129.834 29.5786 129.834 27.069ZM131.853 26.074H136.784C136.487 24.9158 135.596 24.292 134.348 24.292C133.145 24.292 132.21 25.0196 131.853 26.074Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M46.6991 13.9741H43.9023L43.3871 15.4001H42.5039L44.8223 9.02453H45.7883L48.0975 15.4001H47.2143L46.6991 13.9741ZM46.4599 13.2933L45.3007 10.0549L44.1415 13.2933H46.4599Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M50.4327 14.6273L51.9967 10.3585H52.8891L50.9111 15.4001H49.9359L47.9579 10.3585H48.8595L50.4327 14.6273Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M53.4922 12.8609C53.4922 12.3457 53.5964 11.8949 53.805 11.5085C54.0135 11.116 54.2987 10.8124 54.6606 10.5977C55.0286 10.3831 55.4364 10.2757 55.8842 10.2757C56.3258 10.2757 56.7091 10.3708 57.0342 10.5609C57.3592 10.7511 57.6015 10.9903 57.761 11.2785V10.3585H58.6074V15.4001H57.761V14.4617C57.5954 14.7561 57.347 15.0015 57.0158 15.1977C56.6907 15.3879 56.3104 15.4829 55.875 15.4829C55.4272 15.4829 55.0224 15.3725 54.6606 15.1517C54.2987 14.9309 54.0135 14.6212 53.805 14.2225C53.5964 13.8239 53.4922 13.37 53.4922 12.8609ZM57.761 12.8701C57.761 12.4899 57.6843 12.1587 57.531 11.8765C57.3776 11.5944 57.1691 11.3797 56.9054 11.2325C56.6478 11.0792 56.3626 11.0025 56.0498 11.0025C55.737 11.0025 55.4518 11.0761 55.1942 11.2233C54.9366 11.3705 54.7311 11.5852 54.5778 11.8673C54.4244 12.1495 54.3478 12.4807 54.3478 12.8609C54.3478 13.2473 54.4244 13.5847 54.5778 13.8729C54.7311 14.1551 54.9366 14.3728 55.1942 14.5261C55.4518 14.6733 55.737 14.7469 56.0498 14.7469C56.3626 14.7469 56.6478 14.6733 56.9054 14.5261C57.1691 14.3728 57.3776 14.1551 57.531 13.8729C57.6843 13.5847 57.761 13.2504 57.761 12.8701Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M60.2705 9.53973C60.1111 9.53973 59.9761 9.48453 59.8657 9.37413C59.7553 9.26373 59.7001 9.12879 59.7001 8.96933C59.7001 8.80986 59.7553 8.67493 59.8657 8.56453C59.9761 8.45413 60.1111 8.39893 60.2705 8.39893C60.4239 8.39893 60.5527 8.45413 60.6569 8.56453C60.7673 8.67493 60.8225 8.80986 60.8225 8.96933C60.8225 9.12879 60.7673 9.26373 60.6569 9.37413C60.5527 9.48453 60.4239 9.53973 60.2705 9.53973ZM60.6753 10.3585V15.4001H59.8381V10.3585H60.6753Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M62.7554 8.59213V15.4001H61.9182V8.59213H62.7554Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M63.8695 12.8609C63.8695 12.3457 63.9737 11.8949 64.1823 11.5085C64.3908 11.116 64.676 10.8124 65.0379 10.5977C65.4059 10.3831 65.8137 10.2757 66.2615 10.2757C66.7031 10.2757 67.0864 10.3708 67.4115 10.5609C67.7365 10.7511 67.9788 10.9903 68.1383 11.2785V10.3585H68.9847V15.4001H68.1383V14.4617C67.9727 14.7561 67.7243 15.0015 67.3931 15.1977C67.068 15.3879 66.6877 15.4829 66.2523 15.4829C65.8045 15.4829 65.3997 15.3725 65.0379 15.1517C64.676 14.9309 64.3908 14.6212 64.1823 14.2225C63.9737 13.8239 63.8695 13.37 63.8695 12.8609ZM68.1383 12.8701C68.1383 12.4899 68.0616 12.1587 67.9083 11.8765C67.7549 11.5944 67.5464 11.3797 67.2827 11.2325C67.0251 11.0792 66.7399 11.0025 66.4271 11.0025C66.1143 11.0025 65.8291 11.0761 65.5715 11.2233C65.3139 11.3705 65.1084 11.5852 64.9551 11.8673C64.8017 12.1495 64.7251 12.4807 64.7251 12.8609C64.7251 13.2473 64.8017 13.5847 64.9551 13.8729C65.1084 14.1551 65.3139 14.3728 65.5715 14.5261C65.8291 14.6733 66.1143 14.7469 66.4271 14.7469C66.7399 14.7469 67.0251 14.6733 67.2827 14.5261C67.5464 14.3728 67.7549 14.1551 67.9083 13.8729C68.0616 13.5847 68.1383 13.2504 68.1383 12.8701Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M71.3287 11.2969C71.5004 10.9964 71.7519 10.7511 72.0831 10.5609C72.4143 10.3708 72.7915 10.2757 73.2147 10.2757C73.6685 10.2757 74.0764 10.3831 74.4383 10.5977C74.8001 10.8124 75.0853 11.116 75.2939 11.5085C75.5024 11.8949 75.6067 12.3457 75.6067 12.8609C75.6067 13.37 75.5024 13.8239 75.2939 14.2225C75.0853 14.6212 74.7971 14.9309 74.4291 15.1517C74.0672 15.3725 73.6624 15.4829 73.2147 15.4829C72.7792 15.4829 72.3959 15.3879 72.0647 15.1977C71.7396 15.0076 71.4943 14.7653 71.3287 14.4709V15.4001H70.4915V8.59213H71.3287V11.2969ZM74.7511 12.8609C74.7511 12.4807 74.6744 12.1495 74.5211 11.8673C74.3677 11.5852 74.1592 11.3705 73.8955 11.2233C73.6379 11.0761 73.3527 11.0025 73.0399 11.0025C72.7332 11.0025 72.448 11.0792 72.1843 11.2325C71.9267 11.3797 71.7181 11.5975 71.5587 11.8857C71.4053 12.1679 71.3287 12.496 71.3287 12.8701C71.3287 13.2504 71.4053 13.5847 71.5587 13.8729C71.7181 14.1551 71.9267 14.3728 72.1843 14.5261C72.448 14.6733 72.7332 14.7469 73.0399 14.7469C73.3527 14.7469 73.6379 14.6733 73.8955 14.5261C74.1592 14.3728 74.3677 14.1551 74.5211 13.8729C74.6744 13.5847 74.7511 13.2473 74.7511 12.8609Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M77.5458 8.59213V15.4001H76.7086V8.59213H77.5458Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M83.6647 12.6861C83.6647 12.8456 83.6555 13.0143 83.6371 13.1921H79.6075C79.6382 13.6889 79.8068 14.0784 80.1135 14.3605C80.4263 14.6365 80.8035 14.7745 81.2451 14.7745C81.607 14.7745 81.9075 14.6917 82.1467 14.5261C82.392 14.3544 82.5638 14.1275 82.6619 13.8453H83.5635C83.4286 14.3299 83.1587 14.7255 82.7539 15.0321C82.3491 15.3327 81.8462 15.4829 81.2451 15.4829C80.7667 15.4829 80.3374 15.3756 79.9571 15.1609C79.583 14.9463 79.2886 14.6427 79.0739 14.2501C78.8592 13.8515 78.7519 13.3915 78.7519 12.8701C78.7519 12.3488 78.8562 11.8919 79.0647 11.4993C79.2732 11.1068 79.5646 10.8063 79.9387 10.5977C80.319 10.3831 80.7544 10.2757 81.2451 10.2757C81.7235 10.2757 82.1467 10.38 82.5147 10.5885C82.8827 10.7971 83.1648 11.0853 83.3611 11.4533C83.5635 11.8152 83.6647 12.2261 83.6647 12.6861ZM82.7999 12.5113C82.7999 12.1924 82.7294 11.9195 82.5883 11.6925C82.4472 11.4595 82.254 11.2847 82.0087 11.1681C81.7695 11.0455 81.5027 10.9841 81.2083 10.9841C80.7851 10.9841 80.4232 11.1191 80.1227 11.3889C79.8283 11.6588 79.6596 12.0329 79.6167 12.5113H82.7999Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M89.6053 15.4829C89.133 15.4829 88.7037 15.3756 88.3173 15.1609C87.937 14.9463 87.6365 14.6427 87.4157 14.2501C87.201 13.8515 87.0937 13.3915 87.0937 12.8701C87.0937 12.3549 87.2041 11.9011 87.4249 11.5085C87.6518 11.1099 87.9585 10.8063 88.3449 10.5977C88.7313 10.3831 89.1637 10.2757 89.6421 10.2757C90.1205 10.2757 90.5529 10.3831 90.9393 10.5977C91.3257 10.8063 91.6293 11.1068 91.8501 11.4993C92.077 11.8919 92.1905 12.3488 92.1905 12.8701C92.1905 13.3915 92.074 13.8515 91.8409 14.2501C91.614 14.6427 91.3042 14.9463 90.9117 15.1609C90.5192 15.3756 90.0837 15.4829 89.6053 15.4829ZM89.6053 14.7469C89.9058 14.7469 90.188 14.6764 90.4517 14.5353C90.7155 14.3943 90.9271 14.1827 91.0865 13.9005C91.2521 13.6184 91.3349 13.2749 91.3349 12.8701C91.3349 12.4653 91.2552 12.1219 91.0957 11.8397C90.9363 11.5576 90.7277 11.3491 90.4701 11.2141C90.2125 11.0731 89.9334 11.0025 89.6329 11.0025C89.3262 11.0025 89.0441 11.0731 88.7865 11.2141C88.5351 11.3491 88.3326 11.5576 88.1793 11.8397C88.026 12.1219 87.9493 12.4653 87.9493 12.8701C87.9493 13.2811 88.0229 13.6276 88.1701 13.9097C88.3234 14.1919 88.5259 14.4035 88.7773 14.5445C89.0288 14.6795 89.3048 14.7469 89.6053 14.7469Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M95.9317 10.2665C96.545 10.2665 97.0418 10.4536 97.4221 10.8277C97.8024 11.1957 97.9925 11.7293 97.9925 12.4285V15.4001H97.1645V12.5481C97.1645 12.0452 97.0387 11.6619 96.7873 11.3981C96.5358 11.1283 96.1924 10.9933 95.7569 10.9933C95.3153 10.9933 94.9626 11.1313 94.6989 11.4073C94.4413 11.6833 94.3125 12.0851 94.3125 12.6125V15.4001H93.4753V10.3585H94.3125V11.0761C94.4781 10.8185 94.702 10.6192 94.9841 10.4781C95.2724 10.3371 95.5882 10.2665 95.9317 10.2665Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.2763 14.6655C9 15.8164 9 17.2109 9 20C9 22.7891 9 24.1836 9.2763 25.3345C10.1541 28.9909 13.0091 31.8459 16.6655 32.7237C17.8164 33 19.2109 33 22 33C24.7891 33 26.1836 33 27.3345 32.7237C30.9909 31.8459 33.8459 28.9909 34.7237 25.3345C35 24.1836 35 22.7891 35 20C35 17.2109 35 15.8164 34.7237 14.6655C33.8459 11.0091 30.9909 8.15415 27.3345 7.2763C26.1836 7 24.7891 7 22 7C19.2109 7 17.8164 7 16.6655 7.2763C13.0091 8.15415 10.1541 11.0091 9.2763 14.6655ZM25.738 16.3341L25.7914 16.5695H28.8609L28.0334 24.2828C27.8677 25.8515 26.5446 27.0421 24.9669 27.0421H19.0326C17.4549 27.0421 16.1318 25.8515 15.966 24.2826L15.1387 16.5695H18.2081L18.2617 16.3341C18.2617 14.2733 19.9385 12.5968 21.9997 12.5968C24.0609 12.5968 25.738 14.2733 25.738 16.3341ZM19.8934 16.3341L19.8331 16.5695H24.1664L24.1063 16.3341C24.1063 15.1729 23.1613 14.2281 21.9997 14.2281C20.8383 14.2281 19.8934 15.1729 19.8934 16.3341Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "146", height: "39", rx: "6.75", stroke: "black" })
    ]
  }
), t4 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "162",
    height: "44",
    viewBox: "0 0 162 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "160.7", height: "43", rx: "6.75", fill: "black" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M71.2267 22.4386H73.4487V34.5274H71.2267V22.4386Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M46.75 28.5669C46.75 25.1692 49.3146 22.441 52.8429 22.441C55.3098 22.441 57.2538 23.6988 58.2665 25.4957L56.3062 26.672C55.5712 25.3161 54.4279 24.5972 52.8594 24.5972C50.6378 24.5972 48.9551 26.3941 48.9551 28.5669C48.9551 30.772 50.6216 32.5365 52.9409 32.5365C54.7216 32.5365 55.9633 31.5235 56.3877 29.9554H52.5818V27.8318H58.7728V28.7141C58.7728 31.9318 56.5023 34.6931 52.9409 34.6931C49.2165 34.6931 46.75 31.8665 46.75 28.5669Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M59.7877 29.7597C59.7877 26.5905 62.1074 24.7775 64.5251 24.7775C65.783 24.7775 66.9101 25.2999 67.5963 26.1168V24.9735H69.8014V34.5297H67.5963V33.2877C66.8936 34.17 65.7503 34.7258 64.4924 34.7258C62.1889 34.7258 59.7877 32.8794 59.7877 29.7597ZM67.7105 29.727C67.7105 28.1097 66.4853 26.7865 64.8519 26.7865C63.2184 26.7865 61.9605 28.0774 61.9605 29.727C61.9605 31.3928 63.2184 32.6999 64.8519 32.6999C66.4853 32.6999 67.7105 31.3767 67.7105 29.727Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M74.5731 29.7597C74.5731 26.5905 76.8928 24.7775 79.3105 24.7775C80.5684 24.7775 81.6955 25.2999 82.3817 26.1168V24.9735H84.5868V34.5297H82.3817V33.2877C81.6793 34.17 80.536 34.7258 79.2778 34.7258C76.9747 34.7258 74.5731 32.8794 74.5731 29.7597ZM82.4962 29.727C82.4962 28.1097 81.2711 26.7865 79.6379 26.7865C78.0041 26.7865 76.7463 28.0774 76.7463 29.727C76.7463 31.3928 78.0041 32.6999 79.6379 32.6999C81.2707 32.6999 82.4962 31.3767 82.4962 29.727Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M88.8852 29.6617L85.4223 24.9735H88.1179L90.29 28.0117L92.4466 24.9735H95.06L91.6294 29.6944L95.2887 34.5297H92.5935L90.2576 31.3443L87.9868 34.5297H85.2912L88.8852 29.6617Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M99.4231 34.0558L95.5027 24.9732H97.8547L100.518 31.4093L103.033 24.9732H105.353L99.6518 38.94H97.414L99.4231 34.0558Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M109.88 32.553L111.905 30.9522C112.51 31.9813 113.441 32.5692 114.519 32.5692C115.695 32.5692 116.332 31.8021 116.332 30.9684C116.332 29.9558 115.124 29.6455 113.849 29.2534C112.249 28.7468 110.468 28.1263 110.468 25.8554C110.468 23.9444 112.134 22.4413 114.421 22.4413C116.349 22.4413 117.46 23.1767 118.423 24.1731L116.594 25.5614C116.087 24.8101 115.385 24.418 114.438 24.418C113.36 24.418 112.771 25.0062 112.771 25.7736C112.771 26.7212 113.915 27.0318 115.206 27.4566C116.823 27.979 118.652 28.6979 118.652 30.9849C118.652 32.8633 117.149 34.6935 114.536 34.6935C112.379 34.6931 110.958 33.7779 109.88 32.553Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M118.833 24.9732H120.466V23.5193L122.688 22V24.9732H124.632V26.9499H122.688V30.5271C122.688 32.1936 122.917 32.455 124.632 32.455V34.5294H124.322C121.366 34.5294 120.467 33.5821 120.467 30.5439V26.9499H118.833L118.833 24.9732Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M125.221 29.7597C125.221 26.9826 127.41 24.7771 130.171 24.7771C132.915 24.7771 135.12 26.9826 135.12 29.7597C135.12 32.5203 132.915 34.7258 130.171 34.7258C127.41 34.7258 125.221 32.5203 125.221 29.7597ZM132.948 29.7597C132.948 28.1589 131.722 26.8519 130.171 26.8519C128.586 26.8519 127.393 28.1589 127.393 29.7597C127.393 31.3443 128.586 32.651 130.171 32.651C131.722 32.651 132.948 31.3443 132.948 29.7597Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M138.438 24.9732V26.3944C138.879 25.4468 139.679 24.9732 140.888 24.9732C141.574 24.9732 142.146 25.1366 142.571 25.3815L141.737 27.4724C141.41 27.2602 141.035 27.0968 140.414 27.0968C139.14 27.0968 138.454 27.783 138.454 29.4326V34.5294H136.249V24.9732H138.438Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M142.817 29.7759C142.817 26.9826 144.989 24.7771 147.783 24.7771C150.625 24.7771 152.7 26.8681 152.7 29.6944V30.5271H144.924C145.218 31.8672 146.296 32.7817 147.865 32.7817C149.09 32.7817 150.054 32.1121 150.511 31.0991L152.324 32.1444C151.491 33.6805 149.988 34.7255 147.865 34.7255C144.859 34.7255 142.817 32.5365 142.817 29.7759ZM145.039 28.6814H150.462C150.135 27.4074 149.155 26.7212 147.783 26.7212C146.459 26.7212 145.431 27.5216 145.039 28.6814Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M51.3686 15.3715H48.2921L47.7254 16.9401H46.7539L49.3041 9.92693H50.3667L52.9069 16.9401H51.9353L51.3686 15.3715ZM51.1055 14.6226L49.8304 11.0604L48.5553 14.6226H51.1055Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M55.4756 16.09L57.196 11.3943H58.1776L56.0018 16.9401H54.9291L52.7533 11.3943H53.7451L55.4756 16.09Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M58.841 14.147C58.841 13.5802 58.9557 13.0844 59.1851 12.6593C59.4144 12.2275 59.7282 11.8936 60.1262 11.6574C60.531 11.4213 60.9797 11.3032 61.4722 11.3032C61.9579 11.3032 62.3796 11.4078 62.7372 11.617C63.0948 11.8261 63.3612 12.0892 63.5367 12.4063V11.3943H64.4677V16.9401H63.5367V15.9078C63.3545 16.2317 63.0813 16.5016 62.7169 16.7174C62.3594 16.9266 61.9411 17.0312 61.4621 17.0312C60.9696 17.0312 60.5243 16.9097 60.1262 16.6668C59.7282 16.424 59.4144 16.0833 59.1851 15.6447C58.9557 15.2062 58.841 14.7069 58.841 14.147ZM63.5367 14.1571C63.5367 13.7388 63.4523 13.3745 63.2837 13.0641C63.115 12.7538 62.8856 12.5176 62.5955 12.3557C62.3121 12.1871 61.9984 12.1027 61.6543 12.1027C61.3103 12.1027 60.9965 12.1837 60.7132 12.3456C60.4298 12.5075 60.2038 12.7437 60.0351 13.054C59.8665 13.3644 59.7821 13.7287 59.7821 14.147C59.7821 14.572 59.8665 14.9431 60.0351 15.2602C60.2038 15.5705 60.4298 15.81 60.7132 15.9787C60.9965 16.1406 61.3103 16.2216 61.6543 16.2216C61.9984 16.2216 62.3121 16.1406 62.5955 15.9787C62.8856 15.81 63.115 15.5705 63.2837 15.2602C63.4523 14.9431 63.5367 14.5754 63.5367 14.1571Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M66.2972 10.4936C66.1218 10.4936 65.9734 10.4329 65.8519 10.3115C65.7305 10.19 65.6698 10.0416 65.6698 9.86621C65.6698 9.6908 65.7305 9.54237 65.8519 9.42093C65.9734 9.29949 66.1218 9.23877 66.2972 9.23877C66.4659 9.23877 66.6076 9.29949 66.7222 9.42093C66.8437 9.54237 66.9044 9.6908 66.9044 9.86621C66.9044 10.0416 66.8437 10.19 66.7222 10.3115C66.6076 10.4329 66.4659 10.4936 66.2972 10.4936ZM66.7425 11.3943V16.9401H65.8216V11.3943H66.7425Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M69.0306 9.45129V16.9401H68.1096V9.45129H69.0306Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M70.256 14.147C70.256 13.5802 70.3707 13.0844 70.6001 12.6593C70.8295 12.2275 71.1432 11.8936 71.5413 11.6574C71.9461 11.4213 72.3947 11.3032 72.8872 11.3032C73.373 11.3032 73.7946 11.4078 74.1522 11.617C74.5098 11.8261 74.7763 12.0892 74.9517 12.4063V11.3943H75.8827V16.9401H74.9517V15.9078C74.7695 16.2317 74.4963 16.5016 74.132 16.7174C73.7744 16.9266 73.3561 17.0312 72.8771 17.0312C72.3846 17.0312 71.9393 16.9097 71.5413 16.6668C71.1432 16.424 70.8295 16.0833 70.6001 15.6447C70.3707 15.2062 70.256 14.7069 70.256 14.147ZM74.9517 14.1571C74.9517 13.7388 74.8674 13.3745 74.6987 13.0641C74.53 12.7538 74.3006 12.5176 74.0105 12.3557C73.7272 12.1871 73.4135 12.1027 73.0694 12.1027C72.7253 12.1027 72.4116 12.1837 72.1282 12.3456C71.8449 12.5075 71.6188 12.7437 71.4502 13.054C71.2815 13.3644 71.1972 13.7287 71.1972 14.147C71.1972 14.572 71.2815 14.9431 71.4502 15.2602C71.6188 15.5705 71.8449 15.81 72.1282 15.9787C72.4116 16.1406 72.7253 16.2216 73.0694 16.2216C73.4135 16.2216 73.7272 16.1406 74.0105 15.9787C74.3006 15.81 74.53 15.5705 74.6987 15.2602C74.8674 14.9431 74.9517 14.5754 74.9517 14.1571Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M78.4611 12.4266C78.65 12.096 78.9266 11.8261 79.291 11.617C79.6553 11.4078 80.0702 11.3032 80.5357 11.3032C81.035 11.3032 81.4836 11.4213 81.8817 11.6574C82.2797 11.8936 82.5935 12.2275 82.8228 12.6593C83.0522 13.0844 83.1669 13.5802 83.1669 14.147C83.1669 14.7069 83.0522 15.2062 82.8228 15.6447C82.5935 16.0833 82.2764 16.424 81.8716 16.6668C81.4735 16.9097 81.0282 17.0312 80.5357 17.0312C80.0567 17.0312 79.635 16.9266 79.2707 16.7174C78.9132 16.5083 78.6433 16.2418 78.4611 15.918V16.9401H77.5402V9.45129H78.4611V12.4266ZM82.2258 14.147C82.2258 13.7287 82.1414 13.3644 81.9728 13.054C81.8041 12.7437 81.5747 12.5075 81.2846 12.3456C81.0012 12.1837 80.6875 12.1027 80.3434 12.1027C80.0061 12.1027 79.6924 12.1871 79.4023 12.3557C79.1189 12.5176 78.8895 12.7572 78.7141 13.0742C78.5455 13.3846 78.4611 13.7455 78.4611 14.1571C78.4611 14.5754 78.5455 14.9431 78.7141 15.2602C78.8895 15.5705 79.1189 15.81 79.4023 15.9787C79.6924 16.1406 80.0061 16.2216 80.3434 16.2216C80.6875 16.2216 81.0012 16.1406 81.2846 15.9787C81.5747 15.81 81.8041 15.5705 81.9728 15.2602C82.1414 14.9431 82.2258 14.572 82.2258 14.147Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t("path", { d: "M85.3 9.45129V16.9401H84.3791V9.45129H85.3Z", fill: "white" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M92.0308 13.9547C92.0308 14.1301 92.0207 14.3156 92.0004 14.5113H87.5679C87.6016 15.0578 87.7871 15.4862 88.1245 15.7965C88.4685 16.1001 88.8835 16.2519 89.3692 16.2519C89.7673 16.2519 90.0979 16.1609 90.361 15.9787C90.6308 15.7898 90.8197 15.5402 90.9277 15.2298H91.9195C91.771 15.7628 91.4742 16.198 91.0289 16.5353C90.5836 16.8659 90.0304 17.0312 89.3692 17.0312C88.843 17.0312 88.3707 16.9131 87.9524 16.677C87.5409 16.4408 87.217 16.1069 86.9809 15.6751C86.7448 15.2366 86.6267 14.7306 86.6267 14.1571C86.6267 13.5836 86.7414 13.081 86.9708 12.6492C87.2002 12.2174 87.5206 11.8868 87.9322 11.6574C88.3505 11.4213 88.8295 11.3032 89.3692 11.3032C89.8955 11.3032 90.361 11.4179 90.7658 11.6473C91.1706 11.8767 91.4809 12.1938 91.6968 12.5986C91.9195 12.9967 92.0308 13.4487 92.0308 13.9547ZM91.0795 13.7624C91.0795 13.4116 91.0019 13.1114 90.8467 12.8617C90.6916 12.6054 90.479 12.4131 90.2092 12.2849C89.9461 12.15 89.6526 12.0825 89.3287 12.0825C88.8632 12.0825 88.4652 12.2309 88.1346 12.5278C87.8107 12.8246 87.6252 13.2362 87.578 13.7624H91.0795Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M98.5654 17.0312C98.046 17.0312 97.5737 16.9131 97.1487 16.677C96.7304 16.4408 96.3998 16.1069 96.1569 15.6751C95.9208 15.2366 95.8027 14.7306 95.8027 14.1571C95.8027 13.5904 95.9241 13.0911 96.167 12.6593C96.4166 12.2208 96.754 11.8868 97.179 11.6574C97.604 11.4213 98.0797 11.3032 98.6059 11.3032C99.1322 11.3032 99.6078 11.4213 100.033 11.6574C100.458 11.8868 100.792 12.2174 101.035 12.6492C101.284 13.081 101.409 13.5836 101.409 14.1571C101.409 14.7306 101.281 15.2366 101.025 15.6751C100.775 16.1069 100.434 16.4408 100.002 16.677C99.5707 16.9131 99.0917 17.0312 98.5654 17.0312ZM98.5654 16.2216C98.896 16.2216 99.2064 16.144 99.4965 15.9888C99.7866 15.8336 100.019 15.6009 100.195 15.2905C100.377 14.9802 100.468 14.6024 100.468 14.1571C100.468 13.7118 100.38 13.334 100.205 13.0236C100.029 12.7133 99.8001 12.4839 99.5167 12.3355C99.2334 12.1803 98.9264 12.1027 98.5958 12.1027C98.2585 12.1027 97.9481 12.1803 97.6648 12.3355C97.3882 12.4839 97.1655 12.7133 96.9968 13.0236C96.8282 13.334 96.7439 13.7118 96.7439 14.1571C96.7439 14.6091 96.8248 14.9903 96.9867 15.3007C97.1554 15.611 97.378 15.8438 97.6546 15.9989C97.9313 16.1474 98.2349 16.2216 98.5654 16.2216Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M105.524 11.2931C106.199 11.2931 106.746 11.4989 107.164 11.9104C107.582 12.3152 107.791 12.9022 107.791 13.6713V16.9401H106.881V13.8029C106.881 13.2497 106.742 12.828 106.466 12.5379C106.189 12.241 105.811 12.0926 105.332 12.0926C104.846 12.0926 104.458 12.2444 104.168 12.548C103.885 12.8516 103.743 13.2935 103.743 13.8737V16.9401H102.822V11.3943H103.743V12.1837C103.925 11.9003 104.172 11.6811 104.482 11.5259C104.799 11.3707 105.147 11.2931 105.524 11.2931Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "rect",
        {
          x: "9.89844",
          y: "7.69995",
          width: "28.6",
          height: "28.6",
          rx: "10",
          fill: "url(#paint0_angular_2136_37678)"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28.3704 18.2264L28.3116 17.9675C28.3116 15.7006 26.4668 13.8564 24.1995 13.8564C21.9322 13.8564 20.0877 15.7006 20.0877 17.9675L20.0287 18.2264H16.6523L17.5624 26.7109C17.7447 28.4366 19.2001 29.7463 20.9356 29.7463H27.4634C29.1989 29.7463 30.6543 28.4366 30.8366 26.711L31.7468 18.2264H28.3704ZM21.8162 18.2264L21.8825 17.9675C21.8825 16.6901 22.922 15.6509 24.1995 15.6509C25.4773 15.6509 26.5167 16.6901 26.5167 17.9675L26.5829 18.2264H21.8162Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "rect",
        {
          x: "0.5",
          y: "0.5",
          width: "160.7",
          height: "43",
          rx: "6.75",
          stroke: "#A6A6A6"
        }
      ),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ c(
        "radialGradient",
        {
          id: "paint0_angular_2136_37678",
          cx: "0",
          cy: "0",
          r: "1",
          gradientUnits: "userSpaceOnUse",
          gradientTransform: "translate(24.1984 22) rotate(88.8309) scale(14.303)",
          children: [
            /* @__PURE__ */ t("stop", { offset: "0.000415415", stopColor: "#F4605E" }),
            /* @__PURE__ */ t("stop", { offset: "0.0642377", stopColor: "#E94B80" }),
            /* @__PURE__ */ t("stop", { offset: "0.128396", stopColor: "#DE33A4" }),
            /* @__PURE__ */ t("stop", { offset: "0.186654", stopColor: "#D41AC8" }),
            /* @__PURE__ */ t("stop", { offset: "0.250949", stopColor: "#CB06E5" }),
            /* @__PURE__ */ t("stop", { offset: "0.281719", stopColor: "#C902EC" }),
            /* @__PURE__ */ t("stop", { offset: "0.316858", stopColor: "#CB04E5" }),
            /* @__PURE__ */ t("stop", { offset: "0.371347", stopColor: "#D108D3" }),
            /* @__PURE__ */ t("stop", { offset: "0.43351", stopColor: "#D80DBA" }),
            /* @__PURE__ */ t("stop", { offset: "0.504024", stopColor: "#E1139E" }),
            /* @__PURE__ */ t("stop", { offset: "0.59576", stopColor: "#EC1E7B" }),
            /* @__PURE__ */ t("stop", { offset: "0.673288", stopColor: "#F22A65" }),
            /* @__PURE__ */ t("stop", { offset: "0.713795", stopColor: "#F5355B" }),
            /* @__PURE__ */ t("stop", { offset: "0.754495", stopColor: "#F74452" }),
            /* @__PURE__ */ t("stop", { offset: "0.818581", stopColor: "#F75651" }),
            /* @__PURE__ */ t("stop", { offset: "0.878478", stopColor: "#F76051" }),
            /* @__PURE__ */ t("stop", { offset: "0.938046", stopColor: "#F76551" })
          ]
        }
      ) })
    ]
  }
), e4 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "147",
    height: "40",
    viewBox: "0 0 147 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "146", height: "39", rx: "6.75", fill: "black" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M64.7516 20.3987H66.7715V31.3885H64.7516V20.3987Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M42.5 25.9699C42.5 22.8811 44.8314 20.4009 48.039 20.4009C50.2816 20.4009 52.0489 21.5444 52.9695 23.1779L51.1875 24.2473C50.5193 23.0146 49.4799 22.3611 48.054 22.3611C46.0343 22.3611 44.5047 23.9946 44.5047 25.9699C44.5047 27.9745 46.0196 29.5786 48.1281 29.5786C49.7469 29.5786 50.8757 28.6578 51.2616 27.2322H47.8017V25.3017H53.4298V26.1037C53.4298 29.0289 51.3657 31.5392 48.1281 31.5392C44.7423 31.5392 42.5 28.9695 42.5 25.9699Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M54.3525 27.0543C54.3525 24.1732 56.4613 22.525 58.6592 22.525C59.8027 22.525 60.8274 22.9999 61.4512 23.7426V22.7032H63.4558V31.3907H61.4512V30.2616C60.8124 31.0636 59.773 31.5689 58.6295 31.5689C56.5354 31.5689 54.3525 29.8904 54.3525 27.0543ZM61.555 27.0246C61.555 25.5543 60.4412 24.3514 58.9562 24.3514C57.4713 24.3514 56.3278 25.5249 56.3278 27.0246C56.3278 28.539 57.4713 29.7272 58.9562 29.7272C60.4412 29.7272 61.555 28.5243 61.555 27.0246Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M67.7938 27.0543C67.7938 24.1732 69.9026 22.525 72.1005 22.525C73.244 22.525 74.2686 22.9999 74.8925 23.7426V22.7032H76.8971V31.3907H74.8925V30.2616C74.2539 31.0636 73.2146 31.5689 72.0707 31.5689C69.977 31.5689 67.7938 29.8904 67.7938 27.0543ZM74.9966 27.0246C74.9966 25.5543 73.8828 24.3514 72.3981 24.3514C70.9128 24.3514 69.7693 25.5249 69.7693 27.0246C69.7693 28.539 70.9128 29.7272 72.3981 29.7272C73.8825 29.7272 74.9966 28.5243 74.9966 27.0246Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M80.8048 26.9652L77.6566 22.7032H80.1072L82.0818 25.4652L84.0424 22.7032H86.4182L83.2994 26.9949L86.6261 31.3907H84.1759L82.0524 28.4949L79.988 31.3907H77.5375L80.8048 26.9652Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M90.3846 30.9598L86.8206 22.7029H88.9588L91.3796 28.554L93.6663 22.7029H95.7757L90.5926 35.4H88.5582L90.3846 30.9598Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M99.8907 29.5936L101.732 28.1384C102.282 29.074 103.128 29.6083 104.108 29.6083C105.178 29.6083 105.757 28.911 105.757 28.1531C105.757 27.2325 104.658 26.9505 103.499 26.594C102.044 26.1334 100.426 25.5693 100.426 23.5049C100.426 21.7676 101.94 20.4012 104.019 20.4012C105.772 20.4012 106.781 21.0697 107.658 21.9756L105.994 23.2376C105.534 22.5547 104.895 22.1982 104.034 22.1982C103.054 22.1982 102.519 22.7329 102.519 23.4305C102.519 24.292 103.559 24.5743 104.732 24.9605C106.203 25.4355 107.866 26.089 107.866 28.1681C107.866 29.8757 106.499 31.5395 104.123 31.5395C102.163 31.5392 100.871 30.7071 99.8907 29.5936Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M108.03 22.7029H109.515V21.3812L111.535 20V22.7029H113.302V24.4999H111.535V27.7519C111.535 29.2669 111.743 29.5045 113.302 29.5045V31.3904H113.02C110.332 31.3904 109.515 30.5292 109.515 27.7672V24.4999H108.03L108.03 22.7029Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M113.838 27.0543C113.838 24.5296 115.827 22.5247 118.337 22.5247C120.832 22.5247 122.837 24.5296 122.837 27.0543C122.837 29.5639 120.832 31.5689 118.337 31.5689C115.827 31.5689 113.838 29.5639 113.838 27.0543ZM120.862 27.0543C120.862 25.599 119.747 24.4108 118.337 24.4108C116.896 24.4108 115.812 25.599 115.812 27.0543C115.812 28.4949 116.896 29.6828 118.337 29.6828C119.747 29.6828 120.862 28.4949 120.862 27.0543Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M125.853 22.7029V23.9949C126.254 23.1335 126.981 22.7029 128.08 22.7029C128.704 22.7029 129.223 22.8514 129.61 23.0741L128.852 24.9749C128.555 24.782 128.214 24.6334 127.649 24.6334C126.491 24.6334 125.867 25.2573 125.867 26.7569V31.3904H123.862V22.7029H125.853Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M129.834 27.069C129.834 24.5296 131.808 22.5247 134.348 22.5247C136.932 22.5247 138.818 24.4255 138.818 26.9949V27.7519H131.749C132.017 28.9701 132.997 29.8016 134.423 29.8016C135.536 29.8016 136.413 29.1928 136.828 28.2719L138.477 29.2222C137.719 30.6186 136.353 31.5686 134.423 31.5686C131.69 31.5686 129.834 29.5786 129.834 27.069ZM131.853 26.074H136.784C136.487 24.9158 135.596 24.292 134.348 24.292C133.145 24.292 132.21 25.0196 131.853 26.074Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M46.6991 13.9741H43.9023L43.3871 15.4001H42.5039L44.8223 9.02453H45.7883L48.0975 15.4001H47.2143L46.6991 13.9741ZM46.4599 13.2933L45.3007 10.0549L44.1415 13.2933H46.4599Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M50.4327 14.6273L51.9967 10.3585H52.8891L50.9111 15.4001H49.9359L47.9579 10.3585H48.8595L50.4327 14.6273Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M53.4922 12.8609C53.4922 12.3457 53.5964 11.8949 53.805 11.5085C54.0135 11.116 54.2987 10.8124 54.6606 10.5977C55.0286 10.3831 55.4364 10.2757 55.8842 10.2757C56.3258 10.2757 56.7091 10.3708 57.0342 10.5609C57.3592 10.7511 57.6015 10.9903 57.761 11.2785V10.3585H58.6074V15.4001H57.761V14.4617C57.5954 14.7561 57.347 15.0015 57.0158 15.1977C56.6907 15.3879 56.3104 15.4829 55.875 15.4829C55.4272 15.4829 55.0224 15.3725 54.6606 15.1517C54.2987 14.9309 54.0135 14.6212 53.805 14.2225C53.5964 13.8239 53.4922 13.37 53.4922 12.8609ZM57.761 12.8701C57.761 12.4899 57.6843 12.1587 57.531 11.8765C57.3776 11.5944 57.1691 11.3797 56.9054 11.2325C56.6478 11.0792 56.3626 11.0025 56.0498 11.0025C55.737 11.0025 55.4518 11.0761 55.1942 11.2233C54.9366 11.3705 54.7311 11.5852 54.5778 11.8673C54.4244 12.1495 54.3478 12.4807 54.3478 12.8609C54.3478 13.2473 54.4244 13.5847 54.5778 13.8729C54.7311 14.1551 54.9366 14.3728 55.1942 14.5261C55.4518 14.6733 55.737 14.7469 56.0498 14.7469C56.3626 14.7469 56.6478 14.6733 56.9054 14.5261C57.1691 14.3728 57.3776 14.1551 57.531 13.8729C57.6843 13.5847 57.761 13.2504 57.761 12.8701Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M60.2705 9.53973C60.1111 9.53973 59.9761 9.48453 59.8657 9.37413C59.7553 9.26373 59.7001 9.12879 59.7001 8.96933C59.7001 8.80986 59.7553 8.67493 59.8657 8.56453C59.9761 8.45413 60.1111 8.39893 60.2705 8.39893C60.4239 8.39893 60.5527 8.45413 60.6569 8.56453C60.7673 8.67493 60.8225 8.80986 60.8225 8.96933C60.8225 9.12879 60.7673 9.26373 60.6569 9.37413C60.5527 9.48453 60.4239 9.53973 60.2705 9.53973ZM60.6753 10.3585V15.4001H59.8381V10.3585H60.6753Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M62.7554 8.59213V15.4001H61.9182V8.59213H62.7554Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M63.8695 12.8609C63.8695 12.3457 63.9737 11.8949 64.1823 11.5085C64.3908 11.116 64.676 10.8124 65.0379 10.5977C65.4059 10.3831 65.8137 10.2757 66.2615 10.2757C66.7031 10.2757 67.0864 10.3708 67.4115 10.5609C67.7365 10.7511 67.9788 10.9903 68.1383 11.2785V10.3585H68.9847V15.4001H68.1383V14.4617C67.9727 14.7561 67.7243 15.0015 67.3931 15.1977C67.068 15.3879 66.6877 15.4829 66.2523 15.4829C65.8045 15.4829 65.3997 15.3725 65.0379 15.1517C64.676 14.9309 64.3908 14.6212 64.1823 14.2225C63.9737 13.8239 63.8695 13.37 63.8695 12.8609ZM68.1383 12.8701C68.1383 12.4899 68.0616 12.1587 67.9083 11.8765C67.7549 11.5944 67.5464 11.3797 67.2827 11.2325C67.0251 11.0792 66.7399 11.0025 66.4271 11.0025C66.1143 11.0025 65.8291 11.0761 65.5715 11.2233C65.3139 11.3705 65.1084 11.5852 64.9551 11.8673C64.8017 12.1495 64.7251 12.4807 64.7251 12.8609C64.7251 13.2473 64.8017 13.5847 64.9551 13.8729C65.1084 14.1551 65.3139 14.3728 65.5715 14.5261C65.8291 14.6733 66.1143 14.7469 66.4271 14.7469C66.7399 14.7469 67.0251 14.6733 67.2827 14.5261C67.5464 14.3728 67.7549 14.1551 67.9083 13.8729C68.0616 13.5847 68.1383 13.2504 68.1383 12.8701Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M71.3287 11.2969C71.5004 10.9964 71.7519 10.7511 72.0831 10.5609C72.4143 10.3708 72.7915 10.2757 73.2147 10.2757C73.6685 10.2757 74.0764 10.3831 74.4383 10.5977C74.8001 10.8124 75.0853 11.116 75.2939 11.5085C75.5024 11.8949 75.6067 12.3457 75.6067 12.8609C75.6067 13.37 75.5024 13.8239 75.2939 14.2225C75.0853 14.6212 74.7971 14.9309 74.4291 15.1517C74.0672 15.3725 73.6624 15.4829 73.2147 15.4829C72.7792 15.4829 72.3959 15.3879 72.0647 15.1977C71.7396 15.0076 71.4943 14.7653 71.3287 14.4709V15.4001H70.4915V8.59213H71.3287V11.2969ZM74.7511 12.8609C74.7511 12.4807 74.6744 12.1495 74.5211 11.8673C74.3677 11.5852 74.1592 11.3705 73.8955 11.2233C73.6379 11.0761 73.3527 11.0025 73.0399 11.0025C72.7332 11.0025 72.448 11.0792 72.1843 11.2325C71.9267 11.3797 71.7181 11.5975 71.5587 11.8857C71.4053 12.1679 71.3287 12.496 71.3287 12.8701C71.3287 13.2504 71.4053 13.5847 71.5587 13.8729C71.7181 14.1551 71.9267 14.3728 72.1843 14.5261C72.448 14.6733 72.7332 14.7469 73.0399 14.7469C73.3527 14.7469 73.6379 14.6733 73.8955 14.5261C74.1592 14.3728 74.3677 14.1551 74.5211 13.8729C74.6744 13.5847 74.7511 13.2473 74.7511 12.8609Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M77.5458 8.59213V15.4001H76.7086V8.59213H77.5458Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M83.6647 12.6861C83.6647 12.8456 83.6555 13.0143 83.6371 13.1921H79.6075C79.6382 13.6889 79.8068 14.0784 80.1135 14.3605C80.4263 14.6365 80.8035 14.7745 81.2451 14.7745C81.607 14.7745 81.9075 14.6917 82.1467 14.5261C82.392 14.3544 82.5638 14.1275 82.6619 13.8453H83.5635C83.4286 14.3299 83.1587 14.7255 82.7539 15.0321C82.3491 15.3327 81.8462 15.4829 81.2451 15.4829C80.7667 15.4829 80.3374 15.3756 79.9571 15.1609C79.583 14.9463 79.2886 14.6427 79.0739 14.2501C78.8592 13.8515 78.7519 13.3915 78.7519 12.8701C78.7519 12.3488 78.8562 11.8919 79.0647 11.4993C79.2732 11.1068 79.5646 10.8063 79.9387 10.5977C80.319 10.3831 80.7544 10.2757 81.2451 10.2757C81.7235 10.2757 82.1467 10.38 82.5147 10.5885C82.8827 10.7971 83.1648 11.0853 83.3611 11.4533C83.5635 11.8152 83.6647 12.2261 83.6647 12.6861ZM82.7999 12.5113C82.7999 12.1924 82.7294 11.9195 82.5883 11.6925C82.4472 11.4595 82.254 11.2847 82.0087 11.1681C81.7695 11.0455 81.5027 10.9841 81.2083 10.9841C80.7851 10.9841 80.4232 11.1191 80.1227 11.3889C79.8283 11.6588 79.6596 12.0329 79.6167 12.5113H82.7999Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M89.6053 15.4829C89.133 15.4829 88.7037 15.3756 88.3173 15.1609C87.937 14.9463 87.6365 14.6427 87.4157 14.2501C87.201 13.8515 87.0937 13.3915 87.0937 12.8701C87.0937 12.3549 87.2041 11.9011 87.4249 11.5085C87.6518 11.1099 87.9585 10.8063 88.3449 10.5977C88.7313 10.3831 89.1637 10.2757 89.6421 10.2757C90.1205 10.2757 90.5529 10.3831 90.9393 10.5977C91.3257 10.8063 91.6293 11.1068 91.8501 11.4993C92.077 11.8919 92.1905 12.3488 92.1905 12.8701C92.1905 13.3915 92.074 13.8515 91.8409 14.2501C91.614 14.6427 91.3042 14.9463 90.9117 15.1609C90.5192 15.3756 90.0837 15.4829 89.6053 15.4829ZM89.6053 14.7469C89.9058 14.7469 90.188 14.6764 90.4517 14.5353C90.7155 14.3943 90.9271 14.1827 91.0865 13.9005C91.2521 13.6184 91.3349 13.2749 91.3349 12.8701C91.3349 12.4653 91.2552 12.1219 91.0957 11.8397C90.9363 11.5576 90.7277 11.3491 90.4701 11.2141C90.2125 11.0731 89.9334 11.0025 89.6329 11.0025C89.3262 11.0025 89.0441 11.0731 88.7865 11.2141C88.5351 11.3491 88.3326 11.5576 88.1793 11.8397C88.026 12.1219 87.9493 12.4653 87.9493 12.8701C87.9493 13.2811 88.0229 13.6276 88.1701 13.9097C88.3234 14.1919 88.5259 14.4035 88.7773 14.5445C89.0288 14.6795 89.3048 14.7469 89.6053 14.7469Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M95.9317 10.2665C96.545 10.2665 97.0418 10.4536 97.4221 10.8277C97.8024 11.1957 97.9925 11.7293 97.9925 12.4285V15.4001H97.1645V12.5481C97.1645 12.0452 97.0387 11.6619 96.7873 11.3981C96.5358 11.1283 96.1924 10.9933 95.7569 10.9933C95.3153 10.9933 94.9626 11.1313 94.6989 11.4073C94.4413 11.6833 94.3125 12.0851 94.3125 12.6125V15.4001H93.4753V10.3585H94.3125V11.0761C94.4781 10.8185 94.702 10.6192 94.9841 10.4781C95.2724 10.3371 95.5882 10.2665 95.9317 10.2665Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "rect",
        {
          x: "9",
          y: "7",
          width: "26",
          height: "26",
          rx: "10",
          fill: "url(#paint0_angular_2136_36914)"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M25.7934 16.5693L25.7399 16.334C25.7399 14.2732 24.0629 12.5967 22.0016 12.5967C19.9405 12.5967 18.2636 14.2732 18.2636 16.334L18.2101 16.5693H15.1406L15.968 24.2825C16.1337 25.8514 17.4568 27.042 19.0345 27.042H24.9689C26.5466 27.042 27.8697 25.8514 28.0354 24.2827L28.8628 16.5693H25.7934ZM19.8351 16.5693L19.8953 16.334C19.8953 15.1728 20.8403 14.228 22.0016 14.228C23.1633 14.228 24.1082 15.1728 24.1082 16.334L24.1684 16.5693H19.8351Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "rect",
        {
          x: "0.5",
          y: "0.5",
          width: "146",
          height: "39",
          rx: "6.75",
          stroke: "#A6A6A6"
        }
      ),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ c(
        "radialGradient",
        {
          id: "paint0_angular_2136_36914",
          cx: "0",
          cy: "0",
          r: "1",
          gradientUnits: "userSpaceOnUse",
          gradientTransform: "translate(22 20) rotate(88.8309) scale(13.0027)",
          children: [
            /* @__PURE__ */ t("stop", { offset: "0.000415415", stopColor: "#F4605E" }),
            /* @__PURE__ */ t("stop", { offset: "0.0642377", stopColor: "#E94B80" }),
            /* @__PURE__ */ t("stop", { offset: "0.128396", stopColor: "#DE33A4" }),
            /* @__PURE__ */ t("stop", { offset: "0.186654", stopColor: "#D41AC8" }),
            /* @__PURE__ */ t("stop", { offset: "0.250949", stopColor: "#CB06E5" }),
            /* @__PURE__ */ t("stop", { offset: "0.281719", stopColor: "#C902EC" }),
            /* @__PURE__ */ t("stop", { offset: "0.316858", stopColor: "#CB04E5" }),
            /* @__PURE__ */ t("stop", { offset: "0.371347", stopColor: "#D108D3" }),
            /* @__PURE__ */ t("stop", { offset: "0.43351", stopColor: "#D80DBA" }),
            /* @__PURE__ */ t("stop", { offset: "0.504024", stopColor: "#E1139E" }),
            /* @__PURE__ */ t("stop", { offset: "0.59576", stopColor: "#EC1E7B" }),
            /* @__PURE__ */ t("stop", { offset: "0.673288", stopColor: "#F22A65" }),
            /* @__PURE__ */ t("stop", { offset: "0.713795", stopColor: "#F5355B" }),
            /* @__PURE__ */ t("stop", { offset: "0.754495", stopColor: "#F74452" }),
            /* @__PURE__ */ t("stop", { offset: "0.818581", stopColor: "#F75651" }),
            /* @__PURE__ */ t("stop", { offset: "0.878478", stopColor: "#F76051" }),
            /* @__PURE__ */ t("stop", { offset: "0.938046", stopColor: "#F76551" })
          ]
        }
      ) })
    ]
  }
), i4 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "162",
    height: "44",
    viewBox: "0 0 162 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M71.2267 22.4386H73.4487V34.5274H71.2267V22.4386Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M46.75 28.5669C46.75 25.1692 49.3146 22.441 52.8429 22.441C55.3098 22.441 57.2538 23.6988 58.2665 25.4957L56.3062 26.672C55.5712 25.3161 54.4279 24.5972 52.8594 24.5972C50.6378 24.5972 48.9551 26.3941 48.9551 28.5669C48.9551 30.772 50.6216 32.5365 52.9409 32.5365C54.7216 32.5365 55.9633 31.5235 56.3877 29.9554H52.5818V27.8318H58.7728V28.7141C58.7728 31.9318 56.5023 34.6931 52.9409 34.6931C49.2165 34.6931 46.75 31.8665 46.75 28.5669Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M59.7877 29.7597C59.7877 26.5905 62.1074 24.7775 64.5251 24.7775C65.783 24.7775 66.9101 25.2999 67.5963 26.1168V24.9735H69.8014V34.5297H67.5963V33.2877C66.8936 34.17 65.7503 34.7258 64.4924 34.7258C62.1889 34.7258 59.7877 32.8794 59.7877 29.7597ZM67.7105 29.727C67.7105 28.1097 66.4853 26.7865 64.8519 26.7865C63.2184 26.7865 61.9605 28.0774 61.9605 29.727C61.9605 31.3928 63.2184 32.6999 64.8519 32.6999C66.4853 32.6999 67.7105 31.3767 67.7105 29.727Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M74.5731 29.7597C74.5731 26.5905 76.8928 24.7775 79.3105 24.7775C80.5684 24.7775 81.6955 25.2999 82.3817 26.1168V24.9735H84.5868V34.5297H82.3817V33.2877C81.6793 34.17 80.536 34.7258 79.2778 34.7258C76.9747 34.7258 74.5731 32.8794 74.5731 29.7597ZM82.4962 29.727C82.4962 28.1097 81.2711 26.7865 79.6379 26.7865C78.0041 26.7865 76.7463 28.0774 76.7463 29.727C76.7463 31.3928 78.0041 32.6999 79.6379 32.6999C81.2707 32.6999 82.4962 31.3767 82.4962 29.727Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M88.8852 29.6617L85.4223 24.9735H88.1179L90.29 28.0117L92.4466 24.9735H95.06L91.6294 29.6944L95.2887 34.5297H92.5935L90.2576 31.3443L87.9868 34.5297H85.2912L88.8852 29.6617Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M99.4231 34.0558L95.5027 24.9732H97.8547L100.518 31.4093L103.033 24.9732H105.353L99.6518 38.94H97.414L99.4231 34.0558Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M109.88 32.553L111.905 30.9522C112.51 31.9813 113.441 32.5692 114.519 32.5692C115.695 32.5692 116.332 31.8021 116.332 30.9684C116.332 29.9558 115.124 29.6455 113.849 29.2534C112.249 28.7468 110.468 28.1263 110.468 25.8554C110.468 23.9444 112.134 22.4413 114.421 22.4413C116.349 22.4413 117.46 23.1767 118.423 24.1731L116.594 25.5614C116.087 24.8101 115.385 24.418 114.438 24.418C113.36 24.418 112.771 25.0062 112.771 25.7736C112.771 26.7212 113.915 27.0318 115.206 27.4566C116.823 27.979 118.652 28.6979 118.652 30.9849C118.652 32.8633 117.149 34.6935 114.536 34.6935C112.379 34.6931 110.958 33.7779 109.88 32.553Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M118.833 24.9732H120.466V23.5193L122.688 22V24.9732H124.632V26.9499H122.688V30.5271C122.688 32.1936 122.917 32.455 124.632 32.455V34.5294H124.322C121.366 34.5294 120.467 33.5821 120.467 30.5439V26.9499H118.833L118.833 24.9732Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M125.221 29.7597C125.221 26.9826 127.41 24.7771 130.171 24.7771C132.915 24.7771 135.12 26.9826 135.12 29.7597C135.12 32.5203 132.915 34.7258 130.171 34.7258C127.41 34.7258 125.221 32.5203 125.221 29.7597ZM132.948 29.7597C132.948 28.1589 131.722 26.8519 130.171 26.8519C128.586 26.8519 127.393 28.1589 127.393 29.7597C127.393 31.3443 128.586 32.651 130.171 32.651C131.722 32.651 132.948 31.3443 132.948 29.7597Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M138.438 24.9732V26.3944C138.879 25.4468 139.679 24.9732 140.888 24.9732C141.574 24.9732 142.146 25.1366 142.571 25.3815L141.737 27.4724C141.41 27.2602 141.035 27.0968 140.414 27.0968C139.14 27.0968 138.454 27.783 138.454 29.4326V34.5294H136.249V24.9732H138.438Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M142.817 29.7759C142.817 26.9826 144.989 24.7771 147.783 24.7771C150.625 24.7771 152.7 26.8681 152.7 29.6944V30.5271H144.924C145.218 31.8672 146.296 32.7817 147.865 32.7817C149.09 32.7817 150.054 32.1121 150.511 31.0991L152.324 32.1444C151.491 33.6805 149.988 34.7255 147.865 34.7255C144.859 34.7255 142.817 32.5365 142.817 29.7759ZM145.039 28.6814H150.462C150.135 27.4074 149.155 26.7212 147.783 26.7212C146.459 26.7212 145.431 27.5216 145.039 28.6814Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M51.3686 15.3715H48.2921L47.7254 16.9401H46.7539L49.3041 9.92693H50.3667L52.9069 16.9401H51.9353L51.3686 15.3715ZM51.1055 14.6226L49.8304 11.0604L48.5553 14.6226H51.1055Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M55.4756 16.09L57.196 11.3943H58.1776L56.0018 16.9401H54.9291L52.7533 11.3943H53.7451L55.4756 16.09Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M58.841 14.147C58.841 13.5802 58.9557 13.0844 59.1851 12.6593C59.4144 12.2275 59.7282 11.8936 60.1262 11.6574C60.531 11.4213 60.9797 11.3032 61.4722 11.3032C61.9579 11.3032 62.3796 11.4078 62.7372 11.617C63.0948 11.8261 63.3612 12.0892 63.5367 12.4063V11.3943H64.4677V16.9401H63.5367V15.9078C63.3545 16.2317 63.0813 16.5016 62.7169 16.7174C62.3594 16.9266 61.9411 17.0312 61.4621 17.0312C60.9696 17.0312 60.5243 16.9097 60.1262 16.6668C59.7282 16.424 59.4144 16.0833 59.1851 15.6447C58.9557 15.2062 58.841 14.7069 58.841 14.147ZM63.5367 14.1571C63.5367 13.7388 63.4523 13.3745 63.2837 13.0641C63.115 12.7538 62.8856 12.5176 62.5955 12.3557C62.3121 12.1871 61.9984 12.1027 61.6543 12.1027C61.3103 12.1027 60.9965 12.1837 60.7132 12.3456C60.4298 12.5075 60.2038 12.7437 60.0351 13.054C59.8665 13.3644 59.7821 13.7287 59.7821 14.147C59.7821 14.572 59.8665 14.9431 60.0351 15.2602C60.2038 15.5705 60.4298 15.81 60.7132 15.9787C60.9965 16.1406 61.3103 16.2216 61.6543 16.2216C61.9984 16.2216 62.3121 16.1406 62.5955 15.9787C62.8856 15.81 63.115 15.5705 63.2837 15.2602C63.4523 14.9431 63.5367 14.5754 63.5367 14.1571Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M66.2972 10.4936C66.1218 10.4936 65.9734 10.4329 65.8519 10.3115C65.7305 10.19 65.6698 10.0416 65.6698 9.86621C65.6698 9.6908 65.7305 9.54237 65.8519 9.42093C65.9734 9.29949 66.1218 9.23877 66.2972 9.23877C66.4659 9.23877 66.6076 9.29949 66.7222 9.42093C66.8437 9.54237 66.9044 9.6908 66.9044 9.86621C66.9044 10.0416 66.8437 10.19 66.7222 10.3115C66.6076 10.4329 66.4659 10.4936 66.2972 10.4936ZM66.7425 11.3943V16.9401H65.8216V11.3943H66.7425Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M69.0306 9.45129V16.9401H68.1096V9.45129H69.0306Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M70.256 14.147C70.256 13.5802 70.3707 13.0844 70.6001 12.6593C70.8295 12.2275 71.1432 11.8936 71.5413 11.6574C71.9461 11.4213 72.3947 11.3032 72.8872 11.3032C73.373 11.3032 73.7946 11.4078 74.1522 11.617C74.5098 11.8261 74.7763 12.0892 74.9517 12.4063V11.3943H75.8827V16.9401H74.9517V15.9078C74.7695 16.2317 74.4963 16.5016 74.132 16.7174C73.7744 16.9266 73.3561 17.0312 72.8771 17.0312C72.3846 17.0312 71.9393 16.9097 71.5413 16.6668C71.1432 16.424 70.8295 16.0833 70.6001 15.6447C70.3707 15.2062 70.256 14.7069 70.256 14.147ZM74.9517 14.1571C74.9517 13.7388 74.8674 13.3745 74.6987 13.0641C74.53 12.7538 74.3006 12.5176 74.0105 12.3557C73.7272 12.1871 73.4135 12.1027 73.0694 12.1027C72.7253 12.1027 72.4116 12.1837 72.1282 12.3456C71.8449 12.5075 71.6188 12.7437 71.4502 13.054C71.2815 13.3644 71.1972 13.7287 71.1972 14.147C71.1972 14.572 71.2815 14.9431 71.4502 15.2602C71.6188 15.5705 71.8449 15.81 72.1282 15.9787C72.4116 16.1406 72.7253 16.2216 73.0694 16.2216C73.4135 16.2216 73.7272 16.1406 74.0105 15.9787C74.3006 15.81 74.53 15.5705 74.6987 15.2602C74.8674 14.9431 74.9517 14.5754 74.9517 14.1571Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M78.4611 12.4266C78.65 12.096 78.9266 11.8261 79.291 11.617C79.6553 11.4078 80.0702 11.3032 80.5357 11.3032C81.035 11.3032 81.4836 11.4213 81.8817 11.6574C82.2797 11.8936 82.5935 12.2275 82.8228 12.6593C83.0522 13.0844 83.1669 13.5802 83.1669 14.147C83.1669 14.7069 83.0522 15.2062 82.8228 15.6447C82.5935 16.0833 82.2764 16.424 81.8716 16.6668C81.4735 16.9097 81.0282 17.0312 80.5357 17.0312C80.0567 17.0312 79.635 16.9266 79.2707 16.7174C78.9132 16.5083 78.6433 16.2418 78.4611 15.918V16.9401H77.5402V9.45129H78.4611V12.4266ZM82.2258 14.147C82.2258 13.7287 82.1414 13.3644 81.9728 13.054C81.8041 12.7437 81.5747 12.5075 81.2846 12.3456C81.0012 12.1837 80.6875 12.1027 80.3434 12.1027C80.0061 12.1027 79.6924 12.1871 79.4023 12.3557C79.1189 12.5176 78.8895 12.7572 78.7141 13.0742C78.5455 13.3846 78.4611 13.7455 78.4611 14.1571C78.4611 14.5754 78.5455 14.9431 78.7141 15.2602C78.8895 15.5705 79.1189 15.81 79.4023 15.9787C79.6924 16.1406 80.0061 16.2216 80.3434 16.2216C80.6875 16.2216 81.0012 16.1406 81.2846 15.9787C81.5747 15.81 81.8041 15.5705 81.9728 15.2602C82.1414 14.9431 82.2258 14.572 82.2258 14.147Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t("path", { d: "M85.3 9.45129V16.9401H84.3791V9.45129H85.3Z", fill: "white" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M92.0308 13.9547C92.0308 14.1301 92.0207 14.3156 92.0004 14.5113H87.5679C87.6016 15.0578 87.7871 15.4862 88.1245 15.7965C88.4685 16.1001 88.8835 16.2519 89.3692 16.2519C89.7673 16.2519 90.0979 16.1609 90.361 15.9787C90.6308 15.7898 90.8197 15.5402 90.9277 15.2298H91.9195C91.771 15.7628 91.4742 16.198 91.0289 16.5353C90.5836 16.8659 90.0304 17.0312 89.3692 17.0312C88.843 17.0312 88.3707 16.9131 87.9524 16.677C87.5409 16.4408 87.217 16.1069 86.9809 15.6751C86.7448 15.2366 86.6267 14.7306 86.6267 14.1571C86.6267 13.5836 86.7414 13.081 86.9708 12.6492C87.2002 12.2174 87.5206 11.8868 87.9322 11.6574C88.3505 11.4213 88.8295 11.3032 89.3692 11.3032C89.8955 11.3032 90.361 11.4179 90.7658 11.6473C91.1706 11.8767 91.4809 12.1938 91.6968 12.5986C91.9195 12.9967 92.0308 13.4487 92.0308 13.9547ZM91.0795 13.7624C91.0795 13.4116 91.0019 13.1114 90.8467 12.8617C90.6916 12.6054 90.479 12.4131 90.2092 12.2849C89.9461 12.15 89.6526 12.0825 89.3287 12.0825C88.8632 12.0825 88.4652 12.2309 88.1346 12.5278C87.8107 12.8246 87.6252 13.2362 87.578 13.7624H91.0795Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M98.5654 17.0312C98.046 17.0312 97.5737 16.9131 97.1487 16.677C96.7304 16.4408 96.3998 16.1069 96.1569 15.6751C95.9208 15.2366 95.8027 14.7306 95.8027 14.1571C95.8027 13.5904 95.9241 13.0911 96.167 12.6593C96.4166 12.2208 96.754 11.8868 97.179 11.6574C97.604 11.4213 98.0797 11.3032 98.6059 11.3032C99.1322 11.3032 99.6078 11.4213 100.033 11.6574C100.458 11.8868 100.792 12.2174 101.035 12.6492C101.284 13.081 101.409 13.5836 101.409 14.1571C101.409 14.7306 101.281 15.2366 101.025 15.6751C100.775 16.1069 100.434 16.4408 100.002 16.677C99.5707 16.9131 99.0917 17.0312 98.5654 17.0312ZM98.5654 16.2216C98.896 16.2216 99.2064 16.144 99.4965 15.9888C99.7866 15.8336 100.019 15.6009 100.195 15.2905C100.377 14.9802 100.468 14.6024 100.468 14.1571C100.468 13.7118 100.38 13.334 100.205 13.0236C100.029 12.7133 99.8001 12.4839 99.5167 12.3355C99.2334 12.1803 98.9264 12.1027 98.5958 12.1027C98.2585 12.1027 97.9481 12.1803 97.6648 12.3355C97.3882 12.4839 97.1655 12.7133 96.9968 13.0236C96.8282 13.334 96.7439 13.7118 96.7439 14.1571C96.7439 14.6091 96.8248 14.9903 96.9867 15.3007C97.1554 15.611 97.378 15.8438 97.6546 15.9989C97.9313 16.1474 98.2349 16.2216 98.5654 16.2216Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M105.524 11.2931C106.199 11.2931 106.746 11.4989 107.164 11.9104C107.582 12.3152 107.791 12.9022 107.791 13.6713V16.9401H106.881V13.8029C106.881 13.2497 106.742 12.828 106.466 12.5379C106.189 12.241 105.811 12.0926 105.332 12.0926C104.846 12.0926 104.458 12.2444 104.168 12.548C103.885 12.8516 103.743 13.2935 103.743 13.8737V16.9401H102.822V11.3943H103.743V12.1837C103.925 11.9003 104.172 11.6811 104.482 11.5259C104.799 11.3707 105.147 11.2931 105.524 11.2931Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.2024 16.1321C9.89844 17.398 9.89844 18.932 9.89844 22C9.89844 25.0679 9.89844 26.6019 10.2024 27.8678C11.168 31.89 14.3084 35.0304 18.3305 35.996C19.5965 36.2999 21.1305 36.2999 24.1984 36.2999C27.2664 36.2999 28.8004 36.2999 30.0663 35.996C34.0885 35.0304 37.2289 31.89 38.1945 27.8678C38.4984 26.6019 38.4984 25.0679 38.4984 22C38.4984 18.932 38.4984 17.398 38.1945 16.1321C37.2289 12.1099 34.0885 8.96951 30.0663 8.00388C28.8004 7.69995 27.2664 7.69995 24.1984 7.69995C21.1305 7.69995 19.5965 7.69995 18.3305 8.00388C14.3084 8.96951 11.168 12.1099 10.2024 16.1321ZM28.3102 17.9675L28.369 18.2264H31.7454L30.8352 26.711C30.6529 28.4366 29.1975 29.7463 27.462 29.7463H20.9343C19.1988 29.7463 17.7434 28.4366 17.5611 26.7109L16.651 18.2264H20.0274L20.0863 17.9675C20.0863 15.7006 21.9308 13.8564 24.1981 13.8564C26.4654 13.8564 28.3102 15.7006 28.3102 17.9675ZM21.8812 17.9675L21.8149 18.2264H26.5815L26.5153 17.9675C26.5153 16.6901 25.4759 15.6509 24.1981 15.6509C22.9206 15.6509 21.8812 16.6901 21.8812 17.9675Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "rect",
        {
          x: "0.5",
          y: "0.5",
          width: "160.7",
          height: "43",
          rx: "6.75",
          stroke: "white"
        }
      )
    ]
  }
), l4 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "147",
    height: "40",
    viewBox: "0 0 147 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M64.7516 20.3987H66.7715V31.3885H64.7516V20.3987Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M42.5 25.9699C42.5 22.8811 44.8314 20.4009 48.039 20.4009C50.2816 20.4009 52.0489 21.5444 52.9695 23.1779L51.1875 24.2473C50.5193 23.0146 49.4799 22.3611 48.054 22.3611C46.0343 22.3611 44.5047 23.9946 44.5047 25.9699C44.5047 27.9745 46.0196 29.5786 48.1281 29.5786C49.7469 29.5786 50.8757 28.6578 51.2616 27.2322H47.8017V25.3017H53.4298V26.1037C53.4298 29.0289 51.3657 31.5392 48.1281 31.5392C44.7423 31.5392 42.5 28.9695 42.5 25.9699Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M54.3525 27.0543C54.3525 24.1732 56.4613 22.525 58.6592 22.525C59.8027 22.525 60.8274 22.9999 61.4512 23.7426V22.7032H63.4558V31.3907H61.4512V30.2616C60.8124 31.0636 59.773 31.5689 58.6295 31.5689C56.5354 31.5689 54.3525 29.8904 54.3525 27.0543ZM61.555 27.0246C61.555 25.5543 60.4412 24.3514 58.9562 24.3514C57.4713 24.3514 56.3278 25.5249 56.3278 27.0246C56.3278 28.539 57.4713 29.7272 58.9562 29.7272C60.4412 29.7272 61.555 28.5243 61.555 27.0246Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M67.7938 27.0543C67.7938 24.1732 69.9026 22.525 72.1005 22.525C73.244 22.525 74.2686 22.9999 74.8925 23.7426V22.7032H76.8971V31.3907H74.8925V30.2616C74.2539 31.0636 73.2146 31.5689 72.0707 31.5689C69.977 31.5689 67.7938 29.8904 67.7938 27.0543ZM74.9966 27.0246C74.9966 25.5543 73.8828 24.3514 72.3981 24.3514C70.9128 24.3514 69.7693 25.5249 69.7693 27.0246C69.7693 28.539 70.9128 29.7272 72.3981 29.7272C73.8825 29.7272 74.9966 28.5243 74.9966 27.0246Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M80.8048 26.9652L77.6566 22.7032H80.1072L82.0818 25.4652L84.0424 22.7032H86.4182L83.2994 26.9949L86.6261 31.3907H84.1759L82.0524 28.4949L79.988 31.3907H77.5375L80.8048 26.9652Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M90.3846 30.9598L86.8206 22.7029H88.9588L91.3796 28.554L93.6663 22.7029H95.7757L90.5926 35.4H88.5582L90.3846 30.9598Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M99.8907 29.5936L101.732 28.1384C102.282 29.074 103.128 29.6083 104.108 29.6083C105.178 29.6083 105.757 28.911 105.757 28.1531C105.757 27.2325 104.658 26.9505 103.499 26.594C102.044 26.1334 100.426 25.5693 100.426 23.5049C100.426 21.7676 101.94 20.4012 104.019 20.4012C105.772 20.4012 106.781 21.0697 107.658 21.9756L105.994 23.2376C105.534 22.5547 104.895 22.1982 104.034 22.1982C103.054 22.1982 102.519 22.7329 102.519 23.4305C102.519 24.292 103.559 24.5743 104.732 24.9605C106.203 25.4355 107.866 26.089 107.866 28.1681C107.866 29.8757 106.499 31.5395 104.123 31.5395C102.163 31.5392 100.871 30.7071 99.8907 29.5936Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M108.03 22.7029H109.515V21.3812L111.535 20V22.7029H113.302V24.4999H111.535V27.7519C111.535 29.2669 111.743 29.5045 113.302 29.5045V31.3904H113.02C110.332 31.3904 109.515 30.5292 109.515 27.7672V24.4999H108.03L108.03 22.7029Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M113.838 27.0543C113.838 24.5296 115.827 22.5247 118.337 22.5247C120.832 22.5247 122.837 24.5296 122.837 27.0543C122.837 29.5639 120.832 31.5689 118.337 31.5689C115.827 31.5689 113.838 29.5639 113.838 27.0543ZM120.862 27.0543C120.862 25.599 119.747 24.4108 118.337 24.4108C116.896 24.4108 115.812 25.599 115.812 27.0543C115.812 28.4949 116.896 29.6828 118.337 29.6828C119.747 29.6828 120.862 28.4949 120.862 27.0543Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M125.853 22.7029V23.9949C126.254 23.1335 126.981 22.7029 128.08 22.7029C128.704 22.7029 129.223 22.8514 129.61 23.0741L128.852 24.9749C128.555 24.782 128.214 24.6334 127.649 24.6334C126.491 24.6334 125.867 25.2573 125.867 26.7569V31.3904H123.862V22.7029H125.853Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M129.834 27.069C129.834 24.5296 131.808 22.5247 134.348 22.5247C136.932 22.5247 138.818 24.4255 138.818 26.9949V27.7519H131.749C132.017 28.9701 132.997 29.8016 134.423 29.8016C135.536 29.8016 136.413 29.1928 136.828 28.2719L138.477 29.2222C137.719 30.6186 136.353 31.5686 134.423 31.5686C131.69 31.5686 129.834 29.5786 129.834 27.069ZM131.853 26.074H136.784C136.487 24.9158 135.596 24.292 134.348 24.292C133.145 24.292 132.21 25.0196 131.853 26.074Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M46.6991 13.9741H43.9023L43.3871 15.4001H42.5039L44.8223 9.02453H45.7883L48.0975 15.4001H47.2143L46.6991 13.9741ZM46.4599 13.2933L45.3007 10.0549L44.1415 13.2933H46.4599Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M50.4327 14.6273L51.9967 10.3585H52.8891L50.9111 15.4001H49.9359L47.9579 10.3585H48.8595L50.4327 14.6273Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M53.4922 12.8609C53.4922 12.3457 53.5964 11.8949 53.805 11.5085C54.0135 11.116 54.2987 10.8124 54.6606 10.5977C55.0286 10.3831 55.4364 10.2757 55.8842 10.2757C56.3258 10.2757 56.7091 10.3708 57.0342 10.5609C57.3592 10.7511 57.6015 10.9903 57.761 11.2785V10.3585H58.6074V15.4001H57.761V14.4617C57.5954 14.7561 57.347 15.0015 57.0158 15.1977C56.6907 15.3879 56.3104 15.4829 55.875 15.4829C55.4272 15.4829 55.0224 15.3725 54.6606 15.1517C54.2987 14.9309 54.0135 14.6212 53.805 14.2225C53.5964 13.8239 53.4922 13.37 53.4922 12.8609ZM57.761 12.8701C57.761 12.4899 57.6843 12.1587 57.531 11.8765C57.3776 11.5944 57.1691 11.3797 56.9054 11.2325C56.6478 11.0792 56.3626 11.0025 56.0498 11.0025C55.737 11.0025 55.4518 11.0761 55.1942 11.2233C54.9366 11.3705 54.7311 11.5852 54.5778 11.8673C54.4244 12.1495 54.3478 12.4807 54.3478 12.8609C54.3478 13.2473 54.4244 13.5847 54.5778 13.8729C54.7311 14.1551 54.9366 14.3728 55.1942 14.5261C55.4518 14.6733 55.737 14.7469 56.0498 14.7469C56.3626 14.7469 56.6478 14.6733 56.9054 14.5261C57.1691 14.3728 57.3776 14.1551 57.531 13.8729C57.6843 13.5847 57.761 13.2504 57.761 12.8701Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M60.2705 9.53973C60.1111 9.53973 59.9761 9.48453 59.8657 9.37413C59.7553 9.26373 59.7001 9.12879 59.7001 8.96933C59.7001 8.80986 59.7553 8.67493 59.8657 8.56453C59.9761 8.45413 60.1111 8.39893 60.2705 8.39893C60.4239 8.39893 60.5527 8.45413 60.6569 8.56453C60.7673 8.67493 60.8225 8.80986 60.8225 8.96933C60.8225 9.12879 60.7673 9.26373 60.6569 9.37413C60.5527 9.48453 60.4239 9.53973 60.2705 9.53973ZM60.6753 10.3585V15.4001H59.8381V10.3585H60.6753Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M62.7554 8.59213V15.4001H61.9182V8.59213H62.7554Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M63.8695 12.8609C63.8695 12.3457 63.9737 11.8949 64.1823 11.5085C64.3908 11.116 64.676 10.8124 65.0379 10.5977C65.4059 10.3831 65.8137 10.2757 66.2615 10.2757C66.7031 10.2757 67.0864 10.3708 67.4115 10.5609C67.7365 10.7511 67.9788 10.9903 68.1383 11.2785V10.3585H68.9847V15.4001H68.1383V14.4617C67.9727 14.7561 67.7243 15.0015 67.3931 15.1977C67.068 15.3879 66.6877 15.4829 66.2523 15.4829C65.8045 15.4829 65.3997 15.3725 65.0379 15.1517C64.676 14.9309 64.3908 14.6212 64.1823 14.2225C63.9737 13.8239 63.8695 13.37 63.8695 12.8609ZM68.1383 12.8701C68.1383 12.4899 68.0616 12.1587 67.9083 11.8765C67.7549 11.5944 67.5464 11.3797 67.2827 11.2325C67.0251 11.0792 66.7399 11.0025 66.4271 11.0025C66.1143 11.0025 65.8291 11.0761 65.5715 11.2233C65.3139 11.3705 65.1084 11.5852 64.9551 11.8673C64.8017 12.1495 64.7251 12.4807 64.7251 12.8609C64.7251 13.2473 64.8017 13.5847 64.9551 13.8729C65.1084 14.1551 65.3139 14.3728 65.5715 14.5261C65.8291 14.6733 66.1143 14.7469 66.4271 14.7469C66.7399 14.7469 67.0251 14.6733 67.2827 14.5261C67.5464 14.3728 67.7549 14.1551 67.9083 13.8729C68.0616 13.5847 68.1383 13.2504 68.1383 12.8701Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M71.3287 11.2969C71.5004 10.9964 71.7519 10.7511 72.0831 10.5609C72.4143 10.3708 72.7915 10.2757 73.2147 10.2757C73.6685 10.2757 74.0764 10.3831 74.4383 10.5977C74.8001 10.8124 75.0853 11.116 75.2939 11.5085C75.5024 11.8949 75.6067 12.3457 75.6067 12.8609C75.6067 13.37 75.5024 13.8239 75.2939 14.2225C75.0853 14.6212 74.7971 14.9309 74.4291 15.1517C74.0672 15.3725 73.6624 15.4829 73.2147 15.4829C72.7792 15.4829 72.3959 15.3879 72.0647 15.1977C71.7396 15.0076 71.4943 14.7653 71.3287 14.4709V15.4001H70.4915V8.59213H71.3287V11.2969ZM74.7511 12.8609C74.7511 12.4807 74.6744 12.1495 74.5211 11.8673C74.3677 11.5852 74.1592 11.3705 73.8955 11.2233C73.6379 11.0761 73.3527 11.0025 73.0399 11.0025C72.7332 11.0025 72.448 11.0792 72.1843 11.2325C71.9267 11.3797 71.7181 11.5975 71.5587 11.8857C71.4053 12.1679 71.3287 12.496 71.3287 12.8701C71.3287 13.2504 71.4053 13.5847 71.5587 13.8729C71.7181 14.1551 71.9267 14.3728 72.1843 14.5261C72.448 14.6733 72.7332 14.7469 73.0399 14.7469C73.3527 14.7469 73.6379 14.6733 73.8955 14.5261C74.1592 14.3728 74.3677 14.1551 74.5211 13.8729C74.6744 13.5847 74.7511 13.2473 74.7511 12.8609Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M77.5458 8.59213V15.4001H76.7086V8.59213H77.5458Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M83.6647 12.6861C83.6647 12.8456 83.6555 13.0143 83.6371 13.1921H79.6075C79.6382 13.6889 79.8068 14.0784 80.1135 14.3605C80.4263 14.6365 80.8035 14.7745 81.2451 14.7745C81.607 14.7745 81.9075 14.6917 82.1467 14.5261C82.392 14.3544 82.5638 14.1275 82.6619 13.8453H83.5635C83.4286 14.3299 83.1587 14.7255 82.7539 15.0321C82.3491 15.3327 81.8462 15.4829 81.2451 15.4829C80.7667 15.4829 80.3374 15.3756 79.9571 15.1609C79.583 14.9463 79.2886 14.6427 79.0739 14.2501C78.8592 13.8515 78.7519 13.3915 78.7519 12.8701C78.7519 12.3488 78.8562 11.8919 79.0647 11.4993C79.2732 11.1068 79.5646 10.8063 79.9387 10.5977C80.319 10.3831 80.7544 10.2757 81.2451 10.2757C81.7235 10.2757 82.1467 10.38 82.5147 10.5885C82.8827 10.7971 83.1648 11.0853 83.3611 11.4533C83.5635 11.8152 83.6647 12.2261 83.6647 12.6861ZM82.7999 12.5113C82.7999 12.1924 82.7294 11.9195 82.5883 11.6925C82.4472 11.4595 82.254 11.2847 82.0087 11.1681C81.7695 11.0455 81.5027 10.9841 81.2083 10.9841C80.7851 10.9841 80.4232 11.1191 80.1227 11.3889C79.8283 11.6588 79.6596 12.0329 79.6167 12.5113H82.7999Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M89.6053 15.4829C89.133 15.4829 88.7037 15.3756 88.3173 15.1609C87.937 14.9463 87.6365 14.6427 87.4157 14.2501C87.201 13.8515 87.0937 13.3915 87.0937 12.8701C87.0937 12.3549 87.2041 11.9011 87.4249 11.5085C87.6518 11.1099 87.9585 10.8063 88.3449 10.5977C88.7313 10.3831 89.1637 10.2757 89.6421 10.2757C90.1205 10.2757 90.5529 10.3831 90.9393 10.5977C91.3257 10.8063 91.6293 11.1068 91.8501 11.4993C92.077 11.8919 92.1905 12.3488 92.1905 12.8701C92.1905 13.3915 92.074 13.8515 91.8409 14.2501C91.614 14.6427 91.3042 14.9463 90.9117 15.1609C90.5192 15.3756 90.0837 15.4829 89.6053 15.4829ZM89.6053 14.7469C89.9058 14.7469 90.188 14.6764 90.4517 14.5353C90.7155 14.3943 90.9271 14.1827 91.0865 13.9005C91.2521 13.6184 91.3349 13.2749 91.3349 12.8701C91.3349 12.4653 91.2552 12.1219 91.0957 11.8397C90.9363 11.5576 90.7277 11.3491 90.4701 11.2141C90.2125 11.0731 89.9334 11.0025 89.6329 11.0025C89.3262 11.0025 89.0441 11.0731 88.7865 11.2141C88.5351 11.3491 88.3326 11.5576 88.1793 11.8397C88.026 12.1219 87.9493 12.4653 87.9493 12.8701C87.9493 13.2811 88.0229 13.6276 88.1701 13.9097C88.3234 14.1919 88.5259 14.4035 88.7773 14.5445C89.0288 14.6795 89.3048 14.7469 89.6053 14.7469Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M95.9317 10.2665C96.545 10.2665 97.0418 10.4536 97.4221 10.8277C97.8024 11.1957 97.9925 11.7293 97.9925 12.4285V15.4001H97.1645V12.5481C97.1645 12.0452 97.0387 11.6619 96.7873 11.3981C96.5358 11.1283 96.1924 10.9933 95.7569 10.9933C95.3153 10.9933 94.9626 11.1313 94.6989 11.4073C94.4413 11.6833 94.3125 12.0851 94.3125 12.6125V15.4001H93.4753V10.3585H94.3125V11.0761C94.4781 10.8185 94.702 10.6192 94.9841 10.4781C95.2724 10.3371 95.5882 10.2665 95.9317 10.2665Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.2763 14.6655C9 15.8164 9 17.2109 9 20C9 22.7891 9 24.1836 9.2763 25.3345C10.1541 28.9909 13.0091 31.8459 16.6655 32.7237C17.8164 33 19.2109 33 22 33C24.7891 33 26.1836 33 27.3345 32.7237C30.9909 31.8459 33.8459 28.9909 34.7237 25.3345C35 24.1836 35 22.7891 35 20C35 17.2109 35 15.8164 34.7237 14.6655C33.8459 11.0091 30.9909 8.15415 27.3345 7.2763C26.1836 7 24.7891 7 22 7C19.2109 7 17.8164 7 16.6655 7.2763C13.0091 8.15415 10.1541 11.0091 9.2763 14.6655ZM25.738 16.3341L25.7914 16.5695H28.8609L28.0334 24.2828C27.8677 25.8515 26.5446 27.0421 24.9669 27.0421H19.0326C17.4549 27.0421 16.1318 25.8515 15.966 24.2826L15.1387 16.5695H18.2081L18.2617 16.3341C18.2617 14.2733 19.9385 12.5968 21.9997 12.5968C24.0609 12.5968 25.738 14.2733 25.738 16.3341ZM19.8934 16.3341L19.8331 16.5695H24.1664L24.1063 16.3341C24.1063 15.1729 23.1613 14.2281 21.9997 14.2281C20.8383 14.2281 19.8934 15.1729 19.8934 16.3341Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ t("rect", { x: "0.5", y: "0.5", width: "146", height: "39", rx: "6.75", stroke: "white" })
    ]
  }
), k1 = {
  Apple: {
    Black: {
      Large: /* @__PURE__ */ t($7, {}),
      Medium: /* @__PURE__ */ t(E7, {})
    },
    Brand: {
      Large: /* @__PURE__ */ t(W7, {}),
      Medium: /* @__PURE__ */ t(U7, {})
    },
    White: {
      Large: /* @__PURE__ */ t(O7, {}),
      Medium: /* @__PURE__ */ t(q7, {})
    }
  },
  Google: {
    Black: {
      Large: /* @__PURE__ */ t(D7, {}),
      Medium: /* @__PURE__ */ t(T7, {})
    },
    Brand: {
      Large: /* @__PURE__ */ t(G7, {}),
      Medium: /* @__PURE__ */ t(j7, {})
    },
    White: {
      Large: /* @__PURE__ */ t(N7, {}),
      Medium: /* @__PURE__ */ t(S7, {})
    }
  },
  Samsung: {
    Black: {
      Large: /* @__PURE__ */ t(Q7, {}),
      Medium: /* @__PURE__ */ t(C4, {})
    },
    Brand: {
      Large: /* @__PURE__ */ t(t4, {}),
      Medium: /* @__PURE__ */ t(e4, {})
    },
    White: {
      Large: /* @__PURE__ */ t(i4, {}),
      Medium: /* @__PURE__ */ t(l4, {})
    }
  },
  Huawei: {
    Black: {
      Large: /* @__PURE__ */ t(z7, {}),
      Medium: /* @__PURE__ */ t(P7, {})
    },
    Brand: {
      Large: /* @__PURE__ */ t(Y7, {}),
      Medium: /* @__PURE__ */ t(J7, {})
    },
    White: {
      Large: /* @__PURE__ */ t(K7, {}),
      Medium: /* @__PURE__ */ t(X7, {})
    }
  }
}, r4 = ({
  element: C,
  wuiltContext: e
}) => {
  var o, r;
  const i = C == null ? void 0 : C.settings, n = (o = e == null ? void 0 : e.base) == null ? void 0 : o.Link;
  return /* @__PURE__ */ t(Q1, { children: (r = i == null ? void 0 : i.appStoreButtons) == null ? void 0 : r.map((l, h) => {
    var H, V, p, a, L, s;
    return /* @__PURE__ */ t(
      n,
      {
        href: (H = l == null ? void 0 : l.action) == null ? void 0 : H.value,
        target: (V = l == null ? void 0 : l.action) != null && V.newTab ? "_blank" : void 0,
        style: { marginInlineEnd: "15px" },
        children: (s = k1 == null ? void 0 : k1[(p = l == null ? void 0 : l.action) == null ? void 0 : p.type]) == null ? void 0 : s[(a = i == null ? void 0 : i.design) == null ? void 0 : a.style][(L = i == null ? void 0 : i.design) == null ? void 0 : L.size]
      },
      h
    );
  }) });
};
function j() {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t("g", { clipPath: "url(#clip0_4357_22783)", children: /* @__PURE__ */ t(
          "path",
          {
            d: "M7.9987 5.33337V8.00004M7.9987 10.6667H8.00536M14.6654 8.00004C14.6654 11.6819 11.6806 14.6667 7.9987 14.6667C4.3168 14.6667 1.33203 11.6819 1.33203 8.00004C1.33203 4.31814 4.3168 1.33337 7.9987 1.33337C11.6806 1.33337 14.6654 4.31814 14.6654 8.00004Z",
            stroke: "#F04438",
            strokeWidth: "1.33333",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ) }),
        /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "clip0_4357_22783", children: /* @__PURE__ */ t("rect", { width: "16", height: "16", fill: "white" }) }) })
      ]
    }
  );
}
const h4 = "_desktop_i9ate_1", n4 = "_tablet_i9ate_10", o4 = "_mobile_i9ate_19", H4 = "_oldStyles_i9ate_28", a4 = "_generalInputWrapper_i9ate_37", p4 = "_error_i9ate_112", g1 = {
  desktop: h4,
  tablet: n4,
  mobile: o4,
  oldStyles: H4,
  generalInputWrapper: a4,
  error: p4
}, Q = ({
  children: C,
  isError: e,
  customClassNames: i,
  wuiltContext: n
}) => {
  var r;
  const o = (r = n == null ? void 0 : n.props) == null ? void 0 : r.theme;
  return /* @__PURE__ */ t(
    "div",
    {
      id: "general-text",
      className: T(
        o ? "general-input-wrapper-view" : g1.oldStyles,
        {
          [g1.generalInputWrapper]: !i,
          [g1.error]: e,
          [i == null ? void 0 : i.fieldContainerClass]: !!i
        }
      ),
      children: C
    }
  );
}, V4 = ({
  registerProps: C,
  isError: e,
  fieldSettings: i,
  id: n,
  customClassNames: o,
  text: r,
  wuiltContext: l
}) => {
  var h;
  return /* @__PURE__ */ c(
    Q,
    {
      isError: e,
      customClassNames: o,
      wuiltContext: l,
      children: [
        /* @__PURE__ */ t(
          "input",
          Z(d({
            id: n,
            className: o == null ? void 0 : o.textClass,
            placeholder: r[(h = i == null ? void 0 : i.placeholder) == null ? void 0 : h.textId],
            min: i == null ? void 0 : i.min,
            max: i == null ? void 0 : i.max,
            minLength: i == null ? void 0 : i.minLength,
            maxLength: i == null ? void 0 : i.maxLength
          }, C), {
            autoComplete: i == null ? void 0 : i.autoComplete
          })
        ),
        e && /* @__PURE__ */ t(j, {})
      ]
    }
  );
}, c4 = ({
  registerProps: C,
  isError: e,
  fieldSettings: i,
  id: n,
  customClassNames: o,
  text: r,
  wuiltContext: l
}) => {
  var h;
  return /* @__PURE__ */ c(
    Q,
    {
      isError: e,
      customClassNames: o,
      wuiltContext: l,
      children: [
        /* @__PURE__ */ t(
          "textarea",
          Z(d({
            id: n,
            className: o == null ? void 0 : o.textareaClass,
            placeholder: r[(h = i == null ? void 0 : i.placeholder) == null ? void 0 : h.textId],
            minLength: i == null ? void 0 : i.minLength,
            maxLength: i == null ? void 0 : i.maxLength
          }, C), {
            autoComplete: i == null ? void 0 : i.autoComplete
          })
        ),
        e && /* @__PURE__ */ t(j, {})
      ]
    }
  );
}, l1 = ({
  isError: C,
  useFormProps: e,
  field: i,
  customClassNames: n,
  text: o,
  wuiltContext: r
}) => {
  const { min: l, max: h, minLength: H, maxLength: V } = (i == null ? void 0 : i.settings) || {}, p = (i == null ? void 0 : i.type) === g.TextArea ? c4 : V4;
  return /* @__PURE__ */ t(
    p,
    {
      id: i == null ? void 0 : i.id,
      isError: C,
      fieldSettings: (i == null ? void 0 : i.settings) || {},
      customClassNames: n,
      text: o,
      wuiltContext: r,
      registerProps: d({}, e == null ? void 0 : e.register(i == null ? void 0 : i.id, {
        max: h,
        min: l,
        maxLength: V,
        minLength: H
      }))
    }
  );
}, d4 = "_description_n50b4_1", s4 = "_error_n50b4_10", z1 = {
  description: d4,
  error: s4
}, L4 = ({ description: C, isError: e }) => C ? /* @__PURE__ */ t(
  "div",
  {
    id: "general-text",
    className: T("general-input-label", z1.description),
    children: /* @__PURE__ */ t(
      "p",
      {
        className: e ? z1.error : void 0,
        dangerouslySetInnerHTML: { __html: C != null ? C : "" }
      }
    )
  }
) : null, M4 = "_error_14vxa_1", Z4 = {
  error: M4
}, w4 = ({ error: C, errorMessage: e }) => {
  if (!C)
    return null;
  const i = () => {
    switch (C == null ? void 0 : C.type) {
      case "required":
        return "This filed is required";
      case "min":
        return "Minimum value is";
      case "max":
        return "Maximum value is";
      case "minLength":
        return "Minimum characters count is";
      case "maxLength":
        return "Maximum characters count is";
      default:
        return e || "";
    }
  };
  return /* @__PURE__ */ t("div", { id: "general-text", className: Z4.error, children: i() });
}, f4 = "_label_165vs_1", u4 = "_error_165vs_7", P1 = {
  label: f4,
  error: u4
}, k4 = ({ label: C, htmlFor: e, isError: i }) => C ? /* @__PURE__ */ t(
  "label",
  {
    id: "general-text",
    className: T("general-input-label", P1.label),
    htmlFor: e,
    children: /* @__PURE__ */ t(
      "div",
      {
        className: i ? P1.error : void 0,
        dangerouslySetInnerHTML: { __html: C != null ? C : "" }
      }
    )
  }
) : null;
function g4({ color: C = "" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4 0C3.73478 0 3.48043 0.105357 3.29289 0.292893C3.10536 0.48043 3 0.734784 3 1V2H2C1.46957 2 0.960859 2.21071 0.585786 2.58579C0.210714 2.96086 0 3.46957 0 4V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H14C14.5304 16 15.0391 15.7893 15.4142 15.4142C15.7893 15.0391 16 14.5304 16 14V4C16 3.46957 15.7893 2.96086 15.4142 2.58579C15.0391 2.21071 14.5304 2 14 2H13V1C13 0.734784 12.8946 0.48043 12.7071 0.292893C12.5196 0.105357 12.2652 0 12 0C11.7348 0 11.4804 0.105357 11.2929 0.292893C11.1054 0.48043 11 0.734784 11 1V2H5V1C5 0.734784 4.89464 0.48043 4.70711 0.292893C4.51957 0.105357 4.26522 0 4 0ZM4 5C3.73478 5 3.48043 5.10536 3.29289 5.29289C3.10536 5.48043 3 5.73478 3 6C3 6.26522 3.10536 6.51957 3.29289 6.70711C3.48043 6.89464 3.73478 7 4 7H12C12.2652 7 12.5196 6.89464 12.7071 6.70711C12.8946 6.51957 13 6.26522 13 6C13 5.73478 12.8946 5.48043 12.7071 5.29289C12.5196 5.10536 12.2652 5 12 5H4Z",
          fill: C || "currentColor"
        }
      )
    }
  );
}
function x4({
  fieldControl: C,
  isError: e,
  fieldSettings: i,
  id: n,
  text: o,
  customClassNames: r
}) {
  return /* @__PURE__ */ c(
    "div",
    {
      className: T("general-input-wrapper-view", {
        dateContainer: !0,
        error: e,
        [r == null ? void 0 : r.dateClass]: r == null ? void 0 : r.dateClass
      }),
      children: [
        /* @__PURE__ */ t(g4, { color: "#667085" }),
        /* @__PURE__ */ t(
          s1,
          {
            control: C,
            name: n,
            render: ({ field: l }) => {
              var h;
              return /* @__PURE__ */ t(
                c3,
                {
                  dateFormat: "yyyy/MM/dd",
                  popperModifiers: [
                    {
                      name: "flip",
                      enabled: !1
                    }
                  ],
                  showPopperArrow: !1,
                  onChange: (H) => l.onChange(H),
                  placeholderText: o[(h = i == null ? void 0 : i.placeholder) == null ? void 0 : h.textId],
                  selected: l == null ? void 0 : l.value,
                  popperPlacement: "auto",
                  calendarClassName: T({
                    calenderStyle: !0
                  })
                }
              );
            }
          }
        ),
        /* @__PURE__ */ t("div", { children: e && /* @__PURE__ */ t(j, {}) })
      ]
    }
  );
}
const v4 = ({
  isError: C,
  useFormProps: e,
  field: i,
  text: n,
  customClassNames: o
}) => /* @__PURE__ */ t(
  x4,
  {
    id: i == null ? void 0 : i.id,
    isError: C,
    customClassNames: o,
    fieldSettings: (i == null ? void 0 : i.settings) || {},
    fieldControl: e.control,
    registerProps: d({}, e == null ? void 0 : e.register(i == null ? void 0 : i.id, {})),
    text: n
  }
), _4 = "_checkboxWrapper_f4rll_1", b4 = "_checkboxInput_f4rll_5", Y1 = {
  checkboxWrapper: _4,
  checkboxInput: b4
}, m4 = ({
  registerProps: C,
  isError: e,
  fieldSettings: i,
  selectedOptions: n,
  customClassNames: o,
  text: r
}) => {
  var p, a, L;
  const l = ((p = i == null ? void 0 : i.selections) == null ? void 0 : p.type) === m1.Limited, h = i == null ? void 0 : i.isMultipleSelection, H = (a = i == null ? void 0 : i.selections) == null ? void 0 : a.selectionsCount, V = (n == null ? void 0 : n.length) || 0;
  return /* @__PURE__ */ c("div", { className: Y1.checkboxWrapper, children: [
    (L = i == null ? void 0 : i.options) == null ? void 0 : L.map((s) => {
      var f;
      const u = n ? n == null ? void 0 : n.includes(s == null ? void 0 : s.id) : !1, w = h ? l && !u && V === H : !u && V > 0;
      return /* @__PURE__ */ c("div", { className: Y1.checkboxInput, children: [
        /* @__PURE__ */ t(
          "input",
          Z(d({
            id: s == null ? void 0 : s.id,
            className: o == null ? void 0 : o.selectBoxClass,
            value: s == null ? void 0 : s.id,
            type: "checkbox"
          }, C), {
            disabled: w
          })
        ),
        /* @__PURE__ */ t(
          "label",
          {
            htmlFor: s == null ? void 0 : s.id,
            id: "general-text",
            style: { cursor: "pointer" },
            className: "general-input-label",
            children: r[(f = s == null ? void 0 : s.label) == null ? void 0 : f.textId]
          }
        )
      ] }, s == null ? void 0 : s.id);
    }),
    e && /* @__PURE__ */ t(j, {})
  ] });
}, y4 = "_radioWrapper_6fjy4_1", B4 = "_radioInput_6fjy4_5", J1 = {
  radioWrapper: y4,
  radioInput: B4
}, F4 = ({
  registerProps: C,
  isError: e,
  fieldSettings: i,
  text: n,
  customClassNames: o
}) => {
  var r;
  return /* @__PURE__ */ c("div", { className: J1.radioWrapper, children: [
    (r = i == null ? void 0 : i.options) == null ? void 0 : r.map((l) => {
      var h, H;
      return /* @__PURE__ */ c("div", { className: `${J1.radioInput}`, children: [
        /* @__PURE__ */ t(
          "input",
          d({
            id: l == null ? void 0 : l.id,
            className: o == null ? void 0 : o.radioClass,
            value: n[(h = l == null ? void 0 : l.label) == null ? void 0 : h.textId],
            type: "radio"
          }, C)
        ),
        /* @__PURE__ */ t(
          "label",
          {
            htmlFor: l == null ? void 0 : l.id,
            id: "general-text",
            style: { cursor: "pointer" },
            className: "general-input-label",
            children: n[(H = l == null ? void 0 : l.label) == null ? void 0 : H.textId]
          }
        )
      ] }, l == null ? void 0 : l.id);
    }),
    e && /* @__PURE__ */ t(j, {})
  ] });
}, I4 = ({
  registerProps: C,
  isError: e,
  fieldSettings: i,
  selectedOptions: n,
  control: o,
  customClassNames: r,
  text: l
}) => {
  var L, s, u;
  const h = ((L = i == null ? void 0 : i.selections) == null ? void 0 : L.type) === m1.Limited, H = i == null ? void 0 : i.isMultipleSelection, V = (n == null ? void 0 : n.length) || 0, p = V === ((s = i == null ? void 0 : i.selections) == null ? void 0 : s.selectionsCount), a = (u = i == null ? void 0 : i.options) == null ? void 0 : u.map((w) => {
    var f;
    return {
      value: w == null ? void 0 : w.id,
      label: l[(f = w == null ? void 0 : w.label) == null ? void 0 : f.textId]
    };
  });
  return /* @__PURE__ */ c(
    "div",
    {
      className: r == null ? void 0 : r.selectBoxClass,
      style: { marginBottom: `${V > 0 ? "30px" : "0px"}` },
      children: [
        /* @__PURE__ */ t(
          s1,
          {
            control: o,
            name: C == null ? void 0 : C.name,
            render: ({ field: w }) => {
              var f;
              return /* @__PURE__ */ t(
                d3,
                Z(d({}, w), {
                  styles: R4(V, e),
                  options: a,
                  isMulti: H,
                  isClearable: !(i != null && i.required),
                  isOptionDisabled: () => H && h && p,
                  placeholder: l[(f = i == null ? void 0 : i.placeholder) == null ? void 0 : f.textId],
                  classNamePrefix: "select",
                  menuPortalTarget: typeof document == "undefined" || document == null ? void 0 : document.body
                })
              );
            }
          }
        ),
        e && /* @__PURE__ */ t(j, {})
      ]
    }
  );
}, R4 = (C, e) => ({
  control: (i) => Z(d({}, i), {
    border: ` ${e ? "1px solid #FDA29B !important" : "1px solid #D0D5DD"}  `,
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "6px",
    "&:hover": {
      border: ` ${e ? "1px solid #FDA29B" : "1px solid #D0D5DD"}  `
    }
  }),
  multiValue: (i) => Z(d({}, i), {
    padding: "2px 6px 2px 8px",
    background: "#F2F4F7",
    borderRadius: "16px"
  }),
  valueContainer: (i) => Z(d({}, i), {
    top: `${C > 0 ? "45px" : "0px"}`,
    padding: `${C > 0 ? "0px" : "2px 8px"}`
  }),
  multiValueRemove: () => ({
    color: "#667085",
    cursor: "pointer"
  }),
  indicatorSeparator: () => ({
    display: "none"
  }),
  indicatorsContainer: (i) => Z(d({}, i), {
    cursor: "pointer"
  }),
  menuPortal: (i) => Z(d({}, i), {
    zIndex: 9
  })
}), x1 = ({
  isError: C,
  useFormProps: e,
  field: i,
  customClassNames: n,
  text: o
}) => {
  const r = p3({
    control: e == null ? void 0 : e.control,
    name: i == null ? void 0 : i.id
  });
  return (i == null ? void 0 : i.type) === g.Checkbox ? /* @__PURE__ */ t(
    m4,
    {
      customClassNames: n,
      isError: C,
      fieldSettings: (i == null ? void 0 : i.settings) || {},
      registerProps: d({}, e == null ? void 0 : e.register(i == null ? void 0 : i.id)),
      selectedOptions: r,
      text: o
    }
  ) : (i == null ? void 0 : i.type) === g.Radio ? /* @__PURE__ */ t(
    F4,
    {
      isError: C,
      customClassNames: n,
      fieldSettings: (i == null ? void 0 : i.settings) || {},
      registerProps: d({}, e == null ? void 0 : e.register(i == null ? void 0 : i.id)),
      text: o
    }
  ) : (i == null ? void 0 : i.type) === g.Select ? /* @__PURE__ */ t(
    I4,
    {
      isError: C,
      customClassNames: n,
      fieldSettings: (i == null ? void 0 : i.settings) || {},
      selectedOptions: r,
      registerProps: d({}, e == null ? void 0 : e.register(i == null ? void 0 : i.id)),
      control: e == null ? void 0 : e.control,
      text: o
    }
  ) : null;
}, A4 = "_timeInputContainer_12833_1", $4 = "_hours_12833_7", E4 = "_minutes_12833_8", W4 = "_selectPmAm_12833_16", c1 = {
  timeInputContainer: A4,
  hours: $4,
  minutes: E4,
  selectPmAm: W4
}, U4 = ({
  id: C,
  value: e,
  isError: i,
  customClassNames: n,
  onChange: o,
  wuiltContext: r
}) => {
  const l = e == null ? void 0 : e.split(":")[0].toString(), h = e == null ? void 0 : e.split(":")[1].split(" ")[0], H = (e == null ? void 0 : e.split(" ")[1]) || "AM";
  return /* @__PURE__ */ c(
    "div",
    {
      className: `${n == null ? void 0 : n.timeClass} ${c1.timeInputContainer}`,
      children: [
        /* @__PURE__ */ c(Q, { isError: i, wuiltContext: r, children: [
          /* @__PURE__ */ t(
            "input",
            {
              className: c1.hours,
              id: C,
              type: "number",
              min: 0,
              max: 12,
              placeholder: "HH",
              value: l,
              onChange: (V) => {
                var a;
                let p = +((a = V == null ? void 0 : V.target) == null ? void 0 : a.value);
                p = Math.min(+p, 12), p = Math.max(+p, 0), o == null || o(
                  `${p.toString().padStart(2, "0")}:${h || "00"} ${H}`
                );
              }
            }
          ),
          i && /* @__PURE__ */ t(j, {})
        ] }),
        /* @__PURE__ */ c(Q, { isError: i, wuiltContext: r, children: [
          /* @__PURE__ */ t(
            "input",
            {
              type: "number",
              className: c1.minutes,
              min: 0,
              max: 59,
              placeholder: "MM",
              value: h,
              onChange: (V) => {
                var a;
                let p = +((a = V == null ? void 0 : V.target) == null ? void 0 : a.value);
                p = Math.min(+p, 59), p = Math.max(+p, 0), o == null || o(
                  `${l || "00"}:${p.toString().padStart(2, "0")} ${H}`
                );
              }
            }
          ),
          i && /* @__PURE__ */ t(j, {})
        ] }),
        /* @__PURE__ */ t(Q, { isError: i, wuiltContext: r, children: /* @__PURE__ */ c(
          "select",
          {
            className: c1.selectPmAm,
            value: H,
            onChange: (V) => {
              var a;
              const p = (a = V == null ? void 0 : V.target) == null ? void 0 : a.value;
              o == null || o(`${l}:${h} ${p}`);
            },
            children: [
              /* @__PURE__ */ t("option", { value: "AM", children: "AM" }),
              /* @__PURE__ */ t("option", { value: "PM", children: "PM" })
            ]
          }
        ) })
      ]
    }
  );
}, O4 = ({
  isError: C,
  customClassNames: e,
  useFormProps: i,
  field: n,
  wuiltContext: o
}) => /* @__PURE__ */ t(
  s1,
  {
    control: i == null ? void 0 : i.control,
    name: n == null ? void 0 : n.id,
    render: (h) => {
      var { field: H } = h, V = H, { ref: r } = V, l = w1(V, ["ref"]);
      return /* @__PURE__ */ t(
        U4,
        Z(d({
          customClassNames: e,
          isError: C
        }, l), {
          wuiltContext: o
        })
      );
    }
  }
), q4 = "_fileUploadContainer_17g2u_1", D4 = "_NoFileSelectedText_17g2u_15", T4 = "_fileName_17g2u_21", G4 = "_fileUploadInput_17g2u_25", j4 = "_fileUploadButton_17g2u_28", N4 = "_inputContainer_17g2u_45", S4 = "_error_17g2u_50", S = {
  fileUploadContainer: q4,
  NoFileSelectedText: D4,
  fileName: T4,
  fileUploadInput: G4,
  fileUploadButton: j4,
  inputContainer: N4,
  error: S4
};
function z4({ color: C = "" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      width: "16px",
      height: "16px",
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: C || "currentColor",
          d: "M10 2 9 3H4v2h16V3h-5l-1-1h-4zM5 7v13c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V7H5zm3 2h2v11H8V9zm6 0h2v11h-2V9z"
        }
      )
    }
  );
}
function P4({ color: C = "" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M17.5 12.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V12.5M14.1667 6.66667L10 2.5M10 2.5L5.83333 6.66667M10 2.5V12.5",
          stroke: C || "currentColor",
          strokeWidth: "1.66667",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
const Y4 = "_loader_q39p5_1", J4 = "_spin_q39p5_1", K4 = {
  loader: Y4,
  spin: J4
};
function X4() {
  return /* @__PURE__ */ t("div", { className: K4.loader });
}
const Q4 = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;
_.addMethod(_.string, "phone", function() {
  return this.test("phone", "Phone number is not valid", (C) => C ? Q4.test(C) : !0);
});
_.addMethod(_.string, "requiredWhen", function(C) {
  return this.test(
    "requiredWhen",
    "This field is required",
    (e) => {
      var i;
      return C ? !!((i = e == null ? void 0 : e.trim) != null && i.call(e)) : !0;
    }
  );
});
_.addMethod(_.string, "time", function() {
  return this.test("time", "number is required", (C) => !(C != null && C.includes("undefined")));
});
_.addMethod(_.array, "requiredArray", function(C) {
  return this.test("requiredArray", "Array is empty", (e) => C ? (e == null ? void 0 : e.length) > 0 : !0);
});
const C5 = (C) => {
  const { required: e, isMultipleSelection: i } = C, n = _.object().shape({
    label: _.string().requiredWhen(e),
    value: _.string().requiredWhen(e)
  }), o = e && _.array().requiredArray(e), r = i ? _.array(n).requiredArray(e) : n;
  return {
    [g.Text]: _.string().requiredWhen(e),
    [g.Link]: _.string().url().requiredWhen(e),
    [g.Email]: _.string().email().requiredWhen(e),
    [g.TextArea]: _.string().requiredWhen(e),
    [g.Phone]: _.string().phone().requiredWhen(e),
    [g.Checkbox]: o,
    [g.Select]: r,
    [g.File]: _.string().requiredWhen(e),
    [g.Radio]: _.string().requiredWhen(e),
    [g.Date]: _.string().requiredWhen(e),
    [g.Time]: _.string().time().requiredWhen(e)
  };
};
function t5(C) {
  var n;
  const e = (n = C == null ? void 0 : C.fields) == null ? void 0 : n.reduce(
    (o, r) => Z(d({}, o), {
      [r == null ? void 0 : r.id]: C5(r == null ? void 0 : r.settings)[r == null ? void 0 : r.type]
    }),
    {}
  ), i = _.object(e);
  return s3(i);
}
function e5(C) {
  const e = new Date(C), i = e.getFullYear().toString(), n = (e.getMonth() + 1).toString(), o = e.getDate().toString(), r = n.split(""), l = o.split("");
  return C ? i + "/" + (r[1] ? n : "0" + r[0]) + "/" + (l[1] ? o : "0" + l[0]) : "";
}
function i5(C, e, i) {
  var n, o, r;
  if ((C == null ? void 0 : C.type) === g.Checkbox)
    return (r = (o = (n = C == null ? void 0 : C.settings) == null ? void 0 : n.options) == null ? void 0 : o.filter((h) => {
      var H;
      return (H = e || []) == null ? void 0 : H.includes(h == null ? void 0 : h.id);
    })) == null ? void 0 : r.map((h) => {
      var H;
      return i[(H = h == null ? void 0 : h.label) == null ? void 0 : H.textId];
    });
  if ((C == null ? void 0 : C.type) === g.Date)
    return e5(e);
  if ((C == null ? void 0 : C.type) === g.Time)
    return e || "";
  if ((C == null ? void 0 : C.type) === g.Select) {
    const l = e ? Array.isArray(e) ? e : [e] : [];
    return l == null ? void 0 : l.map((H) => H == null ? void 0 : H.label);
  }
  return e || "";
}
function l5(C, e, i) {
  var o;
  return (o = C == null ? void 0 : C.fields) == null ? void 0 : o.map((r) => {
    var H, V, p, a, L;
    const l = e[r == null ? void 0 : r.id], h = i5(r, l, i);
    return {
      type: r == null ? void 0 : r.type,
      required: !!((H = r == null ? void 0 : r.settings) != null && H.required),
      value: h,
      field_name: i[(p = (V = r == null ? void 0 : r.settings) == null ? void 0 : V.label) == null ? void 0 : p.textId] || i[(L = (a = r == null ? void 0 : r.settings) == null ? void 0 : a.placeholder) == null ? void 0 : L.textId] || ""
    };
  });
}
function r5(C, e) {
  var V, p, a, L, s;
  const i = (V = C == null ? void 0 : C.formPostSubmit) == null ? void 0 : V.submitType, n = (p = C == null ? void 0 : C.formPostSubmit) == null ? void 0 : p.redirectType, r = ((a = C == null ? void 0 : C.formPostSubmit) == null ? void 0 : a.newTab) ? "_blank" : "_self", l = t2 || a3 ? "_self" : r, h = (L = C == null ? void 0 : C.formPostSubmit) == null ? void 0 : L.externalLink, H = (s = C == null ? void 0 : C.formPostSubmit) == null ? void 0 : s.internalLink;
  if (typeof window != "undefined" && i === b1.Redirect && (n === O.External_Link && h && window.open(h, l), n === O.Internal_Link && H)) {
    if (!e)
      return;
    e.pushPage(H);
  }
}
function h5(C, e, i, n, o, r, l, h, H) {
  return p1(this, null, function* () {
    const V = new FormData();
    V.append("file", e), V.append("field_id", i.split(":")[1]), r && V.append("row_id", r.split(":")[1]), l && V.append("col_id", l.split(":")[1]), V.append("section_value_id", h), H && V.append("element_id", H.split(":")[1]);
    const p = yield fetch(C(n, o), {
      method: "POST",
      body: V
    });
    return p.status === 429 && alert(
      "You have reached the limit of uploading files, Please try again later after 24 hours."
    ), yield p.json();
  });
}
const H2 = n3((C, e) => {
  var W, k;
  const {
    id: i,
    isError: n,
    formId: o,
    fieldSettings: r,
    sectionId: l,
    rowId: h,
    formSubmitSucceeded: H,
    columnId: V,
    sectionValueId: p,
    customClassNames: a,
    onChange: L,
    uploadFileUrl: s,
    text: u,
    elementId: w,
    wuiltContext: f
  } = C, v = J(null), [I, x] = z(!1), [b, A] = z(null), [F, y] = z(!1), R = r.allowSpecificFileTypes ? `${r.allowedExtensions}` : "", B = r == null ? void 0 : r.allowedExtensions, q = (N) => p1(void 0, null, function* () {
    var t1, e1, Y, i1, E1;
    if (y(!1), !s || !((t1 = N.target.files) != null && t1[0]) || !i || !o || !l || !p)
      return;
    const G = N.target.files[0], o1 = G.size / 1024 / 1024, C1 = G.name.split(".").pop(), K = (e1 = f == null ? void 0 : f.props) == null ? void 0 : e1.site, P = (Y = K == null ? void 0 : K.plan) == null ? void 0 : Y.id, H1 = P === 16 || P === 19 ? 10 : P === 17 || P === 20 ? 100 : 25;
    if (x(!0), A(null), o1 < H1 && (!r.allowSpecificFileTypes || C1 && (B != null && B.includes(C1)))) {
      const X = yield h5(
        s,
        (i1 = N.target.files) == null ? void 0 : i1[0],
        i,
        o,
        l,
        h,
        V,
        p,
        w
      );
      x(!1), X != null && X.uploaded_files ? (A(G), L((E1 = X == null ? void 0 : X.uploaded_files[0]) == null ? void 0 : E1.url)) : (y(!0), x(!1));
    } else
      y(!0), x(!1);
  }), E = () => {
    A(null), L(void 0), v.current.value = "";
  }, D = () => {
    v.current.click();
  };
  return n1(() => {
    H && A(null);
  }, [H]), /* @__PURE__ */ c("div", { ref: e, children: [
    /* @__PURE__ */ c(
      "div",
      {
        className: `${a == null ? void 0 : a.fileUploadClass} ${S.fileUploadContainer}`,
        children: [
          /* @__PURE__ */ c(
            Q,
            {
              isError: F || n,
              wuiltContext: f,
              children: [
                /* @__PURE__ */ c(
                  "div",
                  {
                    "aria-hidden": "true",
                    onClick: D,
                    className: S.inputContainer,
                    children: [
                      I && /* @__PURE__ */ t(X4, {}),
                      b ? /* @__PURE__ */ t("span", { className: S.fileName, children: b == null ? void 0 : b.name }) : /* @__PURE__ */ t("span", { className: S.NoFileSelectedText, children: u[(W = r == null ? void 0 : r.placeholder) == null ? void 0 : W.textId] })
                    ]
                  }
                ),
                n || F ? /* @__PURE__ */ t(j, {}) : null
              ]
            }
          ),
          b ? /* @__PURE__ */ t(
            "div",
            {
              "aria-hidden": "true",
              onClick: E,
              className: S.fileUploadButton,
              children: /* @__PURE__ */ t(z4, { color: "#D21C1C" })
            }
          ) : /* @__PURE__ */ t(
            "div",
            {
              className: S.fileUploadButton,
              "aria-hidden": "true",
              onClick: D,
              children: /* @__PURE__ */ t(P4, { color: "#475467" })
            }
          ),
          /* @__PURE__ */ t(
            "input",
            {
              id: i,
              accept: R,
              ref: v,
              type: "file",
              className: S.fileUploadInput,
              onChange: q
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ t("div", { className: S.error, children: F && !n && u[(k = r == null ? void 0 : r.errorMessage) == null ? void 0 : k.textId] })
  ] });
});
H2.displayName = "FileUploadInput";
const n5 = ({
  isError: C,
  useFormProps: e,
  field: i,
  formId: n,
  sectionId: o,
  rowId: r,
  columnId: l,
  sectionValueId: h,
  formSubmitSucceeded: H,
  customClassNames: V,
  uploadFileUrl: p,
  text: a,
  elementId: L,
  wuiltContext: s
}) => /* @__PURE__ */ t(
  s1,
  {
    control: e == null ? void 0 : e.control,
    name: i == null ? void 0 : i.id,
    render: ({ field: u }) => /* @__PURE__ */ t(
      H2,
      Z(d({
        formId: n,
        sectionId: o,
        rowId: r,
        columnId: l,
        customClassNames: V,
        formSubmitSucceeded: H,
        sectionValueId: h,
        uploadFileUrl: p,
        isError: C,
        id: i == null ? void 0 : i.id,
        fieldSettings: (i == null ? void 0 : i.settings) || {}
      }, u), {
        text: a,
        elementId: L,
        wuiltContext: s
      })
    )
  }
), o5 = {
  [g.Text]: l1,
  [g.Email]: l1,
  [g.Phone]: l1,
  [g.Link]: l1,
  [g.TextArea]: l1,
  [g.Date]: v4,
  [g.Checkbox]: x1,
  [g.Radio]: x1,
  [g.Time]: O4,
  [g.Select]: x1,
  [g.File]: n5
}, H5 = ({
  field: C,
  uploadFileUrl: e,
  useFormProps: i,
  isSubmitting: n,
  formId: o,
  sectionId: r,
  rowId: l,
  columnId: h,
  sectionValueId: H,
  formSubmitSucceeded: V,
  customClassNames: p,
  text: a,
  elementId: L,
  wuiltContext: s
}) => {
  var x, b;
  const u = (b = (x = i == null ? void 0 : i.formState) == null ? void 0 : x.errors) == null ? void 0 : b[C == null ? void 0 : C.id], { label: w, description: f, errorMessage: v } = (C == null ? void 0 : C.settings) || {}, I = o5[C.type];
  return /* @__PURE__ */ c("div", { children: [
    /* @__PURE__ */ t(
      k4,
      {
        isError: !!u,
        label: a[w == null ? void 0 : w.textId],
        htmlFor: C == null ? void 0 : C.id
      }
    ),
    /* @__PURE__ */ t(L4, { isError: !!u, description: a[f == null ? void 0 : f.textId] }),
    /* @__PURE__ */ t(
      I,
      {
        sectionId: r,
        rowId: l,
        columnId: h,
        sectionValueId: H,
        uploadFileUrl: e,
        isError: !!u,
        field: C,
        useFormProps: i,
        isSubmitting: n,
        formId: o,
        formSubmitSucceeded: V,
        customClassNames: p,
        text: a,
        elementId: L,
        wuiltContext: s
      },
      C == null ? void 0 : C.id
    ),
    /* @__PURE__ */ t(
      w4,
      {
        error: u,
        errorMessage: a[v == null ? void 0 : v.textId]
      }
    )
  ] });
};
function a5() {
  return /* @__PURE__ */ t("svg", { viewBox: "0 0 20 20", width: 20, height: 20, children: /* @__PURE__ */ t(
    "path",
    {
      fillRule: "evenodd",
      d: "m11.414 10 4.293-4.293a.999.999 0 1 0-1.414-1.414L10 8.586 5.707 4.293a.999.999 0 1 0-1.414 1.414L8.586 10l-4.293 4.293a1 1 0 0 0 1.414 1.414L10 11.414l4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z"
    }
  ) });
}
const p5 = "_feedbackMessage_qzhtz_1", V5 = "_success_qzhtz_11", c5 = "_fail_qzhtz_17", d5 = "_closeButton_qzhtz_23", d1 = {
  feedbackMessage: p5,
  success: V5,
  fail: c5,
  closeButton: d5
}, s5 = ({
  success: C,
  failure: e,
  formSettings: i,
  resetForm: n,
  text: o
}) => {
  var H, V, p;
  const r = (H = i == null ? void 0 : i.formPostSubmit) == null ? void 0 : H.successMessage, l = (V = i == null ? void 0 : i.formPostSubmit) == null ? void 0 : V.failureMessage, h = (p = i == null ? void 0 : i.formPostSubmit) == null ? void 0 : p.submitType;
  return !C && !e || C && !o[r == null ? void 0 : r.textId] || e && !o[l == null ? void 0 : l.textId] || h !== b1.Message ? null : /* @__PURE__ */ c(
    "div",
    {
      className: T({
        [d1.feedbackMessage]: !0,
        [d1.success]: C,
        [d1.fail]: e
      }),
      children: [
        /* @__PURE__ */ t("div", { children: C ? o[r == null ? void 0 : r.textId] : o[l == null ? void 0 : l.textId] }),
        /* @__PURE__ */ t("button", { className: d1.closeButton, onClick: n, children: /* @__PURE__ */ t(a5, {}) })
      ]
    }
  );
}, L5 = {
  "lds-ring": "_lds-ring_fe9qv_1"
};
function M5() {
  return /* @__PURE__ */ c("div", { className: L5["lds-ring"], children: [
    /* @__PURE__ */ t("div", {}),
    /* @__PURE__ */ t("div", {}),
    /* @__PURE__ */ t("div", {}),
    /* @__PURE__ */ t("div", {})
  ] });
}
const Z5 = "_FormFieldsContainer_mq3sp_1", w5 = {
  FormFieldsContainer: Z5
}, f5 = ({
  element: C,
  wuiltContext: e,
  sectionId: i,
  rowId: n,
  columnId: o,
  sectionValueId: r,
  customClassNames: l,
  text: h
}) => {
  var R, B, q;
  const H = e == null ? void 0 : e.base, V = (R = H == null ? void 0 : H.useRouter) == null ? void 0 : R.call(H), p = e == null ? void 0 : e.props, a = C == null ? void 0 : C.settings, [L, s] = z(!1), [u, w] = z(!1), f = V3({ resolver: t5(a) }), { isSubmitting: v, isSubmitSuccessful: I, isSubmitted: x, isValid: b } = f.formState, A = (E) => p1(void 0, null, function* () {
    var W;
    s(!1), w(!1);
    const D = l5(a, E, h);
    if (p != null && p.getFormSubmitUrl)
      try {
        const k = yield fetch(
          p == null ? void 0 : p.getFormSubmitUrl(a == null ? void 0 : a.formId),
          {
            credentials: "include",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            method: "post",
            body: JSON.stringify({
              subject: (a == null ? void 0 : a.formName) || "Unnamed Form",
              recipients: ((W = a == null ? void 0 : a.notifications) == null ? void 0 : W.emails) || [
                p == null ? void 0 : p.userEmail
              ],
              fields: D
            })
          }
        );
        if (k.ok && (f == null || f.reset()), k.status === 429 && (s(!0), w(!1), alert(
          "You have reached the limit of submitting the form, Please try again later after 24 hours."
        )), !k.ok)
          throw new Error();
        w(!0), r5(a, V);
      } catch (k) {
        w(!1), s(!0);
      }
  }), F = L && !u && x && b, y = u && I;
  return /* @__PURE__ */ c(
    "form",
    {
      id: C == null ? void 0 : C.id,
      "data-test": "FormView",
      onSubmit: f == null ? void 0 : f.handleSubmit(A),
      className: w5.FormFieldsContainer,
      children: [
        (B = a == null ? void 0 : a.fields) == null ? void 0 : B.map((E) => /* @__PURE__ */ t(
          H5,
          {
            formId: a == null ? void 0 : a.formId,
            uploadFileUrl: p == null ? void 0 : p.uploadFileUrl,
            sectionId: i,
            rowId: n,
            columnId: o,
            sectionValueId: r,
            field: E,
            useFormProps: f,
            isSubmitting: v,
            formSubmitSucceeded: y,
            customClassNames: l,
            text: h,
            elementId: C == null ? void 0 : C.id,
            wuiltContext: e
          },
          E.id
        )),
        /* @__PURE__ */ c("div", { className: l == null ? void 0 : l.actionContainerClass, children: [
          /* @__PURE__ */ t(
            F1,
            {
              text: h,
              disabled: v,
              element: {
                id: (q = a == null ? void 0 : a.formButton) == null ? void 0 : q.id,
                settings: a == null ? void 0 : a.formButton,
                type: "Button"
              },
              wuiltContext: e,
              customClassName: l == null ? void 0 : l.buttonClass
            }
          ),
          /* @__PURE__ */ t("span", { children: v && /* @__PURE__ */ t(M5, {}) })
        ] }),
        /* @__PURE__ */ t(
          s5,
          {
            formSettings: a,
            success: y,
            failure: F,
            resetForm: () => {
              s(!1), f == null || f.reset();
            },
            text: h
          }
        )
      ]
    }
  );
}, a2 = ({ size: C = "20px" }) => /* @__PURE__ */ t(
  "svg",
  {
    width: C,
    height: C,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M9 4C6.24 4 4 6.24 4 9V41C4 43.76 6.24 46 9 46H41C43.76 46 46 43.76 46 41V9C46 6.24 43.76 4 41 4H9ZM12 18H18.7305C19.4605 18 23.4102 17.9503 23.4102 21.5703C23.4102 23.4903 22.0998 24.1397 21.5098 24.4297C22.3898 24.7097 24 25.52 24 28C24 31.83 19.6095 32 19.0195 32H12V18ZM29 18H36V20H29V18ZM15 20.4297V23.7109H18.2207C18.6607 23.7109 20.1191 23.47 20.1191 22C20.1191 20.53 18.2197 20.4297 17.9297 20.4297H15ZM32.7305 21C36.6305 21 37.6896 24.0398 37.8496 24.7598C37.9996 25.4898 38 26.13 38 27H30.0996C30.0996 27.87 30.5606 29.8301 32.8906 29.8301C33.5106 29.8301 33.9695 29.6806 34.4395 29.3906C34.8995 29.1006 35.0609 28.8193 35.2109 28.5293H37.8398C37.3798 29.6793 36.7601 30.5509 35.8301 31.1309C34.9001 31.7109 33.8201 32 32.5801 32C31.8001 32 31.03 31.8505 30.25 31.5605C29.63 31.2705 29.0108 30.8402 28.5508 30.4102C28.0908 29.9702 27.7807 29.3899 27.4707 28.6699C27.1607 28.0899 27 27.22 27 26.5C27 25.78 27.2905 21 32.7305 21ZM32.7305 23.0293C30.4705 23.0293 30.0996 25.1998 30.0996 25.3398H35.0605C34.9005 24.6198 34.2505 23.0293 32.7305 23.0293ZM15 25.7109V29.5703H18.3516C18.6406 29.5703 20.6797 29.4809 20.6797 27.7109C20.6797 25.9509 19.0776 25.7109 18.3516 25.7109H15Z",
        fill: "currentColor"
      }
    )
  }
);
function p2({ size: C = "20px" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M9 4C6.25048 4 4 6.25048 4 9V41C4 43.7495 6.25048 46 9 46H41C43.7495 46 46 43.7495 46 41V9C46 6.25048 43.7495 4 41 4H9ZM9 6H41C42.6685 6 44 7.33152 44 9V41C44 42.6685 42.6685 44 41 44H9C7.33152 44 6 42.6685 6 41V9C6 7.33152 7.33152 6 9 6ZM11 16C10.7348 16 10.4805 16.1054 10.2929 16.2929C10.1054 16.4805 10 16.7348 10 17V33.002C10 33.2672 10.1054 33.5215 10.2929 33.709C10.4805 33.8966 10.7348 34.0019 11 34.002H18.6094H18.6113C19.0238 34.0013 20.4704 33.9661 21.9668 33.2637C23.4631 32.5612 25 30.9814 25 28.4277C25 26.8077 24.4695 25.5879 23.7578 24.7852C23.46 24.4492 23.1817 24.4116 22.8672 24.2051C23.469 23.5011 24 22.5484 24 21C24 18.6173 22.695 17.1386 21.3535 16.5371C20.0121 15.9356 18.6326 16 18.293 16H11ZM30 16C29.8675 15.9981 29.7359 16.0226 29.613 16.072C29.49 16.1214 29.3781 16.1948 29.2837 16.2878C29.1893 16.3809 29.1144 16.4918 29.0632 16.614C29.0121 16.7363 28.9858 16.8675 28.9858 17C28.9858 17.1325 29.0121 17.2637 29.0632 17.386C29.1144 17.5082 29.1893 17.6191 29.2837 17.7122C29.3781 17.8052 29.49 17.8786 29.613 17.928C29.7359 17.9774 29.8675 18.0019 30 18H36C36.1325 18.0019 36.2641 17.9774 36.387 17.928C36.51 17.8786 36.6219 17.8052 36.7163 17.7122C36.8107 17.6191 36.8856 17.5082 36.9368 17.386C36.9879 17.2637 37.0142 17.1325 37.0142 17C37.0142 16.8675 36.9879 16.7363 36.9368 16.614C36.8856 16.4918 36.8107 16.3809 36.7163 16.2878C36.6219 16.1948 36.51 16.1214 36.387 16.072C36.2641 16.0226 36.1325 15.9981 36 16H30ZM12 18H18.293C18.7454 18 19.7211 17.9963 20.5352 18.3613C21.3492 18.7263 22 19.2487 22 21C22 22.8759 21.2771 23.2359 20.8477 23.457C20.6737 23.5469 20.5299 23.6858 20.4342 23.8566C20.3385 24.0274 20.295 24.2226 20.3091 24.4178C20.3233 24.6131 20.3944 24.7999 20.5138 24.9552C20.6331 25.1104 20.7954 25.2272 20.9805 25.291C21.3586 25.4206 21.8636 25.6623 22.2617 26.1113C22.6598 26.5604 23 27.2187 23 28.4277C23 30.2581 22.1573 30.9648 21.1172 31.4531C20.0771 31.9414 18.831 32.0016 18.6094 32.002H12V18ZM33 19C32.0876 19 30.4174 19.1813 28.8633 20.248C27.3091 21.3148 26 23.3394 26 26.5C26 29.4434 27.2088 31.4442 28.7285 32.5684C30.2482 33.6926 31.9707 34 33.1699 34C35.7091 34 37.5045 33.1369 38.5801 31.9102C39.5735 30.7771 39.9024 29.4403 39.9531 28.2969C39.9803 28.2121 39.9961 28.1241 40 28.0352C40.0003 28.0266 39.9977 28.0165 39.998 28.0078C39.9981 28.0054 40 28.0024 40 28C39.9997 27.9667 39.9977 27.9335 39.9941 27.9004V27.8965C40.0486 26.0891 39.9086 24.0003 38.9434 22.2129C37.9546 20.3819 35.9666 19 33 19ZM15 20V23H17.6191C17.9761 23 19.166 22.7745 19.166 21.4355C19.166 20.0955 17.6179 20 17.3809 20H15ZM33 21C35.4084 21 36.4829 21.8681 37.1816 23.1621C37.7476 24.2103 37.9197 25.6183 37.9531 27H35H31C30.7348 27 30.4805 27.1054 30.2929 27.2929C30.1054 27.4805 30 27.7348 30 28C30 28 30.0086 28.2524 30.082 28.4727C30.1554 28.6929 30.3001 28.9642 30.543 29.207C31.0287 29.6927 31.8333 30 33 30C34.1667 30 34.9713 29.6927 35.457 29.207C35.5256 29.1384 35.5344 29.0714 35.5879 29H37.8418C37.7086 29.5548 37.4947 30.1125 37.0762 30.5898C36.3983 31.3631 35.2788 32 33.1699 32C32.3412 32 30.9758 31.7435 29.918 30.9609C28.8601 30.1784 28 28.9296 28 26.5C28 23.8536 28.9305 22.6279 29.9961 21.8965C31.0617 21.165 32.3914 21 33 21ZM33.0859 22.6016C32.4949 22.6016 32.0704 22.677 31.7324 22.832C31.3944 22.986 31.1427 23.2192 30.8887 23.4512C30.7197 23.6832 30.5498 23.9166 30.4648 24.2266C30.3798 24.4586 30.2959 24.691 30.2969 25.002H35.7051C35.6201 24.227 35.3664 23.6077 34.9434 23.2207C34.5214 22.8337 33.9309 22.6016 33.0859 22.6016ZM15.0332 26V29.9805H17.9629C18.2169 29.9805 20 29.8825 20 28.0645C20 26.2445 18.5989 26 17.9629 26H15.0332Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function V2({ size: C = "20px" }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M6.25 10.4167C6.25 8.11562 8.11562 6.25 10.4167 6.25H39.5833C41.8844 6.25 43.75 8.11562 43.75 10.4167V39.5833C43.75 41.8844 41.8844 43.75 39.5833 43.75H10.4167C8.11562 43.75 6.25 41.8844 6.25 39.5833V10.4167Z",
            fill: "#2196F3"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M28.125 17.7083H35.4167V19.7916H28.125V17.7083ZM22.4083 24.4041C23.0177 24.1072 24.3906 23.4312 24.3906 21.428C24.3906 17.6603 20.274 17.7093 19.5125 17.7093H12.5V32.2926H19.8177C20.4271 32.2916 25 32.1197 25 28.1239C25 25.5458 23.3229 24.702 22.4083 24.4041ZM15.625 20.2374H18.675C18.9792 20.2374 20.9615 20.3458 20.9615 21.8749C20.9615 23.403 19.4375 23.6603 18.9802 23.6603H15.625V20.2374ZM19.1 29.7614H15.5927V25.7447H19.1C19.8615 25.7447 21.5385 25.9916 21.5385 27.828C21.5385 29.6624 19.4042 29.7614 19.1 29.7614ZM33.7896 29.578C33.3052 29.8791 32.8219 30.0322 32.176 30.0322C29.7531 30.0322 29.2708 27.9895 29.2708 27.0843H37.5C37.5 26.1791 37.5 25.5103 37.3385 24.7551C37.176 23.9999 36.0729 20.8333 32.0146 20.8333C26.3427 20.8333 26.0417 25.8103 26.0417 26.5624C26.0417 27.3155 26.2042 28.2218 26.5281 28.8239C26.85 29.578 27.1729 30.1822 27.6573 30.6322C28.1406 31.0853 28.7854 31.5343 29.4312 31.8374C30.2375 32.1405 31.0448 32.2916 31.8521 32.2916C33.1417 32.2916 34.2729 31.9916 35.2406 31.3874C36.2104 30.7843 36.8552 29.8791 37.3385 28.6728H34.5958C34.4344 28.9749 34.2729 29.2749 33.7896 29.578ZM32.0146 22.9447C33.5958 22.9447 34.2729 24.603 34.4333 25.3551H29.2708C29.2708 25.2062 29.6573 22.9447 32.0146 22.9447Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
const c2 = ({ size: C = "20px" }) => /* @__PURE__ */ t(
  "svg",
  {
    width: C,
    height: C,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M42.298 11.6501C41.622 10.6291 40.665 9.8481 39.53 9.3941C37.066 8.4061 34.947 7.7461 33.051 7.3741C31.721 7.1141 30.404 7.7681 29.771 9.0001L29.613 9.3081C28.209 9.1531 26.718 9.1011 25.02 9.1441C23.279 9.1021 21.783 9.1531 20.377 9.3081L20.22 9.0001C19.587 7.7681 18.268 7.1151 16.941 7.3751C15.045 7.7461 12.925 8.4061 10.462 9.3951C9.32805 9.8491 8.37105 10.6291 7.69405 11.6511C2.97305 18.7821 1.12305 26.4741 2.03905 35.1681C2.07105 35.4731 2.24105 35.7461 2.50005 35.9091C6.13205 38.1991 9.27505 39.7671 12.391 40.8451C13.694 41.3001 15.139 40.7911 15.908 39.6161L17.279 37.5151C16.187 37.1031 15.121 36.6151 14.099 36.0321C13.62 35.7591 13.453 35.1481 13.726 34.6691C13.999 34.1881 14.61 34.0191 15.09 34.2961C18.131 36.0301 21.569 36.9471 25.032 36.9471C28.495 36.9471 31.933 36.0301 34.974 34.2961C35.453 34.0191 36.064 34.1881 36.338 34.6691C36.611 35.1481 36.444 35.7591 35.965 36.0321C34.909 36.6351 33.805 37.1371 32.674 37.5561L34.085 39.6581C34.666 40.5231 35.625 41.0151 36.613 41.0151C36.935 41.0151 37.26 40.9621 37.576 40.8541C40.701 39.7751 43.85 38.2051 47.49 35.9101C47.749 35.7471 47.919 35.4731 47.951 35.1691C48.869 26.4741 47.019 18.7811 42.298 11.6501ZM18.608 28.9831C16.682 28.9831 15.097 26.9541 15.097 24.4881C15.097 22.0221 16.682 19.9931 18.608 19.9931C20.534 19.9931 22.119 22.0221 22.119 24.4881C22.119 26.9541 20.534 28.9831 18.608 28.9831ZM31.601 28.9571C29.693 28.9571 28.123 26.9161 28.123 24.4351C28.123 21.9541 29.693 19.9131 31.601 19.9131C33.509 19.9131 35.079 21.9541 35.079 24.4351C35.079 26.9161 33.509 28.9571 31.601 28.9571Z",
        fill: "currentColor"
      }
    )
  }
);
function d2({ size: C = "20px" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M17.4377 7.32038C17.2732 7.32422 17.1072 7.34267 16.9416 7.37507C14.8307 7.78869 12.6618 8.51329 10.4631 9.3946C9.3311 9.8486 8.36827 10.6342 7.69554 11.6505C2.63105 19.3005 1.20485 27.225 2.04124 35.1661C2.05691 35.3166 2.10654 35.4616 2.18638 35.5902C2.26622 35.7187 2.3742 35.8275 2.50218 35.9083C5.66779 37.9049 8.93459 39.6482 12.3928 40.8438C13.6984 41.2955 15.154 40.772 15.9104 39.6133L17.5608 37.084C18.272 37.2817 19.0017 37.4486 19.7405 37.5997C21.4253 38.0147 23.1763 38.2442 24.9768 38.2442C26.8279 38.2442 28.6276 38.0044 30.3557 37.5665C31.0338 37.4231 31.7036 37.265 32.3596 37.0821L34.0862 39.6544C34.8485 40.7912 36.288 41.2967 37.5784 40.8516C41.0448 39.655 44.3198 37.9089 47.4924 35.9083C47.6204 35.8275 47.7284 35.7187 47.8082 35.5902C47.8881 35.4616 47.9377 35.3166 47.9534 35.1661C48.7897 27.2259 47.3645 19.3015 42.301 11.6524L42.2991 11.6485L42.2951 11.6426V11.6465C41.6222 10.6299 40.6573 9.84542 39.5256 9.39264C37.3281 8.51242 35.1617 7.78868 33.053 7.37507C31.728 7.11548 30.389 7.796 29.7717 9.00007L29.5881 9.35944C28.3213 9.21452 26.9537 9.09686 24.9963 9.1446C23.0404 9.09698 21.6734 9.21405 20.4065 9.35944L20.2229 9.00007H20.2209C19.6805 7.94713 18.5894 7.29351 17.4377 7.32038ZM17.6545 9.32624C17.9756 9.36905 18.2659 9.57165 18.4416 9.91413L18.9182 10.8419C19.013 11.0263 19.1628 11.1767 19.3469 11.2722C19.531 11.3677 19.7402 11.4037 19.9455 11.3751C21.2351 11.1973 22.7784 11.0878 24.9729 11.1426C24.9892 11.143 25.0054 11.143 25.0217 11.1426C27.2159 11.0878 28.7604 11.1981 30.051 11.3751C30.2561 11.4032 30.4649 11.3671 30.6485 11.2716C30.8322 11.1761 30.9817 11.0259 31.0764 10.8419L31.553 9.91413C31.7857 9.46019 32.2271 9.25154 32.6682 9.33796C34.5974 9.71635 36.655 10.3963 38.7815 11.2481C39.5407 11.5515 40.1787 12.0695 40.6291 12.7501L40.6311 12.752L40.635 12.7579C45.3406 19.8674 46.6711 27.0717 45.9807 34.4708C43.0313 36.3016 40.0365 37.8872 36.926 38.961C36.4883 39.112 36.032 38.9642 35.7483 38.5411L34.1819 36.209C34.7699 35.9378 35.349 35.6503 35.9104 35.3301C36.0295 35.2679 36.1349 35.1822 36.2202 35.0783C36.3055 34.9744 36.369 34.8544 36.4068 34.7254C36.4447 34.5964 36.4561 34.4611 36.4405 34.3276C36.4249 34.1941 36.3825 34.0651 36.3159 33.9483C36.2493 33.8315 36.1599 33.7294 36.0529 33.648C35.946 33.5666 35.8237 33.5075 35.6934 33.4744C35.5631 33.4414 35.4275 33.4349 35.2946 33.4554C35.1618 33.4759 35.0344 33.523 34.9201 33.5938C33.1856 34.5831 31.3085 35.3114 29.3342 35.754C27.9373 36.0048 26.4887 36.1635 24.967 36.1954C23.5036 36.1646 22.0995 36.0171 20.7444 35.7833C18.7247 35.3441 16.8066 34.604 15.0354 33.5938C14.8907 33.5083 14.7268 33.4606 14.5588 33.4551C14.3344 33.4479 14.1141 33.5165 13.9334 33.6497C13.7527 33.7829 13.622 33.9731 13.5625 34.1895C13.5029 34.406 13.518 34.6363 13.6052 34.8431C13.6924 35.05 13.8467 35.2216 14.0432 35.3301C14.5975 35.6463 15.1699 35.9289 15.7502 36.1973L14.2346 38.5196C13.953 38.9509 13.4875 39.1056 13.0471 38.9532C9.94461 37.8805 6.95607 36.2994 4.0139 34.4727C3.32295 27.0712 4.65526 19.8659 9.36351 12.754C9.81478 12.0722 10.4493 11.5541 11.2073 11.2501C13.3346 10.3974 15.3954 9.71633 17.3264 9.33796C17.4373 9.31625 17.5475 9.31197 17.6545 9.32624ZM31.6018 19.9122C29.6938 19.9122 28.1233 21.9546 28.1233 24.4356C28.1233 26.9166 29.6938 28.9571 31.6018 28.9571C33.5098 28.9571 35.0784 26.9166 35.0784 24.4356C35.0784 21.9546 33.5098 19.9122 31.6018 19.9122ZM18.6076 19.9923C16.6816 19.9923 15.0979 22.0223 15.0979 24.4883C15.0979 26.9543 16.6816 28.9825 18.6076 28.9825C20.5336 28.9825 22.1194 26.9543 22.1194 24.4883C22.1194 22.0223 20.5336 19.9923 18.6076 19.9923Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function s2({ size: C = "20px" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M40.8835 10.601C37.9626 9.2604 34.8293 8.2729 31.5543 7.70728C31.4949 7.69686 31.4356 7.72394 31.4043 7.77811C31.0012 8.49478 30.5553 9.42915 30.2428 10.1646C26.7199 9.63749 23.2147 9.63749 19.7647 10.1646C19.4522 9.41353 18.9897 8.49478 18.5845 7.77811C18.5533 7.72499 18.4939 7.6979 18.4345 7.70728C15.1606 8.27082 12.0283 9.25832 9.10535 10.601C9.08035 10.6114 9.05847 10.6302 9.04389 10.6542C3.10222 19.5312 1.4741 28.1906 2.27306 36.7417C2.27618 36.7833 2.30014 36.8239 2.33243 36.8489C6.25222 39.7281 10.0501 41.476 13.7772 42.6344C13.8366 42.6521 13.9001 42.6312 13.9376 42.5812C14.8189 41.3771 15.6053 40.1083 16.2793 38.7729C16.3189 38.6948 16.2814 38.6021 16.2001 38.5708C14.9533 38.0979 13.7668 37.5219 12.6251 36.8666C12.5345 36.8135 12.5272 36.6844 12.6106 36.6229C12.8512 36.4427 13.0908 36.2552 13.321 36.0667C13.3626 36.0323 13.4199 36.025 13.4689 36.0469C20.9699 39.4719 29.0908 39.4719 36.5033 36.0469C36.5522 36.0229 36.6095 36.0302 36.6533 36.0646C36.8824 36.2542 37.1231 36.4427 37.3647 36.6229C37.4481 36.6844 37.4428 36.8135 37.3522 36.8666C36.2106 37.5344 35.0231 38.0979 33.7751 38.5687C33.6939 38.6 33.6574 38.6937 33.697 38.7729C34.3856 40.1062 35.171 41.375 36.0366 42.5792C36.0731 42.6302 36.1376 42.6521 36.197 42.6333C39.9418 41.475 43.7397 39.7271 47.6595 36.8479C47.6939 36.8229 47.7158 36.7844 47.7189 36.7427C48.6741 26.8562 46.1178 18.2687 40.9428 10.6552C40.9303 10.6302 40.9085 10.6114 40.8835 10.601ZM17.3991 31.5344C15.1408 31.5344 13.2803 29.4614 13.2803 26.9146C13.2803 24.3677 15.1053 22.2948 17.3991 22.2948C19.7116 22.2948 21.5543 24.3864 21.5178 26.9146C21.5189 29.4604 19.6939 31.5344 17.3991 31.5344ZM32.6293 31.5344C30.371 31.5344 28.5106 29.4614 28.5106 26.9146C28.5106 24.3677 30.3356 22.2948 32.6293 22.2948C34.9418 22.2948 36.7845 24.3864 36.7481 26.9146C36.7481 29.4604 34.9418 31.5344 32.6293 31.5344Z",
          fill: "#536DFE"
        }
      )
    }
  );
}
const L2 = ({ size: C = "20px" }) => /* @__PURE__ */ t(
  "svg",
  {
    width: C,
    height: C,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M9 4C6.24 4 4 6.24 4 9V41C4 43.76 6.24 46 9 46H41C43.76 46 46 43.76 46 41V9C46 6.24 43.76 4 41 4H9ZM26.1699 11C28.1399 11 30 12.77 30 21.5C30 24.62 29.4691 29.1509 27.6191 32.8809C28.4191 33.9209 29.22 34.25 29.75 34C31.25 33.28 32.2094 30.7502 33.1094 27.9902C33.3594 27.2402 34.1909 26.8305 34.9609 27.0605C35.7409 27.3005 36.1797 28.0998 35.9297 28.8398C35.1697 31.1798 33.0403 36.9805 29.8203 36.9805C28.8003 36.9805 27.4291 36.9402 26.1191 35.6602C24.6491 37.6602 22.8204 39 20.6504 39C16.0604 39 14 35.5108 14 32.0508C14 28.3808 15.8809 24.0508 20.1309 24.0508C20.8509 24.0508 21.5101 24.1809 22.0801 24.3809C22.0001 23.3809 22 22.5809 22 21.3809C22 21.2709 22.0399 11 26.1699 11ZM26.2891 14.0508C25.6791 15.0908 24.9609 18.1291 24.9609 21.3691C24.9609 24.8891 25.3702 27.5898 25.9902 29.5898C26.9202 27.0198 27.0391 24.03 27.0391 21.5C27.0391 16.74 26.7591 14.7108 26.2891 14.0508ZM20.1191 27C16.9391 27 17 31.9291 17 32.1191C17 33.3591 17.2891 36 20.6191 36C21.8991 36 23.2008 34.9797 24.3008 33.1797C23.6308 31.9297 23.0001 29.97 22.5801 28C22.5001 27.94 22.4196 27.8805 22.3496 27.8105C22.3496 27.8105 21.3791 27 20.1191 27Z",
        fill: "currentColor"
      }
    )
  }
);
function M2({ size: C = "20px" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M9 4C6.25048 4 4 6.25048 4 9V41C4 43.7495 6.25048 46 9 46H41C43.7495 46 46 43.7495 46 41V9C46 6.25048 43.7495 4 41 4H9ZM9 6H41C42.6685 6 44 7.33152 44 9V41C44 42.6685 42.6685 44 41 44H9C7.33152 44 6 42.6685 6 41V9C6 7.33152 7.33152 6 9 6ZM26.1738 11C22.0398 11 22 21.271 22 21.375C22 22.583 21.9991 23.375 22.0801 24.375C21.5111 24.178 20.85 24.0527 20.127 24.0527C15.881 24.0527 14 28.3769 14 32.0469C14 35.5079 16.0554 39 20.6504 39C22.8174 39 24.65 37.6592 26.123 35.6582C27.429 36.9382 28.7963 36.9805 29.8203 36.9805C33.0363 36.9805 35.1656 31.1778 35.9316 28.8438C36.1756 28.0968 35.7438 27.3005 34.9648 27.0645C34.1928 26.8325 33.3553 27.2432 33.1113 27.9902C32.2063 30.7462 31.254 33.28 29.75 34C29.225 34.251 28.418 33.924 27.625 32.875C29.468 29.148 30 24.621 30 21.5C30 12.774 28.1358 11 26.1738 11ZM26.291 14.0469C26.757 14.7119 27.0449 16.736 27.0449 21.498C27.0439 24.026 26.9242 27.0188 25.9902 29.5918C25.3742 27.5908 24.957 24.892 24.957 21.373C24.957 18.129 25.682 15.0879 26.291 14.0469ZM20.125 27C21.384 27 22.3496 27.8085 22.3496 27.8105C22.4216 27.8825 22.5 27.945 22.582 28C22.995 29.973 23.6307 31.9267 24.3027 33.1777C23.2007 34.9797 21.896 36 20.625 36C17.29 36 17 33.362 17 32.125C17 31.93 16.939 27 20.125 27Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function Z2({ size: C = "20px" }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M43.75 38.5417C43.75 41.4187 41.4187 43.75 38.5417 43.75H11.4583C8.58229 43.75 6.25 41.4187 6.25 38.5417V11.4583C6.25 8.58125 8.58229 6.25 11.4583 6.25H38.5417C41.4187 6.25 43.75 8.58125 43.75 11.4583V38.5417Z",
            fill: "#FF4081"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M34.4387 27.3678C33.7064 27.1376 32.9137 27.5501 32.6825 28.3001C31.8241 31.0688 30.27 33.9449 29.5647 34.1022C29.0366 34.1022 28.2772 33.6542 27.5252 32.6022C29.2689 28.8584 30.1825 24.1584 30.1825 21.0209C30.1825 12.2574 27.97 10.4167 26.1116 10.4167C22.1981 10.4167 22.1533 20.7417 22.1533 20.8459C22.1533 22.0605 22.197 23.1876 22.2793 24.2376C21.7397 24.0407 21.12 23.9053 20.4356 23.9053C16.4147 23.9053 14.5835 27.873 14.5835 31.5584C14.5835 35.0313 16.5325 38.5417 20.8814 38.5417C22.9356 38.5417 24.6668 37.197 26.0637 35.1865C27.3012 36.473 28.597 36.9532 29.5637 36.9532C32.6085 36.9532 34.6241 31.5022 35.3512 29.1553C35.5835 28.4063 35.1741 27.6063 34.4387 27.3678ZM20.8835 35.6917C17.7262 35.6917 17.3835 32.8011 17.3835 31.5574C17.3835 31.3615 17.4189 26.7542 20.4377 26.7542C21.6293 26.7542 22.5439 27.6761 22.5439 27.6761C22.6116 27.749 22.6866 27.8126 22.7647 27.8678C23.1554 29.8511 23.7064 31.4365 24.3439 32.6928C23.2981 34.5032 22.0866 35.6917 20.8835 35.6917ZM25.9387 29.0897C25.3564 27.0792 24.9533 24.3803 24.9533 20.8459C24.9533 17.5897 25.647 14.5251 26.2231 13.4782C26.6647 14.149 27.3845 16.2386 27.3845 21.0209C27.3845 23.5584 26.8231 26.5063 25.9387 29.0897Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
const w2 = ({ size: C = "20px" }) => /* @__PURE__ */ t(
  "svg",
  {
    width: C,
    height: C,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M25 3C12.85 3 3 12.85 3 25C3 36.03 11.125 45.137 21.712 46.728V30.831H16.269V25.048H21.712V21.2C21.712 14.829 24.816 12.032 30.111 12.032C32.647 12.032 33.988 12.22 34.623 12.306V17.354H31.011C28.763 17.354 27.978 19.485 27.978 21.887V25.048H34.566L33.672 30.831H27.978V46.775C38.716 45.318 47 36.137 47 25C47 12.85 37.15 3 25 3Z",
        fill: "currentColor"
      }
    )
  }
), f2 = ({ size: C = "20px" }) => /* @__PURE__ */ t(
  "svg",
  {
    width: C,
    height: C,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M13.0001 1.56006C6.68807 1.56006 1.56006 6.68807 1.56006 13.0001C1.56006 18.73 5.78638 23.472 11.2908 24.2989L11.8879 24.3893V15.3746H9.18537V13.5444H11.8879V11.114C11.8879 9.61744 12.2471 8.63176 12.8416 8.01334C13.4362 7.39492 14.3146 7.08303 15.5371 7.08303C16.5146 7.08303 16.8949 7.14225 17.2565 7.18662V8.68467H15.984C15.2619 8.68467 14.6695 9.08753 14.362 9.62412C14.0545 10.1607 13.9588 10.8014 13.9588 11.4543V13.5434H17.1428L16.8594 15.3736H13.9588V24.4035L14.5489 24.3233C20.1315 23.5661 24.4401 18.786 24.4401 13.0001C24.4401 6.68807 19.312 1.56006 13.0001 1.56006ZM13.0001 2.60006C18.75 2.60006 23.4001 7.25013 23.4001 13.0001C23.4001 18.0595 19.7787 22.2206 14.9988 23.1573V16.4136H17.7512L18.3554 12.5034H14.9988V11.4543C14.9988 10.9148 15.0975 10.4314 15.2639 10.1411C15.4303 9.85074 15.5906 9.72467 15.984 9.72467H18.2965V6.24514L17.8456 6.1842C17.5337 6.142 16.8216 6.04303 15.5371 6.04303C14.1315 6.04303 12.925 6.42593 12.0921 7.29225C11.2592 8.15856 10.8479 9.44852 10.8479 11.114V12.5044H8.14537V16.4146H10.8479V23.1248C6.1449 22.1286 2.60006 18.0048 2.60006 13.0001C2.60006 7.25013 7.25013 2.60006 13.0001 2.60006Z",
        fill: "currentColor"
      }
    )
  }
), u2 = ({ size: C = "20px" }) => /* @__PURE__ */ c(
  "svg",
  {
    width: C,
    height: C,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.0002 2.70825C10.2706 2.70825 7.65292 3.79255 5.72286 5.72261C3.79279 7.65267 2.7085 10.2704 2.7085 12.9999C2.7085 15.7294 3.79279 18.3472 5.72286 20.2772C7.65292 22.2073 10.2706 23.2916 13.0002 23.2916C15.7297 23.2916 18.3474 22.2073 20.2775 20.2772C22.2075 18.3472 23.2918 15.7294 23.2918 12.9999C23.2918 10.2704 22.2075 7.65267 20.2775 5.72261C18.3474 3.79255 15.7297 2.70825 13.0002 2.70825Z",
          fill: "#039BE5"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M14.393 15.7278H17.0564L17.4746 13.0222H14.3925V11.5434C14.3925 10.4195 14.7597 9.4228 15.8111 9.4228H17.5006V7.06167C17.2037 7.02159 16.5759 6.93384 15.3897 6.93384C12.9126 6.93384 11.4604 8.24196 11.4604 11.2222V13.0222H8.91406V15.7278H11.4604V23.1643C11.9647 23.2402 12.4755 23.2916 12.9999 23.2916C13.4738 23.2916 13.9364 23.2483 14.393 23.1865V15.7278Z",
          fill: "white"
        }
      )
    ]
  }
), k2 = ({
  size: C = "20px"
}) => /* @__PURE__ */ t(
  "svg",
  {
    width: C,
    height: C,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M25 2C12.3008 2 2 11.6016 2 23.5C2 29.8008 4.89844 35.6992 10 39.8008V48.6016L18.6016 44.1016C20.6992 44.6992 22.8008 44.8984 25 44.8984C37.6992 44.8984 48 35.3008 48 23.3984C48 11.6016 37.6992 2 25 2ZM27.3008 30.6016L21.5 24.3984L10.6992 30.5L22.6992 17.8008L28.6016 23.6992L39.1016 17.8008L27.3008 30.6016Z",
        fill: "currentColor"
      }
    )
  }
);
function g2({
  size: C = "20px"
}) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M25 2C12.3477 2 2 11.5977 2 23.5C2 30.0078 5.13281 35.7852 10 39.7188V48.6562L11.4688 47.875L18.6875 44.125C20.7031 44.6641 22.8008 45 25 45C37.6523 45 48 35.4023 48 23.5C48 11.5977 37.6523 2 25 2ZM25 4C36.6445 4 46 12.7578 46 23.5C46 34.2422 36.6445 43 25 43C22.8359 43 20.7422 42.6875 18.7812 42.125L18.4062 42.0312L18.0625 42.2188L12 45.375V38.8125L11.625 38.5312C6.96094 34.9414 4 29.5391 4 23.5C4 12.7578 13.3555 4 25 4ZM22.7188 17.7188L10.6875 30.4688L21.5 24.4062L27.2812 30.5938L39.1562 17.7188L28.625 23.625L22.7188 17.7188Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function x2({ size: C = "20px" }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M25.0002 4.16675C14.0627 4.16675 5.2085 12.6042 5.2085 22.9167C5.2085 28.3334 7.60433 33.1251 11.4585 36.5626V45.8334L19.5835 40.9376C21.2502 41.3542 23.1252 41.6667 25.0002 41.6667C35.9377 41.6667 44.7918 33.2292 44.7918 22.9167C44.7918 12.6042 35.9377 4.16675 25.0002 4.16675Z",
            fill: "#448AFF"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M12.5 29.1666L22.9167 17.7083L28.125 22.9166L37.5 17.7083L27.0833 29.1666L21.875 23.9583L12.5 29.1666Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
const v2 = ({ size: C = "20px" }) => /* @__PURE__ */ t(
  "svg",
  {
    width: C,
    height: C,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M17.791 46.836C18.502 46.53 19 45.823 19 45V39.6C19 39.403 19.016 39.198 19.041 38.99C19.027 38.994 19.014 38.997 19 39C19 39 16 39 15.4 39C13.9 39 12.6 38.4 12 37.2C11.3 35.9 11 33.7 9.2 32.5C8.9 32.3 9.1 32 9.7 32C10.3 32.1 11.6 32.9 12.4 34C13.3 35.1 14.2 36 15.8 36C18.287 36 19.62 35.875 20.422 35.445C21.356 34.056 22.649 33 24 33V32.975C18.332 32.793 14.711 30.909 13.025 28C9.36 28.042 6.169 28.405 4.348 28.707C4.29 28.38 4.24 28.051 4.197 27.72C5.994 27.424 9.04 27.073 12.542 27.006C12.43 26.73 12.333 26.447 12.251 26.157C8.74 25.979 5.71 26.118 4.064 26.254C4.044 25.922 4.017 25.591 4.013 25.255C5.662 25.12 8.61 24.985 12.031 25.144C11.952 24.644 11.901 24.133 11.901 23.601C11.901 21.901 12.501 20.101 13.601 18.601C13.101 16.901 12.401 13.301 13.801 12.001C16.501 12.001 18.401 13.301 19.301 14.101C21 13.4 22.9 13 25 13C27.1 13 29 13.4 30.6 14.1C31.5 13.3 33.4 12 36.1 12C37.6 13.4 36.8 17 36.3 18.6C37.4 20.1 38 21.8 37.9 23.6C37.9 24.084 37.855 24.551 37.79 25.009C41.289 24.837 44.317 24.975 45.994 25.111C45.992 25.448 45.961 25.777 45.943 26.11C44.272 25.972 41.168 25.83 37.584 26.021C37.495 26.357 37.387 26.684 37.259 27.001C40.805 27.047 43.924 27.39 45.807 27.69C45.764 28.022 45.714 28.351 45.656 28.677C43.744 28.371 40.485 28.013 36.777 27.995C35.112 30.873 31.557 32.75 26 32.969V33C28.6 33 31 36.9 31 39.6V45C31 45.823 31.498 46.53 32.209 46.836C41.37 43.804 48 35.164 48 25C48 12.318 37.683 2 25 2C12.317 2 2 12.318 2 25C2 35.164 8.63 43.804 17.791 46.836Z",
        fill: "currentColor"
      }
    )
  }
);
function _2({ size: C = "20px" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M25 2C12.3113 2 2 12.3113 2 25C2 37.6887 12.3113 48 25 48C37.6887 48 48 37.6887 48 25C48 12.3113 37.6887 2 25 2ZM25 4C36.6073 4 46 13.3927 46 25C46 25.0714 45.9948 25.1417 45.9941 25.2129C45.3545 25.1539 44.6155 25.0978 43.6758 25.0645C42.3471 25.0173 40.6723 25.031 38.7734 25.125C38.8439 24.6347 38.8932 24.1374 38.8945 23.627C38.9914 21.7543 38.3625 20.0025 37.3398 18.4551C37.5869 17.6014 37.8767 16.5152 37.9492 15.2832C38.0318 13.8789 37.9106 12.3218 36.7832 11.2695L36.4941 11H36.0996C33.4165 11 31.58 12.1232 30.457 13.0137C28.8355 12.386 27.0122 12 25 12C22.9764 12 21.1355 12.3914 19.4473 13.0176C18.3249 12.1267 16.4868 11 13.8008 11H13.4082L13.1191 11.2676C12.021 12.2873 11.9198 13.8018 11.9883 15.1992C12.0487 16.4315 12.3217 17.5521 12.5645 18.4473C11.5245 20.0249 10.9004 21.822 10.9004 23.5996C10.9004 24.1112 10.948 24.6101 11.0176 25.1016C9.21182 25.0178 7.6021 25.0017 6.32422 25.0469C5.38451 25.0801 4.64544 25.1357 4.00586 25.1953C4.00526 25.13 4 25.0655 4 25C4 13.3927 13.3927 4 25 4ZM14.3965 13.1309C16.4141 13.322 17.932 14.223 18.6348 14.8477L19.1035 15.2617L19.6816 15.0254C21.2631 14.3742 23.027 14 25 14C26.973 14 28.7374 14.3761 30.1992 15.0156L30.7852 15.2734L31.2637 14.8477C31.9667 14.2228 33.4872 13.3216 35.5059 13.1309C35.7743 13.5758 36.0075 14.2087 35.9512 15.166C35.8838 16.3117 35.5773 17.5597 35.3457 18.3008L35.1953 18.7832L35.4941 19.1914C36.4836 20.5407 36.9881 22.0009 36.9023 23.5449L36.9004 23.5723V23.5996C36.9004 26.0951 36.0018 28.0923 34.0879 29.5723C32.174 31.0522 29.1527 32 24.9004 32C20.6481 32 17.6248 31.0522 15.7109 29.5723C13.797 28.0923 12.9004 26.0951 12.9004 23.5996C12.9004 22.1349 13.4293 20.5236 14.4062 19.1914L14.6992 18.793L14.5586 18.3184C14.3269 17.5305 14.0428 16.2541 13.9863 15.1016C13.9393 14.1429 14.1662 13.537 14.3965 13.1309ZM8.88477 26.0215C9.59146 26.0305 10.4015 26.0687 11.2129 26.1094C11.2904 26.4212 11.3788 26.7279 11.4863 27.0273C8.17897 27.0971 5.70473 27.4297 4.17969 27.7148C4.11521 27.2145 4.06385 26.71 4.03516 26.1992C5.16221 26.0923 6.751 25.9942 8.88477 26.0215ZM41.1152 26.0371C43.2475 26.01 44.8357 26.1082 45.9629 26.2148C45.9342 26.7183 45.8837 27.2157 45.8203 27.709C44.2408 27.4192 41.6997 27.0867 38.3066 27.0332C38.4119 26.7397 38.4996 26.4382 38.5762 26.1328C39.4713 26.0848 40.3446 26.0469 41.1152 26.0371ZM11.9121 28.0195C12.5088 29.2153 13.3615 30.283 14.4883 31.1543C16.0288 32.3455 18.0316 33.1778 20.4766 33.623C20.1567 33.9517 19.8658 34.3126 19.6074 34.6934L19.5469 34.6406C19.5524 34.6343 19.0498 34.8859 18.2988 34.9531C17.5479 35.0204 16.6216 35 15.8008 35C14.5758 35 14.0362 34.4212 13.1738 33.3672C12.6963 32.7236 12.1141 32.2023 11.5488 31.8066C10.97 31.4015 10.4763 31.1155 9.86523 31.0137L9.7832 31H9.69922C9.23255 31 8.78098 31.0338 8.35938 31.5156C8.14857 31.7565 8.00328 32.2026 8.09766 32.5801C8.19204 32.9576 8.43086 33.1896 8.64453 33.332C10.0113 34.2432 10.2528 36.0465 11.1094 37.6504C11.9093 39.2443 13.6357 40 15.4004 40H18V44.8027C10.9678 42.3205 5.66468 36.2046 4.33203 28.7031C5.86293 28.4148 8.42654 28.0681 11.9121 28.0195ZM37.8828 28.0273C41.4455 28.0578 44.081 28.4041 45.6699 28.6973C44.339 36.2015 39.0341 42.3199 32 44.8027V39.5996C32 38.015 31.4796 36.2677 30.5742 34.8105C30.2993 34.3681 29.9759 33.9497 29.6152 33.5742C31.9305 33.1168 33.8324 32.2988 35.3125 31.1543C36.4368 30.2849 37.2876 29.2204 37.8828 28.0273ZM23.6992 34.0996H26.5C27.3128 34.0996 28.1804 34.7474 28.875 35.8652C29.5696 36.9831 30 38.4842 30 39.5996V45.3984C28.3974 45.7892 26.7238 46 25 46C23.2762 46 21.6026 45.7892 20 45.3984V39.5996C20 38.5089 20.4678 37.0113 21.209 35.8887C21.9501 34.766 22.8864 34.0996 23.6992 34.0996ZM12.3086 35.2812C13.1744 36.1793 14.2225 37 15.8008 37C16.5799 37 17.5525 37.0281 18.4766 36.9453C18.4798 36.945 18.483 36.9437 18.4863 36.9434C18.3646 37.2934 18.2737 37.6455 18.1973 38H15.4004C14.1671 38 13.2958 37.5544 12.8945 36.752L12.8867 36.7383L12.8809 36.7266C12.7165 36.4212 12.5006 35.8106 12.3086 35.2812Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function b2({ size: C = "20px" }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M42.7082 25.0001C42.7082 34.7917 34.7915 42.7084 24.9998 42.7084C15.2082 42.7084 7.2915 34.7917 7.2915 25.0001C7.2915 15.2084 15.2082 7.29175 24.9998 7.29175C34.7915 7.29175 42.7082 15.2084 42.7082 25.0001Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M21.8752 42.7084V36.9792C21.8752 36.6667 22.0835 36.4584 22.396 36.4584C22.7085 36.4584 22.9168 36.6667 22.9168 36.9792V42.7084H25.0002V35.9376C25.0002 35.6251 25.2085 35.4167 25.521 35.4167C25.8335 35.4167 26.0418 35.6251 26.0418 35.9376V42.7084H28.1252V36.9792C28.1252 36.6667 28.3335 36.4584 28.646 36.4584C28.9585 36.4584 29.1668 36.6667 29.1668 36.9792V42.7084H31.0418C31.2502 42.3959 31.2502 42.0834 31.2502 41.5626V37.5001C31.2502 35.2084 29.271 32.0834 26.771 32.0834H24.1668C21.771 32.0834 19.6877 35.3126 19.6877 37.5001V41.5626C19.6877 41.9792 19.7918 42.3959 19.896 42.7084H21.8752ZM41.771 27.5001C41.771 27.5001 40.4168 27.0834 39.271 27.0834H39.1668C38.021 27.0834 36.146 27.3959 36.146 27.3959C36.0418 27.3959 36.0418 27.3959 36.0418 27.2917C36.0418 27.1876 36.0418 27.1876 36.146 27.1876C36.2502 27.1876 38.2293 26.8751 39.3752 26.8751C40.521 26.8751 41.8752 27.2917 41.9793 27.2917C42.0835 27.2917 42.0835 27.3959 42.0835 27.5001C41.8752 27.3959 41.8752 27.5001 41.771 27.5001ZM41.4585 28.3334C41.4585 28.3334 40.0002 27.9167 38.7502 27.9167C37.8127 27.9167 35.6252 28.1251 35.521 28.1251C35.4168 28.1251 35.4168 28.1251 35.4168 28.0209C35.4168 27.9167 35.4168 27.9167 35.521 27.9167C35.6252 27.9167 37.8127 27.7084 38.7502 27.7084C40.1043 27.7084 41.4585 28.1251 41.4585 28.1251C41.5627 28.1251 41.5627 28.2292 41.5627 28.3334C41.5627 28.2292 41.5627 28.3334 41.4585 28.3334ZM8.12516 27.5001C8.021 27.5001 8.021 27.5001 8.021 27.3959C8.021 27.2917 8.021 27.2917 8.12516 27.1876C8.9585 26.9792 10.6252 26.6667 11.5627 26.6667C12.396 26.6667 15.2085 26.8751 15.3127 26.8751C15.4168 26.8751 15.4168 26.9792 15.4168 26.9792C15.4168 27.0834 15.3127 27.0834 15.3127 27.0834C15.3127 27.0834 12.5002 26.8751 11.6668 26.8751C10.521 27.0834 8.9585 27.2917 8.12516 27.5001ZM8.54183 29.0626C8.54183 29.0626 8.43766 29.0626 8.43766 28.9584C8.43766 28.8542 8.43766 28.8542 8.43766 28.7501C8.54183 28.7501 9.896 27.9167 11.4585 27.7084C12.8127 27.5001 15.6252 27.8126 15.8335 27.8126C15.9377 27.8126 15.9377 27.9167 15.9377 27.9167C15.9377 28.0209 15.8335 28.0209 15.8335 28.0209C15.8335 28.0209 12.9168 27.7084 11.5627 27.9167C10.0002 28.2292 8.54183 29.0626 8.54183 29.0626Z",
            fill: "#455A64"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M14.7915 24.4792C14.7915 19.8958 19.5832 15.625 25.5207 15.625C31.4582 15.625 36.2498 19.7917 36.2498 24.4792C36.2498 29.1667 32.8123 32.2917 25.5207 32.2917C18.229 32.2917 14.7915 29.0625 14.7915 24.4792Z",
            fill: "#455A64"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M29.7917 16.9791C29.7917 16.9791 31.5625 14.5833 34.7917 14.5833C36.0417 15.8333 35.2084 19.5833 34.7917 20.6249L29.7917 16.9791ZM21.25 16.9791C21.25 16.9791 19.4792 14.5833 16.25 14.5833C15 15.8333 15.8334 19.5833 16.25 20.6249L21.25 16.9791ZM20.9375 37.3958C20.9375 37.3958 18.5417 37.3958 18.0208 37.3958C16.7708 37.3958 15.625 36.8749 15.1042 35.8333C14.4792 34.6874 13.9584 33.4374 12.3959 32.3958C12.0834 32.1874 12.2917 31.9791 12.8125 31.9791C13.3334 32.0833 14.2709 32.1874 15 33.1249C15.7292 34.0624 16.5625 35.2083 17.9167 35.2083C19.2709 35.2083 20.7292 35.2083 21.5625 34.2708L20.9375 37.3958Z",
            fill: "#455A64"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M24.9998 4.16675C13.5415 4.16675 4.1665 13.5417 4.1665 25.0001C4.1665 36.4584 13.5415 45.8334 24.9998 45.8334C36.4582 45.8334 45.8332 36.4584 45.8332 25.0001C45.8332 13.5417 36.4582 4.16675 24.9998 4.16675ZM24.9998 41.6667C15.8332 41.6667 8.33317 34.1667 8.33317 25.0001C8.33317 15.8334 15.8332 8.33341 24.9998 8.33341C34.1665 8.33341 41.6665 15.8334 41.6665 25.0001C41.6665 34.1667 34.1665 41.6667 24.9998 41.6667Z",
            fill: "#00BCD4"
          }
        )
      ]
    }
  );
}
const m2 = ({ size: C = "20px" }) => /* @__PURE__ */ t(
  "svg",
  {
    width: C,
    height: C,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M16 3C8.83 3 3 8.83 3 16V34C3 41.17 8.83 47 16 47H34C41.17 47 47 41.17 47 34V16C47 8.83 41.17 3 34 3H16ZM37 11C38.1 11 39 11.9 39 13C39 14.1 38.1 15 37 15C35.9 15 35 14.1 35 13C35 11.9 35.9 11 37 11ZM25 14C31.07 14 36 18.93 36 25C36 31.07 31.07 36 25 36C18.93 36 14 31.07 14 25C14 18.93 18.93 14 25 14ZM25 16C20.04 16 16 20.04 16 25C16 29.96 20.04 34 25 34C29.96 34 34 29.96 34 25C34 20.04 29.96 16 25 16Z",
        fill: "currentColor"
      }
    )
  }
);
function y2({ size: C = "20px" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M16 3C8.83248 3 3 8.83248 3 16V34C3 41.1675 8.83248 47 16 47H34C41.1675 47 47 41.1675 47 34V16C47 8.83248 41.1675 3 34 3H16ZM16 5H34C40.0865 5 45 9.91352 45 16V34C45 40.0865 40.0865 45 34 45H16C9.91352 45 5 40.0865 5 34V16C5 9.91352 9.91352 5 16 5ZM37 11C36.4696 11 35.9609 11.2107 35.5858 11.5858C35.2107 11.9609 35 12.4696 35 13C35 13.5304 35.2107 14.0391 35.5858 14.4142C35.9609 14.7893 36.4696 15 37 15C37.5304 15 38.0391 14.7893 38.4142 14.4142C38.7893 14.0391 39 13.5304 39 13C39 12.4696 38.7893 11.9609 38.4142 11.5858C38.0391 11.2107 37.5304 11 37 11ZM25 14C18.9367 14 14 18.9367 14 25C14 31.0633 18.9367 36 25 36C31.0633 36 36 31.0633 36 25C36 18.9367 31.0633 14 25 14ZM25 16C29.9824 16 34 20.0176 34 25C34 29.9824 29.9824 34 25 34C20.0176 34 16 29.9824 16 25C16 20.0176 20.0176 16 25 16Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function B2({ size: C = "20px" }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M43.4064 14.0417C42.9897 14.3125 42.396 14.5625 42.146 14.8438C42.0522 14.9375 42.0002 15.0417 42.021 15.1458V16.2187L41.7085 17.2708L41.396 18.3125L41.0522 19.4583L40.3439 21.8021L39.6564 24.1146L39.1356 25.8542C39.1356 26.125 39.1252 26.3958 39.1043 26.6562C39.0314 27.6562 38.8231 28.6146 38.4897 29.5104C38.2918 30.0625 38.0522 30.5938 37.7606 31.0938C37.6564 31.2917 37.5314 31.4896 37.4064 31.6771C36.9897 32.3333 36.4897 32.9375 35.9377 33.4688C35.5106 33.8958 35.0418 34.2917 34.5314 34.625C34.5314 34.625 34.5314 34.625 34.521 34.625C34.4377 34.6979 34.3439 34.7604 34.2397 34.8125C33.9168 35.0312 33.5731 35.2188 33.2189 35.3854C32.9793 35.5104 32.7397 35.6146 32.4897 35.7083C32.4377 35.7396 32.3752 35.7604 32.3231 35.7812C31.7293 36.0625 31.0418 36.25 30.3543 36.3437C30.3127 36.3542 30.2814 36.3542 30.2397 36.3646C29.8231 36.4375 29.4168 36.5 29.0002 36.5312C28.8127 36.5521 28.6147 36.5625 28.4272 36.5625L27.6877 36.5208L24.1252 36.3333C24.1252 36.3229 24.1147 36.3333 24.1147 36.3333L22.3231 36.2396C22.1877 36.2396 22.0418 36.2396 21.9064 36.2292C21.3439 36.2083 20.8022 36.1458 20.2606 36.0312C20.2502 36.0312 20.2502 36.0312 20.2502 36.0312C19.2606 35.8437 18.3127 35.5104 17.4272 35.0625C16.9377 34.8125 16.4585 34.5312 16.0106 34.2083C15.8231 34.0729 15.646 33.9271 15.4689 33.7708C14.9689 33.3542 14.521 32.9062 14.1043 32.4479C14.0418 32.3854 13.9897 32.3229 13.9377 32.2604C13.8752 32.1979 13.8127 32.125 13.7606 32.0625C13.3647 31.5625 13.0314 31.0521 12.7606 30.5104C12.5106 30.0312 12.3127 29.5208 12.1564 28.9583C12.0939 28.7604 12.0418 28.5729 12.0002 28.3646C11.9897 28.3542 11.9793 28.3333 11.9793 28.3125C11.8752 27.8854 11.7814 27.4375 11.7293 26.9896C11.6668 26.6458 11.6356 26.3021 11.6356 25.9479C11.6147 25.8125 11.6147 25.6667 11.6147 25.5312L13.6043 22.4583L15.5522 19.4583L16.4377 18.0938L17.2397 16.8646L17.5106 16.4375V15.3646C17.5314 15.125 17.5418 14.875 17.5314 14.6458C17.521 13.9167 17.3752 13.2083 17.1356 12.5312C16.9064 11.8125 16.5835 11.1354 16.2502 10.5104C15.8543 9.79167 15.4377 9.14583 15.0939 8.5625C14.5835 7.70833 14.2293 7.01042 14.3231 6.52083C15.0731 6.34375 15.8647 6.25 16.6668 6.25H33.3335C37.6877 6.25 41.4377 8.95833 42.9897 12.7708C43.1564 13.1771 43.3022 13.6042 43.4064 14.0417Z",
            fill: "#304FFE"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M43.7498 16.6667V16.9479L42.3123 17.7812L41.3957 18.3125L40.3853 18.8958L38.3644 20.0729L36.3853 21.2188L34.3644 22.3854L33.5623 22.8542C33.5623 23.3542 33.4373 23.8125 33.2082 24.2292C32.8853 24.8333 32.3436 25.3333 31.6561 25.7604C30.9582 26.1875 30.104 26.5312 29.1457 26.7812C29.1457 26.7812 29.1457 26.7708 29.1353 26.7812C25.4269 27.7396 20.3644 27.3021 17.9061 25.4688C17.2186 24.9583 16.7394 24.3333 16.5311 23.6146C16.4686 23.375 16.4373 23.1146 16.4373 22.8542V15.3646C16.4478 15.2083 16.3436 15.0521 16.1561 14.8958C15.5936 14.4479 14.2707 14.0208 12.7915 13.5938C11.6353 13.2708 10.3957 12.9479 9.354 12.6354C8.53109 12.3854 7.83317 12.1354 7.4165 11.8958C7.604 11.5312 7.82275 11.1667 8.05192 10.8229C9.51025 8.6875 11.7394 7.11458 14.3228 6.52083C15.0728 6.34375 15.8644 6.25 16.6665 6.25H27.9165C33.5103 7.22917 38.6665 9.51042 42.9894 12.7708C43.1561 13.1771 43.3019 13.6042 43.4061 14.0417C43.5936 14.7292 43.7082 15.4375 43.7394 16.1771C43.7498 16.3333 43.7498 16.5 43.7498 16.6667Z",
            fill: "#4928F4"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M43.7502 16.6667V21.2604L43.521 21.9688L42.7397 24.3958L41.9272 26.8958L41.5002 28.2292L41.1043 29.4688L40.7189 30.6458L40.3439 31.8125L40.146 32.4271L39.8856 33.2396C39.8856 34.0312 39.8647 34.7292 39.8127 35.3229C39.8022 35.3854 39.7918 35.4479 39.7918 35.5104C39.7293 36.0625 39.646 36.5312 39.5106 36.9271C39.5002 36.9896 39.4793 37.0521 39.4585 37.1042C39.1877 37.8542 38.7814 38.3333 38.1772 38.6458C38.0314 38.7292 37.8647 38.7917 37.6877 38.8542C37.1356 39.0417 36.4377 39.1354 35.5835 39.1875C34.9585 39.2292 34.2397 39.2396 33.4272 39.2396H32.7085L31.4689 39.1875L31.2502 39.1771L28.9897 39.0833L26.6981 38.9896L19.146 38.6771L17.1877 38.5937H16.9168C16.1043 38.5833 15.4064 38.5312 14.8022 38.4479C13.9272 38.3125 13.2502 38.0833 12.7397 37.7396C12.0106 37.2708 11.5835 36.5833 11.3335 35.625C11.271 35.3958 11.2189 35.1562 11.1877 34.8958C11.0835 34.2917 11.0314 33.5938 11.0002 32.8125C11.0002 32.6562 11.0002 32.5 10.9897 32.3333C10.9793 32.3229 10.9897 32.3229 10.9897 32.3229V31.7188C10.9793 31.4167 10.9793 31.1042 10.9793 30.7812L11.0314 29.1042L11.0627 27.9062L11.1043 26.5104V26.3125L11.1772 23.75L11.2502 21.1875L11.3231 18.7813L11.3856 16.4167L11.4064 15.7917C11.4064 15.4687 10.3127 15.2813 9.09391 15.125C8.12516 15 7.06266 14.8854 6.42725 14.7396C6.47933 14.5 6.53141 14.2604 6.59391 14.0312C6.78141 13.2812 7.06266 12.5729 7.41683 11.8958C7.60433 11.5312 7.82308 11.1667 8.05225 10.8229C10.3022 9.83333 12.646 9.0625 15.0939 8.5625C17.2397 8.11458 19.4793 7.875 21.7918 7.875C29.4585 7.875 36.5418 10.4688 42.146 14.8438C42.6877 15.2604 43.2189 15.7083 43.7397 16.1771C43.7502 16.3333 43.7502 16.5 43.7502 16.6667Z",
            fill: "#6200EA"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M43.75 19.1355V23.8647L43.1771 24.9688L42.0833 27.1042L41.5 28.2292L40.9688 29.2605L40.7396 29.7084C40.7396 30.0313 40.7396 30.3438 40.7188 30.6459C40.7188 31.0938 40.6979 31.5209 40.6667 31.9167C40.625 32.3855 40.5625 32.8126 40.5 33.2084C40.3438 34.0313 40.125 34.7397 39.8125 35.323C39.7708 35.3959 39.7292 35.4688 39.6875 35.5313C39.5729 35.7188 39.4375 35.8959 39.2917 36.0626C39.1042 36.2917 38.8958 36.4897 38.6562 36.6563C38.3021 36.9272 37.8854 37.1459 37.4062 37.3126C36.8125 37.5313 36.125 37.6772 35.3125 37.7605C34.7812 37.8126 34.1979 37.8438 33.5625 37.8438L33.125 37.8647L30.9583 37.9897H30.9479L28.6458 38.1251L26.3021 38.2605L23.0729 38.448L19.1458 38.6772L18.5729 38.7084C18.0417 38.7084 17.5417 38.6772 17.0625 38.6147C17.0104 38.6042 16.9687 38.5938 16.9167 38.5938C16.2083 38.4792 15.5625 38.2917 14.9792 38.0313C14.2708 37.7188 13.6562 37.3022 13.1354 36.8022C12.6771 36.3542 12.2812 35.8438 11.9583 35.2709C11.8854 35.1355 11.8125 35.0105 11.75 34.8647C11.4375 34.2501 11.1875 33.5626 11 32.8126C10.9688 32.6876 10.9375 32.5522 10.9167 32.4167C10.8542 32.1772 10.8021 31.9272 10.7708 31.6667C10.6562 31.0001 10.5938 30.2917 10.5625 29.5522V29.5417C10.5521 29.2397 10.5417 28.948 10.5417 28.6355L10.0312 27.4167L9.95833 27.2292L9.89583 27.073L9.11458 25.2084L8.98958 24.9063L8.23958 23.1042L7.40625 21.0938C7.40625 21.0938 7.40625 21.0938 7.39583 21.0938L6.55208 19.0626L6.25 18.323V16.6667C6.25 16.0105 6.3125 15.3647 6.42708 14.7397C6.47917 14.5001 6.53125 14.2605 6.59375 14.0313C7.47917 13.5209 8.40625 13.0522 9.35417 12.6355C11.5208 11.6667 13.8438 10.948 16.25 10.5105C18.0417 10.1876 19.9062 10.0105 21.7917 10.0105C29.4062 10.0105 36.3125 12.7709 41.7083 17.2709C41.9167 17.4376 42.1146 17.6042 42.3125 17.7813C42.8021 18.2084 43.2812 18.6563 43.75 19.1355Z",
            fill: "#673AB7"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M43.75 22.2396V27.5937L43.1562 28.8333L42.0312 31.1771L42.0208 31.2083C42.0208 31.6562 42 32.0625 41.9688 32.4271C41.8646 33.625 41.5729 34.3854 41.0938 34.8542C40.75 35.2083 40.3229 35.4062 39.7917 35.5104C39.7604 35.5208 39.7187 35.5208 39.6875 35.5312C39.5208 35.5625 39.3438 35.5833 39.1562 35.5833C38.5104 35.6458 37.75 35.6042 36.875 35.5417C36.7812 35.5417 36.6771 35.5312 36.5729 35.5208C35.9375 35.4792 35.2604 35.4375 34.5104 35.4062C34.1042 35.3958 33.6771 35.3854 33.2396 35.3854H33.2187L32.1667 35.4687H32.1562L29.7917 35.6354L27.0938 35.8437L26.6979 35.875L23.5417 36.1042L21.9062 36.2292L20.2917 36.3437C20.0104 36.3437 19.7396 36.3438 19.4688 36.3333C19.4688 36.3333 19.4583 36.3229 19.4583 36.3333C18.2812 36.3125 17.2292 36.2396 16.2917 36.0625C15.4271 35.9167 14.6667 35.6875 14.0208 35.3438C13.3542 35.0208 12.8021 34.5625 12.3542 33.9792C11.9271 33.4062 11.6146 32.6875 11.4167 31.8229C11.4167 31.8125 11.4167 31.8125 11.4167 31.8125C11.2708 31.1146 11.1875 30.3021 11.1875 29.3854L11.0312 29.1042L10.1042 27.4479L9.96875 27.2187L9.89583 27.0729L8.92708 25.3542L8.44792 24.4896L7.84375 23.4167L6.80208 21.5521L6.25 20.5729V16.7396C7.16667 16.1354 8.11458 15.6042 9.09375 15.125C10.2812 14.5208 11.5104 14.0104 12.7917 13.5938C14.1875 13.1354 15.6458 12.7708 17.1354 12.5312C18.6458 12.2812 20.1979 12.1562 21.7917 12.1562C28.875 12.1562 35.375 14.6875 40.3854 18.8958C40.6146 19.0729 40.8333 19.2708 41.0521 19.4583C41.9271 20.2396 42.7604 21.0833 43.5208 21.9688C43.6042 22.0625 43.6875 22.1458 43.75 22.2396Z",
            fill: "#8E24AA"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M43.75 25.7397V33.2709C43.5 33.1251 43.1562 32.948 42.7292 32.7605C42.5 32.6459 42.2396 32.5313 41.9688 32.4272C41.5729 32.2501 41.1458 32.0834 40.6667 31.9167C40.5625 31.8751 40.4583 31.8438 40.3438 31.8126C40.1562 31.7397 39.9583 31.6772 39.7604 31.6147C39.1458 31.4272 38.4688 31.2501 37.7604 31.0938C37.4896 31.0417 37.2083 30.9897 36.9271 30.948C36.0208 30.7917 35.0521 30.698 34.0417 30.6876C33.9583 30.6772 33.8646 30.6772 33.7812 30.6772L31.1042 30.698L27.4583 30.7188H27.4479L19.6458 30.7813C17.1667 30.7813 15.6458 31.3751 14.7292 31.6147C14.7292 31.6147 14.7188 31.6147 14.7188 31.6251C13.75 31.8751 13.4479 31.7188 13.3646 30.0209C13.3437 29.5522 13.3333 28.948 13.3333 28.2084L12.75 27.7605L11.7292 26.9897L11.1042 26.5105L10.9792 26.4167L9.25 25.1042L8.98958 24.9063L8.44792 24.4897L7.44792 23.7397L6.25 22.823V19.2813C6.35417 19.198 6.44792 19.1251 6.55208 19.0626C8.0625 18.0209 9.67708 17.1355 11.3854 16.4167C12.9062 15.7709 14.5104 15.2605 16.1562 14.8959C16.6042 14.8022 17.0625 14.7084 17.5312 14.6459C18.9167 14.4063 20.3438 14.2917 21.7917 14.2917C28.0521 14.2917 33.8021 16.4688 38.3646 20.073C39.0521 20.6147 39.7188 21.1876 40.3438 21.8022C41.1979 22.6147 42 23.4792 42.7396 24.3959C42.8854 24.5834 43.0312 24.7709 43.1771 24.9688C43.375 25.2188 43.5625 25.4792 43.75 25.7397Z",
            fill: "#C2185B"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M43.75 29.9167V33.3333C43.75 34.0104 43.6875 34.6771 43.5625 35.3229C43.375 36.2812 43.0521 37.1979 42.6146 38.0521C42.3854 38.1042 42.125 38.1042 41.8333 38.0625C41.1771 37.9479 40.4062 37.6042 39.5729 37.1562C39.5312 37.1458 39.4896 37.125 39.4583 37.1042C39.1979 36.9688 38.9271 36.8229 38.6562 36.6562C38.1042 36.3542 37.5208 36.0208 36.9375 35.7083C36.8125 35.6458 36.6875 35.5833 36.5729 35.5208C35.9062 35.1771 35.2188 34.8646 34.5312 34.625C34.5312 34.625 34.5312 34.625 34.5208 34.625C34.375 34.5729 34.2188 34.5208 34.0625 34.4792C33.4688 34.3125 32.8646 34.2083 32.2812 34.2083L31.1354 33.875L26.0625 32.4062C26.0625 32.4062 26.0625 32.4062 26.0521 32.4062L22.9375 31.5H22.9271L21.5729 31.1042C17.6562 31.1042 15.25 32.7708 14.0833 32.1354C13.625 31.8958 13.3542 31.2917 13.2604 30.1042C13.2292 29.7708 13.2187 29.3958 13.2187 28.9583L12 28.3646L11.9479 28.3437H11.9375L11.0625 27.9063L10.1042 27.4479L10.0312 27.4167L9.85417 27.3229L7.8125 26.3333L6.25 25.5729V22C6.42708 21.8438 6.61458 21.6979 6.80208 21.5521C7 21.3958 7.19792 21.25 7.39583 21.0938C7.40625 21.0938 7.40625 21.0938 7.40625 21.0938C8.63542 20.2083 9.9375 19.4271 11.3229 18.7813C12.9375 18.0104 14.6562 17.4167 16.4375 17.0313C16.6979 16.9688 16.9687 16.9063 17.2396 16.8646C18.7187 16.5833 20.2396 16.4375 21.7917 16.4375C27.2812 16.4375 32.3229 18.2188 36.3854 21.2188C37.5625 22.0938 38.6562 23.0625 39.6562 24.1146C40.4792 24.9792 41.2396 25.9167 41.9271 26.8958C41.9792 26.9688 42.0312 27.0417 42.0833 27.1042C42.4688 27.6667 42.8229 28.2396 43.1562 28.8333C43.375 29.1875 43.5625 29.5521 43.75 29.9167Z",
            fill: "#D81B60"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M43.5625 35.323C43.375 36.2813 43.0521 37.198 42.6146 38.0522C42.4167 38.4376 42.1979 38.8022 41.9583 39.1563C41.8125 39.3751 41.6562 39.5834 41.5 39.7813C41.125 39.6355 40.5729 39.4272 39.8958 39.198C39.8958 39.198 39.8958 39.198 39.8958 39.1876C39.3854 39.0105 38.8021 38.823 38.1771 38.6459C38 38.5938 37.8229 38.5417 37.6354 38.4897C36.8958 38.2917 36.125 38.1147 35.375 38.0105C34.75 37.9063 34.1354 37.8438 33.5625 37.8438L33.0833 37.7084H33.0729L30.5521 36.9792L29 36.5313L27.2708 36.0313H27.2604L26.6979 35.8751L19.8958 33.9167L17.9375 33.3542L16.4792 33.0105L14.1042 32.448L13.8125 32.3751C13.8125 32.3751 13.8125 32.3751 13.8021 32.3751L11.4167 31.823C11.4167 31.8126 11.4167 31.8126 11.4167 31.8126L10.9896 31.7188L10.7708 31.6667L9.03125 31.2605L8.83333 31.2084L7.35417 29.9897L6.25 29.0626V24.8126C6.63542 24.4376 7.03125 24.0834 7.44792 23.7397C7.57292 23.6251 7.70833 23.5209 7.84375 23.4167C7.96875 23.3126 8.10417 23.2084 8.23958 23.1042C9.1875 22.3855 10.1875 21.7397 11.25 21.1876C12.6042 20.4584 14.0417 19.8751 15.5521 19.4584C15.8438 19.3647 16.1354 19.2813 16.4375 19.2188C18.1458 18.7917 19.9375 18.573 21.7917 18.573C26.4479 18.573 30.7812 19.9792 34.3646 22.3855C36.1458 23.5834 37.75 25.0209 39.1042 26.6563C39.7917 27.4792 40.4167 28.3438 40.9688 29.2605C41.0208 29.3334 41.0625 29.3959 41.1042 29.4688C41.4375 30.0209 41.75 30.5938 42.0312 31.1772C42.2917 31.698 42.5208 32.2188 42.7292 32.7605C43.0625 33.5938 43.3333 34.448 43.5625 35.323Z",
            fill: "#F50057"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M41.9583 39.1562C41.8125 39.375 41.6562 39.5833 41.5 39.7812C41.0417 40.3542 40.5417 40.875 39.9792 41.3333C39.4896 41.7396 38.9688 42.1042 38.4167 42.4167C38.2083 42.3646 38 42.3021 37.7812 42.2187C37.0938 41.9792 36.375 41.5833 35.7083 41.1667C34.7083 40.5312 33.8437 39.8438 33.4583 39.5312C33.3125 39.4062 33.2396 39.3438 33.2396 39.3438L31.4687 39.1875L31.25 39.1667L28.9583 38.9688L26.5833 38.7604L23.0729 38.4479L17.5104 37.9583L17.4896 37.9479L15.5312 37L13.5521 36.0417L11.9583 35.2708L11.6146 35.1042L11.1875 34.8958L9.70833 34.1771L7.73958 33.2292L7.125 32.9271L6.25 32.6563V28C6.73958 27.4167 7.26042 26.8646 7.8125 26.3333C8.16667 26 8.54167 25.6667 8.92708 25.3542C8.98958 25.3021 9.05208 25.25 9.11458 25.2083C9.15625 25.1563 9.20833 25.125 9.25 25.1042C9.86458 24.6042 10.5104 24.1562 11.1771 23.75C11.9479 23.2604 12.7604 22.8229 13.6042 22.4583C14.5104 22.0521 15.4583 21.7083 16.4375 21.4479C18.1354 20.9688 19.9375 20.7188 21.7917 20.7188C26.0417 20.7188 29.9687 22.0104 33.2083 24.2292C35.2812 25.6458 37.0729 27.4375 38.4896 29.5104C38.9583 30.1771 39.375 30.8854 39.7604 31.6146C39.8958 31.8854 40.0312 32.1562 40.1458 32.4271C40.2708 32.6875 40.3854 32.9479 40.5 33.2083C40.7188 33.75 40.9167 34.2917 41.0938 34.8542C41.4271 35.8958 41.6771 36.9583 41.8333 38.0625C41.8854 38.4271 41.9271 38.7917 41.9583 39.1562Z",
            fill: "#FF1744"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M39.9896 41.0626C39.9896 41.1459 39.9896 41.2397 39.9792 41.3334C39.4896 41.7397 38.9688 42.1042 38.4167 42.4167C38.1875 42.5417 37.9583 42.6667 37.7187 42.7709C37.4792 42.8855 37.2396 42.9897 36.9896 43.0834C36.6354 42.8959 36.1562 42.6667 35.6458 42.448C34.9271 42.1251 34.1458 41.8334 33.5417 41.7397C33.3958 41.7084 33.2604 41.698 33.1354 41.698L31.4271 41.4792H31.4062L29.2812 41.198L27.1354 40.9167L26.1354 40.7917L18.2604 39.7709C17.75 39.7709 17.2083 39.7397 16.6458 39.6667C15.9583 39.6042 15.2396 39.5001 14.5208 39.3542C13.8125 39.2292 13.0937 39.0626 12.4062 38.8855C11.6875 38.7188 10.9792 38.5209 10.3229 38.3334C9.5625 38.1042 8.85417 37.8855 8.26042 37.6876C7.77083 37.5313 7.35417 37.3855 7.03125 37.2709C6.84375 36.823 6.6875 36.3542 6.57292 35.8751C6.35417 35.0626 6.25 34.2084 6.25 33.3334V31.5938C6.58333 31.0417 6.94792 30.5001 7.35417 29.9897C8.09375 29.0105 8.9375 28.1147 9.85417 27.323C9.88542 27.2813 9.92708 27.2501 9.95833 27.2292L9.96875 27.2188C10.2917 26.9272 10.625 26.6667 10.9792 26.4167C11.0208 26.3751 11.0625 26.3438 11.1042 26.3126C11.2708 26.1876 11.4479 26.0626 11.6354 25.948C13.125 24.9376 14.7708 24.1459 16.5312 23.6147C18.1979 23.1147 19.9583 22.8542 21.7917 22.8542C25.4271 22.8542 28.8229 23.9272 31.6562 25.7605C33.75 27.1042 35.5521 28.8751 36.9271 30.948C37.0938 31.1876 37.25 31.4272 37.4062 31.6772C38.125 32.8959 38.7188 34.2084 39.1562 35.5834C39.2083 35.7397 39.25 35.8959 39.2917 36.0626C39.375 36.3438 39.4479 36.6355 39.5104 36.9272C39.5312 37.0001 39.5521 37.073 39.5729 37.1563C39.7188 37.8126 39.8229 38.5001 39.8958 39.1876C39.8958 39.198 39.8958 39.198 39.8958 39.198C39.9583 39.8126 39.9896 40.4376 39.9896 41.0626Z",
            fill: "#FF5722"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M37.8436 41.0625C37.8436 41.4271 37.8228 41.8229 37.7811 42.2187C37.7603 42.4062 37.7394 42.5938 37.7186 42.7708C37.479 42.8854 37.2394 42.9896 36.9894 43.0833C36.5207 43.2604 36.0415 43.4062 35.5519 43.5104C35.2186 43.5833 34.8748 43.6458 34.5311 43.6771H34.5207C34.1978 43.4792 33.8228 43.2396 33.4373 42.9688C32.7394 42.4792 32.0103 41.9271 31.4269 41.4792C31.4165 41.4688 31.4165 41.4687 31.4061 41.4583C30.7915 40.9896 30.354 40.6354 30.354 40.6354L29.2498 40.6771L27.1248 40.75L26.1353 40.7917L22.1561 40.9375L18.7915 41.0625C18.5728 41.0729 18.3123 41.0729 17.9894 41.0625H17.979C17.5415 41.0521 17.0207 41.0208 16.4478 40.9688C15.7811 40.9167 15.0519 40.8542 14.3123 40.7813C13.5936 40.6979 12.8644 40.6146 12.1665 40.5312C11.3957 40.4479 10.6665 40.3542 10.0415 40.2708C9.55192 40.2083 9.12484 40.1562 8.78109 40.1146C8.48942 39.7812 8.229 39.4375 7.979 39.0625C7.604 38.5 7.28109 37.9062 7.03109 37.2708C6.84359 36.8229 6.68734 36.3542 6.57275 35.875C6.87484 34.9479 7.27067 34.0729 7.73942 33.2292C8.11442 32.5417 8.55192 31.8854 9.03109 31.2604C9.49984 30.6458 10.0103 30.0729 10.5623 29.5521V29.5417C10.7186 29.3854 10.8748 29.2396 11.0311 29.1042C11.3228 28.8333 11.6248 28.5833 11.9373 28.3437H11.9478C11.9582 28.3229 11.9686 28.3229 11.979 28.3125C12.229 28.1146 12.4894 27.9375 12.7498 27.7604C14.2915 26.7083 16.0311 25.9271 17.9061 25.4688C19.1457 25.1667 20.4478 25 21.7915 25C24.4373 25 26.9373 25.6354 29.1353 26.7812H29.1457C31.0311 27.75 32.6978 29.0833 34.0415 30.6875C34.7811 31.5417 35.4165 32.4792 35.9373 33.4688C36.3019 34.1354 36.6144 34.8333 36.8748 35.5417C36.8957 35.6042 36.9165 35.6562 36.9373 35.7083C37.1144 36.2292 37.2707 36.7708 37.4061 37.3125C37.4998 37.6979 37.5728 38.0938 37.6353 38.4896C37.6561 38.6146 37.6769 38.7292 37.6873 38.8542C37.7915 39.5729 37.8436 40.3125 37.8436 41.0625Z",
            fill: "#FF6F00"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M35.7082 41.0624V41.1666C35.7082 41.5208 35.6769 41.9687 35.6457 42.4478C35.6144 42.802 35.5832 43.1666 35.5519 43.5103C35.2186 43.5833 34.8748 43.6458 34.5311 43.677H34.5207C34.1248 43.7291 33.7394 43.7499 33.3332 43.7499H31.5103L31.1144 43.6353L29.0623 43.0103L26.979 42.3853L22.1561 40.9374L20.0728 40.3124C20.0728 40.3124 19.2082 40.6562 17.9894 41.0624H17.979C17.5103 41.2187 16.9998 41.3853 16.4582 41.552C15.7811 41.7499 15.0623 41.9478 14.354 42.1041C13.6248 42.2708 12.9061 42.3958 12.2603 42.4478C12.0623 42.4687 11.8644 42.4791 11.6873 42.4791C11.104 42.1562 10.5415 41.7708 10.0311 41.3437C9.58317 40.9687 9.1665 40.5624 8.78109 40.1145C8.48942 39.7812 8.229 39.4374 7.979 39.0624C8.05192 38.5937 8.13525 38.1353 8.26025 37.6874C8.57275 36.4478 9.06234 35.2603 9.70817 34.177C10.0623 33.5624 10.4582 32.9687 10.9165 32.4166C10.9269 32.3853 10.9582 32.3541 10.9894 32.3333C10.979 32.3228 10.9894 32.3228 10.9894 32.3228C11.1248 32.1458 11.2707 31.9791 11.4165 31.8228C11.4165 31.8124 11.4165 31.8124 11.4165 31.8124C11.8436 31.3541 12.2811 30.9166 12.7603 30.5103C12.9269 30.3749 13.0832 30.2395 13.2603 30.1041C13.2915 30.0728 13.3228 30.052 13.3644 30.0208C15.7082 28.2291 18.6353 27.1458 21.7915 27.1458C25.3748 27.1458 28.6353 28.4895 31.104 30.6978C32.2915 31.7708 33.3019 33.052 34.0623 34.4791C34.1248 34.5833 34.1873 34.6978 34.2394 34.8124C34.3332 34.9999 34.4269 35.1978 34.5103 35.4062C34.854 36.1562 35.1248 36.9478 35.3123 37.7603C35.3332 37.8437 35.354 37.927 35.3748 38.0103C35.4582 38.3958 35.5311 38.7916 35.5832 39.1874C35.6665 39.802 35.7082 40.427 35.7082 41.0624Z",
            fill: "#FF9800"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M33.5623 41.0625C33.5623 41.2708 33.5519 41.5 33.5415 41.7396C33.5207 42.125 33.4894 42.5417 33.4373 42.9687C33.4165 43.2292 33.3748 43.4896 33.3332 43.75H27.6248L26.5207 43.5729L22.2082 42.8854L21.5936 42.7917L20.1873 42.5625C19.5728 42.5625 18.2394 42.8333 16.8332 43.0937C16.0936 43.2292 15.3436 43.375 14.6665 43.4687C14.5832 43.4792 14.4998 43.4896 14.4269 43.5H14.4165C13.6873 43.3437 12.979 43.1042 12.3123 42.7917C12.104 42.6979 11.8957 42.5937 11.6873 42.4792C11.104 42.1562 10.5415 41.7708 10.0311 41.3437C10.0207 41.2187 10.0103 41.1146 10.0103 41.0625C10.0103 40.7917 10.0207 40.5312 10.0415 40.2708C10.0832 39.6042 10.1769 38.9583 10.3228 38.3333C10.5519 37.3854 10.8853 36.4688 11.3332 35.625C11.4165 35.4479 11.5103 35.2708 11.6144 35.1042C11.6561 35.0208 11.7082 34.9479 11.7498 34.8646C11.9373 34.5625 12.1457 34.2708 12.354 33.9792C12.7915 33.4062 13.2811 32.8646 13.8019 32.375C13.8123 32.375 13.8123 32.375 13.8123 32.375C13.854 32.3333 13.8957 32.2917 13.9373 32.2604C13.9894 32.2187 14.0311 32.1667 14.0832 32.1354C14.2915 31.9479 14.4998 31.7812 14.7186 31.625C14.7186 31.6146 14.729 31.6146 14.729 31.6146C16.6978 30.1458 19.1353 29.2812 21.7915 29.2812C23.854 29.2812 25.7707 29.8021 27.4478 30.7187H27.4582C28.8957 31.5104 30.1457 32.5833 31.1353 33.875C31.5207 34.375 31.8644 34.9062 32.1561 35.4687H32.1665C32.2186 35.5729 32.2707 35.6771 32.3228 35.7812C32.6353 36.3958 32.8853 37.0417 33.0728 37.7083H33.0832C33.0936 37.7604 33.1144 37.8125 33.1248 37.8646C33.2498 38.3125 33.354 38.7708 33.4269 39.2396C33.4373 39.3333 33.4478 39.4375 33.4582 39.5312C33.5311 40.0312 33.5623 40.5417 33.5623 41.0625Z",
            fill: "#FFC107"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M31.4271 40.9478C31.4271 41.1145 31.4271 41.2916 31.4062 41.4583V41.4687C31.4062 41.4791 31.4062 41.4791 31.4062 41.4791C31.3854 42.2291 31.2812 42.9687 31.1146 43.6353C31.1146 43.677 31.1042 43.7083 31.0833 43.7499H26.2187L22.2083 42.8853L21.6771 42.7708L21.5937 42.7916L17.1458 43.7083L16.9479 43.7499H16.6667C16 43.7499 15.3437 43.6874 14.7083 43.5624C14.6146 43.5416 14.5208 43.5208 14.4271 43.4999H14.4167C13.6875 43.3437 12.9792 43.1041 12.3125 42.7916C12.2917 42.677 12.2708 42.5624 12.2604 42.4478C12.1875 41.9999 12.1562 41.5312 12.1562 41.0624C12.1562 40.8853 12.1563 40.7083 12.1667 40.5312C12.1979 39.9687 12.2812 39.4166 12.4062 38.8853C12.4896 38.4895 12.6042 38.1041 12.7396 37.7395C12.8542 37.4166 12.9896 37.1041 13.1354 36.802C13.2604 36.5416 13.4063 36.2916 13.5521 36.0416C13.6979 35.802 13.8542 35.5728 14.0208 35.3437C14.4375 34.7708 14.9271 34.2395 15.4688 33.7707C15.7813 33.4999 16.125 33.2395 16.4792 33.0103C18 32.0103 19.8229 31.427 21.7917 31.427C22.1771 31.427 22.5521 31.4478 22.9167 31.4999H22.9375C24.0521 31.6249 25.0938 31.9374 26.0521 32.4062C26.0625 32.4062 26.0625 32.4062 26.0625 32.4062C27.5729 33.1458 28.8542 34.2603 29.7917 35.6353C29.9479 35.8645 30.1042 36.1145 30.2396 36.3645C30.3542 36.5624 30.4583 36.7708 30.5521 36.9791C30.6979 37.302 30.8333 37.6458 30.9479 37.9895H30.9583C31.0729 38.3749 31.1771 38.7603 31.25 39.1666V39.177C31.3646 39.7499 31.4271 40.3437 31.4271 40.9478Z",
            fill: "#FFD54F"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M29.2811 41.1667V41.198C29.2811 41.8126 29.2082 42.4167 29.0623 43.0105C29.0103 43.2605 28.9373 43.5105 28.8436 43.7501H24.1769L21.7915 43.0938L19.4061 43.7501H16.6665C15.9998 43.7501 15.3436 43.6876 14.7082 43.5626C14.6873 43.5313 14.6769 43.5001 14.6665 43.4688C14.5207 43.0209 14.4061 42.573 14.354 42.1042C14.3123 41.8022 14.2915 41.4897 14.2915 41.1667C14.2915 41.0417 14.2915 40.9063 14.3123 40.7813C14.3228 40.2917 14.3957 39.8126 14.5207 39.3542C14.5832 39.0417 14.6769 38.7397 14.8019 38.448C14.8436 38.3022 14.9061 38.1667 14.979 38.0313C15.1353 37.6772 15.3228 37.3334 15.5311 37.0001C15.7603 36.6667 16.0103 36.3542 16.2915 36.0626C16.6248 35.6876 16.9998 35.3438 17.4269 35.0626C18.1561 34.5313 18.9894 34.1355 19.8957 33.9167C20.4998 33.7501 21.1353 33.6667 21.7915 33.6667C23.8748 33.6667 25.7394 34.5001 27.0936 35.8438C27.1457 35.8959 27.2082 35.9584 27.2603 36.0313H27.2707C27.4165 36.1876 27.5519 36.3438 27.6873 36.5209C28.0728 37.0105 28.3957 37.5417 28.6457 38.1251C28.7707 38.3959 28.8748 38.6772 28.9582 38.9688C28.9686 39.0105 28.979 39.0417 28.9894 39.0834C29.1353 39.5938 29.229 40.1251 29.2498 40.6772C29.2707 40.8334 29.2811 41.0001 29.2811 41.1667Z",
            fill: "#FFE082"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M27.1458 41.1667C27.1458 41.5937 27.0937 42 26.9792 42.3854C26.875 42.8021 26.7187 43.1979 26.5208 43.5729C26.4896 43.6354 26.4167 43.75 26.4167 43.75H17.1667C17.1562 43.7396 17.1458 43.7187 17.1458 43.7083C17.0208 43.5104 16.9167 43.3125 16.8333 43.0937C16.625 42.6146 16.5 42.0937 16.4583 41.5521C16.4375 41.4271 16.4375 41.2917 16.4375 41.1667C16.4375 41.1042 16.4375 41.0313 16.4479 40.9688C16.4583 40.5104 16.5208 40.0729 16.6458 39.6667C16.75 39.2917 16.8854 38.9479 17.0625 38.6146C17.0625 38.6146 17.0729 38.6042 17.0729 38.5937C17.1979 38.375 17.3333 38.1562 17.4896 37.9479C18 37.2604 18.6771 36.6979 19.4583 36.3333C19.4688 36.3333 19.4688 36.3333 19.4688 36.3333C19.7188 36.2083 19.9792 36.1042 20.25 36.0312C20.25 36.0312 20.25 36.0312 20.2604 36.0312C20.7396 35.8854 21.2604 35.8125 21.7917 35.8125C22.4062 35.8125 23 35.9062 23.5417 36.1042C23.7396 36.1562 23.9271 36.2396 24.1146 36.3333C24.1146 36.3333 24.1146 36.3333 24.125 36.3333C25.0208 36.7604 25.7812 37.4271 26.3021 38.2604C26.4062 38.4167 26.5 38.5833 26.5833 38.7604C26.625 38.8333 26.6667 38.9167 26.6979 38.9896C26.9375 39.5312 27.0833 40.125 27.125 40.75C27.1354 40.8021 27.1354 40.8542 27.1354 40.9167C27.1458 41 27.1458 41.0833 27.1458 41.1667Z",
            fill: "#FFECB3"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M31.2502 11.4583H18.7502C14.6877 11.4583 11.4585 14.6874 11.4585 18.7499V31.2499C11.4585 35.3124 14.6877 38.5416 18.7502 38.5416H31.2502C35.3127 38.5416 38.5418 35.3124 38.5418 31.2499V18.7499C38.5418 14.6874 35.3127 11.4583 31.2502 11.4583Z",
            stroke: "white",
            strokeWidth: "2.08333",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M32.2917 17.7083C32.867 17.7083 33.3333 17.242 33.3333 16.6667C33.3333 16.0914 32.867 15.625 32.2917 15.625C31.7164 15.625 31.25 16.0914 31.25 16.6667C31.25 17.242 31.7164 17.7083 32.2917 17.7083Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M25 31.25C28.4518 31.25 31.25 28.4518 31.25 25C31.25 21.5482 28.4518 18.75 25 18.75C21.5482 18.75 18.75 21.5482 18.75 25C18.75 28.4518 21.5482 31.25 25 31.25Z",
            stroke: "white",
            strokeWidth: "2.08333",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
const F2 = ({ size: C = "20px" }) => /* @__PURE__ */ t(
  "svg",
  {
    width: C,
    height: C,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M41 4H9C6.24 4 4 6.24 4 9V41C4 43.76 6.24 46 9 46H41C43.76 46 46 43.76 46 41V9C46 6.24 43.76 4 41 4ZM17 20V39H11V20H17ZM11 14.47C11 13.07 12.2 12 14 12C15.8 12 16.93 13.07 17 14.47C17 15.87 15.88 17 14 17C12.2 17 11 15.87 11 14.47ZM39 39H33C33 39 33 29.74 33 29C33 27 32 25 29.5 24.96H29.42C27 24.96 26 27.02 26 29C26 29.91 26 39 26 39H20V20H26V22.56C26 22.56 27.93 20 31.81 20C35.78 20 39 22.73 39 28.26V39Z",
        fill: "currentColor"
      }
    )
  }
);
function I2({ size: C = "20px" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M9 4C6.25048 4 4 6.25048 4 9V41C4 43.7495 6.25048 46 9 46H41C43.7495 46 46 43.7495 46 41V9C46 6.25048 43.7495 4 41 4H9ZM9 6H41C42.6685 6 44 7.33152 44 9V41C44 42.6685 42.6685 44 41 44H9C7.33152 44 6 42.6685 6 41V9C6 7.33152 7.33152 6 9 6ZM14 11.0117C12.9048 11.0117 11.9192 11.3391 11.1895 11.9531C10.4597 12.5672 10.0117 13.4845 10.0117 14.4668C10.0117 16.334 11.6313 17.7896 13.6914 17.9336L13.6953 17.9355C13.7935 17.969 13.8963 17.9868 14 17.9883C16.273 17.9883 17.9883 16.3961 17.9883 14.4668C17.9881 14.4492 17.9874 14.4316 17.9863 14.4141C17.8846 12.5138 16.1904 11.0117 14 11.0117ZM14 12.9883C15.3922 12.9883 15.942 13.61 16.002 14.4922C15.9898 15.3484 15.4601 16.0117 14 16.0117C12.6146 16.0117 11.9883 15.3022 11.9883 14.4668C11.9883 14.0491 12.1407 13.7343 12.4609 13.4648C12.7812 13.1954 13.2952 12.9883 14 12.9883ZM11 19C10.7348 19 10.4805 19.1054 10.2929 19.2929C10.1054 19.4805 10 19.7348 10 20V39C10 39.2652 10.1054 39.5195 10.2929 39.7071C10.4805 39.8946 10.7348 40 11 40H17C17.2652 40 17.5195 39.8946 17.7071 39.7071C17.8946 39.5195 18 39.2652 18 39V33.1348V20C18 19.7348 17.8946 19.4805 17.7071 19.2929C17.5195 19.1054 17.2652 19 17 19H11ZM20 19C19.7348 19 19.4805 19.1054 19.2929 19.2929C19.1054 19.4805 19 19.7348 19 20V39C19 39.2652 19.1054 39.5195 19.2929 39.7071C19.4805 39.8946 19.7348 40 20 40H26C26.2652 40 26.5195 39.8946 26.7071 39.7071C26.8946 39.5195 27 39.2652 27 39V29C27 28.1703 27.2264 27.345 27.625 26.8047C28.0236 26.2643 28.5265 25.9401 29.4824 25.957C30.4682 25.974 30.99 26.3117 31.3848 26.8418C31.7795 27.3719 32 28.1667 32 29V39C32 39.2652 32.1054 39.5195 32.2929 39.7071C32.4805 39.8946 32.7348 40 33 40H39C39.2652 40 39.5195 39.8946 39.7071 39.7071C39.8946 39.5195 40 39.2652 40 39V28.2617C40 25.3002 39.1228 22.9543 37.6191 21.3672C36.1155 19.78 34.0242 19 31.8125 19C29.7105 19 28.1109 19.7049 27 20.4238V20C27 19.7348 26.8946 19.4805 26.7071 19.2929C26.5195 19.1054 26.2652 19 26 19H20ZM12 21H16V33.1348V38H12V21ZM21 21H25V22.5605C25.0001 22.7702 25.066 22.9746 25.1886 23.1447C25.3111 23.3149 25.4841 23.4422 25.6829 23.5087C25.8818 23.5752 26.0965 23.5775 26.2968 23.5153C26.497 23.4531 26.6726 23.3296 26.7988 23.1621C26.7988 23.1621 28.3692 21 31.8125 21C33.5658 21 35.0694 21.5826 36.168 22.7422C37.2666 23.9018 38 25.6883 38 28.2617V38H34V29C34 27.8333 33.7205 26.6271 32.9902 25.6465C32.26 24.6659 31.0318 23.9831 29.5176 23.957C27.9955 23.93 26.7475 24.627 26.0156 25.6191C25.2837 26.6113 25 27.8297 25 29V38H21V21Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function R2({ size: C = "20px" }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M43.75 38.5417C43.75 41.4187 41.4187 43.75 38.5417 43.75H11.4583C8.58229 43.75 6.25 41.4187 6.25 38.5417V11.4583C6.25 8.58125 8.58229 6.25 11.4583 6.25H38.5417C41.4187 6.25 43.75 8.58125 43.75 11.4583V38.5417Z",
            fill: "#0288D1"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M12.5 19.7917H17.7083V37.5H12.5V19.7917ZM15.0885 17.7083H15.0594C13.5052 17.7083 12.5 16.55 12.5 15.1031C12.5 13.625 13.5365 12.5 15.1187 12.5C16.7031 12.5 17.6792 13.625 17.7083 15.1031C17.7083 16.549 16.7031 17.7083 15.0885 17.7083ZM37.5 37.5H32.2917V28.0219C32.2917 25.7323 31.0156 24.1698 28.9667 24.1698C27.4031 24.1698 26.5573 25.224 26.1469 26.2427C25.9969 26.6073 26.0417 27.6156 26.0417 28.125V37.5H20.8333V19.7917H26.0417V22.5167C26.7927 21.3542 27.9688 19.7917 30.9771 19.7917C34.7042 19.7917 37.499 22.1354 37.499 27.3687L37.5 37.5Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
const A2 = ({ size: C = "20px" }) => /* @__PURE__ */ t(
  "svg",
  {
    width: C,
    height: C,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M25 2C12.3179 2 2 12.3179 2 25C2 34.8842 8.26758 43.3303 17.0364 46.577C16.7838 44.3254 16.8234 40.6379 17.2402 38.8526C17.6304 37.1756 19.7614 28.1655 19.7614 28.1655C19.7614 28.1655 19.1181 26.8771 19.1181 24.9744C19.1181 21.9842 20.8505 19.7532 23.0079 19.7532C24.8429 19.7532 25.7277 21.1308 25.7277 22.7814C25.7277 24.6271 24.5543 27.384 23.9465 29.9392C23.4396 32.0801 25.0198 33.8257 27.1301 33.8257C30.9514 33.8257 33.8886 29.7961 33.8886 23.9804C33.8886 18.8328 30.1906 15.2332 24.9091 15.2332C18.7923 15.2332 15.2018 19.8218 15.2018 24.5642C15.2018 26.4116 15.913 28.3929 16.8019 29.4712C16.9772 29.6845 17.0028 29.8706 16.9507 30.0872C16.7878 30.7661 16.4257 32.2265 16.3537 32.5258C16.2603 32.9203 16.0419 33.0021 15.6351 32.8127C12.9493 31.5624 11.2706 27.6371 11.2706 24.4832C11.2706 17.7016 16.1974 11.4724 25.4771 11.4724C32.936 11.4724 38.7319 16.7862 38.7319 23.8903C38.7319 31.3003 34.059 37.2632 27.575 37.2632C25.3961 37.2632 23.3486 36.1312 22.6483 34.7941C22.6483 34.7941 21.5699 38.8989 21.3078 39.9053C20.8553 41.6457 18.9185 45.2513 17.9462 46.889C20.1705 47.6075 22.5398 48 25 48C37.6826 48 48 37.6826 48 25C48 12.3179 37.6826 2 25 2Z",
        fill: "currentColor"
      }
    )
  }
);
function $2({ size: C = "20px" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M25 2C12.3093 2 2 12.3093 2 25C2 37.6907 12.3093 48 25 48C37.6907 48 48 37.6907 48 25C48 12.3093 37.6907 2 25 2ZM25 4C36.6098 4 46 13.3902 46 25C46 36.6098 36.6098 46 25 46C22.8764 46 20.8277 45.6821 18.8965 45.0977C19.7567 43.6594 20.8673 41.6036 21.3086 39.9062C21.5707 38.8999 22.6484 34.7949 22.6484 34.7949C23.3488 36.1321 25.3953 37.2637 27.5742 37.2637C34.0581 37.2637 38.7324 31.3007 38.7324 23.8906C38.7324 16.7865 32.9354 11.4727 25.4766 11.4727C16.1968 11.4727 11.2715 17.7008 11.2715 24.4824C11.2715 27.6363 12.9489 31.5622 15.6348 32.8125C16.0416 33.0019 16.2601 32.9198 16.3535 32.5254C16.4255 32.226 16.7883 30.7668 16.9512 30.0879C17.0033 29.8712 16.978 29.6841 16.8027 29.4707C15.9138 28.3924 15.2012 26.4118 15.2012 24.5645C15.2012 19.822 18.7915 15.2324 24.9082 15.2324C30.1898 15.2324 33.8887 18.8329 33.8887 23.9805C33.8887 29.7962 30.9521 33.8262 27.1309 33.8262C25.0206 33.8262 23.4404 32.0804 23.9473 29.9395C24.5551 27.3843 25.7285 24.6269 25.7285 22.7812C25.7285 21.1307 24.8428 19.7539 23.0078 19.7539C20.8504 19.7539 19.1172 21.9845 19.1172 24.9746C19.1172 26.8774 19.7617 28.166 19.7617 28.166C19.7617 28.166 17.6305 37.1765 17.2402 38.8535C16.8491 40.5293 16.9539 42.7864 17.1152 44.4668C9.42114 41.3525 4 33.8193 4 25C4 13.3902 13.3902 4 25 4Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function E2({ size: C = "20px" }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M24.9998 45.8334C36.5058 45.8334 45.8332 36.506 45.8332 25.0001C45.8332 13.4941 36.5058 4.16675 24.9998 4.16675C13.4939 4.16675 4.1665 13.4941 4.1665 25.0001C4.1665 36.506 13.4939 45.8334 24.9998 45.8334Z",
            fill: "#E60023"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M25.4623 11.8918C16.4703 11.8918 11.6963 17.9279 11.6963 24.4992C11.6963 27.5553 13.3229 31.359 15.9255 32.5705C16.3196 32.754 16.5312 32.6747 16.6218 32.2925C16.6914 32.0024 17.0424 30.5874 17.2003 29.9295C17.2507 29.7196 17.2259 29.5393 17.0561 29.3325C16.1946 28.2877 15.5056 26.3678 15.5056 24.5777C15.5056 19.9824 18.9847 15.5361 24.9118 15.5361C30.0296 15.5361 33.6129 19.0241 33.6129 24.012C33.6129 29.6474 30.7668 33.5521 27.0641 33.5521C25.0192 33.5521 23.488 31.8606 23.9791 29.7861C24.5681 27.3101 25.7051 24.6387 25.7051 22.8502C25.7051 21.2508 24.8477 19.9159 23.0697 19.9159C20.9791 19.9159 19.3004 22.0777 19.3004 24.9752C19.3004 26.8189 19.9238 28.0673 19.9238 28.0673C19.9238 28.0673 17.8589 36.7981 17.4807 38.4231C17.062 40.2171 17.2252 42.7372 17.4064 44.3849C17.8763 44.5692 18.3464 44.7534 18.8322 44.9038C19.6831 43.5206 20.952 41.252 21.4222 39.4431C21.6762 38.468 22.7211 34.4904 22.7211 34.4904C23.3998 35.7861 25.3837 36.883 27.4952 36.883C33.778 36.883 38.306 31.1049 38.306 23.9247C38.306 17.0409 32.6898 11.8918 25.4623 11.8918Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
const W2 = ({ size: C = "20px" }) => /* @__PURE__ */ c(
  "svg",
  {
    width: C,
    height: C,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t("g", { clipPath: "url(#clip0_6538_91314)", children: /* @__PURE__ */ t(
        "path",
        {
          d: "M14.2812 0C6.41016 0 0 6.32422 0 14.0938C0 16.4766 0.621094 18.8008 1.78125 20.875C1.50781 22.3125 1.375 23.793 1.375 25.25C1.375 38.25 12.0742 48.8125 25.25 48.8125C26.6016 48.8125 27.9531 48.7227 29.2812 48.5C31.2578 49.4883 33.4805 50 35.7188 50C43.5898 50 50 43.6758 50 35.9062C50 33.8203 49.5391 31.8281 48.6562 29.9688C48.9766 28.4336 49.1562 26.8477 49.1562 25.25C49.1562 12.2539 38.4258 1.6875 25.25 1.6875C24.0117 1.6875 22.7617 1.78125 21.5312 1.96875C19.3359 0.683594 16.8477 0 14.2812 0ZM25.0938 9.375C27.1406 9.375 28.9336 9.59766 30.4375 10.0625C31.9453 10.5234 33.2227 11.1367 34.2188 11.9062C35.2266 12.6836 35.9961 13.5117 36.4688 14.375C36.9453 15.2461 37.1875 16.1328 37.1875 16.9688C37.1875 17.7773 36.8438 18.4844 36.2188 19.125C35.5938 19.7656 34.8086 20.0938 33.875 20.0938C33.0273 20.0938 32.3672 19.8984 31.9062 19.5C31.4766 19.125 31.0234 18.5547 30.5312 17.7188C29.9609 16.6484 29.293 15.7773 28.5 15.1875C27.7305 14.6133 26.4219 14.3438 24.6562 14.3438C23.0156 14.3438 21.6758 14.6406 20.6875 15.2812C19.7305 15.8984 19.2812 16.6289 19.2812 17.4688C19.2812 17.9844 19.4414 18.4102 19.75 18.7812C20.0781 19.1719 20.5117 19.4961 21.0938 19.7812C21.6953 20.0781 22.3164 20.332 22.9375 20.5C23.5742 20.6719 24.6602 20.9453 26.125 21.2812C27.9766 21.6758 29.6797 22.0898 31.1875 22.5625C32.7109 23.0469 34.0195 23.6523 35.0938 24.3438C36.1875 25.0469 37.0703 25.9492 37.6875 27.0312C38.3047 28.1133 38.5938 29.4414 38.5938 31C38.5898 32.8594 38.0664 34.5469 37 36.0312C35.9375 37.5117 34.3711 38.7031 32.3438 39.5312C30.3359 40.3516 27.9258 40.75 25.1875 40.75C21.8984 40.75 19.1484 40.1914 17 39.0625C15.4609 38.2461 14.1758 37.1172 13.2188 35.75C12.2422 34.3672 11.75 33.0117 11.75 31.6875C11.75 30.8633 12.0859 30.1523 12.7188 29.5625C13.3477 28.9844 14.1367 28.6875 15.0938 28.6875C15.8789 28.6875 16.5742 28.9141 17.125 29.375C17.6562 29.8164 18.1055 30.4727 18.4688 31.3125C18.875 32.2305 19.3086 32.9805 19.7812 33.5938C20.2266 34.1758 20.8633 34.6797 21.6875 35.0625C22.5156 35.4531 23.6523 35.6562 25.0312 35.6562C26.9258 35.6562 28.4609 35.2539 29.625 34.4688C30.7656 33.7031 31.3438 32.7852 31.3438 31.6562C31.3438 30.7656 31.0312 30.0469 30.4375 29.5C29.8125 28.9258 28.9922 28.4922 28 28.1875C26.957 27.8711 25.5586 27.5195 23.8125 27.1562C21.4375 26.6523 19.418 26.0469 17.8125 25.375C16.168 24.6836 14.8438 23.7227 13.875 22.5312C12.8906 21.3164 12.375 19.8203 12.375 18.0312C12.375 16.3242 12.9023 14.7617 13.9375 13.4375C14.957 12.125 16.4492 11.1055 18.375 10.4062C20.2734 9.71094 22.5391 9.375 25.0938 9.375Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "clip0_6538_91314", children: /* @__PURE__ */ t("rect", { width: "50", height: "50", fill: "white" }) }) })
    ]
  }
);
function U2({ size: C = "20px" }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t("g", { clipPath: "url(#clip0_6538_91284)", children: /* @__PURE__ */ t(
          "path",
          {
            d: "M14.2812 0C6.41797 0 0 6.32031 0 14.0938C0 16.5508 0.6875 18.8281 1.8125 20.8438C1.53906 22.2734 1.375 23.7461 1.375 25.25C1.375 38.2695 12.0742 48.8125 25.25 48.8125C26.625 48.8125 27.9648 48.6914 29.2812 48.4688C31.2148 49.4414 33.4023 50 35.7188 50C43.582 50 50 43.6836 50 35.9062C50 33.7891 49.4805 31.8047 48.625 30C48.9492 28.457 49.1562 26.8789 49.1562 25.25C49.1562 12.2383 38.4297 1.6875 25.25 1.6875C23.9883 1.6875 22.7461 1.8125 21.5312 2C19.4023 0.753906 16.9375 0 14.2812 0ZM14.2812 2C16.6914 2 18.9219 2.66797 20.8125 3.84375C21.0156 3.97656 21.2578 4.03125 21.5 4C22.7227 3.79297 23.9727 3.6875 25.25 3.6875C37.3633 3.6875 47.1562 13.3359 47.1562 25.25C47.1562 26.8398 46.9922 28.3828 46.6562 29.875C46.5938 30.1055 46.6172 30.3477 46.7188 30.5625C47.5391 32.1758 48 33.9727 48 35.9062C48 42.5898 42.5195 48 35.7188 48C33.6133 48 31.6289 47.4766 29.9062 46.5625C29.7148 46.4648 29.4961 46.4297 29.2812 46.4688C27.9766 46.707 26.6211 46.8125 25.25 46.8125C13.1367 46.8125 3.375 37.1758 3.375 25.25C3.375 23.7656 3.52344 22.3086 3.8125 20.9062C3.86328 20.6602 3.81641 20.4023 3.6875 20.1875C2.61328 18.3906 2 16.3281 2 14.0938C2 7.41797 7.48438 2 14.2812 2ZM25.0938 8.375C22.4609 8.375 20.0938 8.73047 18.0625 9.46875C18.0547 9.47266 18.0391 9.46484 18.0312 9.46875C15.9805 10.2188 14.3086 11.3594 13.1562 12.8438C11.9922 14.3359 11.375 16.1211 11.375 18.0312C11.375 20.0078 11.957 21.7852 13.0938 23.1875C14.1797 24.5234 15.6328 25.5703 17.4062 26.3125C19.0938 27.0195 21.1758 27.6133 23.5938 28.125C25.3242 28.4844 26.7266 28.8203 27.7188 29.125C28.5977 29.3945 29.2891 29.7969 29.7812 30.25C30.1797 30.6172 30.3438 30.9805 30.3438 31.6562C30.3438 32.4531 30.0195 32.9805 29.0625 33.625C28.1094 34.2695 26.7852 34.6562 25.0312 34.6562C23.7461 34.6562 22.7578 34.4531 22.125 34.1562C21.418 33.8281 20.8906 33.4297 20.5625 33C20.1523 32.4688 19.7578 31.7695 19.375 30.9062C18.9688 29.9648 18.4414 29.168 17.75 28.5938C17.0156 27.9844 16.0742 27.6875 15.0938 27.6875C13.9336 27.6875 12.8477 28.0586 12.0312 28.8125C11.2266 29.5625 10.75 30.6016 10.75 31.6875C10.75 33.2617 11.3398 34.8398 12.4062 36.3438C13.457 37.8438 14.8633 39.0508 16.5312 39.9375C18.8711 41.1641 21.7812 41.75 25.1875 41.75C28.0273 41.75 30.5625 41.3203 32.7188 40.4375C34.8867 39.5508 36.625 38.2812 37.8125 36.625C38.9922 34.9766 39.5898 33.0508 39.5938 31C39.5938 29.3086 39.2539 27.7969 38.5312 26.5312C37.832 25.3086 36.8438 24.2852 35.625 23.5C34.457 22.75 33.0586 22.1289 31.4688 21.625C29.9336 21.1406 28.2109 20.6797 26.3438 20.2812C26.3281 20.2773 26.3281 20.2852 26.3125 20.2812C24.875 19.9531 23.8203 19.6953 23.2188 19.5312C22.668 19.3789 22.082 19.1758 21.5312 18.9062C21.0508 18.668 20.7227 18.3867 20.5 18.125C20.332 17.9219 20.2812 17.7891 20.2812 17.4688C20.2812 16.9961 20.4609 16.6328 21.25 16.125C22.0234 15.6211 23.1445 15.3438 24.6562 15.3438C26.3086 15.3438 27.4062 15.6484 27.875 16C28.5273 16.4844 29.1406 17.2188 29.6562 18.1875C29.668 18.1992 29.6758 18.207 29.6875 18.2188C30.2109 19.1055 30.6914 19.7617 31.25 20.25C31.9453 20.8516 32.8672 21.0938 33.875 21.0938C35.0391 21.0938 36.1328 20.668 36.9375 19.8438C37.7148 19.0508 38.1875 18.0352 38.1875 16.9688C38.1875 15.9414 37.8828 14.8945 37.3438 13.9062C36.7891 12.8906 35.9375 11.9688 34.8438 11.125C33.7266 10.2617 32.3477 9.58203 30.75 9.09375C29.1211 8.59375 27.2148 8.375 25.0938 8.375ZM25.0938 10.375C27.0664 10.375 28.7812 10.6055 30.1562 11.0312C31.5703 11.4648 32.7461 12.0391 33.625 12.7188C34.5508 13.4336 35.2031 14.1641 35.5938 14.875C36.0039 15.625 36.1875 16.3242 36.1875 16.9688C36.1875 17.5156 36.0039 17.9531 35.5312 18.4375C35.0859 18.8984 34.5742 19.0938 33.875 19.0938C33.1875 19.0938 32.7891 18.9453 32.5625 18.75C32.2734 18.5 31.8789 17.9883 31.4375 17.25C31.4258 17.2266 31.418 17.2109 31.4062 17.1875C30.7852 16.043 30.0117 15.0898 29.0938 14.4062C28.0273 13.6055 26.5312 13.3438 24.6562 13.3438C22.8828 13.3438 21.3633 13.6875 20.1562 14.4688C19.0312 15.1953 18.2812 16.2578 18.2812 17.4688C18.2812 18.1758 18.5234 18.8672 18.9688 19.4062C19.4062 19.9219 19.9766 20.3516 20.6562 20.6875C21.3125 21.0117 22 21.2812 22.6875 21.4688C23.3516 21.6484 24.4336 21.9141 25.9062 22.25C27.7344 22.6367 29.4062 23.0703 30.875 23.5312C32.332 23.9961 33.582 24.5586 34.5625 25.1875C35.5312 25.8125 36.2773 26.5938 36.8125 27.5312C37.3242 28.4297 37.5938 29.5742 37.5938 31C37.5938 32.668 37.1328 34.1484 36.1875 35.4688C35.2539 36.7734 33.8594 37.8203 31.9688 38.5938C30.1133 39.3555 27.8242 39.75 25.1875 39.75C22.0156 39.75 19.4297 39.2148 17.4688 38.1875C16.0586 37.4375 14.9297 36.4258 14.0625 35.1875C14.0508 35.1875 14.043 35.1875 14.0312 35.1875C13.1445 33.9336 12.75 32.7656 12.75 31.6875C12.75 31.1211 12.9492 30.707 13.4062 30.2812C13.8477 29.875 14.3398 29.6875 15.0938 29.6875C15.6836 29.6875 16.1016 29.8164 16.4688 30.125C16.8359 30.4297 17.2148 30.9492 17.5312 31.6875C17.543 31.6992 17.5508 31.707 17.5625 31.7188C17.9922 32.6914 18.4648 33.5234 19 34.2188C19.5625 34.9531 20.3359 35.5312 21.2812 35.9688C22.3086 36.4492 23.5586 36.6562 25.0312 36.6562C27.0625 36.6562 28.8086 36.2383 30.1875 35.3125C31.5117 34.4219 32.3438 33.1133 32.3438 31.6562C32.3438 30.5469 31.9102 29.5078 31.125 28.7812C30.3672 28.082 29.4219 27.5586 28.3125 27.2188C27.2227 26.8828 25.7656 26.5547 24 26.1875C21.668 25.6953 19.7109 25.1055 18.1875 24.4688C16.668 23.832 15.5078 22.957 14.6562 21.9062C13.8242 20.8789 13.375 19.6367 13.375 18.0312C13.375 16.5273 13.8164 15.2188 14.7188 14.0625C14.7305 14.0625 14.7383 14.0625 14.75 14.0625C15.6328 12.9219 16.9297 11.9961 18.7188 11.3438C20.4766 10.6992 22.6289 10.375 25.0938 10.375Z",
            fill: "currentColor"
          }
        ) }),
        /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "clip0_6538_91284", children: /* @__PURE__ */ t("rect", { width: "50", height: "50", fill: "white" }) }) })
      ]
    }
  );
}
function O2({ size: C = "20px" }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M24.9998 4.16675C19.4745 4.16675 14.1755 6.36168 10.2684 10.2687C6.36144 14.1757 4.1665 19.4747 4.1665 25.0001C4.1665 30.5254 6.36144 35.8245 10.2684 39.7315C14.1755 43.6385 19.4745 45.8334 24.9998 45.8334C30.5252 45.8334 35.8242 43.6385 39.7312 39.7315C43.6382 35.8245 45.8332 30.5254 45.8332 25.0001C45.8332 19.4747 43.6382 14.1757 39.7312 10.2687C35.8242 6.36168 30.5252 4.16675 24.9998 4.16675Z",
            fill: "#03A9F4"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M34.8958 22.9167C31.7188 22.9167 28.6718 24.1788 26.4253 26.4253C24.1788 28.6718 22.9167 31.7188 22.9167 34.8958C22.9167 38.0729 24.1788 41.1199 26.4253 43.3664C28.6718 45.6129 31.7188 46.875 34.8958 46.875C38.0729 46.875 41.1199 45.6129 43.3664 43.3664C45.6129 41.1199 46.875 38.0729 46.875 34.8958C46.875 31.7188 45.6129 28.6718 43.3664 26.4253C41.1199 24.1788 38.0729 22.9167 34.8958 22.9167ZM15.1042 3.125C13.531 3.125 11.9733 3.43485 10.5199 4.03686C9.06656 4.63887 7.74599 5.52125 6.63362 6.63362C5.52125 7.74598 4.63887 9.06656 4.03686 10.5199C3.43485 11.9733 3.125 13.531 3.125 15.1042C3.125 16.6773 3.43485 18.235 4.03686 19.6884C4.63887 21.1418 5.52125 22.4623 6.63362 23.5747C7.74599 24.6871 9.06656 25.5695 10.5199 26.1715C11.9733 26.7735 13.531 27.0833 15.1042 27.0833C16.6773 27.0833 18.235 26.7735 19.6884 26.1715C21.1418 25.5695 22.4623 24.6871 23.5747 23.5747C24.6871 22.4623 25.5695 21.1418 26.1715 19.6884C26.7735 18.235 27.0833 16.6773 27.0833 15.1042C27.0833 13.531 26.7735 11.9733 26.1715 10.5199C25.5695 9.06656 24.6871 7.74598 23.5747 6.63362C22.4623 5.52125 21.1418 4.63887 19.6884 4.03686C18.235 3.43485 16.6773 3.125 15.1042 3.125Z",
            fill: "#03A9F4"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M25.6271 37.5C18.75 37.5 15.625 34.0615 15.625 31.4573C15.625 30.1021 16.5604 29.1667 17.9156 29.1667C20.8333 29.1667 20.1052 33.4396 25.626 33.4396C28.4375 33.4396 30 31.8771 30 30.3146C30 29.375 29.5812 28.3333 27.7094 27.8125L21.5615 26.25C16.6667 25 15.7313 22.2896 15.7313 19.6854C15.7313 14.375 20.626 12.5 25.2083 12.5C29.4802 12.5 34.375 14.7906 34.375 17.9156C34.375 19.2708 33.3333 20.1052 31.9781 20.1052C29.4802 20.1052 29.8948 16.5615 24.8938 16.5615C22.3958 16.5615 20.9385 17.7094 20.9385 19.3771C20.9385 21.0417 22.9156 21.5625 24.6865 21.9812L29.2719 23.0229C34.2687 24.1656 35.4167 27.0833 35.4167 29.8948C35.3104 34.2687 32.1854 37.5 25.6271 37.5Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
const q2 = ({ size: C = "20px" }) => /* @__PURE__ */ t(
  "svg",
  {
    width: C,
    height: C,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M25 2C37.703 2 48 12.297 48 25C48 37.703 37.703 48 25 48C12.297 48 2 37.703 2 25C2 12.297 12.297 2 25 2ZM32.934 34.375C33.357 33.077 35.339 20.141 35.584 17.592C35.658 16.82 35.414 16.307 34.936 16.078C34.358 15.8 33.502 15.939 32.509 16.297C31.147 16.788 13.735 24.181 12.729 24.609C11.775 25.014 10.873 25.456 10.873 26.096C10.873 26.546 11.14 26.799 11.876 27.062C12.642 27.335 14.571 27.92 15.71 28.234C16.807 28.537 18.056 28.274 18.756 27.839C19.498 27.378 28.061 21.648 28.676 21.146C29.29 20.644 29.78 21.287 29.278 21.79C28.776 22.292 22.898 27.997 22.123 28.787C21.182 29.746 21.85 30.74 22.481 31.138C23.202 31.592 28.387 35.07 29.168 35.628C29.949 36.186 30.741 36.439 31.466 36.439C32.191 36.439 32.573 35.484 32.934 34.375Z",
        fill: "currentColor"
      }
    )
  }
);
function D2({ size: C = "20px" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M25 2C12.3093 2 2 12.3093 2 25C2 37.6907 12.3093 48 25 48C37.6907 48 48 37.6907 48 25C48 12.3093 37.6907 2 25 2ZM25 4C36.6098 4 46 13.3902 46 25C46 36.6098 36.6098 46 25 46C13.3902 46 4 36.6098 4 25C4 13.3902 13.3902 4 25 4ZM34.0879 14.0352C33.4039 14.0352 32.6353 14.1936 31.7363 14.5176C30.3403 15.0206 13.9207 21.9922 12.0527 22.7852C10.9847 23.2392 8.99609 24.0837 8.99609 26.0977C8.99609 27.4327 9.77836 28.3875 11.3184 28.9375C12.1464 29.2325 14.1129 29.8286 15.2539 30.1426C15.7379 30.2756 16.2523 30.3438 16.7812 30.3438C17.8162 30.3438 18.8578 30.0859 19.6738 29.6309C19.6668 29.7989 19.6714 29.9687 19.6914 30.1387C19.8144 31.1887 20.4619 32.1762 21.4219 32.7812C22.0499 33.1772 27.1793 36.6142 27.9453 37.1602C29.0213 37.9292 30.2108 38.3359 31.3828 38.3359C33.6228 38.3359 34.3743 36.0231 34.7363 34.9121C35.2613 33.2991 37.2272 20.1821 37.4492 17.8691C37.6002 16.2841 36.9396 14.979 35.6816 14.377C35.2106 14.15 34.6729 14.0352 34.0879 14.0352ZM34.0879 16.0352C34.3629 16.0352 34.6084 16.0806 34.8164 16.1816C35.2894 16.4086 35.53 16.9147 35.457 17.6797C35.215 20.2027 33.2539 33.009 32.8359 34.293C32.4779 35.391 32.1008 36.3359 31.3828 36.3359C30.6648 36.3359 29.8804 36.0842 29.1074 35.5312C28.3344 34.9793 23.2013 31.5369 22.4883 31.0879C21.8633 30.6939 21.2018 29.7117 22.1328 28.7617C22.8998 27.9797 28.7178 22.3329 29.2148 21.8359C29.5848 21.4649 29.4118 21.0176 29.0488 21.0176C28.9238 21.0176 28.7741 21.0703 28.6191 21.1973C28.0111 21.6943 19.5348 27.3663 18.8008 27.8223C18.3148 28.1243 17.5623 28.3418 16.7812 28.3418C16.4482 28.3418 16.1111 28.3019 15.7871 28.2129C14.6591 27.9019 12.7502 27.3227 11.9922 27.0527C11.2632 26.7927 10.998 26.5437 10.998 26.0977C10.998 25.4637 11.8929 25.026 12.8359 24.625C13.8319 24.202 31.0661 16.8834 32.4141 16.3984C33.0381 16.1724 33.6089 16.0352 34.0879 16.0352Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function T2({ size: C = "20px" }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M24.9998 4.16675C19.4745 4.16675 14.1755 6.36168 10.2684 10.2687C6.36144 14.1757 4.1665 19.4747 4.1665 25.0001C4.1665 30.5254 6.36144 35.8245 10.2684 39.7315C14.1755 43.6385 19.4745 45.8334 24.9998 45.8334C30.5252 45.8334 35.8242 43.6385 39.7312 39.7315C43.6382 35.8245 45.8332 30.5254 45.8332 25.0001C45.8332 19.4747 43.6382 14.1757 39.7312 10.2687C35.8242 6.36168 30.5252 4.16675 24.9998 4.16675Z",
            fill: "#29B6F6"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M35.3644 15.6249L31.4623 35.5478C31.4623 35.5478 31.2946 36.4583 30.1655 36.4583C29.5655 36.4583 29.2561 36.1728 29.2561 36.1728L20.804 29.1593L16.6686 27.0749L11.3613 25.6635C11.3613 25.6635 10.4165 25.3905 10.4165 24.6093C10.4165 23.9583 11.3884 23.6478 11.3884 23.6478L33.5925 14.827C33.5925 14.827 34.2707 14.5822 34.7655 14.5833C35.0696 14.5833 35.4165 14.7135 35.4165 15.1041C35.4165 15.3645 35.3644 15.6249 35.3644 15.6249Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M23.9582 31.776L20.3895 35.2906C20.3895 35.2906 20.2342 35.4104 20.027 35.4156C19.9551 35.4176 19.878 35.4062 19.7988 35.3708L20.803 29.1572L23.9582 31.776Z",
            fill: "#B0BEC5"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M31.1425 18.9541C30.9665 18.7249 30.6415 18.6832 30.4123 18.8572L16.6665 27.0832C16.6665 27.0832 18.8603 33.2207 19.1946 34.2832C19.53 35.3468 19.7988 35.3718 19.7988 35.3718L20.803 29.1582L31.0446 19.6832C31.2738 19.5093 31.3165 19.1832 31.1425 18.9541Z",
            fill: "#CFD8DC"
          }
        )
      ]
    }
  );
}
const G2 = ({ size: C = "20px" }) => /* @__PURE__ */ t(
  "svg",
  {
    width: C,
    height: C,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M41 4H9C6.243 4 4 6.243 4 9V41C4 43.757 6.243 46 9 46H41C43.757 46 46 43.757 46 41V9C46 6.243 43.757 4 41 4ZM37.006 22.323C36.779 22.344 36.549 22.358 36.316 22.358C33.693 22.358 31.388 21.009 30.047 18.97C30.047 24.319 30.047 30.405 30.047 30.507C30.047 35.216 26.229 39.034 21.52 39.034C16.811 39.034 12.993 35.216 12.993 30.507C12.993 25.798 16.811 21.98 21.52 21.98C21.698 21.98 21.872 21.996 22.047 22.007V26.209C21.872 26.188 21.7 26.156 21.52 26.156C19.116 26.156 17.168 28.104 17.168 30.508C17.168 32.912 19.116 34.86 21.52 34.86C23.924 34.86 26.047 32.966 26.047 30.562C26.047 30.467 26.089 10.968 26.089 10.968H30.105C30.483 14.559 33.382 17.393 37.006 17.653V22.323Z",
        fill: "currentColor"
      }
    )
  }
);
function j2({ size: C = "20px" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M9 4C6.24958 4 4 6.24958 4 9V41C4 43.7504 6.24958 46 9 46H41C43.7504 46 46 43.7504 46 41V9C46 6.24958 43.7504 4 41 4H9ZM9 6H41C42.6716 6 44 7.32842 44 9V41C44 42.6716 42.6716 44 41 44H9C7.32842 44 6 42.6716 6 41V9C6 7.32842 7.32842 6 9 6ZM26.043 10C25.7781 10 25.5241 10.1051 25.3366 10.2922C25.1491 10.4793 25.0435 10.7332 25.043 10.998C25.043 10.998 25.032 15.8733 25.0215 20.7598C25.0162 23.203 25.0098 25.6488 25.0059 27.4902C25.0019 29.3317 25 30.4968 25 30.5938C25 32.409 23.3514 33.8926 21.4727 33.8926C19.6089 33.8926 18.1211 32.4029 18.1211 30.5391C18.1211 28.6753 19.6089 27.1875 21.4727 27.1875C21.5358 27.1875 21.6631 27.2082 21.8809 27.2344C22.0213 27.2512 22.1638 27.2381 22.2988 27.1958C22.4338 27.1535 22.5583 27.083 22.6641 26.9891C22.7699 26.8951 22.8545 26.7798 22.9124 26.6507C22.9703 26.5216 23.0002 26.3817 23 26.2402V22.0391C23 21.7847 22.903 21.5399 22.7288 21.3544C22.5547 21.169 22.3164 21.0569 22.0625 21.041C21.9067 21.0312 21.7106 21.0117 21.4727 21.0117C16.2231 21.0117 11.9453 25.2895 11.9453 30.5391C11.9453 35.7886 16.2231 40.0664 21.4727 40.0664C26.722 40.0664 31 35.7886 31 30.5391V21.4902C32.4546 22.6536 34.2675 23.3906 36.2695 23.3906C36.5426 23.3906 36.8023 23.3744 37.0508 23.3516C37.2991 23.3286 37.5299 23.2138 37.6979 23.0295C37.8659 22.8452 37.959 22.6048 37.959 22.3555V17.6855C37.9591 17.4327 37.8635 17.1892 37.6914 17.0041C37.5193 16.8189 37.2834 16.7058 37.0312 16.6875C33.8866 16.4619 31.3798 14.0122 31.0527 10.8965C31.0271 10.6506 30.9114 10.4229 30.7278 10.2574C30.5442 10.0918 30.3058 10.0001 30.0586 10H26.043ZM27.041 12H29.3223C30.049 15.2987 32.6267 17.8144 35.959 18.4453V21.3105C33.8201 21.2019 31.9415 20.1349 30.8359 18.4531C30.7177 18.2731 30.5445 18.1361 30.3421 18.0625C30.1397 17.9888 29.919 17.9825 29.7127 18.0444C29.5064 18.1062 29.3257 18.2331 29.1972 18.4059C29.0688 18.5788 28.9997 18.7885 29 19.0039V30.5391C29 34.7075 25.6413 38.0664 21.4727 38.0664C17.3042 38.0664 13.9453 34.7075 13.9453 30.5391C13.9453 26.5385 17.0661 23.3632 21 23.1074V25.2832C18.2864 25.5357 16.1211 27.7622 16.1211 30.5391C16.1211 33.4833 18.5284 35.8926 21.4727 35.8926C24.4019 35.8926 27 33.5865 27 30.5938C27 30.6427 27.0019 29.3356 27.0059 27.4941C27.0098 25.6527 27.0162 23.2069 27.0215 20.7637C27.0309 16.3768 27.0392 12.8492 27.041 12Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function N2({ size: C = "20px" }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.3583 6.25H38.6406C41.4625 6.25 43.75 8.5375 43.75 11.3583V38.6406C43.75 41.4625 41.4625 43.75 38.6417 43.75H11.3583C8.5375 43.75 6.25 41.4625 6.25 38.6417V11.3583C6.25 8.5375 8.5375 6.25 11.3583 6.25Z",
            fill: "#212121"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M30.4248 21.4657C32.0665 22.6386 34.0779 23.3282 36.2498 23.3282V19.15C35.8383 19.15 35.429 19.1073 35.0269 19.0219V22.3104C32.855 22.3104 30.8446 21.6198 29.2019 20.4479V28.9729C29.2019 33.2375 25.7425 36.6948 21.4758 36.6948C19.8842 36.6948 18.404 36.2136 17.1748 35.3886C18.5779 36.8219 20.5342 37.7115 22.6988 37.7115C26.9654 37.7115 30.4248 34.2542 30.4248 29.9896V21.4657ZM31.9342 17.2511C31.0956 16.3354 30.5446 15.1511 30.4248 13.8417V13.3042H29.2654C29.5571 14.9677 30.5529 16.3896 31.9342 17.2511ZM19.8738 32.1167C19.405 31.5021 19.1519 30.7511 19.1529 29.9782C19.1529 28.0271 20.7352 26.4459 22.6873 26.4459C23.0508 26.4459 23.4123 26.5011 23.7592 26.6115V22.3407C23.354 22.2854 22.9456 22.2615 22.5363 22.2698V25.5938C22.1894 25.4834 21.8279 25.4282 21.4633 25.4282C19.5113 25.4282 17.929 27.0094 17.929 28.9604C17.93 30.3407 18.7206 31.5354 19.8738 32.1167Z",
            fill: "#EC407A"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M29.2022 20.4479C30.8438 21.6209 32.8553 22.3104 35.0272 22.3104V19.0219C33.8147 18.7636 32.7418 18.1302 31.9345 17.25C30.5532 16.3886 29.5584 14.9677 29.2668 13.3042H26.222V29.9896C26.2147 31.9344 24.6355 33.5094 22.6876 33.5094C21.5397 33.5094 20.5199 32.9625 19.8741 32.1157C18.7209 31.5344 17.9303 30.3396 17.9303 28.9604C17.9303 27.0094 19.5126 25.4282 21.4647 25.4282C21.8386 25.4282 22.1991 25.4865 22.5376 25.5938V22.2709C18.3459 22.3573 14.9751 25.7802 14.9751 29.9907C14.9751 32.0927 15.8147 33.9979 17.1772 35.3896C18.4063 36.2146 19.8866 36.6959 21.4782 36.6959C25.7449 36.6959 29.2043 33.2386 29.2043 28.974L29.2022 20.4479Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M35.0271 19.0228V18.1333C33.9333 18.1353 32.8625 17.8291 31.9344 17.2499C32.7552 18.1489 33.8365 18.7687 35.0271 19.0228ZM29.2656 13.3041C29.2375 13.1447 29.2167 12.9853 29.2021 12.8239V12.2864H24.9979V28.9728C24.9917 30.9176 23.4115 32.4926 21.4635 32.4926C20.8917 32.4926 20.3521 32.3572 19.874 32.1155C20.5198 32.9624 21.5396 33.5093 22.6875 33.5093C24.6354 33.5093 26.2146 31.9343 26.2219 29.9895V13.3041H29.2656ZM22.5365 22.2708V21.3239C22.1854 21.276 21.8313 21.252 21.476 21.252C17.2083 21.252 13.75 24.7093 13.75 28.9739C13.75 31.6478 15.1094 34.0041 17.175 35.3895C15.8125 33.9978 14.9729 32.0926 14.9729 29.9905C14.9729 25.7801 18.3448 22.3572 22.5365 22.2708Z",
            fill: "#81D4FA"
          }
        )
      ]
    }
  );
}
const S2 = ({ size: C = "20px" }) => /* @__PURE__ */ t(
  "svg",
  {
    width: C,
    height: C,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M11 4C7.134 4 4 7.134 4 11V39C4 42.866 7.134 46 11 46H39C42.866 46 46 42.866 46 39V11C46 7.134 42.866 4 39 4H11ZM13.0859 13H21.0234L26.6602 21.0098L33.5 13H36L27.7891 22.6133L37.9141 37H29.9785L23.4375 27.707L15.5 37H13L22.3086 26.1035L13.0859 13ZM16.9141 15L31.0215 35H34.0859L19.9785 15H16.9141Z",
        fill: "currentColor"
      }
    )
  }
);
function z2({ size: C = "20px" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M11 4C7.14567 4 4 7.14567 4 11V39C4 42.8543 7.14567 46 11 46H39C42.8543 46 46 42.8543 46 39V11C46 7.14567 42.8543 4 39 4H11ZM11 6H39C41.7737 6 44 8.22633 44 11V39C44 41.7737 41.7737 44 39 44H11C8.22633 44 6 41.7737 6 39V11C6 8.22633 8.22633 6 11 6ZM13.0859 13L22.3086 26.1035L13 37H15.5L23.4375 27.707L29.9766 37H37.9141L27.7891 22.6133L36 13H33.5L26.6602 21.0098L21.0234 13H13.0859ZM16.9141 15H19.9785L34.0859 35H31.0215L16.9141 15Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function P2({ size: C = "20px" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M11 4C7.134 4 4 7.134 4 11V39C4 42.866 7.134 46 11 46H39C42.866 46 46 42.866 46 39V11C46 7.134 42.866 4 39 4H11ZM13.0859 13H21.0234L26.6602 21.0098L33.5 13H36L27.7891 22.6133L37.9141 37H29.9785L23.4375 27.707L15.5 37H13L22.3086 26.1035L13.0859 13ZM16.9141 15L31.0215 35H34.0859L19.9785 15H16.9141Z",
          fill: "black"
        }
      )
    }
  );
}
const Y2 = ({ size: C = "20px" }) => /* @__PURE__ */ t(
  "svg",
  {
    width: C,
    height: C,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M25.0001 2C12.3181 2 2.00015 12.318 2.00015 25C2.00015 28.96 3.02315 32.854 4.96315 36.29L2.03715 46.73C1.94115 47.073 2.03415 47.441 2.28215 47.696C2.47315 47.893 2.73315 48 3.00015 48C3.08015 48 3.16115 47.99 3.24015 47.971L14.1361 45.272C17.4631 47.058 21.2101 48 25.0001 48C37.6821 48 48.0001 37.682 48.0001 25C48.0001 12.318 37.6821 2 25.0001 2ZM36.5701 33.116C36.0781 34.478 33.7181 35.721 32.5841 35.888C31.5661 36.037 30.2781 36.101 28.8641 35.657C28.0071 35.387 26.9071 35.029 25.4981 34.428C19.5751 31.902 15.7071 26.013 15.4111 25.624C15.1161 25.235 13.0001 22.463 13.0001 19.594C13.0001 16.725 14.5251 15.314 15.0671 14.73C15.6091 14.146 16.2481 14 16.6421 14C17.0361 14 17.4291 14.005 17.7741 14.021C18.1371 14.039 18.6241 13.884 19.1031 15.022C19.5951 16.19 20.7761 19.059 20.9221 19.352C21.0702 19.644 21.1681 19.985 20.9721 20.374C20.7761 20.763 20.6781 21.006 20.3821 21.347C20.0861 21.688 19.7621 22.107 19.4961 22.369C19.2001 22.66 18.8931 22.975 19.2371 23.559C19.5811 24.143 20.7661 26.052 22.5221 27.598C24.7771 29.584 26.6801 30.2 27.2701 30.492C27.8601 30.784 28.2051 30.735 28.5491 30.346C28.8931 29.956 30.0251 28.643 30.4181 28.06C30.8111 27.477 31.2051 27.573 31.7471 27.768C32.2891 27.962 35.1922 29.372 35.7822 29.664C36.3722 29.956 36.7662 30.102 36.9142 30.345C37.0621 30.587 37.0621 31.755 36.5701 33.116Z",
        fill: "currentColor"
      }
    )
  }
);
function J2({ size: C = "20px" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M25 2C12.3095 2 2 12.3095 2 25C2 29.0791 3.11869 32.8859 4.98438 36.209L2.03711 46.7305C1.99002 46.8988 1.9879 47.0766 2.03094 47.246C2.07398 47.4155 2.16069 47.5707 2.28242 47.6962C2.40415 47.8217 2.55665 47.913 2.72471 47.9612C2.89277 48.0094 3.07052 48.0127 3.24023 47.9707L14.2109 45.252C17.4346 46.9729 21.0926 48 25 48C37.6905 48 48 37.6905 48 25C48 12.3095 37.6905 2 25 2ZM25 4C36.6095 4 46 13.3905 46 25C46 36.6095 36.6095 46 25 46C21.278 46 17.7921 45.0296 14.7617 43.334C14.5401 43.2101 14.2796 43.1752 14.0332 43.2363L4.42578 45.6172L7.00195 36.4258C7.03882 36.2959 7.04899 36.1599 7.03188 36.0259C7.01476 35.892 6.97069 35.7629 6.90234 35.6465C5.06069 32.5236 4 28.8901 4 25C4 13.3905 13.3905 4 25 4ZM16.6426 13C16.0015 13 15.086 13.2385 14.334 14.0488C13.8823 14.5355 12 16.3695 12 19.5938C12 22.9553 14.3314 25.8558 14.6133 26.2285H14.6152V26.2305C14.5885 26.1953 14.973 26.7522 15.4863 27.4199C15.9996 28.0877 16.7174 28.9646 17.6191 29.9141C19.4226 31.8129 21.9583 34.0074 25.1055 35.3496C26.5548 35.9668 27.6982 36.3394 28.5645 36.6113C30.1698 37.1154 31.6321 37.0388 32.7305 36.877C33.5526 36.7559 34.4569 36.3611 35.3516 35.7949C36.2462 35.2287 37.1231 34.5247 37.5098 33.4551C37.7868 32.6882 37.9276 31.9796 37.9785 31.3965C38.004 31.1049 38.0072 30.8476 37.9883 30.6094C37.9693 30.3711 37.9896 30.1887 37.7676 29.8242C37.302 29.0598 36.7748 29.0399 36.2246 28.7676C35.9189 28.6163 35.0487 28.1913 34.1758 27.7754C33.3039 27.3599 32.5489 26.992 32.084 26.8262C31.7902 26.7205 31.4316 26.5684 30.9141 26.627C30.3966 26.6856 29.8855 27.0589 29.5879 27.5C29.3058 27.9181 28.1704 29.2583 27.8242 29.6523C27.8196 29.6495 27.8497 29.6634 27.7129 29.5957C27.2848 29.3838 26.7612 29.2037 25.9863 28.7949C25.2115 28.3862 24.2423 27.7826 23.1816 26.8477V26.8457C21.603 25.4559 20.4973 23.7111 20.1484 23.125C20.1719 23.097 20.1456 23.1309 20.1953 23.082L20.1973 23.0801C20.5538 22.7289 20.8697 22.3095 21.1367 22.002C21.5153 21.5659 21.6823 21.1814 21.8633 20.8223C22.224 20.1064 22.0231 19.3187 21.8145 18.9043V18.9023C21.8289 18.931 21.7016 18.6502 21.5645 18.3262C21.4269 18.0013 21.2517 17.58 21.0645 17.1309C20.69 16.2325 20.272 15.2249 20.0234 14.6348V14.6328C19.7306 13.9377 19.3344 13.4369 18.8164 13.1953C18.2984 12.9537 17.8408 13.0224 17.8223 13.0215H17.8203C17.4507 13.0044 17.045 13 16.6426 13ZM16.6426 15C17.0281 15 17.4082 15.0047 17.7266 15.0195C18.0541 15.0359 18.0337 15.0372 17.9707 15.0078C17.9067 14.978 17.9935 14.9683 18.1797 15.4102C18.4231 15.988 18.8432 16.9992 19.2188 17.9004C19.4065 18.351 19.5823 18.7738 19.7227 19.1055C19.863 19.4371 19.9391 19.6223 20.0273 19.7988V19.8008L20.0293 19.8027C20.1158 19.9735 20.1082 19.8642 20.0781 19.9238C19.8671 20.3427 19.8385 20.4455 19.625 20.6914C19.3 21.0658 18.9685 21.4834 18.793 21.6562C18.6394 21.8071 18.3624 22.042 18.1895 22.502C18.0162 22.9626 18.0971 23.5946 18.375 24.0664C18.745 24.6946 19.9644 26.6793 21.8594 28.3477C23.0528 29.3997 24.1646 30.0959 25.0527 30.5645C25.9409 31.033 26.6643 31.3066 26.8262 31.3867C27.2105 31.577 27.6307 31.7247 28.1191 31.666C28.6076 31.6074 29.0288 31.311 29.2969 31.0078L29.2988 31.0059C29.6556 30.6013 30.7158 29.3907 31.2246 28.6445C31.2462 28.6521 31.2391 28.6462 31.4082 28.707V28.709H31.4102C31.4874 28.7365 32.4543 29.1693 33.3164 29.5801C34.1785 29.9909 35.0536 30.4179 35.3379 30.5586C35.7482 30.7617 35.9421 30.8939 35.9922 30.8945C35.9956 30.9825 35.999 31.0779 35.9863 31.2227C35.9513 31.6243 35.8439 32.1802 35.6289 32.7754C35.5236 33.0667 34.975 33.6677 34.2832 34.1055C33.5914 34.5433 32.7493 34.8525 32.4375 34.8984C31.4999 35.0366 30.3867 35.087 29.1641 34.7031C28.3163 34.437 27.2593 34.0926 25.8906 33.5098C23.1148 32.326 20.7556 30.3115 19.0703 28.5371C18.2277 27.6499 17.5526 26.824 17.0723 26.1992C16.5929 25.5756 16.3835 25.2511 16.209 25.0215L16.207 25.0195C15.8972 24.6098 14 21.9709 14 19.5938C14 17.078 15.1685 16.0914 15.8008 15.4102C16.1327 15.0525 16.4956 15 16.6426 15Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function K2({ size: C = "20px" }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.0708 45.1072L7.87705 34.8624C6.1458 31.8645 5.23538 28.4624 5.23643 24.978C5.24163 14.077 14.1125 5.20825 25.0145 5.20825C30.3052 5.21034 35.2698 7.26971 39.0041 11.0062C42.7375 14.7437 44.7937 19.7103 44.7916 24.9937C44.7875 35.8947 35.9145 44.7645 25.0145 44.7645H25.0062C21.6968 44.7635 18.4437 43.9333 15.5552 42.3572L5.0708 45.1072Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.07067 45.6281C4.93317 45.6281 4.79984 45.574 4.70088 45.474C4.57067 45.3417 4.51963 45.149 4.56859 44.9708L7.31755 34.9333C5.61338 31.9062 4.71442 28.4687 4.7165 24.9792C4.72067 13.7896 13.8259 4.6875 25.0144 4.6875C30.4415 4.68958 35.5405 6.80313 39.3728 10.6385C43.205 14.475 45.3144 19.5729 45.3123 24.9937C45.3082 36.1823 36.2019 45.2854 25.0144 45.2854C21.6925 45.2844 18.4061 44.4646 15.4894 42.9135L5.20296 45.6104C5.15921 45.6229 5.11546 45.6281 5.07067 45.6281Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M25.0147 5.20841C30.3053 5.2105 35.2699 7.26987 39.0042 11.0063C42.7376 14.7438 44.7938 19.7105 44.7917 24.9938C44.7876 35.8949 35.9147 44.7647 25.0147 44.7647H25.0063C21.6969 44.7636 18.4438 43.9334 15.5553 42.3574L5.0709 45.1074L7.87715 34.8626C6.1459 31.8647 5.23549 28.4626 5.23653 24.9782C5.24174 14.0772 14.1126 5.20841 25.0147 5.20841ZM25.0147 4.16675C13.5397 4.16675 4.20007 13.5022 4.19486 24.9782C4.19382 28.4855 5.07924 31.9417 6.7584 35.0011L4.0657 44.8334C3.96778 45.1928 4.06778 45.5761 4.33028 45.8407C4.5282 46.0407 4.7959 46.1501 5.0709 46.1501C5.15945 46.1501 5.24799 46.1386 5.33549 46.1157L15.4261 43.4699C18.3719 44.999 21.674 45.8063 25.0063 45.8074C36.4897 45.8074 45.8292 36.4709 45.8344 24.9949C45.8365 19.4334 43.673 14.2042 39.7428 10.2709C35.8105 6.33654 30.5803 4.16883 25.0147 4.16675Z",
            fill: "#CFD8DC"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M36.6419 13.3666C33.5377 10.2604 29.4117 8.54889 25.02 8.54785C15.9533 8.54785 8.57936 15.9187 8.5752 24.9791C8.57415 28.0843 9.4429 31.1072 11.0887 33.7249L11.4804 34.3468L9.81895 40.4103L16.0408 38.7791L16.6419 39.1353C19.1648 40.6333 22.0585 41.4249 25.0085 41.426H25.0148C34.0752 41.426 41.4492 34.0541 41.4523 24.9926C41.4533 20.602 39.746 16.4729 36.6419 13.3666Z",
            fill: "#40C351"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.0707 16.7135C19.7009 15.8906 19.3113 15.874 18.9582 15.8594C18.6696 15.8469 18.3405 15.8479 18.0113 15.8479C17.6821 15.8479 17.1467 15.9719 16.6936 16.4667C16.2405 16.9615 14.9634 18.1563 14.9634 20.5875C14.9634 23.0188 16.7342 25.3688 16.9811 25.6979C17.228 26.0271 20.3998 31.176 25.4228 33.1573C29.5967 34.8031 30.4467 34.476 31.353 34.3938C32.2592 34.3115 34.2769 33.199 34.6884 32.0448C35.0998 30.8906 35.0998 29.9021 34.9769 29.6958C34.853 29.4896 34.5238 29.3667 34.03 29.1188C33.5363 28.8708 31.1061 27.676 30.653 27.5115C30.1998 27.3469 29.8707 27.2646 29.5405 27.7594C29.2113 28.2531 28.2644 29.3667 27.9759 29.6958C27.6873 30.026 27.3988 30.0677 26.905 29.8198C26.4113 29.5719 24.8196 29.051 22.9311 27.3677C21.4623 26.0583 20.4707 24.4406 20.1821 23.9458C19.8936 23.4521 20.1509 23.1844 20.3988 22.9375C20.6207 22.7156 20.8925 22.3604 21.1405 22.0719C21.3873 21.7833 21.4696 21.5771 21.6342 21.2479C21.7988 20.9177 21.7165 20.6292 21.5925 20.3823C21.4707 20.1344 20.5103 17.6906 20.0707 16.7135Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
const X2 = ({ size: C = "20px" }) => /* @__PURE__ */ t(
  "svg",
  {
    width: C,
    height: C,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M44.8984 14.5C44.5 12.3008 42.6016 10.6992 40.3984 10.1992C37.1016 9.5 31 9 24.3984 9C17.8008 9 11.6016 9.5 8.30078 10.1992C6.10156 10.6992 4.19922 12.1992 3.80078 14.5C3.39844 17 3 20.5 3 25C3 29.5 3.39844 33 3.89844 35.5C4.30078 37.6992 6.19922 39.3008 8.39844 39.8008C11.8984 40.5 17.8984 41 24.5 41C31.1016 41 37.1016 40.5 40.6016 39.8008C42.8008 39.3008 44.6992 37.8008 45.1016 35.5C45.5 33 46 29.3984 46.1016 25C45.8984 20.5 45.3984 17 44.8984 14.5ZM19 32V18L31.1992 25L19 32Z",
        fill: "currentColor"
      }
    )
  }
);
function Q2({ size: C = "20px" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M24.4023 9C17.8008 9 11.6016 9.5 8.30078 10.1992C6.10156 10.6992 4.19922 12.1992 3.80078 14.5C3.40234 16.8984 3 20.5 3 25C3 29.5 3.39844 33 3.89844 35.5C4.30078 37.6992 6.19922 39.3008 8.39844 39.8008C11.9023 40.5 17.8984 41 24.5 41C31.1016 41 37.0977 40.5 40.5977 39.8008C42.8008 39.3008 44.6992 37.8008 45.0977 35.5C45.5 33 46 29.4023 46.0977 24.9023C46.0977 20.4023 45.5977 16.8008 45.0977 14.3008C44.6992 12.1016 42.8008 10.5 40.5977 10C37.0977 9.5 31 9 24.4023 9ZM24.4023 11C31.6016 11 37.3984 11.5977 40.1992 12.0977C41.6992 12.5 42.8984 13.5 43.0977 14.8008C43.6992 18 44.0977 21.4023 44.0977 24.9023C44 29.1992 43.5 32.6992 43.0977 35.1992C42.8008 37.0977 40.8008 37.6992 40.1992 37.9023C36.5977 38.6016 30.5977 39.0977 24.5977 39.0977C18.5977 39.0977 12.5 38.6992 9 37.9023C7.5 37.5 6.30078 36.5 6.10156 35.1992C5.30078 32.3984 5 28.6992 5 25C5 20.3984 5.40234 17 5.80078 14.9023C6.10156 13 8.19922 12.3984 8.69922 12.1992C12 11.5 18.1016 11 24.4023 11ZM19 17V33L33 25L19 17ZM21 20.4023L29 25L21 29.5977V20.4023Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function C3({ size: C = "20px" }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M44.9998 35.3125C44.5832 37.5 42.8123 39.1667 40.6248 39.4792C37.1873 40 31.4582 40.625 24.9998 40.625C18.6457 40.625 12.9165 40 9.37484 39.4792C7.18734 39.1667 5.4165 37.5 4.99984 35.3125C4.58317 32.9167 4.1665 29.375 4.1665 25C4.1665 20.625 4.58317 17.0833 4.99984 14.6875C5.4165 12.5 7.18734 10.8333 9.37484 10.5208C12.8123 10 18.5415 9.375 24.9998 9.375C31.4582 9.375 37.0832 10 40.6248 10.5208C42.8123 10.8333 44.5832 12.5 44.9998 14.6875C45.4165 17.0833 45.9373 20.625 45.9373 25C45.8332 29.375 45.4165 32.9167 44.9998 35.3125Z",
            fill: "#FF3D00"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M20.8335 32.2916V17.7083L33.3335 24.9999L20.8335 32.2916Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function t3({ size: C = "20px" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M46.7735 35.0781C40.9688 34.1211 38.3165 28.1094 38.2306 27.9141C38.2188 27.8789 38.1915 27.8164 38.1759 27.7812C38.0001 27.4297 37.8243 26.9336 37.9727 26.582C38.2266 25.9805 39.4337 25.5977 40.1563 25.3672C40.4102 25.2852 40.6524 25.2109 40.8399 25.1367C42.5938 24.4414 43.4688 23.5352 43.4493 22.4336C43.4337 21.5469 42.754 20.7344 41.754 20.3828C41.4063 20.2344 41.0079 20.1602 40.6056 20.1602C40.3321 20.1602 39.9181 20.1992 39.5196 20.3828C38.8516 20.6953 38.2657 20.8633 37.8477 20.8828C37.7579 20.8789 37.6798 20.8711 37.6134 20.8594L37.6563 20.1719C37.8516 17.0625 38.0977 13.1875 37.047 10.832C33.9454 3.89062 27.3751 3.35156 25.4337 3.35156L24.5509 3.35937C22.6134 3.35937 16.0548 3.89844 12.961 10.8359C11.9102 13.1914 12.1524 17.0625 12.3516 20.1758L12.3595 20.293C12.3712 20.4844 12.3829 20.6758 12.3946 20.8594C11.961 20.9375 11.1134 20.793 10.2345 20.3828C9.03914 19.8242 6.8868 20.5625 6.58993 22.125C6.45711 22.8164 6.61727 24.1289 9.16415 25.1328C9.35555 25.2109 9.59383 25.2852 9.85165 25.3672C10.5704 25.5977 11.7774 25.9766 12.0313 26.582C12.1798 26.9336 12.004 27.4297 11.797 27.8555C11.6876 28.1094 9.05086 34.1211 3.23446 35.0781C2.49227 35.1992 1.96493 35.8555 2.00399 36.6133C2.01571 36.8125 2.06649 37.0117 2.14852 37.207C2.67586 38.4453 4.59383 39.2969 8.17196 39.8789C8.23446 40.0898 8.30477 40.4023 8.34383 40.5742C8.41805 40.9297 8.50008 41.2891 8.60946 41.6641C8.71493 42.0195 9.07821 42.8438 10.211 42.8438C10.5548 42.8438 10.9298 42.7695 11.3321 42.6914C11.9259 42.5742 12.6681 42.4297 13.6212 42.4297C14.1524 42.4297 14.6993 42.4766 15.2501 42.5664C16.2657 42.7344 17.1837 43.3867 18.2501 44.1367C19.9141 45.3164 21.8009 46.6484 24.7266 46.6484C24.8048 46.6484 24.8829 46.6445 24.9571 46.6406C25.0626 46.6445 25.172 46.6484 25.2813 46.6484C28.2071 46.6484 30.0938 45.3125 31.7618 44.1367C32.7774 43.4141 33.7384 42.7383 34.7579 42.5664C35.3087 42.4766 35.8556 42.4297 36.3868 42.4297C37.3048 42.4297 38.0313 42.5469 38.6798 42.6758C39.1407 42.7656 39.5079 42.8086 39.8477 42.8086C40.6056 42.8086 41.1876 42.375 41.3985 41.6484C41.5079 41.2812 41.586 40.9258 41.6641 40.5664C41.6954 40.4336 41.7696 40.0977 41.836 39.875C45.4141 39.293 47.3321 38.4414 47.8556 37.2148C47.9415 37.0195 47.9884 36.8164 48.004 36.6055C48.0431 35.8594 47.5157 35.2031 46.7735 35.0781Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function e3({ size: C = "20px" }) {
  return /* @__PURE__ */ t(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ t(
        "path",
        {
          d: "M24.5626 3.34375C23.5782 3.34375 21.4884 3.49609 19.2188 4.5C16.9493 5.50391 14.4962 7.41797 12.9688 10.8438C11.8165 13.4258 12.1563 17.1836 12.3438 20.1875C12.3595 20.4102 12.3634 20.6016 12.3751 20.8125C12.2813 20.8555 12.3634 20.875 12.0626 20.875C11.6095 20.875 11.004 20.7266 10.2501 20.375C9.94932 20.2344 9.629 20.1875 9.3126 20.1875C8.73838 20.1875 8.17588 20.3594 7.6876 20.6562C7.19932 20.9531 6.73057 21.4141 6.59385 22.125C6.51182 22.5625 6.60557 23.2188 7.03135 23.75C7.45713 24.2812 8.11728 24.7148 9.15635 25.125C9.38291 25.2148 9.61338 25.3008 9.84385 25.375C10.3126 25.5234 10.8634 25.6836 11.2813 25.9062C11.6993 26.1289 11.9454 26.3906 12.0313 26.5938C12.1251 26.8125 12.1524 27.1523 11.8438 27.7812C11.8321 27.8008 11.8204 27.8242 11.8126 27.8438C11.8087 27.8594 11.7931 27.8711 11.7813 27.9062C11.6563 28.1875 8.91807 34.1562 3.21885 35.0938C2.48447 35.2148 1.96103 35.8555 2.0001 36.5938C2.01182 36.8086 2.08213 37.0391 2.15635 37.2188C2.43369 37.8711 3.02744 38.3516 4.0001 38.7812C4.89853 39.1797 6.29697 39.5312 8.15635 39.8438C8.20322 39.9727 8.26572 40.2148 8.34385 40.5625C8.34385 40.5703 8.33994 40.5859 8.34385 40.5938C8.41416 40.918 8.48057 41.2734 8.59385 41.6562C8.70713 42.0469 8.99619 42.4297 9.34385 42.625C9.6915 42.8203 10.0196 42.8438 10.2188 42.8438C10.6329 42.8438 10.9767 42.7578 11.3438 42.6875C11.9493 42.5703 12.6798 42.4375 13.6251 42.4375C14.1485 42.4375 14.6954 42.4727 15.2501 42.5625C16.1993 42.7188 17.1329 43.3359 18.2501 44.125C19.8673 45.2695 21.8087 46.6562 24.7188 46.6562C24.7696 46.6562 24.8243 46.6289 24.8751 46.625C24.9259 46.6289 24.9806 46.625 25.0313 46.625C25.1134 46.6289 25.1993 46.6562 25.2813 46.6562C28.1915 46.6562 30.129 45.2695 31.7501 44.125C32.8634 43.3359 33.8009 42.7188 34.7501 42.5625C35.3048 42.4727 35.8517 42.4375 36.3751 42.4375C37.2892 42.4375 38.0118 42.5547 38.6876 42.6875C39.1173 42.7734 39.4454 42.8125 39.7813 42.8125H39.8438C40.1524 42.8125 40.5079 42.7266 40.8126 42.5C41.1173 42.2734 41.3204 41.9492 41.4063 41.6562C41.5196 41.2734 41.5821 40.9062 41.6563 40.5625C41.7384 40.1797 41.8009 39.9727 41.8438 39.8438C43.7032 39.5312 45.1017 39.1797 46.0001 38.7812C46.9728 38.3516 47.5665 37.8672 47.8438 37.2188C47.9259 37.0312 47.9884 36.8086 48.0001 36.5938C48.0392 35.8594 47.5118 35.2148 46.7813 35.0938C43.9063 34.6211 41.797 32.8906 40.3751 31.2188C38.961 29.5547 38.2579 27.9648 38.2188 27.875C38.2188 27.8633 38.2188 27.8555 38.2188 27.8438C38.211 27.8242 38.1993 27.8008 38.1876 27.7812C37.8751 27.1523 37.8751 26.8164 37.9688 26.5938C38.0548 26.3906 38.3009 26.1289 38.7188 25.9062C39.1368 25.6836 39.6837 25.5234 40.1563 25.375C40.3907 25.3008 40.6251 25.2109 40.8438 25.125C41.754 24.7656 42.379 24.3906 42.8126 23.9375C43.2462 23.4844 43.4454 22.9219 43.4376 22.4375C43.4181 21.4141 42.6563 20.7344 41.7813 20.4062L41.7501 20.375C41.7423 20.3711 41.7267 20.3789 41.7188 20.375C41.3595 20.2305 40.9806 20.1562 40.5938 20.1562C40.3321 20.1562 39.9688 20.168 39.5313 20.375C38.8517 20.6953 38.2813 20.8516 37.8438 20.875C37.8165 20.875 37.8399 20.875 37.8126 20.875C37.7853 20.875 37.8048 20.8789 37.7813 20.875C37.6524 20.8594 37.6915 20.8359 37.6251 20.8125C37.6368 20.6406 37.6446 20.4883 37.6563 20.3125V20.1875C37.8478 17.1836 38.1837 13.4297 37.0313 10.8438C35.504 7.41797 33.0548 5.47266 30.7813 4.46875C28.5079 3.46484 26.4259 3.34375 25.4376 3.34375H25.3438C25.3321 3.34375 25.3243 3.34375 25.3126 3.34375H24.5626ZM24.5626 5.34375H25.4376C26.2384 5.34375 28.0548 5.46875 29.9688 6.3125C31.8829 7.15625 33.8985 8.69141 35.2188 11.6562C35.9688 13.3359 35.8478 17.0625 35.6563 20.0625V20.1875C35.629 20.6055 35.5821 21.0117 35.5626 21.4062C35.5548 21.6875 35.6681 21.9609 35.8751 22.1562C36.0313 22.3164 36.6876 22.832 37.7813 22.875C37.7931 22.875 37.8009 22.875 37.8126 22.875C37.8243 22.875 37.8321 22.875 37.8438 22.875C38.6524 22.8438 39.5001 22.5977 40.3751 22.1875C40.3985 22.1758 40.5079 22.1562 40.5938 22.1562C40.7188 22.1562 40.8829 22.1875 40.9688 22.2188C40.9767 22.2227 40.9923 22.2148 41.0001 22.2188C41.0196 22.2305 41.0431 22.2422 41.0626 22.25C41.297 22.332 41.4063 22.4258 41.4376 22.4688C41.4454 22.4766 41.4337 22.4961 41.4376 22.5C41.4259 22.5195 41.4142 22.5195 41.3751 22.5625C41.2306 22.7148 40.8321 22.9883 40.0938 23.2812C39.9728 23.3281 39.7892 23.3984 39.5626 23.4688C39.0899 23.6172 38.4181 23.8203 37.7813 24.1562C37.1446 24.4922 36.4728 24.9883 36.1251 25.8125C35.754 26.6836 35.9103 27.6406 36.3438 28.5625C36.3478 28.5781 36.3399 28.582 36.3438 28.5938C36.3595 28.6367 36.3751 28.6602 36.3751 28.6562C36.4649 28.8633 37.2228 30.6289 38.8438 32.5312C40.3009 34.2422 42.5157 36.0117 45.4688 36.7812C45.3438 36.8633 45.4298 36.8594 45.1876 36.9688C44.4688 37.2852 43.2345 37.625 41.2188 37.9375C40.6485 38.0234 40.2228 38.5625 40.0626 38.9375C39.9024 39.3125 39.8204 39.6836 39.7188 40.1562C39.672 40.375 39.6134 40.5742 39.5626 40.7812C39.4259 40.7695 39.3126 40.7695 39.0626 40.7188C38.336 40.5781 37.4571 40.4375 36.3751 40.4375C35.7345 40.4375 35.0938 40.4844 34.4376 40.5938C32.9024 40.8516 31.7071 41.7109 30.5938 42.5C28.9688 43.6445 27.586 44.6562 25.2813 44.6562C25.1876 44.6562 25.0938 44.6602 25.0001 44.6562C24.9571 44.6523 24.9181 44.6523 24.8751 44.6562C24.836 44.6602 24.7657 44.6562 24.7188 44.6562C22.4142 44.6562 21.0235 43.6445 19.4063 42.5C18.2892 41.7109 17.0978 40.8477 15.5626 40.5938C14.9063 40.4844 14.2657 40.4375 13.6251 40.4375C12.4728 40.4375 11.5431 40.6016 10.9376 40.7188C10.6954 40.7656 10.6056 40.793 10.4688 40.8125C10.4142 40.5938 10.3321 40.3867 10.2813 40.1562C10.1876 39.7266 10.1251 39.3477 9.96885 38.9688C9.89072 38.7812 9.78135 38.5742 9.59385 38.375C9.40635 38.1758 9.129 38.0156 8.8126 37.9688C6.80088 37.6562 5.53135 37.2852 4.8126 36.9688C4.5626 36.8594 4.65635 36.8672 4.53135 36.7812C10.7618 35.1719 13.4728 29.0078 13.6251 28.6562C13.6368 28.6328 13.6446 28.6172 13.6563 28.5938C13.6603 28.582 13.6524 28.5781 13.6563 28.5625C14.0899 27.6406 14.2462 26.6836 13.8751 25.8125C13.5235 24.9883 12.8556 24.4922 12.2188 24.1562C11.5821 23.8203 10.9415 23.6172 10.4688 23.4688C10.2384 23.3945 10.0235 23.3281 9.90635 23.2812C9.0665 22.9492 8.69932 22.6328 8.59385 22.5C8.59385 22.5195 8.57041 22.4336 8.71885 22.3438C8.88291 22.2461 9.17197 22.1875 9.3126 22.1875C9.39072 22.1875 9.38682 22.1914 9.3751 22.1875C10.3126 22.625 11.2032 22.875 12.0626 22.875C13.2501 22.875 13.961 22.3594 14.1563 22.1562C14.3517 21.957 14.4532 21.6836 14.4376 21.4062C14.4142 20.9688 14.3712 20.5234 14.3438 20.0625C14.1563 17.0586 14.0313 13.3359 14.7813 11.6562C16.1017 8.69531 18.0899 7.15625 20.0001 6.3125C21.9103 5.46875 23.7618 5.34375 24.5626 5.34375Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function i3({ size: C = "20px" }) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 50 50",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ c("g", { clipPath: "url(#clip0_7177_541)", children: [
          /* @__PURE__ */ t(
            "path",
            {
              d: "M4.01611 35.3173V35.3192C4.04125 36.2515 4.049 37.1893 4.20627 38.1159C4.37292 39.0962 4.61115 40.0521 5.06564 40.9419C5.6801 42.1461 6.52396 43.1631 7.58916 43.9938C8.35395 44.5903 9.18941 45.0638 10.1142 45.3625C11.4628 45.7975 12.854 45.9643 14.2656 45.9724C15.1463 45.978 16.0264 46 16.9074 45.9963C23.3053 45.9694 29.7035 46.0425 36.1016 45.9568C36.9506 45.9453 37.7857 45.8418 38.619 45.6894C40.216 45.3971 41.6275 44.7156 42.8351 43.6382C44.2425 42.383 45.1921 40.8467 45.6207 38.9926C45.9012 37.7806 45.9714 36.5511 45.9834 35.3172V35.071C45.9834 34.9755 45.9471 14.1056 45.9437 13.8297C45.9343 13.072 45.8785 12.3199 45.7364 11.5743C45.5637 10.6657 45.3196 9.78041 44.8845 8.95841C44.4251 8.08998 43.8496 7.30912 43.1379 6.62676C42.0477 5.58131 40.7895 4.84199 39.3248 4.45091C38.0019 4.09777 36.6523 4.01959 35.2928 4.02081C35.2906 4.02048 35.2855 4.00669 35.2851 4H14.7078C14.7074 4.00702 14.7072 4.01404 14.7067 4.02081C13.9351 4.03493 13.1624 4.02914 12.3948 4.12429C11.5539 4.22884 10.721 4.38627 9.92506 4.68023C8.67134 5.14395 7.58206 5.86622 6.65161 6.83046C5.59742 7.92292 4.85435 9.18635 4.46008 10.6576C4.10833 11.9702 4.03178 13.309 4.02991 14.6572",
              fill: "#FFFC00"
            }
          ),
          /* @__PURE__ */ t(
            "path",
            {
              d: "M25.1905 39.436C25.1034 39.436 25.0202 39.4328 24.957 39.4298C24.9068 39.4341 24.8549 39.436 24.803 39.436C22.9719 39.436 21.7476 38.5703 20.6671 37.8059C19.8927 37.2589 19.1624 36.7424 18.3067 36.6001C17.8865 36.5304 17.4685 36.4951 17.0646 36.4951C16.3369 36.4951 15.7617 36.6079 15.3419 36.6901C15.0835 36.7404 14.8607 36.7837 14.6885 36.7837C14.5081 36.7837 14.289 36.7437 14.1977 36.4319C14.1253 36.1859 14.0734 35.9476 14.0233 35.7181C13.8979 35.1446 13.807 34.7946 13.5923 34.7614C11.2956 34.407 9.93866 33.885 9.66836 33.2529C9.64004 33.1865 9.62421 33.1196 9.6207 33.0535C9.61017 32.8651 9.7432 32.6998 9.92895 32.669C11.7528 32.3687 13.3745 31.4047 14.7493 29.8029C15.8142 28.5628 16.3372 27.378 16.3933 27.2471C16.3958 27.2413 16.3986 27.2351 16.4016 27.2294C16.6666 26.6918 16.7193 26.2272 16.5588 25.8489C16.2628 25.151 15.2828 24.8401 14.6344 24.6343C14.4731 24.5833 14.3206 24.535 14.199 24.4868C13.6243 24.2597 12.6789 23.78 12.8049 23.1179C12.8966 22.6351 13.5352 22.2989 14.0513 22.2989C14.1946 22.2989 14.3216 22.324 14.4285 22.3742C15.0117 22.6474 15.5364 22.7859 15.9877 22.7859C16.5488 22.7859 16.8198 22.5723 16.8854 22.5115C16.8692 22.2122 16.8495 21.8957 16.8304 21.5963C16.8304 21.596 16.83 21.5924 16.83 21.5924C16.6982 19.497 16.534 16.8894 17.201 15.394C19.1974 10.9178 23.4311 10.5698 24.6808 10.5698C24.7141 10.5698 25.2255 10.5647 25.2255 10.5647C25.2486 10.5643 25.2736 10.564 25.2996 10.564C26.5526 10.564 30.7952 10.9124 32.7928 15.3913C33.4599 16.8877 33.2954 19.4975 33.1633 21.5951L33.1571 21.6955C33.139 21.9803 33.1222 22.2499 33.1081 22.5112C33.1698 22.568 33.4178 22.7639 33.9224 22.7837C34.3526 22.7672 34.8469 22.6294 35.3913 22.3745C35.5596 22.2955 35.7459 22.2791 35.8724 22.2791C36.0636 22.2791 36.2582 22.3163 36.4203 22.384L36.429 22.3873C36.8909 22.5513 37.1934 22.879 37.2 23.2232C37.2058 23.5441 36.9673 24.0237 35.7944 24.487C35.6742 24.5345 35.521 24.5832 35.359 24.6345C34.7101 24.8405 33.7308 25.1513 33.4349 25.8487C33.2741 26.227 33.327 26.6915 33.5921 27.2289C33.595 27.2348 33.5975 27.2408 33.6004 27.247C33.682 27.4383 35.6574 31.9425 40.0648 32.6686C40.2505 32.6996 40.3837 32.865 40.3731 33.0531C40.3692 33.1207 40.3529 33.1882 40.3243 33.2543C40.0559 33.8829 38.699 34.4042 36.4017 34.759C36.1861 34.7923 36.0953 35.1408 35.9711 35.7113C35.9196 35.9469 35.8673 36.1779 35.7959 36.4206C35.7291 36.6488 35.5804 36.7604 35.3416 36.7604H35.3056C35.1501 36.7604 34.9298 36.7322 34.652 36.6778C34.1665 36.5833 33.6219 36.4953 32.9293 36.4953C32.5255 36.4953 32.1075 36.5307 31.6868 36.6004C30.8321 36.7427 30.1019 37.2583 29.3288 37.8048C28.2462 38.5702 27.0215 39.436 25.1905 39.436Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ t(
            "path",
            {
              d: "M25.2995 10.9329C26.4792 10.9329 30.5415 11.2498 32.4559 15.5417C33.0863 16.955 32.9247 19.5151 32.7951 21.5716C32.7749 21.898 32.7548 22.2143 32.7385 22.5163L32.7316 22.6462L32.8183 22.7429C32.8533 22.7817 33.181 23.1242 33.9098 23.1523L33.9215 23.153L33.9337 23.1527C34.4156 23.1344 34.9583 22.9847 35.5477 22.7086C35.6345 22.668 35.7501 22.6481 35.8724 22.6481C36.0117 22.6481 36.1597 22.6743 36.2818 22.7258L36.3002 22.7331C36.6093 22.8414 36.8278 23.0456 36.8311 23.2304C36.8329 23.3348 36.7548 23.7111 35.6593 24.1439C35.5522 24.1862 35.4112 24.2312 35.2479 24.2827C34.5349 24.5091 33.4578 24.8507 33.0953 25.7049C32.8912 26.1861 32.9471 26.754 33.2613 27.3925C33.3905 27.6942 35.4256 32.2782 40.0049 33.0328C40.004 33.0545 39.9985 33.0782 39.9862 33.1062C39.9086 33.289 39.4153 33.9206 36.3454 34.3943C35.865 34.4679 35.7473 35.0064 35.6109 35.6323C35.5616 35.8565 35.5115 36.0827 35.4426 36.3163C35.4215 36.3869 35.4176 36.3909 35.342 36.3909C35.3315 36.3909 35.3193 36.3909 35.3059 36.3909C35.1698 36.3909 34.9631 36.3627 34.7236 36.3157C34.2874 36.2307 33.6914 36.1265 32.9296 36.1265C32.5044 36.1265 32.0664 36.1635 31.6269 36.2368C30.6875 36.393 29.9235 36.9334 29.1144 37.5053C28.0278 38.2731 26.9048 39.0676 25.1912 39.0676C25.1164 39.0676 25.0434 39.0651 24.9701 39.0614L24.9509 39.0606L24.9315 39.0621C24.8895 39.0658 24.8472 39.0676 24.8039 39.0676C23.0906 39.0676 21.9671 38.2734 20.881 37.5053C20.0717 36.9334 19.3073 36.393 18.3681 36.2368C17.929 36.1637 17.4906 36.1265 17.0656 36.1265C16.3039 36.1265 15.7073 36.243 15.272 36.3282C15.0324 36.375 14.8251 36.4152 14.6893 36.4152C14.5782 36.4152 14.5761 36.4086 14.5526 36.3283C14.4837 36.0945 14.4333 35.8629 14.3843 35.6391C14.2475 35.0125 14.1297 34.4711 13.6496 34.3974C10.5799 33.9233 10.0865 33.2907 10.0087 33.1083C9.99649 33.0796 9.99102 33.0551 9.9898 33.0334C14.569 32.2795 16.6037 27.6953 16.7334 27.3925C17.0482 26.7544 17.104 26.1867 16.8992 25.7049C16.5367 24.8512 15.4598 24.5091 14.7473 24.2831C14.5835 24.2312 14.4425 24.1862 14.3353 24.1439C13.4102 23.7784 13.1256 23.4102 13.1678 23.187C13.2169 22.9297 13.663 22.6681 14.0523 22.6681C14.1398 22.6681 14.2165 22.6822 14.2732 22.7087C14.9054 23.005 15.4826 23.1553 15.9888 23.1553C16.7846 23.1553 17.1388 22.785 17.1769 22.7427L17.2631 22.6463L17.2562 22.5171C17.2401 22.2152 17.2203 21.8989 17.1994 21.5732C17.0702 19.5162 16.9086 16.9578 17.5387 15.5445C19.446 11.2683 23.4885 10.9387 24.6818 10.9387C24.7112 10.9387 25.23 10.9334 25.23 10.9334C25.2512 10.9332 25.2748 10.9329 25.2995 10.9329ZM25.2995 10.1953H25.2981C25.271 10.1953 25.2454 10.1953 25.2211 10.1956C25.0272 10.1976 24.7084 10.2007 24.6798 10.201C23.9807 10.201 22.5819 10.2998 21.0795 10.963C20.2204 11.3419 19.4477 11.8542 18.7829 12.4858C17.9903 13.2384 17.3446 14.1662 16.8641 15.244C16.1603 16.822 16.3274 19.4801 16.4615 21.6161L16.462 21.6194C16.4764 21.8482 16.4915 22.0871 16.5053 22.3198C16.402 22.3672 16.2347 22.4173 15.9879 22.4173C15.591 22.4173 15.1189 22.2904 14.5853 22.0403C14.4283 21.9672 14.249 21.9302 14.0513 21.9302C13.7336 21.9302 13.3986 22.0237 13.1081 22.1945C12.7426 22.4092 12.5064 22.7125 12.4422 23.0489C12.4 23.2713 12.402 23.7111 12.8905 24.157C13.1591 24.4025 13.5538 24.6289 14.0632 24.8302C14.1969 24.8828 14.3555 24.9331 14.5236 24.9864C15.1067 25.1717 15.9893 25.4518 16.2194 25.9934C16.336 26.268 16.2858 26.6294 16.0706 27.0662C16.065 27.0781 16.0594 27.0898 16.0542 27.102C16.0004 27.2276 15.4987 28.3642 14.4695 29.5628C13.8846 30.2444 13.2405 30.8141 12.5559 31.2564C11.7204 31.7964 10.8163 32.1495 9.86902 32.3055C9.49703 32.3666 9.23138 32.698 9.25211 33.0746C9.25848 33.1832 9.28394 33.2914 9.32809 33.3961C9.32842 33.3968 9.32883 33.3974 9.32915 33.398C9.47956 33.7498 9.82829 34.0487 10.3952 34.3123C11.0881 34.6341 12.1242 34.9048 13.4746 35.1166C13.5429 35.2463 13.6137 35.5724 13.6627 35.7957C13.7141 36.0331 13.7676 36.2771 13.8439 36.5363C13.9263 36.8171 14.1398 37.1527 14.6885 37.1527C14.8965 37.1527 15.1356 37.1058 15.4125 37.0521C15.818 36.9726 16.3726 36.864 17.0647 36.864C17.4485 36.864 17.8462 36.8978 18.2465 36.9643C19.0181 37.0928 19.6833 37.5627 20.453 38.1069C21.5796 38.9033 22.8548 39.8047 24.8031 39.8047C24.8562 39.8047 24.9095 39.803 24.9622 39.7993C25.0265 39.8023 25.1064 39.8047 25.1906 39.8047C27.1395 39.8047 28.4143 38.9029 29.5397 38.1072L29.5415 38.1056C30.3113 37.5621 30.9758 37.0928 31.7472 36.9643C32.1473 36.8979 32.545 36.864 32.9289 36.864C33.5901 36.864 34.1136 36.9483 34.5811 37.0395C34.8862 37.0996 35.1232 37.1285 35.3052 37.1285L35.3229 37.1288H35.3414C35.7427 37.1288 36.0375 36.9085 36.1501 36.5231C36.2248 36.2693 36.2782 36.031 36.3309 35.7897C36.3767 35.5804 36.45 35.245 36.5182 35.1139C37.8696 34.9017 38.9053 34.6315 39.5982 34.3098C40.1638 34.0474 40.5122 33.7489 40.6635 33.3985C40.7088 33.2935 40.7354 33.1846 40.7413 33.0738C40.7626 32.6978 40.4966 32.3657 40.1243 32.3047C35.9144 31.6108 34.0178 27.2851 33.9394 27.1013C33.9343 27.0892 33.9286 27.0772 33.9226 27.0655C33.7074 26.6286 33.6577 26.2676 33.7744 25.9925C34.0041 25.4513 34.8861 25.1713 35.4696 24.9861C35.6385 24.9329 35.7978 24.8823 35.9304 24.8299C36.5048 24.603 36.9154 24.3569 37.1863 24.0773C37.5098 23.7441 37.5728 23.4248 37.5689 23.2159C37.559 22.7104 37.1726 22.2612 36.5579 22.0413C36.3503 21.9554 36.1135 21.9101 35.8724 21.9101C35.7083 21.9101 35.4653 21.9327 35.2352 22.0401C34.7427 22.2705 34.3015 22.3965 33.9227 22.4145C33.7213 22.4043 33.58 22.3606 33.4886 22.3189C33.5001 22.1217 33.5128 21.9192 33.5259 21.708L33.5314 21.6175C33.6663 19.4801 33.8339 16.8201 33.1299 15.2409C32.6473 14.1593 31.9993 13.2291 31.2035 12.4749C30.5361 11.8429 29.7608 11.3306 28.8986 10.9519C27.3983 10.2937 25.9996 10.1953 25.2995 10.1953Z",
              fill: "#020202"
            }
          )
        ] }),
        /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "clip0_7177_541", children: /* @__PURE__ */ t(
          "rect",
          {
            width: "42",
            height: "42",
            fill: "white",
            transform: "translate(4 4)"
          }
        ) }) })
      ]
    }
  );
}
const C9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BehanceColored: V2,
  BehanceFilled: a2,
  BehanceOutlined: p2,
  DiscordColored: s2,
  DiscordFilled: c2,
  DiscordOutlined: d2,
  DribbbleColored: Z2,
  DribbbleFilled: L2,
  DribbbleOutlined: M2,
  FacebookColored: u2,
  FacebookFilled: w2,
  FacebookMessengerColored: x2,
  FacebookMessengerFilled: k2,
  FacebookMessengerOutlined: g2,
  FacebookOutlined: f2,
  GithubColored: b2,
  GithubFilled: v2,
  GithubOutlined: _2,
  InstagramColored: B2,
  InstagramFilled: m2,
  InstagramOutlined: y2,
  LinkedinColored: R2,
  LinkedinFilled: F2,
  LinkedinOutlined: I2,
  PinterestColored: E2,
  PinterestFilled: A2,
  PinterestOutlined: $2,
  SkypeColored: O2,
  SkypeFilled: W2,
  SkypeOutlined: U2,
  SnapchatColored: i3,
  SnapchatFilled: t3,
  SnapchatOutlined: e3,
  TelegramAppColored: T2,
  TelegramFilled: q2,
  TelegramOutlined: D2,
  TiktokColored: N2,
  TiktokFilled: G2,
  TiktokOutlined: j2,
  TwitterColored: P2,
  TwitterFilled: S2,
  TwitterOutlined: z2,
  WhatsappColored: K2,
  WhatsappFilled: Y2,
  WhatsappOutlined: J2,
  YoutubeColored: C3,
  YoutubeFilled: X2,
  YoutubeOutlined: Q2
}, Symbol.toStringTag, { value: "Module" })), u5 = "_linkContainer_1wfr1_1", k5 = {
  linkContainer: u5
}, g5 = ({
  element: C,
  wuiltContext: e,
  noAction: i,
  customClassNames: n
}) => {
  var H, V, p;
  const o = C == null ? void 0 : C.settings, r = (H = e == null ? void 0 : e.base) == null ? void 0 : H.Link, l = (V = o == null ? void 0 : o.iconStyle) == null ? void 0 : V.size, h = {
    [$.Behance]: {
      [M.Filled]: /* @__PURE__ */ t(a2, { size: l }),
      [M.Outlined]: /* @__PURE__ */ t(p2, { size: l }),
      [M.Colored]: /* @__PURE__ */ t(V2, { size: l })
    },
    [$.Discord]: {
      [M.Filled]: /* @__PURE__ */ t(c2, { size: l }),
      [M.Outlined]: /* @__PURE__ */ t(d2, { size: l }),
      [M.Colored]: /* @__PURE__ */ t(s2, { size: l })
    },
    [$.Dribbble]: {
      [M.Filled]: /* @__PURE__ */ t(L2, { size: l }),
      [M.Outlined]: /* @__PURE__ */ t(M2, { size: l }),
      [M.Colored]: /* @__PURE__ */ t(Z2, { size: l })
    },
    [$.Facebook]: {
      [M.Filled]: /* @__PURE__ */ t(w2, { size: l }),
      [M.Outlined]: /* @__PURE__ */ t(f2, { size: l }),
      [M.Colored]: /* @__PURE__ */ t(u2, { size: l })
    },
    [$.Messenger]: {
      [M.Filled]: /* @__PURE__ */ t(k2, { size: l }),
      [M.Outlined]: /* @__PURE__ */ t(g2, { size: l }),
      [M.Colored]: /* @__PURE__ */ t(x2, { size: l })
    },
    [$.Github]: {
      [M.Filled]: /* @__PURE__ */ t(v2, { size: l }),
      [M.Outlined]: /* @__PURE__ */ t(_2, { size: l }),
      [M.Colored]: /* @__PURE__ */ t(b2, { size: l })
    },
    [$.Instagram]: {
      [M.Filled]: /* @__PURE__ */ t(m2, { size: l }),
      [M.Outlined]: /* @__PURE__ */ t(y2, { size: l }),
      [M.Colored]: /* @__PURE__ */ t(B2, { size: l })
    },
    [$.Linkedin]: {
      [M.Filled]: /* @__PURE__ */ t(F2, { size: l }),
      [M.Outlined]: /* @__PURE__ */ t(I2, { size: l }),
      [M.Colored]: /* @__PURE__ */ t(R2, { size: l })
    },
    [$.Pinterest]: {
      [M.Filled]: /* @__PURE__ */ t(A2, { size: l }),
      [M.Outlined]: /* @__PURE__ */ t($2, { size: l }),
      [M.Colored]: /* @__PURE__ */ t(E2, { size: l })
    },
    [$.Skype]: {
      [M.Filled]: /* @__PURE__ */ t(W2, { size: l }),
      [M.Outlined]: /* @__PURE__ */ t(U2, { size: l }),
      [M.Colored]: /* @__PURE__ */ t(O2, { size: l })
    },
    [$.Telegram]: {
      [M.Filled]: /* @__PURE__ */ t(q2, { size: l }),
      [M.Outlined]: /* @__PURE__ */ t(D2, { size: l }),
      [M.Colored]: /* @__PURE__ */ t(T2, { size: l })
    },
    [$.Tiktok]: {
      [M.Filled]: /* @__PURE__ */ t(G2, { size: l }),
      [M.Outlined]: /* @__PURE__ */ t(j2, { size: l }),
      [M.Colored]: /* @__PURE__ */ t(N2, { size: l })
    },
    [$.Twitter]: {
      [M.Filled]: /* @__PURE__ */ t(S2, { size: l }),
      [M.Outlined]: /* @__PURE__ */ t(z2, { size: l }),
      [M.Colored]: /* @__PURE__ */ t(P2, { size: l })
    },
    [$.Whatsapp]: {
      [M.Filled]: /* @__PURE__ */ t(Y2, { size: l }),
      [M.Outlined]: /* @__PURE__ */ t(J2, { size: l }),
      [M.Colored]: /* @__PURE__ */ t(K2, { size: l })
    },
    [$.Youtube]: {
      [M.Filled]: /* @__PURE__ */ t(X2, { size: l }),
      [M.Outlined]: /* @__PURE__ */ t(Q2, { size: l }),
      [M.Colored]: /* @__PURE__ */ t(C3, { size: l })
    },
    [$.Snapchat]: {
      [M.Filled]: /* @__PURE__ */ t(t3, { size: l }),
      [M.Outlined]: /* @__PURE__ */ t(e3, { size: l }),
      [M.Colored]: /* @__PURE__ */ t(i3, { size: l })
    }
  };
  return /* @__PURE__ */ t(
    "div",
    {
      className: T(
        k5.linkContainer,
        n == null ? void 0 : n.hiddenClass
      ),
      children: (p = o == null ? void 0 : o.socialLinks) == null ? void 0 : p.map((a, L) => {
        var s, u, w;
        return /* @__PURE__ */ t(
          r,
          {
            href: i || a == null ? void 0 : a.link,
            target: i ? void 0 : "_blank",
            style: {
              marginInlineEnd: "15px",
              color: ((s = o == null ? void 0 : o.iconStyle) == null ? void 0 : s.color) || (n == null ? void 0 : n.navLinksColor)
            },
            children: (w = h == null ? void 0 : h[a == null ? void 0 : a.name]) == null ? void 0 : w[(u = o == null ? void 0 : o.iconStyle) == null ? void 0 : u.shape]
          },
          L
        );
      })
    }
  );
}, x5 = "_desktop_1c2da_1", v5 = "_tablet_1c2da_10", _5 = "_mobile_1c2da_19", b5 = "_overlay_1c2da_28", m5 = "_video_1c2da_37", y5 = {
  desktop: x5,
  tablet: v5,
  mobile: _5,
  overlay: b5,
  video: m5
}, B5 = ({ element: C }) => {
  const e = C == null ? void 0 : C.settings;
  return /* @__PURE__ */ t(
    "div",
    {
      "data-test": "VideoView",
      className: y5.video,
      style: { "--width": e == null ? void 0 : e.width },
      children: /* @__PURE__ */ t(
        C2,
        {
          light: !(e != null && e.autoplay),
          url: e == null ? void 0 : e.url,
          controls: e == null ? void 0 : e.controls,
          muted: e == null ? void 0 : e.muted,
          loop: e == null ? void 0 : e.loop,
          playing: e == null ? void 0 : e.autoplay,
          width: "100%",
          height: e == null ? void 0 : e.height
        },
        `${e == null ? void 0 : e.url}-${Date.now()}`
      )
    }
  );
}, F5 = (C) => {
  var o;
  const e = {};
  function i(r = "") {
    const l = `Content:${r1()}`;
    return Object.assign(e, { [l]: r }), { textId: l, content: r };
  }
  const n = (o = C == null ? void 0 : C.rows) == null ? void 0 : o.map((r) => {
    var h;
    const l = (h = r == null ? void 0 : r.columns) == null ? void 0 : h.map((H) => {
      var p;
      const V = (p = H == null ? void 0 : H.elements) == null ? void 0 : p.map((a) => {
        var L, s, u, w, f, v, I, x, b, A, F, y, R, B, q, E, D;
        if ((a == null ? void 0 : a.type) === "Text")
          return Z(d({}, a), {
            settings: d(d({}, a == null ? void 0 : a.settings), i((L = a == null ? void 0 : a.settings) == null ? void 0 : L.content))
          });
        if ((a == null ? void 0 : a.type) === "Form") {
          const W = (u = (s = a == null ? void 0 : a.settings) == null ? void 0 : s.fields) == null ? void 0 : u.map(
            (k) => {
              var G, o1, C1, K, P, M1, Z1, H1, t1, e1;
              const N = (o1 = (G = k == null ? void 0 : k.settings) == null ? void 0 : G.options) == null ? void 0 : o1.map((Y) => {
                var i1;
                return Z(d({}, Y), {
                  label: i((i1 = Y == null ? void 0 : Y.label) == null ? void 0 : i1.content)
                });
              });
              return Z(d({}, k), {
                settings: Z(d({}, k == null ? void 0 : k.settings), {
                  label: i((K = (C1 = k == null ? void 0 : k.settings) == null ? void 0 : C1.label) == null ? void 0 : K.content),
                  description: i(
                    (M1 = (P = k == null ? void 0 : k.settings) == null ? void 0 : P.description) == null ? void 0 : M1.content
                  ),
                  placeholder: i(
                    (H1 = (Z1 = k == null ? void 0 : k.settings) == null ? void 0 : Z1.placeholder) == null ? void 0 : H1.content
                  ),
                  errorMessage: i(
                    (e1 = (t1 = k == null ? void 0 : k.settings) == null ? void 0 : t1.errorMessage) == null ? void 0 : e1.content
                  ),
                  options: N
                })
              });
            }
          );
          return Z(d({}, a), {
            settings: Z(d({}, a == null ? void 0 : a.settings), {
              fields: W,
              formButton: d(d({
                id: (f = (w = a == null ? void 0 : a.settings) == null ? void 0 : w.formButton) == null ? void 0 : f.id
              }, (v = a == null ? void 0 : a.settings) == null ? void 0 : v.formButton), i(
                (x = (I = a == null ? void 0 : a.settings) == null ? void 0 : I.formButton) == null ? void 0 : x.content
              )),
              formPostSubmit: Z(d({}, (b = a == null ? void 0 : a.settings) == null ? void 0 : b.formPostSubmit), {
                failureMessage: i(
                  (y = (F = (A = a == null ? void 0 : a.settings) == null ? void 0 : A.formPostSubmit) == null ? void 0 : F.failureMessage) == null ? void 0 : y.content
                ),
                successMessage: i(
                  (q = (B = (R = a == null ? void 0 : a.settings) == null ? void 0 : R.formPostSubmit) == null ? void 0 : B.successMessage) == null ? void 0 : q.content
                )
              })
            })
          });
        }
        if ((a == null ? void 0 : a.type) === "Buttons") {
          const W = (D = (E = a == null ? void 0 : a.settings) == null ? void 0 : E.buttons) == null ? void 0 : D.map(
            (k) => d(d({}, k), i(k == null ? void 0 : k.content))
          );
          return Z(d({}, a), {
            settings: Z(d({}, a == null ? void 0 : a.settings), {
              buttons: W
            })
          });
        }
        return a;
      });
      return Z(d({}, H), { elements: V });
    });
    return Z(d({}, r), { columns: l });
  });
  return Z(d({}, C), { rows: n, text: e });
};
function I5(C) {
  var e;
  return {
    formId: (e = C == null ? void 0 : C.settings) == null ? void 0 : e.formId
  };
}
const v1 = {
  Form: I5
};
function R5(C) {
  const e = {};
  return C.rows.forEach(
    (i, n) => {
      var o;
      return (o = i == null ? void 0 : i.columns) == null ? void 0 : o.forEach(
        (r, l) => r.elements.forEach((h, H) => {
          var p;
          const V = {
            [h.id]: Z(d({}, (p = v1[h.type]) == null ? void 0 : p.call(v1, h)), {
              id: h.id,
              location: {
                row: n,
                column: l,
                element: H
              }
            })
          };
          Object.hasOwn(e, h.type) ? Object.assign(e[h.type], V) : Object.assign(e, { [h.type]: V });
        })
      );
    }
  ), Z(d({}, C), { metadata: e });
}
const A5 = (C) => {
  if (!(C != null && C.text)) {
    const e = F5(C);
    return R5(e);
  }
  return C;
}, $5 = (C, e = {}) => {
  const { action: i = "start", duration: n = 1e3, delay: o = 16 } = e;
  if (i === "stop") {
    K1(C);
    return;
  }
  if (K1(C), !/[0-9]/.test(C.innerHTML))
    return;
  const r = E5(C.innerHTML, {
    duration: n || C.getAttribute("data-duration"),
    delay: o || C.getAttribute("data-delay")
  });
  C._countUpOrigInnerHTML = C.innerHTML, C.innerHTML = r[0] || "&nbsp;", C.style.visibility = "visible";
  const l = function() {
    C.innerHTML = r.shift() || "&nbsp;", r.length ? (clearTimeout(C.countUpTimeout), C.countUpTimeout = setTimeout(l, o)) : C._countUpOrigInnerHTML = void 0;
  };
  C.countUpTimeout = setTimeout(l, o);
}, K1 = (C) => {
  clearTimeout(C.countUpTimeout), C._countUpOrigInnerHTML && (C.innerHTML = C._countUpOrigInnerHTML, C._countUpOrigInnerHTML = void 0), C.style.visibility = "";
}, E5 = (C, e = {}) => {
  const { duration: i = 1e3, delay: n = 16 } = e, o = i / n, r = C.toString().split(/(<[^>]+>|[0-9.][,.0-9]*[0-9]*)/), l = [];
  for (let h = 0; h < o; h++)
    l.push("");
  for (let h = 0; h < r.length; h++)
    if (/([0-9.][,.0-9]*[0-9]*)/.test(r[h]) && !/<[^>]+>/.test(r[h])) {
      let H = r[h];
      const V = [...H.matchAll(/[.,]/g)].map((a) => ({ char: a[0], i: H.length - a.index - 1 })).sort((a, L) => a.i - L.i);
      H = H.replace(/[.,]/g, "");
      let p = l.length - 1;
      for (let a = o; a >= 1; a--) {
        let L = parseInt(H / o * a, 10);
        L = V.reduce((s, { char: u, i: w }) => s.length <= w ? s : s.slice(0, -w) + u + s.slice(-w), L.toString()), l[p--] += L;
      }
    } else
      for (let H = 0; H < o; H++)
        l[H] += r[h];
  return l[l.length] = C.toString(), l;
};
function W5({ counterSettings: C }) {
  const e = J(null), i = C == null ? void 0 : C.counterValue, n = C == null ? void 0 : C.counterLabel, o = C == null ? void 0 : C.animationSpeed, r = J(null);
  return n1(() => {
    const l = new IntersectionObserver((h) => {
      h.forEach((H) => {
        if (H.isIntersecting) {
          if (r.current) {
            const V = 2e3 - o * 12;
            $5(r.current, {
              duration: o === 0 ? 0 : V
            });
          }
          l.unobserve(H.target);
        }
      });
    });
    return e.current && l.observe(e.current), () => {
      l.disconnect();
    };
  }, [o]), /* @__PURE__ */ c("div", { ref: e, id: "general-text", children: [
    /* @__PURE__ */ t(
      "div",
      {
        style: {
          fontSize: i.size,
          color: i.color
        },
        children: /* @__PURE__ */ t("span", { ref: r, "data-counter": "counterup", children: i.value || "0" })
      }
    ),
    (C == null ? void 0 : C.LabelEnabled) && /* @__PURE__ */ t(
      "span",
      {
        style: {
          fontSize: n.size,
          color: n.color
        },
        children: n.value
      }
    )
  ] });
}
const U5 = ({ element: C }) => {
  const e = C.settings;
  return /* @__PURE__ */ t(W5, { counterSettings: e });
};
function O5(C, e = null) {
  const i = {
    shape1: /* @__PURE__ */ t("svg", { width: "108%", height: "108%", style: C, children: /* @__PURE__ */ t("rect", { width: "100%", height: "100%" }) }),
    shape2: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("circle", { cx: "50", cy: "50", r: "50" })
      }
    ),
    shape3: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M50 0 L63 38 L100 38 L69 59 L82 100 L50 75 L18 100 L31 59 L0 38 L37 38 Z" })
      }
    ),
    shape4: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("polygon", { points: "50 0, 100 100, 0 100" })
      }
    ),
    shape5: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M50 1l49 49-49 49L1 50z" })
      }
    ),
    shape6: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M99.5 13.5h-13V.5h-73v13H.5v73h13v13h73v-13h13v-73z" })
      }
    ),
    shape7: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M50 .5l43.1 6.4L99.5 50l-6.4 43.1L50 99.5 6.9 93.1.5 50 6.9 6.9 50 .5z" })
      }
    ),
    shape8: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M90 95a190 190 0 01-80 0 8 8 0 01-5-5 188 188 0 010-80 8 8 0 015-5 190 190 0 0180 0 8 8 0 015 5 188 188 0 010 80 8 8 0 01-5 5z" })
      }
    ),
    shape9: /* @__PURE__ */ t(
      "svg",
      {
        className: "sqs-shape",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M70.5.5h-41l-29 29v41l29 29h41l29-29v-41l-29-29z" })
      }
    ),
    shape10: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M36.1 4.1a28.3 28.3 0 0127.8 0 279.7 279.7 0 0126.4 19.6c6.9 6 10.8 18 8.6 27a289.4 289.4 0 01-10.1 31.7A28.8 28.8 0 0166.3 99a273.8 273.8 0 01-32.6 0c-9-.6-19.1-8.1-22.5-16.6A289.4 289.4 0 011.1 50.7c-2.2-9 1.7-21 8.6-27A279.7 279.7 0 0136 4.1z" })
      }
    ),
    shape11: /* @__PURE__ */ t(
      "svg",
      {
        className: "sqs-shape",
        viewBox: "0 0 152 152",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M75.9957 152C74.4393 152 72.7717 151.047 72.5493 148.904C72.2757 146.25 70.112 145.051 68.2221 145.051C66.2979 145.051 64.7329 146.19 64.1343 148.028C63.6468 149.525 62.441 150.418 60.9016 150.418C59.8583 150.418 58.8492 149.984 58.1907 149.253C57.5579 148.555 57.2842 147.637 57.3868 146.599C57.5237 145.348 57.1559 144.175 56.352 143.29C55.5225 142.38 54.2825 141.835 53.0254 141.835C51.4775 141.835 50.1348 142.627 49.3395 144.004C48.681 145.136 47.6462 145.757 46.4233 145.757C45.2603 145.757 44.1229 145.187 43.4473 144.26C42.8144 143.401 42.669 142.312 43.0368 141.206C43.4815 139.845 43.2848 138.493 42.4723 137.387C41.6428 136.256 40.266 135.55 38.872 135.55C37.6747 135.55 36.5544 136.06 35.7078 136.996C35.0065 137.77 34.1343 138.178 33.185 138.178C31.9279 138.178 30.705 137.455 30.055 136.349C29.4393 135.294 29.4649 134.095 30.1234 132.964C30.9188 131.594 30.9359 130.038 30.1662 128.711C29.3794 127.358 27.8914 126.482 26.3777 126.482C25.4883 126.482 24.6075 126.78 23.8378 127.333C23.1879 127.801 22.4951 128.039 21.7853 128.039C20.4512 128.039 19.1599 127.171 18.5784 125.87C18.0225 124.62 18.2534 123.293 19.2198 122.229C20.3999 120.928 20.6907 119.21 19.9809 117.645C19.2711 116.054 17.7317 115.025 16.0556 115.025C15.4484 115.025 14.8327 115.161 14.2426 115.425C13.738 115.646 13.2335 115.756 12.746 115.756C11.0698 115.756 9.90678 114.515 9.50484 113.273C9.03448 111.818 9.51339 110.398 10.7962 109.479C12.3697 108.348 12.9769 106.511 12.3783 104.699C11.7882 102.896 10.1633 101.688 8.33323 101.688C8.00826 101.688 7.68329 101.722 7.35832 101.79C7.0761 101.849 6.79389 101.883 6.52878 101.883C4.66447 101.883 3.52707 100.488 3.23631 99.102C2.9541 97.8006 3.33893 96.1079 5.2289 95.2658C7.44384 94.2876 8.06812 92.1442 7.70039 90.443C7.34121 88.7503 5.88739 87.0321 3.47576 87.0321C1.30358 87.0321 0.174736 85.4756 0.0208025 83.9445C-0.141683 82.4049 0.64509 80.6527 2.74885 80.2104C5.11772 79.7086 6.17816 77.7352 6.17816 76C6.17816 74.2648 5.11772 72.2914 2.74885 71.7896C0.636538 71.3473 -0.141683 69.5951 0.0208025 68.0555C0.183288 66.516 1.31214 64.9679 3.46721 64.9679C5.89595 64.9679 7.34121 63.2582 7.70894 61.557C8.06812 59.8644 7.44384 57.7124 5.23745 56.7342C3.33893 55.9006 2.96265 54.2079 3.24486 52.898C3.54418 51.5116 4.67303 50.1166 6.53734 50.1166C6.811 50.1166 7.08466 50.1506 7.36687 50.2102C7.69184 50.2782 8.02536 50.3123 8.34178 50.3123C10.1719 50.3123 11.8053 49.1044 12.3868 47.3012C12.9769 45.4809 12.3697 43.6522 10.8047 42.5209C9.52194 41.5937 9.04304 40.1818 9.51339 38.7273C9.91533 37.4939 11.0784 36.2435 12.7546 36.2435C13.2506 36.2435 13.7551 36.3541 14.2511 36.5753C14.8498 36.839 15.4569 36.975 16.0641 36.975C17.7403 36.975 19.2796 35.9458 19.9894 34.3552C20.6907 32.7816 20.4085 31.072 19.2283 29.7706C18.262 28.7073 18.0311 27.3804 18.5869 26.1301C19.1685 24.8372 20.4512 23.9611 21.7939 23.9611C22.5122 23.9611 23.1964 24.1992 23.8463 24.667C24.616 25.2284 25.4969 25.5176 26.3863 25.5176C27.8999 25.5176 29.388 24.6415 30.1747 23.2891C30.9444 21.9537 30.9273 20.4056 30.132 19.0361C29.4735 17.9049 29.4478 16.7055 30.0636 15.6508C30.705 14.5365 31.9364 13.8135 33.1936 13.8135C34.1428 13.8135 35.0151 14.2218 35.7164 14.9959C36.563 15.9315 37.6833 16.4419 38.8806 16.4419C40.2745 16.4419 41.6514 15.7359 42.4809 14.6046C43.2848 13.4988 43.49 12.1379 43.0453 10.7855C42.6861 9.67969 42.8315 8.59944 43.4558 7.74035C44.1314 6.82171 45.2688 6.24331 46.4319 6.24331C47.6548 6.24331 48.6896 6.86424 49.3481 7.99552C50.1434 9.37348 51.486 10.1645 53.0339 10.1645C54.291 10.1645 55.5311 9.62015 56.3606 8.71002C57.1645 7.82541 57.5237 6.6516 57.3954 5.40123C57.2842 4.36351 57.5579 3.44488 58.1993 2.7474C58.8577 2.01589 59.8754 1.58209 60.9102 1.58209C62.4495 1.58209 63.6553 2.47521 64.1428 3.97224C64.7414 5.80951 66.3064 6.9493 68.2306 6.9493C70.1206 6.9493 72.2756 5.74147 72.5579 3.09614C72.7802 0.961164 74.4478 0 76.0043 0C77.5607 0 79.2283 0.952658 79.4507 3.09614C79.7243 5.74997 81.888 6.9493 83.7779 6.9493C85.7021 6.9493 87.2671 5.80951 87.8657 3.97224C88.3532 2.47521 89.559 1.58209 91.0983 1.58209C92.1417 1.58209 93.1508 2.01589 93.8093 2.7474C94.4421 3.44488 94.7158 4.36351 94.6132 5.40123C94.4763 6.6516 94.8441 7.82541 95.6479 8.71002C96.4775 9.62015 97.7175 10.1645 98.9746 10.1645C100.523 10.1645 101.865 9.37348 102.66 7.99552C103.319 6.86424 104.354 6.24331 105.577 6.24331C106.74 6.24331 107.877 6.81321 108.553 7.74035C109.186 8.59944 109.331 9.68819 108.963 10.7855C108.519 12.1464 108.715 13.4988 109.528 14.6046C110.357 15.7359 111.734 16.4419 113.128 16.4419C114.325 16.4419 115.446 15.9315 116.292 14.9959C116.993 14.2218 117.866 13.8135 118.815 13.8135C120.072 13.8135 121.304 14.5365 121.945 15.6423C122.552 16.697 122.535 17.8964 121.877 19.0276C121.081 20.3971 121.064 21.9537 121.834 23.2806C122.621 24.633 124.109 25.5091 125.622 25.5091C126.512 25.5091 127.393 25.2114 128.162 24.6585C128.812 24.1907 129.505 23.9525 130.215 23.9525C131.549 23.9525 132.84 24.8201 133.422 26.1215C133.977 27.3719 133.747 28.6988 132.78 29.7621C131.6 31.0635 131.309 32.7816 132.019 34.3467C132.729 35.9373 134.268 36.9665 135.944 36.9665C136.552 36.9665 137.167 36.8304 137.757 36.5668C138.262 36.3456 138.767 36.235 139.254 36.235C140.93 36.235 142.093 37.4854 142.495 38.7188C142.965 40.1733 142.487 41.5937 141.204 42.5124C139.63 43.6437 139.023 45.4809 139.622 47.2927C140.212 49.0959 141.837 50.3037 143.667 50.3037C143.992 50.3037 144.317 50.2697 144.642 50.2017C144.924 50.1421 145.206 50.1081 145.471 50.1081C147.336 50.1081 148.473 51.5031 148.764 52.8895C149.037 54.1909 148.661 55.8836 146.771 56.7257C144.556 57.7039 143.932 59.8473 144.3 61.5485C144.659 63.2412 146.113 64.9594 148.524 64.9594C150.696 64.9594 151.825 66.516 151.979 68.047C152.142 69.5866 151.355 71.3388 149.251 71.7811C146.882 72.2829 145.822 74.2563 145.822 75.9915C145.822 77.7267 146.882 79.7001 149.251 80.2019C151.363 80.6442 152.142 82.3964 151.979 83.936C151.817 85.4755 150.688 87.0236 148.533 87.0236C146.104 87.0236 144.659 88.7333 144.291 90.4345C143.932 92.1271 144.556 94.2791 146.763 95.2573C148.661 96.0909 149.037 97.7835 148.755 99.0935C148.456 100.48 147.327 101.875 145.463 101.875C145.189 101.875 144.915 101.841 144.633 101.781C144.308 101.713 143.975 101.679 143.658 101.679C141.828 101.679 140.195 102.887 139.613 104.69C139.023 106.511 139.63 108.339 141.195 109.471C142.478 110.398 142.957 111.81 142.487 113.264C142.085 114.498 140.922 115.748 139.245 115.748C138.749 115.748 138.245 115.637 137.749 115.416C137.15 115.153 136.543 115.016 135.936 115.016C134.26 115.016 132.72 116.046 132.011 117.636C131.309 119.21 131.591 120.92 132.772 122.221C133.738 123.284 133.969 124.611 133.413 125.861C132.832 127.154 131.549 128.03 130.206 128.03C129.488 128.03 128.804 127.792 128.154 127.324C127.384 126.763 126.503 126.474 125.614 126.474C124.1 126.474 122.612 127.35 121.825 128.702C121.056 130.038 121.073 131.586 121.868 132.955C122.526 134.087 122.552 135.286 121.936 136.341C121.295 137.455 120.064 138.178 118.806 138.178C117.857 138.178 116.985 137.77 116.284 136.996C115.437 136.06 114.317 135.55 113.119 135.55C111.725 135.55 110.349 136.256 109.519 137.387C108.715 138.493 108.51 139.854 108.955 141.206C109.314 142.312 109.168 143.392 108.544 144.251C107.869 145.17 106.731 145.748 105.568 145.748C104.345 145.748 103.31 145.127 102.652 143.996C101.857 142.618 100.514 141.827 98.9661 141.827C97.7089 141.827 96.4689 142.371 95.6394 143.281C94.8355 144.166 94.4763 145.34 94.6046 146.59C94.7158 147.628 94.4421 148.547 93.8007 149.244C93.1422 149.976 92.1246 150.409 91.0898 150.409C89.5505 150.409 88.3446 149.516 87.8572 148.019C87.2585 146.182 85.6935 145.042 83.7694 145.042C81.8794 145.042 79.7243 146.25 79.4421 148.895C79.2198 151.039 77.5522 152 75.9957 152Z" })
      }
    ),
    shape12: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M50 15.3L99 1 84.7 50 99 99 50 84.7 1 99l14.3-49L1 1l49 14.3z" })
      }
    ),
    shape13: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M99.5 99.5V.5L50 10.5.5.5v99l49.5-10 49.5 10z" })
      }
    ),
    shape14: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M99.5 30.5h-15v-15h-15V.5h-39v15h-15v15H.5v39h15v15h15v15h39v-15h15v-15h15v-39z" })
      }
    ),
    shape15: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M40.8 8.5c5-10.7 13.3-10.7 18.4 0S77.7 29.4 89 31.1s13.9 10 5.7 18.3S81.4 74.2 83.3 86s-4.8 16.9-14.9 11.3-26.7-5.6-36.8 0-16.9.5-15-11.3-3.1-28.3-11.3-36.6S-.3 32.8 11 31.1 35.7 19.2 40.8 8.5z" })
      }
    ),
    shape16: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M61.2 84.8c6.3 19.6-28.7 19.6-22.4 0-26.7 19.6-43.2 3-23.6-23.6-19.6 6.3-19.6-28.7 0-22.4-19.6-26.7-3-43.2 23.6-23.6-6.3-19.6 28.7-19.6 22.4 0 26.7-19.6 43.2-3 23.6 23.6 19.6-6.3 19.6 28.7 0 22.4 19.6 26.7 3 43.2-23.6 23.6z" })
      }
    ),
    shape17: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M99.5 31.5A30 30 0 0050 8.7 30 30 0 007.3 50.5 30 30 0 0050 92.3a30 30 0 0042.7-41.8 29.9 29.9 0 006.8-19z" })
      }
    ),
    shape18: /* @__PURE__ */ t(
      "svg",
      {
        className: "sqs-shape",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M50 100c-6 0-12-1-17-3-5-2-9-5-10-8-1-2-1-5 0-8 1-3 4-7 7-11l0 0c-6 6-11 8-15 8h0c-4 0-8-2-10-7-3-5-5-13-5-21 0-8 2-16 5-21 3-5 6-7 10-7 4 0 10 3 15 8l0 0c-4-4-6-7-7-11-1-3-1-6 0-8 1-4 5-6 10-8 5-2 11-3 17-3 6 0 12 1 17 3 5 2 9 5 10 8 1 2 1 5 0 8-1 3-4 7-7 11l0 0c6-6 11-8 15-8 5 0 9 3 11 9 2 5 4 12 4 20 0 7-1 14-4 20-3 6-7 9-11 9h0c-4 0-10-3-15-8l0 0c4 4 6 7 7 11 1 3 1 6 0 8-1 4-5 6-10 8-5 2-11 3-17 3Z" })
      }
    ),
    shape19: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 150 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M100 .5a49.3 49.3 0 00-25 6.8 49.5 49.5 0 100 85.4A49.5 49.5 0 10100 .5z" })
      }
    ),
    shape20: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 150 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M119.5.5a29.9 29.9 0 00-22.3 9.9 30 30 0 00-44.5 0A30 30 0 00.5 30.5v39a30 30 0 0052.3 20.1 30 30 0 0044.5 0 30 30 0 0052.2-20.1v-39a30 30 0 00-30-30z" })
      }
    ),
    shape21: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 150 100",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t(
          "ellipse",
          {
            cx: "75",
            cy: "50",
            rx: "78",
            ry: "43.7",
            transform: "rotate(-21.1 75 50)"
          }
        )
      }
    ),
    shape22: /* @__PURE__ */ t(
      "svg",
      {
        className: "sqs-shape",
        viewBox: "0 0 241 111",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M56.1335 0H240.266L184.132 111H0L56.1335 0Z" })
      }
    ),
    shape23: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 150",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M50 .5A49.5 49.5 0 00.5 50v99.5h99V50A49.5 49.5 0 0050 .5z" })
      }
    ),
    shape24: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 150",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M88.2 18.5a49.4 49.4 0 00-76.3 0H.6v131h99v-131z" })
      }
    ),
    shape25: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 150",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M99.5 49.9a49.4 49.4 0 10-89.1 29.4H.5v70.2h99V79.3h-9.7A49.1 49.1 0 0099.5 50z" })
      }
    ),
    shape26: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 150",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M68 150c-6-25-30-25-36 0-6-25-15-35-31-32 16-14 16-72 0-86 16 3 25-7 31-31 6 24 30 24 36 0 6 24 15 34 32 31-17 14-17 72 0 86-17-3-26 7-32 32z" })
      }
    ),
    shape27: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 150",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M50 149.5h0c-13.5.3-26.4-8.9-35.4-19.5A58 58 0 01.5 90.8h0a152.6 152.6 0 0112.3-55C21 17.2 34 0 50 .5h0C66 0 79 17.2 87.2 35.8a152.6 152.6 0 0112.3 55h0c.2 15.8-5 28.2-14.1 39.2-9 10.6-22 19.8-35.4 19.5z" })
      }
    ),
    shape28: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 150",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M99.5 30.5h0V.5H.5v30h0A49.5 49.5 0 0029.4 75 49.5 49.5 0 00.5 119.5h0v30h99v-30h0A49.5 49.5 0 0070.6 75a49.5 49.5 0 0028.9-44.5z" })
      }
    ),
    shape29: /* @__PURE__ */ t(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        className: "sqs-shape",
        viewBox: "0 0 100 150",
        preserveAspectRatio: "none",
        style: C,
        children: /* @__PURE__ */ t("path", { d: "M79.2 149.5H20.8L1 .5h98l-19.8 149z" })
      }
    )
  };
  return e ? i[e] : i;
}
function q5({
  element: C,
  wuiltContext: e,
  mutateElementApi: i,
  updateElementUi: n
}) {
  const o = {
    fill: C.fill,
    filter: C.filter,
    stroke: C.stroke,
    strokeWidth: C.strokeWidth
  }, r = O5(o, C.shape);
  return /* @__PURE__ */ t("div", { className: "shapes-edit", children: r });
}
const X1 = {
  Section: n7,
  Column: V7,
  Row: u7,
  Element: x7,
  Text: e2,
  Button: F1,
  Buttons: A3,
  Image: R7,
  AppStoreButtons: r4,
  Form: f5,
  Video: B5,
  SocialLinks: g5,
  Counter: U5,
  Shapes: q5
}, t9 = ({
  sectionId: C,
  data: e,
  wuiltContext: i
}) => {
  var H;
  const n = A5(e), { Section: o, Row: r, Column: l, Element: h } = X1;
  return /* @__PURE__ */ t(o, { settings: n.settings, children: (H = n.rows) == null ? void 0 : H.map((V) => {
    var p;
    return /* @__PURE__ */ t(r, { row: V, children: (p = V == null ? void 0 : V.columns) == null ? void 0 : p.map((a) => {
      var L;
      return /* @__PURE__ */ t(l, { column: a, children: (L = a.elements) == null ? void 0 : L.map((s) => /* @__PURE__ */ t(
        h,
        {
          Component: X1[s.type],
          element: s,
          column: a,
          row: V,
          section: n,
          wuiltContext: i,
          sectionId: C,
          rowId: V == null ? void 0 : V.id,
          columnId: a == null ? void 0 : a.id,
          sectionValueId: n == null ? void 0 : n.id,
          text: n == null ? void 0 : n.text
        },
        s.id
      )) }, a.id);
    }) }, V.id);
  }) });
};
export {
  B3 as AlignmentValue,
  b3 as AppStoreButtonActionType,
  m3 as AppStoreButtonStyle,
  E7 as AppleStoreBlackMedium,
  U7 as AppleStoreBrandMedium,
  q7 as AppleStoreWhiteMedium,
  y3 as AutoCompleteType,
  y1 as BackgroundPosition,
  B1 as BackgroundRepeat,
  L1 as BackgroundScrollEffect,
  r2 as BackgroundSize,
  m as BackgroundType,
  O as ButtonActionType,
  _3 as ButtonDesignSize,
  i2 as ButtonDesignType,
  I3 as ColorsType,
  t9 as CustomSectionPreview,
  X1 as ElementsViewer,
  g as FieldType,
  b1 as FormPostSubmitType,
  M as IconShape,
  U as ImageActionType,
  l2 as ImageObjectFit,
  m1 as SelectionsLimitationType,
  _1 as ShadowType,
  $ as SocialLinkName,
  C9 as SocialLinksIcons,
  F3 as UtilityPageType,
  A5 as migrateCustomSectionData
};
//# sourceMappingURL=main.es.js.map
